/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Autogenerated return type of DeleteAttachment. */
  DeleteAttachmentPayload: unknown;
  /** An ISO 8601-encoded date */
  ISO8601Date: string;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string;
  JSON: { [key: string]: any };
  /** An RFC 3339-encoded datetime */
  RFC3339DateTime: string;
  /** Autogenerated return type of ShareAccessInformation. */
  ShareAccessInformationPayload: unknown;
  /** Autogenerated return type of SignOut. */
  SignOutPayload: unknown;
  Upload: unknown;
  /** Autogenerated return type of VerifyPhone. */
  VerifyPhonePayload: unknown;
};

export type AcceptedReferral = {
  completed: Scalars["Boolean"];
  id: Scalars["ID"];
  referralId: Scalars["ID"];
  referredAccountId: Scalars["ID"];
  referredEmail?: Maybe<Scalars["String"]>;
  referredName?: Maybe<Scalars["String"]>;
};

export type AccessCodesFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Title to display on the feed item */
  title: Scalars["String"];
};

/** Housekeeping access instructions */
export type AccessInstructions = {
  /** building code */
  buildingCode?: Maybe<Scalars["String"]>;
  /** Detailed access instructions */
  detailedAccessInstructions?: Maybe<Scalars["String"]>;
  /** lockbox code */
  lockboxCode?: Maybe<Scalars["String"]>;
  /** Backup unit code */
  unitBackupCode?: Maybe<Scalars["String"]>;
  /** Unit code */
  unitCode?: Maybe<Scalars["String"]>;
};

export type AccessShareRecipient = Node & {
  email: Scalars["String"];
  firstName: Scalars["String"];
  id: Scalars["ID"];
  lastName?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export enum AccessUnavailableReason {
  BeforeReadableTime = "BEFORE_READABLE_TIME",
  CancelledBooking = "CANCELLED_BOOKING",
  IdvNotStarted = "IDV_NOT_STARTED",
  IdvPending = "IDV_PENDING",
  PaymentFailed = "PAYMENT_FAILED",
  PaymentPending = "PAYMENT_PENDING",
  RoomUnassigned = "ROOM_UNASSIGNED",
}

export type Account = Node & {
  /** Object describing features this account is enabled for */
  accountFlags: AccountFlags;
  /** Account notifications associated with this account. */
  accountNotifications: Array<AccountNotification>;
  /** List of Action permissions */
  actions?: Maybe<Array<Maybe<Action>>>;
  /** Address of the guest. */
  address?: Maybe<Address>;
  /** Bookings associated with this account. */
  bookings: Array<Inquiry>;
  /** Bookings and cancellations associated with this account. */
  bookingsAndCancellations: Array<Inquiry>;
  /**
   * Flag indicating if this account use the Instant ECI/LCO feature
   * @deprecated Using an inquiry level flag instead
   */
  canInstantEciLco?: Maybe<Scalars["Boolean"]>;
  /** Flag indicating if the account has QA permissions */
  canQa?: Maybe<Scalars["Boolean"]>;
  /** Flag indicating if this account can receive Access Info */
  canReceiveAccessInfo?: Maybe<Scalars["Boolean"]>;
  /** When the guest signed up. */
  createdAt: Scalars["ISO8601DateTime"];
  /** Stripe customer information. */
  customer?: Maybe<Customer>;
  /** Birthday of the guest. */
  dateOfBirth?: Maybe<Scalars["ISO8601Date"]>;
  /** Confirmed email of the guest. */
  email: Scalars["String"];
  /** Account feed for this guest */
  feed: AccountFeed;
  /** Fidelity information for the account */
  fidelity?: Maybe<Fidelity>;
  /** First name of the guest. */
  firstName?: Maybe<Scalars["String"]>;
  /** Gladly ID associated with this account */
  gladlyId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Flag indicating if the account is a shell account */
  isShell?: Maybe<Scalars["Boolean"]>;
  /** Language preference of the guest */
  languagePreference: Scalars["String"];
  /** Last name of the guest. */
  lastName?: Maybe<Scalars["String"]>;
  /** Flag indicating whether this account has opted to receive marketing emails. */
  marketingOptIn?: Maybe<Scalars["Boolean"]>;
  /** Configuration object to allow accounts to enable in app messaging_configuration */
  messagingConfiguration?: Maybe<MessagingConfiguration>;
  /**
   * Full name of the guest.
   * @deprecated This field has been seperated into 'firstName' and 'lastName'
   */
  name?: Maybe<Scalars["String"]>;
  /** The ID of the account without the class name prepended */
  normalizedId?: Maybe<Scalars["Int"]>;
  /** Number of bookings by this account */
  numberOfBookings: Scalars["Int"];
  /** Phone numbers of the guest. */
  phoneNumbers?: Maybe<Array<PhoneNumber>>;
  /** Phone number the guest. */
  primaryPhoneNumber?: Maybe<Scalars["String"]>;
  /** Data relating to the Salesforce integration. */
  salesforceAssociation?: Maybe<SalesforceAssociation>;
  /** Source system of the account */
  source?: Maybe<Scalars["String"]>;
  /** List of tom tasks associated with this account */
  tasksForPastBookings: TaskConnections;
  /** Unconfirmed email of the guest. */
  unconfirmedEmail?: Maybe<Scalars["String"]>;
  /**
   * [DEPRECATED] Flag indicating whether this account is verified.
   * @deprecated Use Inquiry#bookingActionables instead
   */
  verified: Scalars["Boolean"];
};

export type AccountTasksForPastBookingsArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type AccountFeed = Node & {
  /** Feed items for this account */
  feedItems: Array<FeedItem>;
  id: Scalars["ID"];
  /** Subtitle to display on account feed */
  subtitle?: Maybe<Scalars["String"]>;
  /** Title to display on account feed */
  title: Scalars["String"];
};

export type AccountFlags = {
  /** Flag indicating whether or not guests can self checkout */
  canSelfCheckout: Scalars["Boolean"];
  /** Flag indicating whether or not guests can view the new lobby screen */
  canViewLobby: Scalars["Boolean"];
  /**
   * List of SplitIO experiments applied to current session
   * @deprecated No longer used, will be removed in the future
   */
  experiments: Array<ExperimentValue>;
  /**
   * determines whether in-app booking is enabled
   * @deprecated In-App booking fully rolled out
   */
  inAppBooking: Scalars["Boolean"];
  /** determines whether in-app messaging is enabled */
  inAppMessaging: Scalars["Boolean"];
  /** determines whether member_pricing_experiment is enabled */
  memberPricingExperiment: Scalars["Boolean"];
  /** determines credit amount used for referral */
  referralCreditAmount: Scalars["Int"];
  /** determines currency used for referral */
  referralCreditCurrency: Scalars["String"];
  /** determines whether referal is enabled */
  referralEnabled: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether request account deletion is enabled
   * @deprecated Fully relased on prod
   */
  requestAccountDeletion: Scalars["Boolean"];
};

export type AccountNotification = Node & {
  /** Created timestamp. */
  createdAt: Scalars["ISO8601DateTime"];
  /** Flag indicating this account notification has been previously read. */
  hasRead: Scalars["Boolean"];
  id: Scalars["ID"];
  /** Message associated with this account notification. */
  message: Scalars["String"];
  /** Enum type of account notification. */
  notificationType: Scalars["String"];
  /** Optional polymorphic subject associated with this account notification */
  subject?: Maybe<Inquiry>;
};

export type AccountPageResult = {
  accounts: Array<Account>;
  pageInfo: PageInfo;
};

/** Attributes for updating account settings on account */
export type AccountSettingsInput = {
  dateOfBirth?: InputMaybe<Scalars["ISO8601DateTime"]>;
  discountPricingMember?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  marketingEmailPreferencesInput?: InputMaybe<MarketingEmailPreferencesInput>;
  marketingOptIn?: InputMaybe<Scalars["Boolean"]>;
};

export type AccountVerificationPromptFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
  verificationUrl: Scalars["String"];
};

/** Filter for searching accounts */
export type AccountsFilterInput = {
  email?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
};

export type Action = {
  /** Action external URL  */
  externalUrl?: Maybe<Scalars["String"]>;
  /** Action Type */
  type: ActionType;
};

export enum ActionType {
  AccountEdit = "ACCOUNT_EDIT",
  AccountView = "ACCOUNT_VIEW",
  InquiryAncillaryBreakfast = "INQUIRY_ANCILLARY_BREAKFAST",
  InquiryAncillaryEci = "INQUIRY_ANCILLARY_ECI",
  InquiryAncillaryIntrastayCleaning = "INQUIRY_ANCILLARY_INTRASTAY_CLEANING",
  InquiryAncillaryLco = "INQUIRY_ANCILLARY_LCO",
  InquiryAncillaryParking = "INQUIRY_ANCILLARY_PARKING",
  InquiryAncillaryPets = "INQUIRY_ANCILLARY_PETS",
  InquiryAncillaryWebBreakfast = "INQUIRY_ANCILLARY_WEB_BREAKFAST",
  InquiryAncillaryWebEci = "INQUIRY_ANCILLARY_WEB_ECI",
  InquiryAncillaryWebLco = "INQUIRY_ANCILLARY_WEB_LCO",
  InquiryAncillaryWebParking = "INQUIRY_ANCILLARY_WEB_PARKING",
  InquiryCreate = "INQUIRY_CREATE",
  InquiryEdit = "INQUIRY_EDIT",
  InquiryGuestInvite = "INQUIRY_GUEST_INVITE",
  InquiryInvoiceRequest = "INQUIRY_INVOICE_REQUEST",
  InquirySkipBookingGuards = "INQUIRY_SKIP_BOOKING_GUARDS",
  InquiryVerificationViaPavUi = "INQUIRY_VERIFICATION_VIA_PAV_UI",
}

export type Actionable = {
  /** ... */
  completed?: Maybe<Scalars["Boolean"]>;
  /** json objects related to a speficic actionable type */
  metadata?: Maybe<Scalars["JSON"]>;
  /** Status of the actionable */
  status?: Maybe<Scalars["String"]>;
  /** ... */
  step?: Maybe<Scalars["String"]>;
  /** ... */
  type: Scalars["String"];
};

export enum ActivitySource {
  ActivitySourceAccess = "activity_source_access",
  ActivitySourceAloha = "activity_source_aloha",
  ActivitySourceAsana = "activity_source_asana",
  ActivitySourceBackbone = "activity_source_backbone",
  ActivitySourceDd = "activity_source_dd",
  ActivitySourceHk = "activity_source_hk",
  ActivitySourceHkCleanShuffler = "activity_source_hk_clean_shuffler",
  ActivitySourceHkFlatbookApi = "activity_source_hk_flatbook_api",
  ActivitySourceHkFlatbookWebApp = "activity_source_hk_flatbook_web_app",
  ActivitySourceMahalo = "activity_source_mahalo",
  ActivitySourceSystem = "activity_source_system",
  ActivitySourceTom = "activity_source_tom",
}

export type AdaAccessibilityInfo = {
  hearingFeatures?: Maybe<Array<Scalars["String"]>>;
  isHearingAccessible?: Maybe<Scalars["Boolean"]>;
  isMobilityAccessible?: Maybe<Scalars["Boolean"]>;
  mobilityFeatures?: Maybe<Array<Scalars["String"]>>;
};

export type Address = {
  /** City */
  city: City;
  /** Name of the city */
  cityName: Scalars["String"];
  /** Country code */
  countryCode: Scalars["String"];
  /** Google maps URL for this address */
  googleMapsUrl: Scalars["String"];
  /** Unique identifier */
  id: Scalars["ID"];
  /** Latitude */
  latitude?: Maybe<Scalars["Float"]>;
  /** Longitude */
  longitude?: Maybe<Scalars["Float"]>;
  /** Postal code */
  postalCode: Scalars["String"];
  /** State or province */
  stateOrProvince: Scalars["String"];
  /** Street address */
  streetAddress: Scalars["String"];
  /** Street address 2 */
  streetAddress2?: Maybe<Scalars["String"]>;
};

/** Address */
export type AddressInput = {
  cityName: Scalars["String"];
  countryCode: Scalars["String"];
  postalCode: Scalars["String"];
  stateOrProvince: Scalars["String"];
  streetAddress: Scalars["String"];
  streetAddress2?: InputMaybe<Scalars["String"]>;
};

/** All types that can be returned as the result of a text search, or a list of mentions */
export type All = Unit | User;

export type AllTypesFeed = {
  /** Feed items for this account */
  items: Array<All>;
};

export type AlterationAvailability = Node & {
  /** The alteration policy for the rental site */
  alterationsRules: AlterationsRules;
  /** The available data for the unit */
  availabilityData: Array<AlterationDayAvailability>;
  /** Check in date of the inquiry. */
  checkInDate: Scalars["RFC3339DateTime"];
  /** Check out date of the inquiry. */
  checkOutDate: Scalars["RFC3339DateTime"];
  /** Whether another extension request already exists */
  hasPendingRequest: Scalars["Boolean"];
  id: Scalars["ID"];
  /** the maximum night stay for the unit booking */
  maximumNightStay: Scalars["Int"];
  /** the default minimum night stay for the unit booking */
  minimumNightStay: Scalars["Int"];
  /** the OTA of the booking */
  otaName: Scalars["String"];
  /** the last time the inquiry was updated */
  updatedAt: Scalars["RFC3339DateTime"];
};

export type AlterationDayAvailability = Node & {
  /** The info for this date */
  data: AlterationDayAvailabilityData;
  /** The relevant date */
  date: Scalars["RFC3339DateTime"];
  /** Unique identifier */
  id: Scalars["ID"];
};

export type AlterationDayAvailabilityData = Node & {
  /** Is this date available for checkin */
  checkinAvailable: Scalars["Boolean"];
  /** Is this date available for checkout */
  checkoutAvailable: Scalars["Boolean"];
  /** Unique identifier */
  id: Scalars["ID"];
  /** the minimum number of nights for this date */
  minNights: Scalars["Int"];
};

export type AlterationPromptFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type AlterationsRules = Node & {
  /** can cancellations be performed on the ota without manual operations */
  canPerformCancellationAutomatically?: Maybe<Scalars["Boolean"]>;
  /** can reductions be performed on the ota without manual operations */
  canPerformReductionAutomatically?: Maybe<Scalars["Boolean"]>;
  /** can refunds be performed on the ota without manual operations */
  canPerformRefundAutomatically?: Maybe<Scalars["Boolean"]>;
  /** do extensions have to be done through the ota */
  extensionsThroughOta?: Maybe<Scalars["Boolean"]>;
  /** number of days within which a booking is no longer eligible for a half refund */
  fiftyRefundThresholdDays?: Maybe<Scalars["Int"]>;
  /** the number of days within which a booking is no longer eligible for a full refund */
  fullRefundThresholdDays?: Maybe<Scalars["Int"]>;
  /** the hours after booking the grace period lasts */
  gracePeriodHours?: Maybe<Scalars["Int"]>;
  /** how long before the bookings start date before it is no longer eligible for a grace periodeven if in the threshold hours */
  graceRefundThresholdDays?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  /** do reductions have to be done through the ota */
  reductionsThroughOta?: Maybe<Scalars["Boolean"]>;
  /** do refunds get performed over ach */
  refundThroughAch?: Maybe<Scalars["Boolean"]>;
  /** do guests have to go through the ota to cancel */
  selfServiceCancellations?: Maybe<Scalars["Boolean"]>;
  /** is there integration with a third party system for the payment (ex. airbnb) */
  thirdPartyPaymentIntegration?: Maybe<Scalars["Boolean"]>;
};

export type Amenity = {
  active?: Maybe<Scalars["Boolean"]>;
  label?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type AncillaryService = {
  /** Has this ancillary upgrade been booked */
  booked?: Maybe<Scalars["Boolean"]>;
  /** The localized, formatted price for displaying to the user. */
  displayPrice: Scalars["String"];
  /** The fee type of the ancillary service, e.g., $/night or $/guest/night. */
  feeType: AncillaryServiceFee;
  /** The name of the ancillary service. */
  name: AncillaryServiceName;
  /** The raw price of the add-on, in USD. Useful for analytics. */
  price: Scalars["Int"];
};

export enum AncillaryServiceFee {
  Flat = "flat",
  FlatPerNight = "flat_per_night",
  FlatPerNightPerQuantity = "flat_per_night_per_quantity",
  FlatPerQuantity = "flat_per_quantity",
}

/** Ancillary services to be added to the invoice */
export type AncillaryServiceInput = {
  key: Scalars["String"];
  quantity?: InputMaybe<Scalars["Int"]>;
  value?: InputMaybe<Scalars["String"]>;
};

export enum AncillaryServiceName {
  Parking = "parking",
  PetFriendlyStay = "pet_friendly_stay",
}

/** Represents ancillary workflows in the client */
export enum AncillaryServiceWorkflow {
  AutoApprovalWithoutPayment = "AUTO_APPROVAL_WITHOUT_PAYMENT",
  AutoApprovalWithPayment = "AUTO_APPROVAL_WITH_PAYMENT",
  ManualApproval = "MANUAL_APPROVAL",
  NotAvailable = "NOT_AVAILABLE",
}

/** Represents ancillary workflows in the client for each ancillary service */
export type AncillaryServicesWorkflows = {
  /** Represents ancillary workflow for breakfast */
  breakfastWorkflow: AncillaryServiceWorkflow;
  /** Represents ancillary workflow for ECI */
  eciWorkflow: AncillaryServiceWorkflow;
  /** Represents ancillary workflow for intrastay cleanings */
  intrastayCleaningWorkflow: AncillaryServiceWorkflow;
  /** Represents ancillary workflow for LCO */
  lcoWorkflow: AncillaryServiceWorkflow;
  /** Represents ancillary workflow for parking */
  parkingWorkflow: AncillaryServiceWorkflow;
};

export type AnnouncementBanner = {
  /** This property will determine if the banner can be dismissed by a guest. */
  dismissible?: Maybe<Scalars["Boolean"]>;
  /** An array of strings that will be highlighted. */
  highlightedText: Array<Scalars["String"]>;
  /** The name of the icon. */
  icon: Scalars["String"];
  /** This will be a unique key for each announcement banner. */
  key: Scalars["String"];
  /** The route that will be used for the press handler. */
  route: Scalars["String"];
  /** This property will be used to determine when the banner should start displaying. */
  startDisplayingAt: Scalars["RFC3339DateTime"];
  /**
   * This property will be used to determine when the banner should stop displaying.
   *                               This will be used on the client-side as a
   * precautionary measure to stop displaying the banner
   *                               in case the guest has not refreshed their app in a while.
   */
  stopDisplayingAt: Scalars["RFC3339DateTime"];
  /** A string of the text that will be displayed. */
  text: Scalars["String"];
};

export type ApartmentGuideFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type AppFlags = {
  /** determines whether the app should be in auth barrier mode or not */
  authBarrier: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether the app should display the typescript account settings flow
   * @deprecated Fully released on prod
   */
  tsAccountSettingsFlow: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether the app should display the typescript birthday settings flow
   * @deprecated Fully released on prod
   */
  tsBirthdaySettingsFlow: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether the app should display the typescript find reservation flow
   * @deprecated Fully released on prod
   */
  tsFindReservationFlow: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether the app should display the typescript login flow
   * @deprecated Fully released on prod
   */
  tsLoginFlow: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether the app should display the typescript notification settings flow
   * @deprecated Fully released on prod
   */
  tsNotificationSettingsFlow: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether the app should display the typescript reset password flow
   * @deprecated Fully released on prod
   */
  tsResetPasswordFlow: Scalars["Boolean"];
  /**
   * [DEPRECATED] determines whether the app should display the typescript share access settings flow
   * @deprecated Fully released on prod
   */
  tsShareAccessFlow: Scalars["Boolean"];
};

export type AppliedOffer = {
  discountLabel: Scalars["String"];
  discountValue: Scalars["Float"];
  filterKey: Scalars["String"];
};

/** Autogenerated return type of ApproveHkCost. */
export type ApproveHkCostPayload = {
  hkCost: HkCost;
};

export type AssaAbloyConfiguration = {
  invitationCode?: Maybe<Scalars["String"]>;
};

export type AssigneeIdChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New assignee. */
  newAssignee?: Maybe<User>;
  /** Previous assignee. */
  prevAssignee?: Maybe<User>;
};

/** Autogenerated return type of AssociateAccount. */
export type AssociateAccountPayload = {
  success: Scalars["String"];
};

/** Autogenerated return type of AssociateGuestAccount. */
export type AssociateGuestAccountPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of AssociateInquiry. */
export type AssociateInquiryPayload = {
  success: Scalars["String"];
};

/** Autogenerated return type of AsyncBookingPayment. */
export type AsyncBookingPaymentPayload = {
  response: AsyncPaymentResponse;
};

export type AsyncPaymentResponse = {
  checkoutProcessId: Scalars["String"];
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
  trackingInfo?: Maybe<Scalars["JSON"]>;
};

/** Autogenerated return type of AttachPaymentMethod. */
export type AttachPaymentMethodPayload = {
  customer: Customer;
};

export enum Attachable {
  Comment = "comment",
  Task = "task",
  User = "user",
}

export type Attachment = Node & {
  /** Id of the object this is attached to. */
  attachableId: Scalars["Int"];
  /** Type of object this is attached to. */
  attachableType?: Maybe<Scalars["String"]>;
  /** When this attachment was created. */
  createdAt: Scalars["RFC3339DateTime"];
  /** file format of the attachment. */
  format?: Maybe<Format>;
  /** where is this attachment hosted. */
  host?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** image or video. */
  resourceType: Resource;
  /** When this attachment was last updated. */
  updatedAt: Scalars["RFC3339DateTime"];
  /** url of the attachment. */
  url: Scalars["String"];
  /** User that first created this attachment */
  user?: Maybe<User>;
};

export type AutomatedRelocationEligibility = {
  /** A unit of the collection is available. */
  eligible: Scalars["Boolean"];
  /** Automated relocation enabled, inquiry booked, unit part of collection. */
  enabled: Scalars["Boolean"];
  /** Error message when something is wrong. */
  errorMessage?: Maybe<Scalars["String"]>;
  /** The inquiry to relocate. */
  inquiry: Inquiry;
};

export type AutomaticPaymentSchedule = {
  chargeDate: Scalars["String"];
  revenueUntil: Scalars["String"];
};

/** Group trip automatic payment schedule upsert input */
export type AutomaticPaymentScheduleInput = {
  chargeDate: Scalars["String"];
  revenueUntil: Scalars["String"];
};

export type Availability = {
  available: Scalars["Boolean"];
  checkinAvailable: Scalars["Boolean"];
  checkoutAvailable: Scalars["Boolean"];
  currency: Scalars["String"];
  date: Scalars["String"];
  listingId: Scalars["Int"];
  maximumStayLength: Scalars["Int"];
  minimumStayLength: Scalars["Int"];
  price: Scalars["Float"];
};

export type BaseError = {
  code: Scalars["String"];
  message: Scalars["String"];
};

export type BaseResponse = {
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
  trackingInfo?: Maybe<Scalars["JSON"]>;
};

export enum BatchActions {
  BatchUpdate = "batch_update",
}

/** Autogenerated return type of BatchCreateTasks. */
export type BatchCreateTasksPayload = {
  batchJob: BatchJob;
};

export type BatchJob = Node & {
  /** Action that this batch job is performing (ex. 'UpdateTasks'). */
  action?: Maybe<Scalars["String"]>;
  /** When the batch job was created. */
  createdAt: Scalars["RFC3339DateTime"];
  /** User that created the batch job. */
  creator?: Maybe<User>;
  /** ID of the user that created the batch job. */
  creatorId?: Maybe<Scalars["ID"]>;
  /** Failed jobs in the batch. */
  errors: Array<BatchJobError>;
  id: Scalars["ID"];
  /** Number of remaining jobs in the batch. */
  remaining: Scalars["Int"];
  /** Status of the batch job. Can be 'pending' and 'completed'. */
  status: BatchJobStatus;
  /** Number of individual jobs associated with this batch. */
  total: Scalars["Int"];
  /** When the batch job was updated. */
  updatedAt: Scalars["RFC3339DateTime"];
};

export type BatchJobError = {
  /** Batch job error message */
  message: Scalars["String"];
  /** Batch job target object ID */
  targetId: Scalars["ID"];
  /** Batch job target object type */
  targetType: Scalars["String"];
  /** Batch job target object (just tasks for now) */
  task?: Maybe<Task>;
};

export enum BatchJobStatus {
  Complete = "complete",
  Pending = "pending",
}

/** Autogenerated return type of BatchUpdateUnits. */
export type BatchUpdateUnitsPayload = {
  batchJob: UnitBatchJob;
};

export enum Bed {
  Convertible = "convertible",
  Murphy = "murphy",
  Regular = "regular",
}

export enum BedSize {
  California = "california",
  Double = "double",
  King = "king",
  Queen = "queen",
  Single = "single",
}

export type Bedroom = {
  /** Description of the bed size. */
  bedSizeDescription: Scalars["String"];
  /** Name of the room. */
  name: Scalars["String"];
};

export type BeniContext = {
  /** Provides Flipper Flags necessary to boot BENI */
  flippers: BeniFlippers;
  /** Links shown in Header: Inquiries, Bookings, Flex Leases,...  */
  headerLinks: Array<BeniLink>;
  /** Links shown in Menu: Sign Out, Occupancy Board, Banned Guest List,... */
  menuLinks: Array<BeniLink>;
  /** User first name to show in header */
  userFirstName: Scalars["String"];
};

export type BeniFlippers = {
  /** Flag determines if selection of unit options are single or multi-select. */
  multiselectComparables?: Maybe<Scalars["Boolean"]>;
  /** Flag determines if temporary relocations are enabled */
  temporaryRelocation?: Maybe<Scalars["Boolean"]>;
};

export type BeniLink = {
  /** Path of the link */
  path?: Maybe<Scalars["String"]>;
  /** Text shown on the link */
  text?: Maybe<Scalars["String"]>;
};

/** interface to Inquiry, LeaseInquiry and Tom::Booking. */
export type Booking = {
  /** Owner of the booking */
  account?: Maybe<Account>;
  /** ID of the owner of the booking */
  accountId?: Maybe<Scalars["Int"]>;
  /** Actual arrival date time. */
  actualArrivalDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Actual departure date time. */
  actualDepartureDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** URL to the booking */
  bookingUrl?: Maybe<Scalars["String"]>;
  /** Check in time. */
  checkInTime: Scalars["RFC3339DateTime"];
  /** Check out time. */
  checkOutTime: Scalars["RFC3339DateTime"];
  /** the start date time of the cleaning window for check-out clean */
  cleaningWindowStartDateTime: Scalars["RFC3339DateTime"];
  /** confirmation code of the booking  */
  confirmationCode?: Maybe<Scalars["String"]>;
  /** The profile of the guest who owns the booking. */
  guestProfile?: Maybe<GuestProfile>;
  /** Unique inquiry identifier */
  id: Scalars["ID"];
  /** Tasks related to this booking */
  tomTasks: Array<Task>;
  /** unique key of the booking  */
  uniqueKey: Scalars["String"];
  /** unit assgined to the booking */
  unit: Unit;
};

/** interface to Inquiry, LeaseInquiry and Tom::Booking. */
export type BookingTomTasksArgs = {
  includeIntrastayCleanTasks?: InputMaybe<Scalars["Boolean"]>;
};

export type BookingDateAdjustmentRequest = Node & {
  id: Scalars["ID"];
  /** The new check in datetime requested in the units local timezone */
  newLocalCheckInTime: Scalars["RFC3339DateTime"];
  /** The new check out datetime requested in the units local timezone */
  newLocalCheckOutTime: Scalars["RFC3339DateTime"];
  /** The invoice created when creating the adjustment request */
  revenueReceivableInvoice?: Maybe<ReceivableInvoice>;
};

export type BookingInfo = {
  /** Inquiry or LeaseInquiry is currently in unit */
  currentBooking?: Maybe<Booking>;
  /** Inquiry or LeaseInquiry that last checked out */
  previousBooking?: Maybe<Booking>;
  /** next Inquiry or LeaseInquiry upcoming for this unit */
  upcomingBooking?: Maybe<Booking>;
};

export type BookingOrderInfo = {
  city: Scalars["String"];
  code: Scalars["String"];
  metadata?: Maybe<Scalars["JSON"]>;
};

export type BookingStay = Booking &
  Node & {
    /** Owner of the booking */
    account?: Maybe<Account>;
    /** ID of the owner of the booking */
    accountId?: Maybe<Scalars["Int"]>;
    /** Actual arrival date time. */
    actualArrivalDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Actual departure date time. */
    actualDepartureDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** URL to the booking */
    bookingUrl?: Maybe<Scalars["String"]>;
    /** Check in time. */
    checkInTime: Scalars["RFC3339DateTime"];
    /** Check out time. */
    checkOutTime: Scalars["RFC3339DateTime"];
    /** the start date time of the cleaning window for check-out clean */
    cleaningWindowStartDateTime: Scalars["RFC3339DateTime"];
    /** confirmation code of the booking  */
    confirmationCode?: Maybe<Scalars["String"]>;
    /** The profile of the guest who owns the booking. */
    guestProfile?: Maybe<GuestProfile>;
    /** Unique inquiry identifier */
    id: Scalars["ID"];
    /** Tasks related to this booking */
    tomTasks: Array<Task>;
    /** unique key of the booking  */
    uniqueKey: Scalars["String"];
    /** unit assgined to the booking */
    unit: Unit;
  };

export type BookingStayTomTasksArgs = {
  includeIntrastayCleanTasks?: InputMaybe<Scalars["Boolean"]>;
};

export type BookingVerificationRedirection = {
  /** Verification redirection path */
  redirectionPath: Scalars["String"];
  /** Verification redirection url */
  redirectionUrl: Scalars["String"];
};

export type BookingWithPaymentLinkResponse = {
  bookingUniqKey: Scalars["String"];
  url: Scalars["String"];
};

export type Building = {
  /** [DEPRECATED] If building has ecilco requests enabled. */
  allowEciLcoRequests: Scalars["Boolean"];
  /** Total bath count of the object for inventory ordering */
  bathCount: Scalars["Float"];
  /** Flat list of beds in all units in the object */
  beds?: Maybe<ChangedBeds>;
  /** Breakfast description, when available */
  breakfastDescription?: Maybe<Scalars["String"]>;
  /** Timing for breakfast, when available */
  breakfastTiming?: Maybe<Scalars["String"]>;
  /** Total number of different buildings those units are part of. */
  buildingCount: Scalars["Int"];
  /** City of the unit. */
  city: City;
  /** list of cleaning supervisors of the building */
  cleaningSupervisors: Array<User>;
  /** Country of the building */
  country: Scalars["String"];
  /** Country code of the building */
  countryCode: Scalars["String"];
  /** A list of cleaning accessible spaces in the building */
  cufSpaces: Array<CufSpace>;
  /** Total number of units with dishwashers in the object */
  dishwasherCount: Scalars["Int"];
  /** Display Name */
  displayName?: Maybe<Scalars["String"]>;
  essentialsClosetApartmentCount: Scalars["Int"];
  essentialsClosetHotelCount: Scalars["Int"];
  essentialsClosetTotalCount: Scalars["Int"];
  /** whether breakfast is freely available or not */
  freeBreakfast: Scalars["Boolean"];
  /** Full address of the building, including City and State */
  fullAddress: Scalars["String"];
  /** Full address of the building, including City, State and Postal Code */
  fullAddressWithPostalCode: Scalars["String"];
  /** Instructions for taking out garbage */
  garbageInformation?: Maybe<Scalars["String"]>;
  /** A list of guest accessible spaces in the building */
  guestSpaces: Array<GuestSpace>;
  /** Building ID */
  id: Scalars["String"];
  /** Internal ref of the building */
  internalRef: Scalars["String"];
  /** Intrastay cleaning config information for the building. */
  intrastayCleaningConfig?: Maybe<IntrastayCleaningConfig>;
  /** Total kitchen count of the object */
  kitchenCount: Scalars["Int"];
  /** Latitude of the building location. */
  latitude: Scalars["Float"];
  /** Longitude of the building location. */
  longitude: Scalars["Float"];
  /** Instructions for receiving mail */
  mailInstructions?: Maybe<Scalars["String"]>;
  /**
   * [DEPRECATED] If building has mobile keys enabled
   * @deprecated Rely on presence of mobile_key_email or mobile_key_type on InquiryAccess instead
   */
  mobileKeysEnabled: Scalars["Boolean"];
  /** Name */
  name: Scalars["String"];
  /** Postal code of the building */
  postalCode: Scalars["String"];
  /** the property reference reference. eventually this is going to replace internal-ref */
  propertyRef?: Maybe<Scalars["String"]>;
  /** Instructions for handling recycling */
  recyclingInformation?: Maybe<Scalars["String"]>;
  /** whether the building requires a background check */
  requiresBackgroundCheck?: Maybe<Scalars["Boolean"]>;
  /** Short internal ref, strips out the city code */
  shortInternalRef: Scalars["String"];
  /** Total sleep count of the object */
  sleepCount: Scalars["Int"];
  /** State code of the building */
  stateCode: Scalars["String"];
  /** Luggage storage locations */
  storageLocations: Array<CufStorageLocation>;
  /** Address of the building, excluding City and State */
  streetAddress: Scalars["String"];
  /** Timezone this building occupies */
  timezone: Scalars["String"];
  /** Count of units */
  totalUnitCount: Scalars["Int"];
  /** Town of the building */
  town: Scalars["String"];
  /** return list of Units in the building */
  unitConnections: UnitConnections;
  /** Count of live units, determined using life_status complete and bookable_at in the past */
  unitCount: Scalars["Int"];
  /** Total of each types of units of the objects. Possible values are 'Hotel, 1BR, 2BR, etc' */
  unitTypeCount?: Maybe<UnitTypeCounts>;
  /** Total number of units with washing machines in the object */
  washerCount: Scalars["Int"];
};

export type BuildingTotalUnitCountArgs = {
  live?: InputMaybe<Scalars["Boolean"]>;
};

export type BuildingUnitConnectionsArgs = {
  filter?: InputMaybe<BuildingUnitFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Array<UnitSortInput>>;
};

export type BuildingCollectionsAvailability = {
  collections: Array<CollectionInfoAndAvailability>;
  filters: CollectionsFilter;
};

export type BuildingConnections = {
  /** The list of buildings */
  buildings: Array<Building>;
  /** cursor */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records. */
  hasMore?: Maybe<Scalars["Boolean"]>;
  /** How many items total. */
  total: Scalars["Int"];
};

/** Building filters params */
export type BuildingFilterInput = {
  /** Only load buildings with non-dead units */
  activeOnly?: InputMaybe<Scalars["Boolean"]>;
  /** [DEPRECATED] building's city id */
  city?: InputMaybe<Scalars["ID"]>;
  /** City ids */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Building IDs */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Building internal_refs */
  internalRefs?: InputMaybe<Array<Scalars["String"]>>;
};

export type BuildingListing = {
  accessibilityInfo: Array<Scalars["String"]>;
  amenities: Array<Amenity>;
  brandSegment?: Maybe<Scalars["String"]>;
  buildingAddress: Scalars["String"];
  buildingName: Scalars["String"];
  buildingPhotos: Array<Photo>;
  cityName: Scalars["String"];
  contactEmailLtr: Scalars["String"];
  contactEmailStr: Scalars["String"];
  countryCode: Scalars["String"];
  countryName: Scalars["String"];
  currency: Scalars["String"];
  displayPriceRaw: Scalars["Int"];
  downtownDrivingInfo?: Maybe<Scalars["String"]>;
  featuredPhotos: Array<Photo>;
  geocode: GeoCoordinates;
  homeTruths?: Maybe<Scalars["String"]>;
  houseRules: Array<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  isHotel?: Maybe<Scalars["Boolean"]>;
  location: Scalars["String"];
  neighborhoodContent?: Maybe<Scalars["String"]>;
  neighborhoodDescription?: Maybe<Scalars["String"]>;
  neighborhoodName?: Maybe<Scalars["String"]>;
  neighborhoodTags: Array<Scalars["String"]>;
  parkingInfo: Array<Scalars["String"]>;
  photos: Array<Photo>;
  publicTransportationInfo?: Maybe<Scalars["String"]>;
  ratingAverage?: Maybe<Scalars["Float"]>;
  ratingState?: Maybe<Scalars["String"]>;
  ratingTotal?: Maybe<Scalars["Int"]>;
  shortDescription?: Maybe<Scalars["String"]>;
  stateCode?: Maybe<Scalars["String"]>;
  stateName: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
  topAmenities: Array<Amenity>;
  tripadvisorAward?: Maybe<TripadvisorAward>;
  url: Scalars["String"];
};

export type BuildingMapFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type BuildingPhase = Node & {
  /** Phase abatement */
  abatement?: Maybe<Scalars["Int"]>;
  /** Phase abatement doc url */
  abatementDocUrl?: Maybe<Scalars["String"]>;
  /** Flag for whether the phase abatement is finalized */
  abatementFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase bookable date */
  bookableDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase bookable date is finalized */
  bookableDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase construction/renovation start date */
  constructionStartDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase construction start date is finalized */
  constructionStartDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase construction status */
  constructionStatus?: Maybe<Scalars["String"]>;
  /** Phase early access date */
  earlyAccessDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase early access date is finalized */
  earlyAccessDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase FF&E need by date */
  ffeNeedByDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Phase handover date */
  handoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase handover date is finalized */
  handoverDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Does the phase have have a valid handover date? */
  handoverDateValid?: Maybe<Scalars["Boolean"]>;
  /** Phase handover doc url */
  handoverDocUrl?: Maybe<Scalars["String"]>;
  /** Phase handover reason */
  holdReason?: Maybe<Scalars["String"]>;
  /** Phase lifecycle id */
  id: Scalars["ID"];
  /** Phase ID brief submission date */
  idBriefSubmissionDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase id brief submission date is finalized */
  idBriefSubmissionDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase lcd revised date */
  lcdRevisedDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase lcd revised date is finalized */
  lcdRevisedDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Does the phase have have a valid lcd revised date? */
  lcdRevisedDateValid?: Maybe<Scalars["Boolean"]>;
  /** Phase listings date */
  listingsDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Phase openings complete date */
  openingsCompleteDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase openings complete date is finalized */
  openingsCompleteDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Does the phase have have a valid openings complete date? */
  openingsCompleteDateValid?: Maybe<Scalars["Boolean"]>;
  /** Phase punch date */
  punchDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase punch date is finalized */
  punchDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Total burn */
  totalBurn?: Maybe<Scalars["Int"]>;
  /** Total unplanned burn */
  totalUnplannedBurn?: Maybe<Scalars["Int"]>;
  /** Phase's unit count */
  unitCount?: Maybe<Scalars["Int"]>;
};

/** Building phase summaries params */
export type BuildingPhaseSummariesInput = {
  /** Filter by building ref */
  buildingRef?: InputMaybe<Scalars["String"]>;
  /** Filter by city names */
  city?: InputMaybe<Array<Scalars["String"]>>;
  /** Flag to include live units */
  includeLive?: InputMaybe<Scalars["Boolean"]>;
  /** Filter by regions */
  region?: InputMaybe<Array<Scalars["String"]>>;
  /** Filter by Sr BOPM associated with the building project */
  srBopm?: InputMaybe<Scalars["ID"]>;
};

export type BuildingPhaseSummary = Node & {
  /** Building project asana link */
  asanaLink?: Maybe<Scalars["String"]>;
  /** Average burn */
  averageBurn?: Maybe<Scalars["Int"]>;
  /** Burn comments */
  burnComments?: Maybe<Scalars["String"]>;
  /** List of burn reasons */
  burnReasons?: Maybe<Array<Scalars["String"]>>;
  /** Building's city */
  city: Scalars["String"];
  /** Building project gdrive link */
  gdriveLink?: Maybe<Scalars["String"]>;
  /** Do all of the building's phases have valid handover dates? */
  handoverDateValid?: Maybe<Scalars["Boolean"]>;
  /** Do all of the building's phases with finalized handover_date also have  non-null handover doc urls? */
  handoverFinalDocValid?: Maybe<Scalars["Boolean"]>;
  /** IA burn */
  iaBurn?: Maybe<Scalars["Int"]>;
  /** Building id */
  id: Scalars["ID"];
  /** Building's internal ref */
  internalRef: Scalars["String"];
  /** Do all of the building's phases have valid lcd revised dates? */
  lcdRevisedDateValid?: Maybe<Scalars["Boolean"]>;
  /** Max bookable date */
  maxBookableDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Max early access date */
  maxEarlyAccessDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Max handover date */
  maxHandoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Max lcd revised date */
  maxLcdRevisedDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Max openings complete date */
  maxOpeningsCompleteDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Minimum bookable date */
  minBookableDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Minimum early access date */
  minEarlyAccessDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Minimum handover date */
  minHandoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Minimum lcd revised date */
  minLcdRevisedDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Minimum openings complete date */
  minOpeningsCompleteDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Do all of the building's phases have valid openings complete dates? */
  openingsCompleteDateValid?: Maybe<Scalars["Boolean"]>;
  /** Phase count for the building */
  phaseCount?: Maybe<Scalars["Int"]>;
  /** DateTime of the last update for the building project */
  projectLastUpdated?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Building's region */
  region?: Maybe<Scalars["String"]>;
  /** Total unplanned burn */
  totalUnplannedBurn?: Maybe<Scalars["Int"]>;
  /** Unit count for the building */
  unitCount?: Maybe<Scalars["Int"]>;
  /** Units without phase count for the building */
  unitsWithoutPhaseCount?: Maybe<Scalars["Int"]>;
};

export type BuildingPhases = Node & {
  id: Scalars["ID"];
  /** Building phase lifecycles */
  phases: Array<BuildingPhase>;
  /** Count of units without a phase */
  unitsWithoutPhaseCount?: Maybe<Scalars["Int"]>;
};

/** Building phases params */
export type BuildingPhasesInput = {
  /** Building id */
  buildingId: Scalars["ID"];
  /** Flag to include live units */
  includeLive?: InputMaybe<Scalars["Boolean"]>;
};

export type BuildingProject = Node & {
  /** Project Asana link */
  asanaLink?: Maybe<Scalars["String"]>;
  /** Building opening project manager of the deal. */
  bopm?: Maybe<User>;
  /** Building associated with the project */
  building: Building;
  /** Burn comments */
  burnComments?: Maybe<Scalars["String"]>;
  /** List of burn reason */
  burnReasons?: Maybe<Array<Scalars["String"]>>;
  /** Comments */
  comments?: Maybe<Scalars["String"]>;
  /** Development manager of the building project */
  dm?: Maybe<User>;
  /** Project google drive link */
  gdriveLink?: Maybe<Scalars["String"]>;
  /** Project investment analysis forecasted burn */
  iaBurn?: Maybe<Scalars["Int"]>;
  /** Building project id */
  id: Scalars["ID"];
  /** Interior design manager of the deal. */
  idm?: Maybe<User>;
  /** Landlord contact email */
  landlordEmail?: Maybe<Scalars["String"]>;
  /** Landlord entity name */
  landlordEntity?: Maybe<Scalars["String"]>;
  /** Landlord contact name */
  landlordName?: Maybe<Scalars["String"]>;
  /** Landlord contact phone */
  landlordPhone?: Maybe<Scalars["String"]>;
  /** Lease deals associated with this building */
  leaseDeals?: Maybe<Array<LeaseDeal>>;
  /** Directus lease documents associated with the building */
  leaseDocuments?: Maybe<Array<DirectusLeaseDocument>>;
  /** Project lease execution date */
  leaseExecutionDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Project lease handover date */
  leaseHandoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Project lease onboarding access period */
  leaseOap?: Maybe<Scalars["Int"]>;
  /** Project lease visual inspection period */
  leaseVip?: Maybe<Scalars["Int"]>;
  /** Project type */
  projectType?: Maybe<Scalars["String"]>;
  /** Project scope */
  scope?: Maybe<Scalars["String"]>;
  /** Project unit arrangement */
  unitArrangement?: Maybe<Scalars["String"]>;
  /** Project underwriting model spreadsheet link */
  uwLink?: Maybe<Scalars["String"]>;
};

/** Building project filter params */
export type BuildingProjectFilterInput = {
  /** Building ID */
  buildingId: Scalars["ID"];
};

/** Building project update params */
export type BuildingProjectInput = {
  /** Project Asana link */
  asanaLink?: InputMaybe<Scalars["String"]>;
  /** Building opening project manager id */
  bopmId?: InputMaybe<Scalars["ID"]>;
  /** Project burn comments */
  burnComments?: InputMaybe<Scalars["String"]>;
  /** Project burn reason */
  burnReasons?: InputMaybe<Array<Scalars["String"]>>;
  /** Project comments */
  comments?: InputMaybe<Scalars["String"]>;
  /** Dev manager id */
  dmId?: InputMaybe<Scalars["ID"]>;
  /** Project google drive link */
  gdriveLink?: InputMaybe<Scalars["String"]>;
  /** Project investment analysis forecasted burn */
  iaBurn?: InputMaybe<Scalars["Int"]>;
  /** Building project ID */
  id: Scalars["ID"];
  /** Interior design manager id */
  idmId?: InputMaybe<Scalars["ID"]>;
  /** Landlord contact email */
  landlordEmail?: InputMaybe<Scalars["String"]>;
  /** Landlord entity name */
  landlordEntity?: InputMaybe<Scalars["String"]>;
  /** Landlord contact name */
  landlordName?: InputMaybe<Scalars["String"]>;
  /** Landlord contact phone */
  landlordPhone?: InputMaybe<Scalars["String"]>;
  /** Project lease execution date */
  leaseExecutionDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Project lease handover date */
  leaseHandoverDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Project lease onboarding access period */
  leaseOap?: InputMaybe<Scalars["Int"]>;
  /** Project lease visual inspection period */
  leaseVip?: InputMaybe<Scalars["Int"]>;
  /** Project type */
  projectType?: InputMaybe<Scalars["String"]>;
  /** Project scope */
  scope?: InputMaybe<Scalars["String"]>;
  /** Project unit arrangement */
  unitArrangement?: InputMaybe<Scalars["String"]>;
  /** Project underwriting model spreadsheet link */
  uwLink?: InputMaybe<Scalars["String"]>;
};

/** Building search filters params */
export type BuildingSearchFilterInput = {
  /** Building city IDs */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
};

/** Sort by column */
export type BuildingSortInput = {
  column: UnitSortColumn;
  order: SortAscDesc;
};

/** units input filter inside of buildings query */
export type BuildingUnitFilterInput = {
  /** unit ids */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type CalendarAvailability = {
  checkinAvailable: Scalars["Boolean"];
  date: Scalars["String"];
  minimumStayLength: Scalars["Int"];
};

/** Autogenerated return type of CancelEciLcoRequest. */
export type CancelEciLcoRequestPayload = {
  inquiry: Inquiry;
};

/** Autogenerated return type of CancelIntrastayClean. */
export type CancelIntrastayCleanPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of CancelParkingReservation. */
export type CancelParkingReservationPayload = {
  success: Scalars["Boolean"];
};

/** Autogenerated return type of CancelPendingAlteration. */
export type CancelPendingAlterationPayload = {
  inquiry: Inquiry;
};

/** Autogenerated return type of CancelRelocation. */
export type CancelRelocationPayload = {
  /** Relocation request */
  relocationRequest: RelocationRequest;
};

export type CancellationEligibility = {
  /** The reason a booking is not eligible for cancellation. */
  ineligibleReason?: Maybe<IneligibleForCancellationReason>;
  /** A flag indicating whether or not the booking can be cancelled. */
  isEligible: Scalars["Boolean"];
  /** The url of the OTA that guests need cancel their booking with. */
  otaLink?: Maybe<Scalars["String"]>;
};

export type CancellationInfo = {
  cancellationPolicy: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  priceFormula?: Maybe<PriceFormula>;
};

export type CancellationPayload = Node & {
  id: Scalars["ID"];
  /** The percentage of the cost of the reservation that can be refunded. */
  refundPercentage: Scalars["Float"];
  /** A list of all the refunds for this cancellation. */
  refunds: Array<Refund>;
};

export type CardDetails = {
  brand: Scalars["String"];
  expMonth: Scalars["Int"];
  expYear: Scalars["Int"];
  last4: Scalars["String"];
};

export enum ChangeReason {
  BookingCancelled = "booking_cancelled",
  BookingStayChanged = "booking_stay_changed",
  BookingStayDiscarded = "booking_stay_discarded",
  CompanyChanged = "company_changed",
  Eci = "eci",
  Eco = "eco",
  GuestDeclined = "guest_declined",
  InquiryExtension = "inquiry_extension",
  InquiryNotBooked = "inquiry_not_booked",
  InquiryReduction = "inquiry_reduction",
  InquiryRelocation = "inquiry_relocation",
  Lco = "lco",
  NewBooking = "new_booking",
  NotWithinCleanCreationCutoffTime = "not_within_clean_creation_cutoff_time",
  ReasonUnknown = "reason_unknown",
  RestoredCheckOut = "restored_check_out",
  SetToDefaultCleaningWindow = "set_to_default_cleaning_window",
  StayoverCleaningNotSupported = "stayover_cleaning_not_supported",
  SyncWithTom = "sync_with_tom",
  UnitMismatch = "unit_mismatch",
  UnitNotAssigned = "unit_not_assigned",
  User = "user",
}

export type ChangedBeds = {
  /** The number of different california beds we have changed in the past x days */
  california?: Maybe<Scalars["Int"]>;
  /** The number of different double beds we have changed in the past x days */
  double?: Maybe<Scalars["Int"]>;
  /** The number of different king beds we have changed in the past x days */
  king?: Maybe<Scalars["Int"]>;
  /** The number of different queen beds we have changed in the past x days */
  queen?: Maybe<Scalars["Int"]>;
  /** The number of different single beds we have changed in the past x days */
  single?: Maybe<Scalars["Int"]>;
  /** The number of sofa beds changed */
  sofaBed?: Maybe<Scalars["Int"]>;
};

export type ChangedTagMetadata = Node & {
  id: Scalars["ID"];
  /** affected tom tag. */
  tag: TomTag;
};

/** Autogenerated return type of ChargeGroup. */
export type ChargeGroupPayload = {
  /** It will always return true, if not, it will raise an error. */
  success: Scalars["Boolean"];
};

export type CheckInCheckOutInfo = {
  /** Inquiry or LeaseInquiry that is checking in today (if any) */
  checkInToday?: Maybe<Booking>;
  /** Inquiry or LeaseInquiry that is checking out today (if any) */
  checkOutToday?: Maybe<Booking>;
  /** If this unit is fully vacant today */
  isVacantAllDayToday: Scalars["Boolean"];
  /** Inquiry or LeaseInquiry that is occupying the full day today (if any) */
  occupiedByToday?: Maybe<Booking>;
};

export type CheckInState = {
  idVerification?: Maybe<IdVerification>;
  paymentVerification?: Maybe<PaymentVerification>;
  personalInfoVerification?: Maybe<PersonalInfoVerification>;
  phoneVerification?: Maybe<PhoneVerification>;
};

export type CheckOutInstructionsFeedItem = Node & {
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type ChecklistItem = Node & {
  /** `true` if the task is completed and the check passed. Null if not complete. */
  checkPassed?: Maybe<Scalars["Boolean"]>;
  /** The parent cleaning for this checklist item. */
  cleaning: Cleaning;
  /** Scheduled start time. */
  completedAt?: Maybe<Scalars["RFC3339DateTime"]>;
  id: Scalars["ID"];
  /** Images submitted by the HK for this item. */
  images: Array<Image>;
  /** Instructions on how to complete this checklist task. */
  instructions?: Maybe<Scalars["String"]>;
  /** Name of the checklist item. */
  name: Scalars["String"];
  /** Notes/issues reported by the HK for this item. */
  notes?: Maybe<Scalars["String"]>;
  /** Number of the item reported by the HK. */
  reportedQuantity?: Maybe<Scalars["Int"]>;
  /** `true` if photo(s) are required to complete the task. */
  requirePhotos: Scalars["Boolean"];
  /** Type of TOM task to reported for this issue. */
  tomTaskType: Scalars["String"];
  /** Internal type of the checklist item (ie `Hk::ChecklistItems::StockItem`). */
  type: Scalars["String"];
};

export enum ChecklistItemStatus {
  Active = "active",
  Completed = "completed",
  Deleted = "deleted",
}

export type CheckoutCountPerUnit = {
  /** The number of checkouts for this unit in the given time period */
  checkoutCount: Scalars["Int"];
  /** Internal ref of unit */
  internalRef: Scalars["String"];
};

/** Filter for CheckoutCountPerUnit query */
export type CheckoutCountPerUnitFilterInput = {
  /** City ID. All units from that city with checkouts between start_date and end_date will be included. */
  cityId: Scalars["ID"];
  /** End date of the range (inclusive) */
  endDate: Scalars["ISO8601Date"];
  /** Start date of the range (inclusive) */
  startDate: Scalars["ISO8601Date"];
};

export type CheckoutDetailsInfo = {
  pricingPlans?: Maybe<Array<PricingPlan>>;
  productDetails?: Maybe<ProductDetails>;
};

export type CheckoutInquiry = {
  guestInfo: GuestInfo;
  inquiryId: Scalars["Int"];
  invoiceInfo: OrderableInvoiceInfo;
  /** An inquiry is unavailable if it isn't chargeable */
  isUnavailable: Scalars["Boolean"];
  /** The URL for the listing the inquiry is made for */
  listingUrl: Scalars["String"];
  loyaltyInfos?: Maybe<Array<LoyaltyInfo>>;
  ltsInfo: LtsInfo;
  paymentInfo: PaymentInfo;
  productInfo: ProductInfo;
};

export type CheckoutInvoice = {
  appliedPromoCodes: Array<Scalars["String"]>;
  invoiceInfo: InvoiceInfo;
  promoError?: Maybe<Scalars["String"]>;
  rateInfo: RateInfo;
  remainingUnitsCount?: Maybe<Scalars["Int"]>;
};

export type CheckoutProcess = {
  actionDetails?: Maybe<Scalars["String"]>;
  authError?: Maybe<Scalars["String"]>;
  authResultAvailable: Scalars["Boolean"];
  authSuccess?: Maybe<Scalars["Boolean"]>;
  jwt?: Maybe<Scalars["String"]>;
  paymentGateway?: Maybe<PaymentGateway>;
  paymentIntentClientSecret?: Maybe<Scalars["String"]>;
  redirectUri?: Maybe<Scalars["String"]>;
  status: CheckoutProcessStatus;
  trackingInfo?: Maybe<Scalars["JSON"]>;
};

export enum CheckoutProcessStatus {
  Completed = "completed",
  Error = "error",
  Processing = "processing",
  Reversing = "reversing",
}

export type Chekin = {
  /** Indicate whether ID verification is enabled or not */
  idvEnabled?: Maybe<Scalars["Boolean"]>;
  /** Chekin registration link per booking */
  registrationLink?: Maybe<Scalars["String"]>;
  /** Indicate whether ID verification is required for all guests or not */
  requiredForAllGuests?: Maybe<Scalars["Boolean"]>;
  /** Indicate the type of ID verification required */
  verificationType?: Maybe<Scalars["String"]>;
};

export type City = {
  /** Abbreviation of the city. */
  abbreviation: Scalars["String"];
  /** Total bath count of the object for inventory ordering */
  bathCount: Scalars["Float"];
  /** Flat list of beds in all units in the object */
  beds?: Maybe<ChangedBeds>;
  /** Total number of different buildings those units are part of. */
  buildingCount: Scalars["Int"];
  /** Buildings in the city */
  buildings: Array<Building>;
  /** Image used for in-app cities component */
  cityOptionImage?: Maybe<Scalars["String"]>;
  /** New tag visibility on in-app cities component */
  cityOptionNewTag?: Maybe<Scalars["Boolean"]>;
  /** Display ordering in in-app cities component */
  cityOptionOrder?: Maybe<Scalars["Int"]>;
  /** Hex color for the city. */
  color: Scalars["String"];
  /** Country in which this city exists */
  country: Scalars["String"];
  /** 3-char currency code used by the city */
  currency: Currency;
  /**
   * City's default storage location
   * @deprecated This field returns old StorageLocations
   */
  defaultStorageLocation?: Maybe<StorageLocation>;
  /** Description of the city */
  description?: Maybe<Scalars["String"]>;
  /** Total number of units with dishwashers in the object */
  dishwasherCount: Scalars["Int"];
  essentialsClosetApartmentCount: Scalars["Int"];
  essentialsClosetHotelCount: Scalars["Int"];
  essentialsClosetTotalCount: Scalars["Int"];
  /** Marketing image used for booking jumping-off points */
  homeImage?: Maybe<Scalars["String"]>;
  /** Unique identifier of the city. */
  id: Scalars["String"];
  /** Total kitchen count of the object */
  kitchenCount: Scalars["Int"];
  /** Whether or not Lyft operates in this city */
  lyftSupported: Scalars["Boolean"];
  /** Name of the city. */
  name: Scalars["String"];
  /** City's service partnerships */
  servicePartners: Array<ServicePartner>;
  /** Total sleep count of the object */
  sleepCount: Scalars["Int"];
  /** Timezone of the city */
  timezone?: Maybe<Scalars["String"]>;
  /** Whether or not Uber operates in this city */
  uberSupported: Scalars["Boolean"];
  /** Total of each types of units of the objects. Possible values are 'Hotel, 1BR, 2BR, etc' */
  unitTypeCount?: Maybe<UnitTypeCounts>;
  /** Total number of units with washing machines in the object */
  washerCount: Scalars["Int"];
};

/** Autogenerated return type of ClaimGiftCard. */
export type ClaimGiftCardPayload = {
  response: BaseResponse;
};

export type Clean = {
  paymentStatus?: InputMaybe<PaymentStatus>;
  reasonForManualCompletion?: InputMaybe<ReasonForManualCompletion>;
};

export type CleanActivity = Node &
  UserNotificationResource & {
    /** When the activity was created. */
    activityTime: Scalars["RFC3339DateTime"];
    /** type of activity. */
    activityType: Scalars["String"];
    /** creator of the activity. */
    author?: Maybe<User>;
    /** the body of the activity to be used in user notification. */
    body: Scalars["String"];
    /** cleaning request that activity belongs to. */
    cleaningRequest: CleaningRequest;
    /** ID of the resource */
    id: Scalars["ID"];
    /** indicates if the activity is still relevant or not. */
    obsolete?: Maybe<Scalars["Boolean"]>;
    /** the reason for activity creation. */
    reason: ChangeReason;
    /** status of the clean in the shuffling. */
    shuffleStatus?: Maybe<CleanShuffleDetailStatus>;
    /** the title of the activity to used in user notification. */
    title: Scalars["String"];
    /** creator of the activity. */
    user?: Maybe<User>;
  };

export enum CleanShuffleDetailStatus {
  Failed = "failed",
  NotChanged = "not_changed",
  Successful = "successful",
}

export type Cleaning = {
  /** Cleaning access instructions */
  accessInstructions?: Maybe<AccessInstructions>;
  /** Actual cleaning end. */
  actualEnd?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Actual cleaning end. */
  actualEndInLocalTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Actual cleaning end time. */
  actualStart?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Scheduled start time. */
  actualStartInLocalTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** the employees who this clean is assigned to. */
  assignees?: Maybe<Array<User>>;
  /** List of tasks associated with this cleaning. */
  checklistItems: Array<ChecklistItem>;
  /** Unique ID of the cleaning. */
  id: Scalars["ID"];
  /** Whether this is a mid-stay cleaning, which means the guest is expected to be in the unit. */
  midStay: Scalars["Boolean"];
  /** Notes on cleaning from Sonder. */
  noteFromAdmin?: Maybe<Scalars["String"]>;
  /** Notes on cleaning from the team admin. */
  noteFromCompany?: Maybe<Scalars["String"]>;
  /** Whether there is a check in on the same day of the cleaning. */
  sameDayTurnover: Scalars["Boolean"];
  /** Scheduled end time. */
  scheduledEnd?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Scheduled start time. */
  scheduledStart?: Maybe<Scalars["RFC3339DateTime"]>;
};

export type CleaningCompany = Node & {
  /** The active flag of the cleaning company */
  active: Scalars["Boolean"];
  /** Address of the cleaning company */
  address?: Maybe<Scalars["String"]>;
  /** Units assigned to the cleaning company */
  assignedUnits: Array<Unit>;
  /** The city. */
  city?: Maybe<City>;
  /** Employees associated with the cleaning company */
  employees?: Maybe<Array<Employee>>;
  /** General unit cleaning pricing overrides associated with the cleaning company */
  generalUnitCleaningPricing?: Maybe<Array<GeneralUnitCleaningPricing>>;
  id: Scalars["ID"];
  /** Individual unit cleaning pricing associated with the cleaning company */
  individualUnitCleaningPricing?: Maybe<Array<IndividualUnitCleaningPricing>>;
  /** Whether the cleaning company is internal */
  isInternal: Scalars["Boolean"];
  /** Manager of the cleaning company */
  manager?: Maybe<User>;
  /** Minimum number of photos required for cleaning completion */
  minPhotosRequiredForCleaningCompletion?: Maybe<Scalars["Int"]>;
  /** The name of the cleaning company */
  name: Scalars["String"];
  /** Phone number of the cleaning company */
  phone?: Maybe<Scalars["String"]>;
  /** The status of the cleaning company */
  status: Scalars["String"];
  /** The status of the cleaning company */
  statusLocalized: Scalars["String"];
};

/** Cleaning Company filters params */
export type CleaningCompanyFilterInput = {
  /** Filter by company status (archived / active) */
  active?: InputMaybe<Scalars["Boolean"]>;
  /** [DEPRECATED] Filter companies by city */
  cityId?: InputMaybe<Scalars["ID"]>;
  /** Filter companies by cities */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter fake companies */
  filterFakeCompanies?: InputMaybe<Scalars["Boolean"]>;
  /** Filter by cleaning company ids */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter companies based on their name */
  searchTerm?: InputMaybe<Scalars["String"]>;
};

export type CleaningPrice = Node & {
  /** Currency */
  currency: Currency;
  id: Scalars["ID"];
  /** Cleaning price */
  price: Scalars["Float"];
};

export type CleaningRequest = {
  /** The booking associated with the Cleaning Request. */
  booking?: Maybe<Booking>;
  /** Cleaning request category. */
  category?: Maybe<CleaningRequestCategory>;
  /** Cleaning associated with this cleaning request. */
  cleaning?: Maybe<Cleaning>;
  /** The estimated duration of the cleaning. */
  cleaningDuration?: Maybe<Scalars["Int"]>;
  /** The Cleaning Company associated */
  company?: Maybe<CleaningCompany>;
  /** Cleaning cost */
  cost?: Maybe<Scalars["Float"]>;
  /** Cleaning request cost adjustment */
  costAdjustment?: Maybe<HkCleaningRequestCostAdjustment>;
  /** Currency */
  currency?: Maybe<Scalars["String"]>;
  /** Scheduled end time. */
  endAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Unique ID of the cleaning. */
  id: Scalars["ID"];
  /** returns if the previous same-day check_in booking is late check-out or not */
  isSameDayCheckInBookingEci?: Maybe<Scalars["Boolean"]>;
  /** returns if the previous same-day check_in booking is late check-out or not */
  isSameDayCheckOutBookingLco?: Maybe<Scalars["Boolean"]>;
  /** Prep kit for the cleaning request. */
  prepKit?: Maybe<PrepKit>;
  /** the next booking if it is same-day check_out */
  sameDayCheckInBooking?: Maybe<Booking>;
  /** the previous booking if it is same-day check_in */
  sameDayCheckOutBooking?: Maybe<Booking>;
  /** indicates if the last scheduling activity has been done by clean shuffler or not. */
  shuffled: Scalars["Boolean"];
  /** The common space to be cleaned. */
  space?: Maybe<CufSpace>;
  /** Scheduled start time. */
  startAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Cleaning status information */
  status: CleaningRequestStatus;
  /** The unit to be cleaned. */
  unit?: Maybe<Unit>;
};

export enum CleaningRequestCategory {
  Checkout = "checkout",
  CheckoutPlus = "checkout_plus",
  CustomCheckout = "custom_checkout",
  CustomCheckoutPlus = "custom_checkout_plus",
  Deep = "deep",
  Intrastay = "intrastay",
  ReClean = "re_clean",
  SetUp = "set_up",
  SpaceClean = "space_clean",
  Stayover = "stayover",
  TouchUpTurnover = "touch_up_turnover",
}

export type CleaningRequestConnections = {
  /** The list of cleaning requests. */
  cleaningRequests: Array<CleaningRequest>;
  /** Index-based position of the search. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records? */
  hasMore: Scalars["Boolean"];
  /** Total number of cleaning requests. */
  total: Scalars["Int"];
};

/** Cleaning Request input filters */
export type CleaningRequestFilterInput = {
  /** filter by actual end at date range */
  actualEndAtFrom?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** filter by actual end at date range */
  actualEndAtTo?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** filter by building id */
  buildingIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** filter by city id */
  cityId: Scalars["String"];
  /** filter by cleaning request category */
  cleanCategories?: InputMaybe<Array<CleaningRequestCategory>>;
  /** filter by cleaning request status */
  cleanStatuses?: InputMaybe<Array<CleaningRequestStatus>>;
  /**
   * filter by assigned company id. If passed nil or [], only return cleaning
   * requests withno company assigned. If not passed, return all cleaning requests
   * for all companies includingthose that do not have a company assigned.
   */
  companyIds?: InputMaybe<Array<Scalars["String"]>>;
  /** filter by cost approval status */
  costApprovalStatuses?: InputMaybe<Array<Scalars["String"]>>;
  /** filter by end at date range */
  endAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** filter by internal or external company */
  isInternal?: InputMaybe<Scalars["Boolean"]>;
  /** filter by start at date range */
  startAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
};

export enum CleaningRequestStatus {
  /** The clean request is cancelled */
  Cancelled = "cancelled",
  /** After the clean request has been fulfilled */
  Completed = "completed",
  /** When the clean request is neither confirmed nor cancelled */
  Pending = "pending",
  /** The clean request is accepted */
  Scheduled = "scheduled",
}

export enum CleaningWindow {
  /** Cleaning window from 12:00 to 15:00 */
  EarlyAfternoon = "early_afternoon",
  /** Cleaning window from 15:00 to 18:00 */
  LateAfternoon = "late_afternoon",
  /** Cleaning window from 09:00 to 12:00 */
  Morning = "morning",
}

/** Client/Device Info */
export type ClientInfoInput = {
  inEu: Scalars["Boolean"];
};

export type Collection = Node & {
  id: Scalars["ID"];
  /** Primary unit of the collection. Used for default pictures, description, etc */
  primaryUnit?: Maybe<Unit>;
};

export type CollectionInfoAndAvailability = {
  adaAccessibilityInfo?: Maybe<AdaAccessibilityInfo>;
  amenities: Array<Amenity>;
  available?: Maybe<Scalars["Boolean"]>;
  bathroomCount: Scalars["Int"];
  bedroomCount: Scalars["Int"];
  collectionId: Scalars["ID"];
  collectionName?: Maybe<Scalars["String"]>;
  collectionType: Scalars["String"];
  displayPrice: Scalars["String"];
  displayPriceLabel: Scalars["String"];
  displayPriceRaw: Scalars["Float"];
  listingUrl: Scalars["String"];
  longTermRental: Scalars["Boolean"];
  minimumStayLength?: Maybe<Scalars["Int"]>;
  photos: Array<Photo>;
  quote?: Maybe<CollectionQuote>;
  sleepCount: Scalars["Int"];
  squareFootage: Scalars["Int"];
  viewCount: Scalars["Int"];
};

export type CollectionInvoice = {
  adr?: Maybe<Scalars["String"]>;
  contactToBookLts?: Maybe<Scalars["Boolean"]>;
  isBookingDisabled?: Maybe<Scalars["Boolean"]>;
  lineItems: Array<QuoteLineItem>;
};

export type CollectionQuote = {
  invoice: CollectionInvoice;
  originalRateLabel?: Maybe<Scalars["String"]>;
  rateLabel?: Maybe<Scalars["String"]>;
  remainingUnitsCount?: Maybe<Scalars["Int"]>;
  totalLabel?: Maybe<Scalars["String"]>;
};

export type CollectionsFilter = {
  availabilityFilter: SearchAvailabilityFilter;
  guestCountFilter: SearchGuestCountFilter;
  pricingFilter: SearchPricingFilter;
};

export type Comment = Node &
  TaskFeedItem &
  UserNotificationResource & {
    /** Any attachments for this comment. */
    attachments?: Maybe<Array<Attachment>>;
    /** author of this item */
    author?: Maybe<User>;
    /** Comment text content. */
    body: Scalars["String"];
    /** When the comment was created. */
    createdAt: Scalars["RFC3339DateTime"];
    /** When the comment was soft-deleted. */
    deletedAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** ID of the resource */
    id: Scalars["ID"];
    /** list of mentioned objects.. Users for now */
    mentions?: Maybe<AllTypesFeed>;
    /** body in rich content format. namely html for now */
    richBody?: Maybe<Scalars["String"]>;
    /** Object that the comment is referring to. */
    target?: Maybe<CommentTarget>;
    /** ID of the comment thread (task, inquiry, etc.). */
    targetId?: Maybe<Scalars["Int"]>;
    /** Type of the comment thread (task, inquiry, etc.). */
    targetType?: Maybe<Scalars["String"]>;
    /** When the comment was last updated. */
    updatedAt: Scalars["RFC3339DateTime"];
    /** User that created this comment */
    user: User;
  };

/** Interface to comment's target object */
export type CommentTarget = {
  /** ID of the resource */
  id: Scalars["ID"];
};

export enum Commentable {
  Inquiry = "inquiry",
  Task = "task",
  Unit = "unit",
}

export type ComparableOption = {
  /** The type of comparable option (full, partial, split ... ) */
  type: Scalars["String"];
  /** The unit availabilites that make up the comparable option */
  unitAvailabilities: Array<UnitAvailability>;
};

export type ComparableSearchFilter = {
  /** If multiple selections are allowed or not for the option */
  multipleAllowed?: Maybe<Scalars["Boolean"]>;
  /** The name of the parameter to return */
  paramName: Scalars["String"];
  /** The parameter value(s) to return when filled/selected/checked */
  paramValues?: Maybe<Array<ComparableSearchFilterValue>>;
  /** The type of data provided that should be returned for this search filter. (integer, string, array) */
  type: Scalars["String"];
};

export type ComparableSearchFilterValue = {
  /** The value to return when it's filled/selected/checked. */
  paramKey: Scalars["String"];
  /** The label to display for this option */
  paramValue: Scalars["String"];
  /** If the option should be selected when necessary */
  selected?: Maybe<Scalars["Boolean"]>;
};

/** Comparable Search Query */
export type ComparableSearchInput = {
  adName?: InputMaybe<Scalars["String"]>;
  bathroomsCount: Scalars["Float"];
  bedroomsCount: Scalars["Int"];
  checkInDate?: InputMaybe<Scalars["String"]>;
  filterAmenities?: InputMaybe<Array<Scalars["String"]>>;
  filterAvailabilities?: InputMaybe<Array<Scalars["String"]>>;
  filterAvailables?: InputMaybe<Scalars["String"]>;
  filterCollections?: InputMaybe<Array<Scalars["String"]>>;
  sleepsCount: Scalars["Int"];
};

/** Autogenerated return type of CompleteAutomatedRelocation. */
export type CompleteAutomatedRelocationPayload = {
  message: Scalars["String"];
  newInquiryId?: Maybe<Scalars["Int"]>;
  success: Scalars["Boolean"];
  urlNewInquiry?: Maybe<Scalars["String"]>;
};

export type ConcurrentAccessDuration = {
  /** The option can be selected */
  enabled: Scalars["Boolean"];
  /** The label to display for this concurrent access value */
  label: Scalars["String"];
  /** The number of hour of concurrent access */
  value: Scalars["Int"];
};

export type ConcurrentAccessExtendedDurationOptions = {
  /** If the concurrent access duration can be extended until the next cutoff time */
  allowed: Scalars["Boolean"];
  /** The cutoff time when the extended duration must end */
  cutoffTime: Scalars["String"];
  /** The default label to use for the dropdown menu item */
  defaultLabel: Scalars["String"];
  /** The minimum number of hours that must be given before the cutoff time */
  minimumDurationHours: Scalars["Int"];
  /** The label to display if the minimum number of hours is met */
  minimumDurationLabel: Scalars["String"];
};

export type ConcurrentAccessOptions = {
  /** The ranges of available concurrent access durations */
  durations: Array<ConcurrentAccessDuration>;
  /**
   * If the concurrent access duration can be extended
   * @deprecated Use allowed field on extended_duration_options
   */
  extendedDurationAllowed?: Maybe<Scalars["Boolean"]>;
  /**
   * The label to display if extended duration access is not allowed
   * @deprecated Use label fields on extended_duration_options
   */
  extendedDurationNotAllowedLabel?: Maybe<Scalars["String"]>;
  /** Options for extended duration concurrent access */
  extendedDurationOptions?: Maybe<ConcurrentAccessExtendedDurationOptions>;
  /**
   * If the concurrent access duration can be overnight or not
   * @deprecated Use allowed field on extended_duration_options
   */
  overnightDurationAllowed?: Maybe<Scalars["Boolean"]>;
};

/** Mobile key configuration */
export type Configuration = AssaAbloyConfiguration;

/** Autogenerated return type of ConfigureMobileKey. */
export type ConfigureMobileKeyPayload = {
  /** The mobile key configuration object */
  configuration: Configuration;
};

/** Autogenerated return type of ConfirmPaymentMethod. */
export type ConfirmPaymentMethodPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of ConfirmPhoneVerificationCode. */
export type ConfirmPhoneVerificationCodePayload = {
  response: BaseResponse;
};

/** Autogenerated return type of ConfirmRelocationProposition. */
export type ConfirmRelocationPropositionPayload = {
  /** Relocation inquiries */
  relocationInquiries: Array<Inquiry>;
  relocationRequest: RelocationRequest;
};

/** Autogenerated return type of ConfirmTemporaryRelocationProposition. */
export type ConfirmTemporaryRelocationPropositionPayload = {
  /** Relocation inquiries */
  relocationInquiries: Array<Inquiry>;
  relocationRequest: RelocationRequest;
};

export type ConfirmationBooking = {
  /** ... */
  actionables: Array<Actionable>;
  /** ... */
  cancellationInfo?: Maybe<CancellationInfo>;
  /** ... */
  chekinRegistrationLink?: Maybe<Scalars["String"]>;
  /** Contains new check-in and/or check-out times for the inquiry */
  eciLcoInfo?: Maybe<EciLcoInfo>;
  /** ... */
  guestInfo: GuestInfo;
  /** ... */
  inquiry: Inquiry;
  /** ... */
  invoiceInfo?: Maybe<InvoiceInfo>;
  /** ... */
  invoiceInfoInTargetCurrency?: Maybe<InvoiceInfo>;
  /** ... */
  orderInfo: BookingOrderInfo;
  otaGuestInfoRequired?: Maybe<Scalars["Boolean"]>;
  /** ... */
  paymentInfo?: Maybe<PaymentInfo>;
  /** ... */
  productInfo: ProductInfo;
  showWelcomeReward?: Maybe<Scalars["Boolean"]>;
  showWelcomeRewardCta?: Maybe<Scalars["Boolean"]>;
};

export type ConfirmationOrderable = {
  /** ... */
  invoiceInfo: OrderableInvoiceInfo;
  /** ... */
  orderInfo: OrderInfo;
  /** ... */
  paymentInfo?: Maybe<PaymentInfo>;
};

export type ConnectedSpacesMaintenance = {
  subType: ConnectedSpacesMaintenanceTypeEnum;
};

export enum ConnectedSpacesMaintenanceTypeEnum {
  BackupCodeRotationFailed = "backup_code_rotation_failed",
  ChangeBattery = "change_battery",
  CheckHubConnection = "check_hub_connection",
  FixLockAlignment = "fix_lock_alignment",
  LockTampered = "lock_tampered",
  ReviveDeadHub = "revive_dead_hub",
}

export type ContactUsFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Optional inquiry for localizing contact numbers */
  relatedInquiry?: Maybe<Inquiry>;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type CostarFiles = Node & {
  /** The generated CSV or S3 path of the building records */
  building?: Maybe<Scalars["String"]>;
  /** The generated CSV or S3 path of the lease expense records */
  expenses?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** The generated CSV or S3 path of the lease records */
  lease?: Maybe<Scalars["String"]>;
  /** The generated CSV or S3 path of the option charge records */
  optioncharges?: Maybe<Scalars["String"]>;
  /** The generated CSV or S3 path of the lease option records */
  options?: Maybe<Scalars["String"]>;
};

export type CountryCode = {
  alpha2: Scalars["String"];
  alpha3: Scalars["String"];
  code: Scalars["String"];
  name: Scalars["String"];
  /** nullable field for states */
  states?: Maybe<Array<State>>;
};

/** Input used to create an account with phone and address */
export type CreateAccountAsAdminInput = {
  address?: InputMaybe<AddressInput>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  phoneNumbers: Array<PhoneNumberInput>;
};

/** Autogenerated return type of CreateAccountAsAdmin. */
export type CreateAccountAsAdminPayload = {
  account: Account;
};

/** Input used to create an account */
export type CreateAccountInput = {
  dateOfBirth?: InputMaybe<Scalars["ISO8601DateTime"]>;
  discountPricingMember: Scalars["Boolean"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  marketingOptIn: Scalars["Boolean"];
  password: Scalars["String"];
};

/** Autogenerated return type of CreateAccount. */
export type CreateAccountPayload = {
  accountJwt: Scalars["String"];
  refreshJwt: Scalars["String"];
};

/** Autogenerated return type of CreateAccountWithInquiryToken. */
export type CreateAccountWithInquiryTokenPayload = {
  accountJwt: Scalars["String"];
  refreshJwt: Scalars["String"];
};

/** Input used to create an account from oauth flow */
export type CreateAccountWithOauthInput = {
  code?: InputMaybe<Scalars["String"]>;
  discountPricingMember: Scalars["Boolean"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  provider: Scalars["String"];
  uid?: InputMaybe<Scalars["String"]>;
};

/** Autogenerated return type of CreateAccountWithOauth. */
export type CreateAccountWithOauthPayload = {
  account: Account;
  accountJwt: Scalars["String"];
  refreshJwt: Scalars["String"];
};

/** Autogenerated return type of CreateAttachment. */
export type CreateAttachmentPayload = {
  attachment: Attachment;
};

export type CreateBookingBeforePaymentInput = {
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  collectionId: Scalars["String"];
  guestId: Scalars["String"];
  paymentGateway: Scalars["String"];
  ratePlanId: Scalars["String"];
};

/** Autogenerated return type of CreateCleaningRequestCostAdjustment. */
export type CreateCleaningRequestCostAdjustmentPayload = {
  cleaningRequestCostAdjustment: HkCleaningRequestCostAdjustment;
};

/** Autogenerated return type of CreateComment. */
export type CreateCommentPayload = {
  comment: Comment;
};

/** Autogenerated return type of CreateCompany. */
export type CreateCompanyPayload = {
  company: CleaningCompany;
};

/** Autogenerated return type of CreateFilter. */
export type CreateFilterPayload = {
  newSavedFilter: SavedTomFilter;
};

/** Autogenerated return type of CreateFlexLeaseInquiry. */
export type CreateFlexLeaseInquiryPayload = {
  response: BaseResponse;
};

/** Create GeneralUnitCleaningPricing input */
export type CreateGeneralUnitCleaningPricingInput = {
  bathCount: Scalars["Int"];
  bedCount: Scalars["Int"];
  cleanType: CleaningRequestCategory;
  currency: UnitCleaningPricingCurrency;
  price: Scalars["Float"];
};

/** Autogenerated return type of CreateGroupInquiry. */
export type CreateGroupInquiryPayload = {
  /** The inquiry */
  inquiry: Inquiry;
};

/** Create IndividualUnitCleaningPricing input */
export type CreateIndividualUnitCleaningPricingInput = {
  cleanType: CleaningRequestCategory;
  currency: UnitCleaningPricingCurrency;
  price: Scalars["Float"];
  unitId: Scalars["ID"];
};

/** Autogenerated return type of CreateIntrastayClean. */
export type CreateIntrastayCleanPayload = {
  response?: Maybe<CreateIntrastayCleanResponse>;
};

export type CreateIntrastayCleanResponse = {
  /** The id of the new Hk::CleaningRequest */
  cleaningRequestId?: Maybe<Scalars["ID"]>;
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
  trackingInfo?: Maybe<Scalars["JSON"]>;
};

/** Autogenerated return type of CreateItem. */
export type CreateItemPayload = {
  /** The created checklist item */
  checklistItem: TaskChecklistItem;
};

/** Autogenerated return type of CreateMiscService. */
export type CreateMiscServicePayload = {
  miscService: MiscService;
};

/** Autogenerated return type of CreateOrUpdateGuestAccount. */
export type CreateOrUpdateGuestAccountPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of CreateOrUpdateRelocationRequest. */
export type CreateOrUpdateRelocationRequestPayload = {
  relocationRequestId: Scalars["ID"];
};

/** Autogenerated return type of CreateParkingReservation. */
export type CreateParkingReservationPayload = {
  reservationId: Scalars["String"];
};

/** Input used to create a phase lifecycle */
export type CreatePhaseLifecycleInput = {
  /** phase lifecycle's latest bookable date */
  bookableLatestDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** phase lifecycle latest bookable date is final */
  bookableLatestDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** phase lifecycle's comments */
  comment?: InputMaybe<Scalars["String"]>;
  /** phase lifecycle's handover date */
  handoverDate: Scalars["RFC3339DateTime"];
  /** phase lifecycle handover date is final */
  handoverDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** phase lifecycle's lcd revised date */
  lcdRevisedDate: Scalars["RFC3339DateTime"];
  /** phase lifecycle lcd revised date is final */
  lcdRevisedDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** the phase lifecycle's lease deal */
  leaseDealId: Scalars["ID"];
  /** phase lifecycle's name */
  name?: InputMaybe<Scalars["String"]>;
  /** phase status */
  status?: InputMaybe<Scalars["String"]>;
  /** email of user making the update */
  user?: InputMaybe<Scalars["String"]>;
};

/** Autogenerated return type of CreateRelocationPropositions. */
export type CreateRelocationPropositionsPayload = {
  /** Relocation propositions */
  relocationPropositions: Array<RelocationProposition>;
  /** Relocation request */
  relocationRequest: RelocationRequest;
};

/** Autogenerated return type of CreateSubscription. */
export type CreateSubscriptionPayload = {
  success?: Maybe<Scalars["Boolean"]>;
};

/** Autogenerated return type of CreateTask. */
export type CreateTaskPayload = {
  task: Task;
};

export type CreditCardPaymentStatus = {
  requiresAction: Scalars["Boolean"];
  status: CreditCardStatus;
  statusReason?: Maybe<Scalars["String"]>;
};

export enum CreditCardStatus {
  Invalid = "INVALID",
  Valid = "VALID",
}

export type CroBuildingCollectionsAvailability = {
  collections: Array<CroCollectionInfoAndAvailability>;
  currency: Scalars["String"];
};

export type CroCheckoutInvoice = {
  appliedPromoCodes: Array<Scalars["String"]>;
  inquiry: Inquiry;
  invoiceInfo: InvoiceInfo;
  promoError?: Maybe<Scalars["String"]>;
  rateInfo: RateInfo;
  remainingUnitsCount?: Maybe<Scalars["Int"]>;
};

export type CroCollectionInfoAndAvailability = {
  adaAccessibilityInfo?: Maybe<AdaAccessibilityInfo>;
  amenities: Array<Amenity>;
  available?: Maybe<Scalars["Boolean"]>;
  bathroomCount: Scalars["Int"];
  bedCount: Scalars["Int"];
  bedroomCount: Scalars["Int"];
  buildingAddress: Scalars["String"];
  buildingAmenities: Array<Amenity>;
  buildingName: Scalars["String"];
  collectionId: Scalars["ID"];
  collectionName?: Maybe<Scalars["String"]>;
  collectionType: Scalars["String"];
  displayPrice: Scalars["String"];
  displayPriceLabel: Scalars["String"];
  displayPriceRaw: Scalars["Float"];
  listingUrl: Scalars["String"];
  longTermRental: Scalars["Boolean"];
  minimumStayLength?: Maybe<Scalars["Int"]>;
  photos: Array<Photo>;
  quote?: Maybe<CollectionQuote>;
  sleepCount: Scalars["Int"];
  squareFootage: Scalars["Int"];
  viewCount: Scalars["Int"];
};

/** Autogenerated return type of CroUpdateInquiryRatePlan. */
export type CroUpdateInquiryRatePlanPayload = {
  /** The inquiry object */
  inquiry: Inquiry;
};

/** Survey feedback input */
export type CsatFeedbackInput = {
  bookingUniqKey: Scalars["String"];
  cleanliness?: InputMaybe<Scalars["Int"]>;
  condition?: InputMaybe<Scalars["Int"]>;
  csatScore?: InputMaybe<Scalars["Int"]>;
  safety?: InputMaybe<Scalars["Int"]>;
  scoreReason?: InputMaybe<Scalars["String"]>;
  staff?: InputMaybe<Scalars["Int"]>;
};

export type CsatFeedbackResponse = {
  feedbackQuestionnaireCompleted: Scalars["Boolean"];
  rateCompleted: Scalars["Boolean"];
};

export type CufSpace = {
  /** Who can access this particular space */
  accessibleTo?: Maybe<Scalars["String"]>;
  /** Space's building */
  building: Building;
  /** Default time to clean space if no estimate exist */
  defaultCleaningMinutes: Scalars["Int"];
  /** Estimated time to clean space */
  estimatedCleaningMinutes?: Maybe<Scalars["Int"]>;
  /** The floor of the building */
  floorOfBuilding?: Maybe<Scalars["String"]>;
  /** Unique identifier */
  id: Scalars["ID"];
  /** The internal ref for the space */
  internalRef: Scalars["String"];
  /** related schedules for cuf space */
  relatedSchedules: Array<Schedule>;
  /** List of related tasks */
  relatedTasks: TaskConnections;
  /** The status of the space, can be 'active' or 'deleted' */
  status: Scalars["String"];
  /** The type of space */
  type: Scalars["String"];
};

export type CufSpaceRelatedSchedulesArgs = {
  filter?: InputMaybe<RelatedScheduleFilterInput>;
};

export type CufSpaceRelatedTasksArgs = {
  filter?: InputMaybe<CufSpaceRelatedTaskFilterInput>;
};

/** filters */
export type CufSpaceRelatedTaskFilterInput = {
  /** can pass in '-1' for tasks without assignees set */
  assignee?: InputMaybe<Array<Scalars["String"]>>;
  /** ignored if filter_triaged == new */
  dueAtEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** ignored if filter_triaged == new */
  dueAtStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  dueOrLatestEndAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  scheduledOrEarliestStartAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  status?: InputMaybe<Array<FilterStatus>>;
};

export type CufStorageLocation = {
  /** Storage location address */
  address: Address;
  /** Array of strings for guest facing text */
  guestFacingTextArray: Array<Scalars["String"]>;
  /** Unique identifier */
  id: Scalars["ID"];
  /** Storage instructions and location info */
  instructions: Scalars["String"];
  /** Display name/location */
  name: Scalars["String"];
};

export enum Currency {
  Aed = "AED",
  Cad = "CAD",
  Chf = "CHF",
  Czk = "CZK",
  Eur = "EUR",
  Gbp = "GBP",
  Ils = "ILS",
  Isk = "ISK",
  Mxn = "MXN",
  Pln = "PLN",
  Usd = "USD",
}

export enum CurrentAccountStatus {
  Guest = "guest",
  Primary = "primary",
}

export type CustomAccessCode = {
  code?: Maybe<Scalars["String"]>;
};

export type Customer = Node & {
  /** List of saved cards attached to the customer. */
  cards?: Maybe<Array<PaymentMethod>>;
  id: Scalars["ID"];
  /** Stripe's unique identifier for the Customer object. */
  stripeId: Scalars["String"];
};

/** Daily Aggregate Housekeeping Metrics */
export type DailyAggregateHousekeepingMetrics = {
  /** Count of completed cleans for the day */
  cleanCompletedCount: Scalars["Int"];
  /** Count of scheduled cleans for the day */
  cleanScheduledCount?: Maybe<Scalars["Int"]>;
  /** Count of not-created but expected check-out cleans for the day */
  cleanTbdCount?: Maybe<Scalars["Int"]>;
  /** Count of all cleans for the day */
  cleanTotalCount?: Maybe<Scalars["Int"]>;
  /** Count of unscheduled cleans for the day */
  cleanUnscheduledCount?: Maybe<Scalars["Int"]>;
  /** Local date of aggregate metrics */
  date: Scalars["ISO8601Date"];
};

/** Daily Aggregate Housekeeping Metrics input filters */
export type DailyAggregateHousekeepingMetricsFilterInput = {
  /** assignee ids */
  assignees?: InputMaybe<Array<Scalars["ID"]>>;
  /** Building ids */
  buildingIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** City ids */
  cityIds: Array<Scalars["ID"]>;
  /** Cleaning company ids */
  cleaningCompanyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Cleaning request categories */
  cleaningRequestCategories?: InputMaybe<Array<CleaningRequestCategory>>;
  /** Earliest clean start date to filter from, inclusive */
  earliestStartDateFrom: Scalars["ISO8601Date"];
  /** Latest clean start date to filter to, inclusive */
  earliestStartDateTo: Scalars["ISO8601Date"];
};

export type DailyRate = {
  amount: Scalars["Float"];
  date: Scalars["String"];
};

export enum DaysOfWeek {
  Friday = "friday",
  Monday = "monday",
  Saturday = "saturday",
  Sunday = "sunday",
  Thursday = "thursday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
}

/** Autogenerated return type of DeleteAccountData. */
export type DeleteAccountDataPayload = {
  result: DeleteAccountDataResult;
};

export type DeleteAccountDataResult = {
  /** Error message, if status is failure. */
  message?: Maybe<Scalars["String"]>;
  /** The name of the system called to remove account data. */
  name: Scalars["String"];
  /** Whether the account data was successfully removed. */
  status: Scalars["String"];
  /** Data deletion results for subsystems that this system called. */
  subsystems?: Maybe<Array<DeleteAccountDataResult>>;
};

/** Attributes for account deletion */
export type DeleteAccountInput = {
  reason?: InputMaybe<Scalars["String"]>;
};

/** Autogenerated return type of DeleteAccount. */
export type DeleteAccountPayload = {
  status: Scalars["String"];
};

/** Autogenerated return type of DeleteFilter. */
export type DeleteFilterPayload = {
  id: Scalars["String"];
  success: Scalars["String"];
};

/** Autogenerated return type of DeleteSubscription. */
export type DeleteSubscriptionPayload = {
  success: Scalars["Boolean"];
};

export enum DepositPayment {
  Adyen = "Adyen",
  Stripe = "Stripe",
}

/** Autogenerated return type of DetachPaymentMethod. */
export type DetachPaymentMethodPayload = {
  customer: Customer;
};

export type DirectusLeaseDocument = Node & {
  /** Directus lease id */
  directusId: Scalars["String"];
  /** Lease document type */
  documentType?: Maybe<Scalars["String"]>;
  /** Document execution date */
  executionDate?: Maybe<Scalars["String"]>;
  /** Document filename */
  filename?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Directus lease identifier */
  leaseRef: Scalars["String"];
};

/** Autogenerated return type of DiscardRelocationPropositions. */
export type DiscardRelocationPropositionsPayload = {
  success: Scalars["Boolean"];
};

export type DispatchRole = {
  /** Display name used by clients */
  displayName: Scalars["String"];
  /** Role name in flatbook */
  name: DispatchRoleName;
  /** Additional information about the role */
  toolTip: Scalars["String"];
};

export enum DispatchRoleName {
  CleaningAdmin = "cleaning_admin",
  HkContractor = "hk_contractor",
  HkManager = "hk_manager",
  Housekeeper = "housekeeper",
  TomManager = "tom_manager",
  TomTeamLead = "tom_team_lead",
}

export type DueAtChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New due at. */
  newDueAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Previous due at. */
  prevDueAt?: Maybe<Scalars["RFC3339DateTime"]>;
};

export type EarlyCheckIn = {
  /** Desired check-in time (HH:MM format). */
  desiredCheckInTime: Scalars["String"];
};

export type EarlyCheckInPromptFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type EarlyCheckInRequest = Node & {
  /** Time approved by city */
  approvedTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Indicates how the modification was requested */
  channel: Scalars["String"];
  /** Time the modification request was created */
  createdAt: Scalars["RFC3339DateTime"];
  /** Desired modification time indicated by guest */
  desiredTime: Scalars["RFC3339DateTime"];
  /** The ID of the Tom::EciLcoRequest request without its class name prepended */
  eciLcoRequestId: Scalars["Int"];
  id: Scalars["ID"];
  /** Current status of this request */
  status: EciLcoStatus;
};

/** How the ECI/LCO was approved */
export enum EciLcoApproval {
  AutoApprovalWithoutPayment = "AUTO_APPROVAL_WITHOUT_PAYMENT",
  AutoApprovalWithPayment = "AUTO_APPROVAL_WITH_PAYMENT",
  ManualApproval = "MANUAL_APPROVAL",
}

export type EciLcoApprovedMetadata = Node & {
  /** Approved time of the EciLco request. */
  approvedTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** The type of EciLco request. */
  eciLcoType?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type EciLcoInfo = {
  checkInChanged: Scalars["Boolean"];
  checkInDate: Scalars["String"];
  checkOutChanged: Scalars["Boolean"];
  checkOutDate: Scalars["String"];
  newCheckInTime: Scalars["String"];
  newCheckOutTime: Scalars["String"];
};

export enum EciLcoStatus {
  /** This request has been approved */
  Approved = "approved",
  /** This request has been approved, but still requires payment */
  ApprovedPendingPayment = "approved_pending_payment",
  /** This request has been cancelled */
  Cancelled = "cancelled",
  /** This request has  been missed */
  Missed = "missed",
  /** This request is still waiting for action */
  Pending = "pending",
  /** This request has been rejected */
  Rejected = "rejected",
}

export type EciLcoTime = {
  /** Is this time available */
  available: Scalars["Boolean"];
  /** Price to request changes formatted for currency */
  displayPrice?: Maybe<Scalars["String"]>;
  /** Standard price to request changes formatted for currency */
  displayStandardPrice?: Maybe<Scalars["String"]>;
  /** Time value to be displayed to the guest */
  displayTime?: Maybe<Scalars["String"]>;
  /**
   * [DEPRECATED] Time value formatted as a range
   * @deprecated The value will default to display_time. Use display_time instead.
   */
  formattedTimeRange?: Maybe<Scalars["String"]>;
  /** Is this time the same as the guest intended arrival/departure time */
  isTheSameAsExistingTime?: Maybe<Scalars["Boolean"]>;
  /** Actual price to request changes */
  price: Scalars["Int"];
  /** Standard price to request changes, ignoring discounts */
  standardPrice: Scalars["Int"];
  /** The relevant time as a full timestamp for display to the user */
  time: Scalars["RFC3339DateTime"];
};

/** ECI/LCO times for a booking and metadata */
export type EciLcoTimes = {
  /** The type of approval */
  approvalType: EciLcoApproval;
  /** The current check in time for the inquiry */
  checkInTime: Scalars["RFC3339DateTime"];
  /** The current check out time for the inquiry */
  checkOutTime: Scalars["RFC3339DateTime"];
  /** Currency used for eci/lco fee */
  currency: Scalars["String"];
  /** The ECI note */
  eciNote?: Maybe<Message>;
  /** the reason some eci times are unavailable */
  eciReason: Scalars["String"];
  /** the eci times for the inquiry */
  eciTimes: Array<EciLcoTime>;
  /** A flag to indicate eci/lco monetization state */
  isMonetized: Scalars["Boolean"];
  /** The LCO note */
  lcoNote?: Maybe<Message>;
  /** the reason some lco times are unavailable */
  lcoReason: Scalars["String"];
  /** the lco times for the inquiry */
  lcoTimes: Array<EciLcoTime>;
  /** eci times available for manual request */
  requestCheckInTimes: Array<EciLcoTime>;
  /** lco times available for manual request */
  requestCheckOutTimes: Array<EciLcoTime>;
};

export type EciTimes = {
  /** The current check in time for the inquiry */
  checkInTime: Scalars["RFC3339DateTime"];
  /** Currency used for eci/lco fee */
  currency: Scalars["String"];
  /** the reason some eci times are unavailable */
  eciReason: Scalars["String"];
  /** the eci times for the inquiry */
  eciTimes: Array<EciLcoTime>;
};

export type EmailUsed = {
  used: Scalars["Boolean"];
};

export type Employee = Node & {
  id: Scalars["ID"];
  /** The user associated with this employee */
  user: User;
};

export type EmptyTaskActivityMetadata = Node & {
  id: Scalars["ID"];
};

/** Autogenerated return type of EnqueueFailedPreBookingPayment. */
export type EnqueueFailedPreBookingPaymentPayload = {
  /** The new, backend-consolidated deposits (pre-booking payments) */
  preBookingPaymentSchedule: Array<PreBookingPaymentSchedule>;
};

export type EtaChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New estimated time of arrival. */
  newEta?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Reason for ETA change. */
  reason?: Maybe<Scalars["String"]>;
};

export type EtaInfo = {
  /** List of ETA options associated with this EtaInfo */
  etaOptions: Array<EtaOption>;
  /** List of ETA update options associated with this EtaInfo */
  etaUpdateOptions: Array<EtaOption>;
  /** Initial copy displayed on the ETA modal */
  setEtaTitle: Scalars["String"];
  /** List of reasons used to update ETA */
  updateEtaReasons: Array<EtaReason>;
  /** Update copy displayed on the ETA modal */
  updateEtaTitle: Scalars["String"];
};

export type EtaOption = {
  /** Disclaimer provided to HAs */
  disclaimer: Scalars["String"];
  /** Estimated time of arrival */
  eta: Scalars["RFC3339DateTime"];
  /** End of task ETA window */
  etaRangeEnd: Scalars["RFC3339DateTime"];
  /** Beginning of task ETA window */
  etaRangeStart: Scalars["RFC3339DateTime"];
  /** Copy representing ETA */
  etaText: Scalars["String"];
  /** Next task status */
  nextStatus: Scalars["String"];
  /** Copy associated with next task status */
  nextStatusCta: Scalars["String"];
  /** Subtext associated with next task status */
  nextStatusCtaSubtext?: Maybe<Scalars["String"]>;
};

export type EtaReason = {
  /** Slug corresponding to ETA reason */
  slug: Scalars["String"];
  /** Reason for ETA update */
  text: Scalars["String"];
};

export type ExperimentValue = {
  /** Additional configuration provided to the experiment */
  config?: Maybe<Scalars["String"]>;
  /** Every experiment has at least two treatments. In the simplest case, these are on and off. */
  experiment: Scalars["String"];
  /** A descriptive string that illustrates what we will be testing. */
  treatment: Scalars["String"];
};

export type ExtensionNightlyPricing = Node & {
  /** Unique identifier */
  id: Scalars["ID"];
  /** The price for this date */
  price: Scalars["Float"];
  /** The relevant date for this pricing */
  priceDt: Scalars["RFC3339DateTime"];
};

export type ExtensionPreview = Node & {
  /** The total base fee for the extension */
  baseAmount?: Maybe<Scalars["Float"]>;
  /** The currency that the payment is owed in or the refund will be issued in */
  currency?: Maybe<Scalars["String"]>;
  /** The currency symbol for the currency that the payment is owed in or the refund will be in */
  currencySymbol?: Maybe<Scalars["String"]>;
  /** The number of hours that the extension will be held on hold for payment */
  holdHours?: Maybe<Scalars["Float"]>;
  id: Scalars["ID"];
  /** The message when preview generation fails. */
  message?: Maybe<Scalars["String"]>;
  /** The prices for the nights involved in the extension */
  nightlyPrices?: Maybe<Array<ExtensionNightlyPricing>>;
  /** The number of nights added by the adjustment */
  nightsAdded?: Maybe<Scalars["Int"]>;
  /** The number of nights removed by the adjustment */
  nightsRemoved?: Maybe<Scalars["Int"]>;
  /** Difference of the adjustment. Total: preview['total'] + preview['payment_difference'] */
  paymentDifference?: Maybe<Scalars["Float"]>;
  /** The refund method that the user is eligible to have refunded. */
  refundMethod?: Maybe<RefundMethod>;
  /** The percentage of the booking fees that the user is eligible to have refunded. */
  refundPercentage?: Maybe<Scalars["Float"]>;
  /** The total taxes owed on the extension */
  taxAmount?: Maybe<Scalars["Float"]>;
  /** The total owed on the extension */
  total?: Maybe<Scalars["Float"]>;
};

export type ExtensionPromptFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type FeaturedCity = {
  /** Name of the city. */
  city: Scalars["String"];
  /** Description of the collection */
  description: Scalars["String"];
  /** Main photo's url */
  mainPhoto: Scalars["String"];
  /** Title of the collection */
  title: Scalars["String"];
};

export type FeaturedStayWithPricing = {
  city: Scalars["String"];
  defaultRateLabel?: Maybe<Scalars["String"]>;
  effectiveNightlyRate: Scalars["Int"];
  effectiveRateLabel?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  listingUrl: Scalars["String"];
  mainPhoto?: Maybe<Scalars["String"]>;
  monthlyPricingDescription?: Maybe<Scalars["String"]>;
  subtitle: Scalars["String"];
  title: Scalars["String"];
};

/** Feed item types that may be returned */
export type FeedItem =
  | AccessCodesFeedItem
  | AccountVerificationPromptFeedItem
  | AlterationPromptFeedItem
  | ApartmentGuideFeedItem
  | BuildingMapFeedItem
  | CheckOutInstructionsFeedItem
  | ContactUsFeedItem
  | EarlyCheckInPromptFeedItem
  | ExtensionPromptFeedItem
  | FeedbackPromptFeedItem
  | FindASonderFeedItem
  | GroceryExperimentConfirmationFeedItem
  | GroceryExperimentFeedItem
  | HelpCenterFeedItem
  | LateCheckOutPromptFeedItem
  | LocalRecommendationExperimentFeedItem
  | LocalRecommendationFeedItem
  | LocalRecommendationV2FeedItem
  | LuggageStoragePromptFeedItem
  | NotificationFeedItem
  | PendingAlterationNoteFeedItem
  | PendingAlterationPromptFeedItem
  | PendingExtensionPromptFeedItem
  | PreStaySurveyEditFeedItem
  | PreStaySurveyFeedItem
  | ReservationFeedItem
  | WelcomeFeedItem
  | WifiInfoFeedItem;

export type FeedbackPromptFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  surveyUrl: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type FetchCheckoutDetailsInput = {
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  collectionId: Scalars["String"];
};

export type Fidelity = {
  /** Fidelity number */
  number?: Maybe<Scalars["String"]>;
  /** Fidelity source system */
  source?: Maybe<Scalars["String"]>;
};

export enum FilesAttachable {
  Comment = "comment",
  Task = "task",
  User = "user",
}

export enum Filter {
  Activities = "activities",
  Archived = "archived",
  Comments = "comments",
  Subtasks = "subtasks",
}

export enum FilterClient {
  /** tasks related to get? same as assignee? not implemented yet. */
  Get = "get",
  /** tasks related to city ops teams, filters out GET stuff */
  Ops = "ops",
}

export enum FilterDropOffLocation {
  Office = "office",
  Unit = "unit",
}

export enum FilterDuringStay {
  DuringStay = "during_stay",
}

export enum FilterEtaEnabled {
  No = "no",
  Yes = "yes",
}

export enum FilterOccupancy {
  Occupied = "occupied",
  Vacant = "vacant",
}

export enum FilterOwner {
  City = "city",
}

export enum FilterPte {
  GuestInformed = "guest_informed",
  No = "no",
  Yes = "yes",
}

export enum FilterStatus {
  Arriving = "arriving",
  Canceled = "canceled",
  Complete = "complete",
  Deleted = "deleted",
  Enroute = "enroute",
  /** shorthand for tasks not complete/deleted/canceled */
  Incomplete = "incomplete",
  Inprogress = "inprogress",
  Ready = "ready",
  Waiting = "waiting",
}

export enum FilterTriaged {
  New = "new",
  Triaged = "triaged",
}

export type FindASonderFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  destinationUrl: Scalars["String"];
  id: Scalars["ID"];
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type FlipperValue = {
  enabled: Scalars["Boolean"];
  name: Scalars["String"];
};

export enum Format {
  Amr = "amr",
  Avi = "avi",
  Gif = "gif",
  Heic = "heic",
  Jpg = "jpg",
  M4a = "m4a",
  Mov = "mov",
  Mp4 = "mp4",
  Pdf = "pdf",
  Png = "png",
  Tiff = "tiff",
  Webp = "webp",
}

export type GeneralUnitCleaningPricing = Node & {
  /** Bath count for this general cleaning pricing */
  bathCount: Scalars["Float"];
  /** Bed count for this general cleaning pricing */
  bedCount: Scalars["Int"];
  /** Clean type for this general cleaning pricing */
  cleanType: CleaningRequestCategory;
  /** Currency for this general cleaning pricing */
  currency: Scalars["String"];
  id: Scalars["ID"];
  /** Price for this general cleaning pricing */
  price: Scalars["Float"];
};

/** Geo input for confining search to map area */
export type GeoBoundingBoxInput = {
  bottomRight: GeoLocationInput;
  topLeft: GeoLocationInput;
};

export type GeoCoordinates = {
  lat: Scalars["Float"];
  lng: Scalars["Float"];
};

/** Geo input for centering search area around a location */
export type GeoDistanceInput = {
  center: GeoLocationInput;
  radius?: InputMaybe<Scalars["String"]>;
};

/** Geo location */
export type GeoLocationInput = {
  lat: Scalars["Float"];
  lng: Scalars["Float"];
};

export type GroceryExperimentConfirmationFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type GroceryExperimentFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type GroceryItem = Node & {
  /** Category to which the item belongs (Fresh Fruit, Bread and Pantry, etc.) */
  category: Scalars["String"];
  id: Scalars["ID"];
  /** Image URL of the item */
  imageUrl: Scalars["String"];
  /** Total number of this item that the customer can order */
  maxQuantity: Scalars["Int"];
  /** Price of the item ($1.99) */
  price: Scalars["String"];
  /** Quantity of the item (lbs, fl oz, etc.) */
  quantity: Scalars["String"];
  /** Title of the item, ie, name */
  title: Scalars["String"];
};

/** Grocery Order */
export type GroceryOrder = {
  id: Scalars["ID"];
  quantity: Scalars["Int"];
};

export type GroupBlock = Node & {
  building: Building;
  collectionId: Scalars["String"];
  collectionName: Scalars["String"];
  collectionVersion: Scalars["String"];
  /** The group trip this block belongs to */
  groupTrip: GroupTrip;
  /** number of nights requested to be held by date */
  holdData: Array<GroupBlockHoldDataDate>;
  id: Scalars["ID"];
  /** All inquiries in group block including dead, booked, on_hold */
  inquiries: Array<Inquiry>;
  /** The sum nights booked for that block */
  numBookedNights: Scalars["Int"];
  /** The sum of nights on hold for that block */
  numHoldNights: Scalars["Int"];
  /** The sum of nights of inquiries that were invoiced for that block */
  numInvoicedNights: Scalars["Int"];
  /** The sum of nights we want to reserve for this block */
  numRequestedNights: Scalars["Int"];
  /** The sum nights booked or on_hold for that block */
  numTotalNights: Scalars["Int"];
  /** The code of the rate plan */
  ratePlanCode: Scalars["String"];
  /** booked + inquired + held nights by date */
  reservedData: Array<GroupBlockHoldDataDate>;
};

export type GroupBlockInquiriesArgs = {
  firstDate?: InputMaybe<Scalars["String"]>;
  lastDate?: InputMaybe<Scalars["String"]>;
};

export type GroupBlockExternal = {
  collectionId: Scalars["String"];
  collectionName: Scalars["String"];
};

export type GroupBlockHoldDataDate = {
  /** the date of the hold */
  date: Scalars["String"];
  /** the number of units to hold for the specified day */
  numberOfUnits: Scalars["Int"];
};

/** Group block hold data date input */
export type GroupBlockHoldDataDateInput = {
  date: Scalars["String"];
  numberOfUnits: Scalars["Int"];
};

/** Group block upsert input */
export type GroupBlockInput = {
  buildingId: Scalars["ID"];
  collectionId: Scalars["Int"];
  collectionName: Scalars["String"];
  collectionVersion?: InputMaybe<Scalars["String"]>;
  holdData?: InputMaybe<Array<GroupBlockHoldDataDateInput>>;
  id?: InputMaybe<Scalars["ID"]>;
  ratePlanCode: Scalars["String"];
};

/** Group inquiry upsert input */
export type GroupInquiryInput = {
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  email: Scalars["String"];
  guestNb: Scalars["Int"];
  language?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  phone: Scalars["String"];
  websiteName?: InputMaybe<Scalars["String"]>;
};

export type GroupTrip = Node & {
  automaticPaymentSchedule: Array<AutomaticPaymentSchedule>;
  billingType: GroupTripBilling;
  /** @deprecated Use payment_details_capture_link instead. */
  cardCaptureLink?: Maybe<Scalars["String"]>;
  cardOnFile?: Maybe<CardDetails>;
  /** manual charge preview data for this group trip */
  chargePreview: RevenueInfo;
  city: City;
  contractUrl?: Maybe<Scalars["String"]>;
  createdAt: Scalars["RFC3339DateTime"];
  /** deposits that were collected for this group */
  deposits: Array<Payment>;
  endDt: Scalars["String"];
  groupBlocks?: Maybe<Array<GroupBlock>>;
  groupInvoiceEmailedAt?: Maybe<Scalars["String"]>;
  groupInvoiceUrl?: Maybe<Scalars["String"]>;
  groupTripMembers: Array<GroupTripMember>;
  /** The datetime the inquiry holds were released */
  holdReleasedAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** status of the hold creation process */
  holdStatus: GroupTripHoldStatus;
  id: Scalars["ID"];
  name: Scalars["String"];
  /** The number of nights based on the sum of group blocks hold_data number_of_units. */
  numRequestedNights: Scalars["Int"];
  /** The number of nights booked or still on_hold. */
  numTotalNights: Scalars["Int"];
  paymentDetailsCaptureLink?: Maybe<Scalars["String"]>;
  paymentGateway?: Maybe<DepositPayment>;
  paymentGatewayCustomer?: Maybe<Scalars["String"]>;
  paymentTerms: GroupTripPaymentTerm;
  preBookingPaymentSchedule: Array<PreBookingPaymentSchedule>;
  /** The datetime the inquiry holds will be released */
  reservationReleaseAt: Scalars["RFC3339DateTime"];
  /** The date the inquiry holds will be released */
  reservationReleaseDate: Scalars["String"];
  /** revenue data for this group trip */
  revenueInfo: RevenueInfo;
  salesAccount?: Maybe<SalesAccount>;
  salesforceCustomerId?: Maybe<Scalars["String"]>;
  salesforceDetailUrl?: Maybe<Scalars["String"]>;
  salesforceOpportunityId?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  startDt: Scalars["String"];
  status: GroupTripStatus;
};

export type GroupTripChargePreviewArgs = {
  billUpTo?: InputMaybe<Scalars["String"]>;
};

export type GroupTripRevenueInfoArgs = {
  firstDate?: InputMaybe<Scalars["String"]>;
  lastDate?: InputMaybe<Scalars["String"]>;
};

export enum GroupTripBilling {
  Individual = "individual",
  Master = "master",
}

export type GroupTripExternal = {
  billingType: GroupTripBilling;
  endDt: Scalars["String"];
  groupBlocks?: Maybe<Array<GroupBlockExternal>>;
  name: Scalars["String"];
  paymentTerms: GroupTripPaymentTerm;
  slug?: Maybe<Scalars["String"]>;
  startDt: Scalars["String"];
  status: GroupTripStatus;
};

export enum GroupTripHoldStatus {
  Done = "done",
  Error = "error",
  Processing = "processing",
  Ready = "ready",
}

/** Group trip upsert input */
export type GroupTripInput = {
  automaticPaymentSchedule?: InputMaybe<Array<AutomaticPaymentScheduleInput>>;
  billingType: GroupTripBilling;
  cityId: Scalars["ID"];
  endDate: Scalars["String"];
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  paymentTerms: GroupTripPaymentTerm;
  reservationReleaseDate: Scalars["String"];
  salesAccountId?: InputMaybe<Scalars["ID"]>;
  salesPocUserId?: InputMaybe<Scalars["ID"]>;
  salesforceCustomerId?: InputMaybe<Scalars["String"]>;
  salesforceOpportunityId?: InputMaybe<Scalars["String"]>;
  startDate: Scalars["String"];
  status: GroupTripStatus;
};

export type GroupTripMember = Node & {
  account: Account;
  id: Scalars["ID"];
  role: GroupTripMemberRole;
};

/** Group trip member upsert input */
export type GroupTripMemberInput = {
  email: Scalars["String"];
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  phone: Scalars["String"];
  role: GroupTripMemberRole;
};

export enum GroupTripMemberRole {
  Organizer = "organizer",
  Payer = "payer",
}

export enum GroupTripPaymentTerm {
  AtCheckin = "at_checkin",
  AtCheckout = "at_checkout",
  MasterBillCard = "master_bill_card",
  MasterBillWireMan = "master_bill_wire_man",
  Prepaid = "prepaid",
}

/** Group trip Search Query */
export type GroupTripSearchInput = {
  buildingInternalRef?: InputMaybe<Scalars["String"]>;
  buildingName?: InputMaybe<Scalars["String"]>;
  cityId?: InputMaybe<Scalars["ID"]>;
  createdOn?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["String"]>;
  groupTripId?: InputMaybe<Scalars["ID"]>;
  id?: InputMaybe<Scalars["ID"]>;
  memberEmail?: InputMaybe<Scalars["String"]>;
  memberName?: InputMaybe<Scalars["String"]>;
  memberPhone?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  salesPocName?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<GroupTripStatus>;
};

export enum GroupTripStatus {
  Cancelled = "cancelled",
  Definite = "definite",
  Tentative = "tentative",
}

export type GuestActualDepartureTime = Node & {
  /** actual departure time of the guest. */
  actualDepartureTime: Scalars["RFC3339DateTime"];
  /** Platform/channel which the request has been initiated. */
  channel?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export enum GuestAlreadyAware {
  No = "no",
  Yes = "yes",
}

export type GuestInfo = {
  /** ... */
  address: Address;
  countryAlpha2?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  dateOfBirth?: Maybe<Scalars["String"]>;
  discountPricingMember?: Maybe<Scalars["Boolean"]>;
  email?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  isBgcNeeded?: Maybe<Scalars["Boolean"]>;
  isFilled?: Maybe<Scalars["Boolean"]>;
  lastName?: Maybe<Scalars["String"]>;
  marketingOptIn?: Maybe<Scalars["Boolean"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  previousBookingsCount: Scalars["Int"];
  requiresIdVerification?: Maybe<Scalars["Boolean"]>;
  requiresPhoneVerification?: Maybe<Scalars["Boolean"]>;
  trustAndSafetyState: Scalars["String"];
};

/** Guest Info */
export type GuestInfoInput = {
  addressApt?: InputMaybe<Scalars["String"]>;
  addressCity?: InputMaybe<Scalars["String"]>;
  addressCountry?: InputMaybe<Scalars["String"]>;
  addressState?: InputMaybe<Scalars["String"]>;
  addressStreet?: InputMaybe<Scalars["String"]>;
  addressZipcode?: InputMaybe<Scalars["String"]>;
  countryAlpha2: Scalars["String"];
  countryCode: Scalars["String"];
  dateOfBirth: Scalars["String"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  marketingOptIn: Scalars["Boolean"];
  password?: InputMaybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
};

export type GuestIssue = {
  /** Storage/drop-off location. */
  dropOffLocation?: InputMaybe<Scalars["String"]>;
  /** Item drop off time (HH:MM format). */
  dropOffTime?: InputMaybe<Scalars["String"]>;
  guestUrgency?: InputMaybe<GuestUrgency>;
  issueType: GuestIssueTypeEnum;
  /** Item pick up time (HH:MM format). */
  pickUpTime?: InputMaybe<Scalars["String"]>;
};

export enum GuestIssueTypeEnum {
  Access = "access",
  AirConditioning = "air_conditioning",
  BrokenAppliance = "broken_appliance",
  BrokenFurnitureOrAmenities = "broken_furniture_or_amenities",
  BugsOrRodents = "bugs_or_rodents",
  Cable = "cable",
  Cleanliness = "cleanliness",
  Electrical = "electrical",
  Heat = "heat",
  Internet = "internet",
  MissingItemOrAmenity = "missing_item_or_amenity",
  NoiseComplaint = "noise_complaint",
  Parking = "parking",
  Plumbing = "plumbing",
  StainedOrDamagedLinens = "stained_or_damaged_linens",
}

export type GuestLoyaltyTier = {
  /** Code of the loyalty tier. */
  code?: Maybe<LoyaltyTier>;
};

export type GuestProfile = {
  /** Email address of the guest. */
  email?: Maybe<Scalars["String"]>;
  /** First name of the guest. */
  firstName?: Maybe<Scalars["String"]>;
  /** Last name of the guest. */
  lastName?: Maybe<Scalars["String"]>;
  /** Loyalty tier of the guest. */
  loyaltyTier?: Maybe<GuestLoyaltyTier>;
  /** Number of bookings associated with the guest */
  numberOfBookings: Scalars["Int"];
  /** List of tasks associated with the guest */
  tasks: TaskConnection;
};

export type GuestProfileTasksArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export enum GuestReceivedPreviousWarning {
  No = "no",
  Yes = "yes",
}

export type GuestRequest = {
  dateToComplete?: InputMaybe<Scalars["String"]>;
  /** Storage/drop-off location. */
  dropOffLocation?: InputMaybe<Scalars["String"]>;
  /** Item drop off time (HH:MM format). */
  dropOffTime?: InputMaybe<Scalars["String"]>;
  earliestStartTime?: InputMaybe<Scalars["String"]>;
  guestUrgency?: InputMaybe<GuestUrgency>;
  /** Item pick up time (HH:MM format). */
  pickUpTime?: InputMaybe<Scalars["String"]>;
  requestType: GuestRequestTypeEnum;
};

export type GuestRequestAmenity = {
  /** The number of bar_soap requested */
  barSoap?: Maybe<Scalars["Int"]>;
  /** The number of bath_mat requested */
  bathMat?: Maybe<Scalars["Int"]>;
  /** The number of blanket requested */
  blanket?: Maybe<Scalars["Int"]>;
  /** The number of body_lotion requested */
  bodyLotion?: Maybe<Scalars["Int"]>;
  /** The number of coffee_creamer requested */
  coffeeCreamer?: Maybe<Scalars["Int"]>;
  /** The number of coffee_filter requested */
  coffeeFilter?: Maybe<Scalars["Int"]>;
  /** The number of coffee_packet requested */
  coffeePacket?: Maybe<Scalars["Int"]>;
  /** The number of conditioner requested */
  conditioner?: Maybe<Scalars["Int"]>;
  /** The number of dishwasher_pod requested */
  dishwasherPod?: Maybe<Scalars["Int"]>;
  /** The number of facial_tissue requested */
  facialTissue?: Maybe<Scalars["Int"]>;
  /** The number of garbage_bag_large requested */
  garbageBagLarge?: Maybe<Scalars["Int"]>;
  /** The number of garbage_bag_small requested */
  garbageBagSmall?: Maybe<Scalars["Int"]>;
  /** The number of laundry_detergent_pod requested */
  laundryDetergentPod?: Maybe<Scalars["Int"]>;
  /** The number of olive_oil requested */
  oliveOil?: Maybe<Scalars["Int"]>;
  /** The number of shampoo requested */
  shampoo?: Maybe<Scalars["Int"]>;
  /** The number of sheet_set requested */
  sheetSet?: Maybe<Scalars["Int"]>;
  /** The number of sugar_regular requested */
  sugarRegular?: Maybe<Scalars["Int"]>;
  /** The number of sugar_zing requested */
  sugarZing?: Maybe<Scalars["Int"]>;
  /** The number of tea_black requested */
  teaBlack?: Maybe<Scalars["Int"]>;
  /** The number of tea_green requested */
  teaGreen?: Maybe<Scalars["Int"]>;
  /** The number of tea_mint requested */
  teaMint?: Maybe<Scalars["Int"]>;
  /** The number of toilet_paper requested */
  toiletPaper?: Maybe<Scalars["Int"]>;
  /** The number of towel_bath requested */
  towelBath?: Maybe<Scalars["Int"]>;
  /** The number of towel_facial requested */
  towelFacial?: Maybe<Scalars["Int"]>;
  /** The number of towel_hand requested */
  towelHand?: Maybe<Scalars["Int"]>;
  /** The number of towel_paper requested */
  towelPaper?: Maybe<Scalars["Int"]>;
};

export enum GuestRequestTypeEnum {
  Amenities = "amenities",
  Fan = "fan",
  ForgottenPersonalItem = "forgotten_personal_item",
  Furniture = "furniture",
  Groceries = "groceries",
  Heater = "heater",
  HighChair = "high_chair",
  IntrastayCleaning = "intrastay_cleaning",
  NoiseMachine = "noise_machine",
  PackAndPlay = "pack_and_play",
  PackageOrMail = "package_or_mail",
  Sheets = "sheets",
  SpecialOccasion = "special_occasion",
}

export type GuestSpace = {
  /** The guest facing description of the space */
  description?: Maybe<Scalars["String"]>;
  /** Unique identifier */
  id: Scalars["ID"];
  /** The location of the space in the building */
  location: Scalars["String"];
  /** An object representing the open hours of the space */
  openHours: OpenInfo;
  /** The type of the space */
  type: Scalars["String"];
};

export enum GuestUrgency {
  High = "high",
  Low = "low",
  Medium = "medium",
}

export type GuideContent = Node & {
  /** Human readable, translated category for this item */
  category: Scalars["String"];
  /** Slug representing the category */
  categorySlug: Scalars["String"];
  /** Guest-facing description for this guide content item */
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** brand and model, if this content relates to an appliance */
  itemBrandModel?: Maybe<Scalars["String"]>;
  /** Human readable, translated item type for this item */
  itemType: Scalars["String"];
  /** Slug representing the category */
  itemTypeSlug: Scalars["String"];
};

export type HelpCenterFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Optional inquiry for localizing contact numbers */
  relatedInquiry?: Maybe<Inquiry>;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type HkCleaningRequestCostAdjustment = Node & {
  /** Adjustment created by */
  creator: User;
  /** Housekeeping cost details */
  hkCost: HkCost;
  id: Scalars["ID"];
  /** Notes to capture additional details regarding the cost adjustment */
  notes?: Maybe<Scalars["String"]>;
};

export type HkCost = Node & {
  /** Housekeeping cost. */
  amount: Scalars["Float"];
  /** Housekeeping cost approval status */
  approvalStatus: HkCostApprovalStatus;
  /** Currency */
  currency: Scalars["String"];
  id: Scalars["ID"];
  /** Reason for rejecting the housekeeping cost */
  rejectionReason?: Maybe<Scalars["String"]>;
  /** Person approving/rejecting the housekeeping cost */
  reviewer?: Maybe<User>;
};

export enum HkCostApprovalStatus {
  Approved = "approved",
  None = "none",
  Pending = "pending",
  Rejected = "rejected",
}

export enum HkServiceableType {
  Building = "Building",
  CufSpace = "Cuf_Space",
  Unit = "Unit",
}

export type HoldSecurityDeposit = {
  securityDepositAmount: Scalars["Float"];
  securityDepositReason: Scalars["String"];
};

export type HomeTruth = Node & {
  /** The type of truth, like 'laundry' */
  category: Scalars["String"];
  /** The user-facing disclaimer text */
  description: Scalars["String"];
  /** User facing disclaimer title -- Temporary, will be deprecated at the end of the unit guildes pilot */
  disclaimerTitle?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export enum Host {
  Cloudinary = "cloudinary",
}

export type IdVerification = {
  /** Chekin verification provider */
  chekin?: Maybe<Chekin>;
  /** Indicate whether this steps is completed or not */
  completed: Scalars["Boolean"];
  /** Persona verification provider */
  persona?: Maybe<Persona>;
  /** Status of the current step */
  status?: Maybe<Scalars["String"]>;
};

export type Image = {
  /** Attachable ID */
  attachableId: Scalars["ID"];
  /** Attachable Type: ex. user, task or comment */
  attachableType: FilesAttachable;
  /** Image format for this item. */
  format: Scalars["String"];
  /** Unique ID of the image. */
  id: Scalars["ID"];
  /** Public ID of image */
  publicId: Scalars["String"];
  /** URL of the image. */
  url: Scalars["String"];
};

export type IndividualUnitCleaningPricing = Node & {
  /** Clean type for this unit cleaning pricing */
  cleanType: CleaningRequestCategory;
  /** Currency for this unit cleaning pricing */
  currency: Scalars["String"];
  id: Scalars["ID"];
  /** Price for this unit cleaning pricing */
  price: Scalars["Float"];
  /** The unit associated with this unit cleaning pricing */
  unit: Unit;
};

export enum IneligibleForCancellationReason {
  BookingInRelocation = "BOOKING_IN_RELOCATION",
  InquiryNotBooked = "INQUIRY_NOT_BOOKED",
  NotSupportedByProvider = "NOT_SUPPORTED_BY_PROVIDER",
  OtaCancellationRequired = "OTA_CANCELLATION_REQUIRED",
  TooLate = "TOO_LATE",
}

export type Inquiry = Booking &
  CommentTarget &
  Node & {
    /** Access information for the unit, including building, lockbox, door access codes */
    access?: Maybe<InquiryAccess>;
    /** The number of hours before check-in that access details are made available */
    accessHoursAvailableBeforeCheckIn?: Maybe<Scalars["Int"]>;
    /** Check in instructions for the inquiry. */
    accessInstructions?: Maybe<Scalars["String"]>;
    /** Guests who will receive access instructions */
    accessShareRecipients: Array<AccessShareRecipient>;
    /** Reason why access details are not available */
    accessUnavailableReason?: Maybe<AccessUnavailableReason>;
    /** Account which booked the inquiry */
    account?: Maybe<Account>;
    /** ID of the owner of the booking */
    accountId?: Maybe<Scalars["Int"]>;
    /** Returns true if account information is not required */
    accountInformationStepCompleted: Scalars["Boolean"];
    /** List of Action permissions */
    actions?: Maybe<Array<Maybe<Action>>>;
    /** Actual arrival date time. */
    actualArrivalDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Actual departure date time. */
    actualDepartureDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** if this booking can be altered. */
    alterationsAllowed: Scalars["Boolean"];
    /** Ancillary workflows for the inquiry */
    ancillaryServicesWorkflows?: Maybe<AncillaryServicesWorkflows>;
    /** Returns list of announcement banner data for the inquiry based on stage */
    announcementBannerData: Array<AnnouncementBanner>;
    /** Verfication status of the current account for this inquiry */
    bookingActionables?: Maybe<Array<Actionable>>;
    /** URL to the booking */
    bookingUrl?: Maybe<Scalars["String"]>;
    /** Returns true if guest can see the access details */
    canReceiveAccessInstructions: Scalars["Boolean"];
    /** An object representing the cancellation eligibility status of a booking. */
    cancellationEligibility?: Maybe<CancellationEligibility>;
    /** cancellations to this booking must be treated as alterations because it's already started. */
    cancellationIsAlteration: Scalars["Boolean"];
    /** This should be changed to not allow null => cancellationsAllowed: Boolean! */
    cancellationsAllowed?: Maybe<Scalars["Boolean"]>;
    /** Check in date of the inquiry */
    checkInDt: Scalars["String"];
    /** The check in state for OTA bookings */
    checkInState: CheckInState;
    /** Check in time of the inquiry. */
    checkInTime: Scalars["RFC3339DateTime"];
    /** Check out date of the inquiry */
    checkOutDt: Scalars["String"];
    /** Check out instructions for the inquiry. */
    checkOutInstructions?: Maybe<Scalars["String"]>;
    /** check out status of the inquiry */
    checkOutStatus: InquiryCheckoutStatus;
    /** Check out time of the inquiry. */
    checkOutTime: Scalars["RFC3339DateTime"];
    /** the start date time of the cleaning window for check-out clean */
    cleaningWindowStartDateTime: Scalars["RFC3339DateTime"];
    /** Returns the collection id of the booking */
    collectionId?: Maybe<Scalars["ID"]>;
    /** Comparable basis (price) for the inquiry */
    comparableBasis?: Maybe<Scalars["Float"]>;
    /** A unique identifier belonging to an inquiry. */
    confirmationCode?: Maybe<Scalars["String"]>;
    creditCardPaymentStatus?: Maybe<CreditCardPaymentStatus>;
    /** Returns true if credit card requirements are completed */
    creditCardRequirementsCompleted: Scalars["Boolean"];
    /** Status of the current account, either primary or guest */
    currentAccountStatus: CurrentAccountStatus;
    /** Early check-in request for inquiry */
    earlyCheckInRequest?: Maybe<EarlyCheckInRequest>;
    /** Time after which a guest may not request an early check-in */
    eciRequestCutoff: Scalars["RFC3339DateTime"];
    /** actual departure tim of the guest */
    guestActualDepartureTime?: Maybe<GuestActualDepartureTime>;
    /** Phone number for guest experience */
    guestExperiencePhone: Scalars["String"];
    /** Guest intended arrival time. */
    guestIntendedArrivalTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Guest intended departure time. */
    guestIntendedDepartureTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Returns true if guests can be modified */
    guestModificationAllowed: Scalars["Boolean"];
    /** The profile of the guest who owns the booking. */
    guestProfile?: Maybe<GuestProfile>;
    /** Whether the booking has payment method or not */
    hasPaymentMethod: Scalars["Boolean"];
    /** Whether the booking is an LTS booking or not. */
    hasPaymentPlan: Scalars["Boolean"];
    /** if the booking has a pending extension, reduction or shift. */
    hasPendingDateAdjustmentRequest: Scalars["Boolean"];
    /** Flag to determine if request eci/lco should be displayed */
    hideEciLcoLink?: Maybe<Scalars["Boolean"]>;
    /** ID of the resource */
    id: Scalars["ID"];
    /**
     * Flag indicating whether or not to enable the cancellations and modifications flow in the guest app
     * @deprecated Use more specific flags in_app_cancellations_enabled, in_app_ota_alterations_enabled, in_app_modifications_enabled instead
     */
    inAppAlterationEnabled?: Maybe<Scalars["Boolean"]>;
    /** Flag indicating whether or not to enable the cancellations flow in the guest app */
    inAppCancellationsEnabled?: Maybe<Scalars["Boolean"]>;
    /** determines whether in-app checkin help is enabled; for the guided flows project */
    inAppCheckinHelp: Scalars["Boolean"];
    /** Flag indicating whether or not to enable the modifications flow in the guest app */
    inAppModificationsEnabled?: Maybe<Scalars["Boolean"]>;
    /** Flag indicating whether or not to enable the OTA alterations flow in the guest app */
    inAppOtaAlterationsEnabled?: Maybe<Scalars["Boolean"]>;
    /** determines whether in-app guest issue reporting is enabled; for the guided flows project */
    inAppReportGuestIssue: Scalars["Boolean"];
    /** determines whether in-app amenities request is enabled; for the guided flows project */
    inAppRequestAmenities: Scalars["Boolean"];
    /** Current state of this inquiry. */
    inquiryState: InquiryState;
    /** Flag to determine if request eci/lco should be displayed */
    instantEciLcoEnabled?: Maybe<Scalars["Boolean"]>;
    /** Intrastay cleaning config information for an entity. */
    intrastayCleaningConfig?: Maybe<IntrastayCleaningConfig>;
    /** Cleaning task information like cleaning status and date. */
    intrastayCleaningRequests?: Maybe<Array<CleaningRequest>>;
    /**
     * Invoice associated with this inquiry
     * @deprecated Use revenue_receivable_invoices instead as this single invoice is inaccurate. Deprecated in favour of Objects::Revenue::Invoice
     */
    invoice?: Maybe<Invoice>;
    /** Invoice delivery information for the inquiry */
    invoiceDelivery?: Maybe<InvoiceDelivery>;
    /** Whether the booking is booked or not */
    isBooked?: Maybe<Scalars["Boolean"]>;
    /** Flag indicating whether the booking has been cancelled. */
    isCancelled?: Maybe<Scalars["Boolean"]>;
    /** Returns true if it is an early_check_in */
    isEarlyCheckIn: Scalars["Boolean"];
    /** Returns true if the user is able to make an early check-in request */
    isEciRequestAvailable: Scalars["Boolean"];
    /** Returns false if inquiry is dead and has referred inquiries (ie: was relocated pre-stay) */
    isGuestVisible: Scalars["Boolean"];
    /** Whether the booking is just an inquiry or is|has been reserved already. */
    isInquiry?: Maybe<Scalars["Boolean"]>;
    /** Returns true if it is an late_check_out */
    isLateCheckOut: Scalars["Boolean"];
    /** Returns true if the user is able to make a late check-out request */
    isLcoRequestAvailable: Scalars["Boolean"];
    /** Returns true if inquiry is migrated */
    isMigrated: Scalars["Boolean"];
    /** Whether the booking is on hold or not */
    isOnHold?: Maybe<Scalars["Boolean"]>;
    /** Returns true if current time is 24-hours before check-out (the pre-checkout stage) */
    isPreCheckOutStage: Scalars["Boolean"];
    /**
     * Whether the booking is unpaid or not
     * @deprecated Check instead for presence with revenue_receivable_invoices: revenueReceivableInvoices(state: pending) { checkoutUrl }
     */
    isUnpaid?: Maybe<Scalars["Boolean"]>;
    /** Late check-out request for inquiry */
    lateCheckOutRequest?: Maybe<LateCheckOutRequest>;
    /** latest receipt URL for this inquiry */
    latestReceipt?: Maybe<Scalars["String"]>;
    /** Time after which a guest may not request an late check-out */
    lcoRequestCutoff: Scalars["RFC3339DateTime"];
    /** Check in time of the inquiry in the unit's local timezone. */
    localCheckInTime: Scalars["RFC3339DateTime"];
    /** Check out time of the inquiry in the unit's local timezone. */
    localCheckOutTime: Scalars["RFC3339DateTime"];
    /** The guest name when there is no account linked to the inquiry */
    name?: Maybe<Scalars["String"]>;
    /** The ID of the inquiry without its class name prepended */
    normalizedId: Scalars["Int"];
    /** Parking addon information for the inquiry. */
    parkingAddonInfo: ParkingAddonInfo;
    /**
     * the payment link of the inquiry, needed for pending date adjustments or other pending payments
     * @deprecated Use a more specific query in the situation with what may be being paid for e.g. alteration
     */
    paymentLink?: Maybe<Scalars["String"]>;
    /** if the booking has a pending extension, reduction or shift, it will show here */
    pendingDateAdjustmentRequest?: Maybe<BookingDateAdjustmentRequest>;
    /** The pre stay survey for the booking, if it has been started */
    preStaySurvey?: Maybe<PreStaySurvey>;
    /** Basic product info about the current inquiry */
    productInfo?: Maybe<ProductInfo>;
    /** the rental site for the inquiry */
    rentalSiteName: Scalars["String"];
    /** Indicates whether this booking still needs account verification or a valid credit card */
    requiresCompletion: Scalars["Boolean"];
    /** Indicates whether this booking still needs its travel survey filled out */
    requiresSurvey: Scalars["Boolean"];
    /** Indicates whether this unit requires verification */
    requiresVerification: Scalars["Boolean"];
    /** Receivable invoices */
    revenueReceivableInvoices?: Maybe<Array<RevenueInvoice>>;
    /** Source system of the account */
    source?: Maybe<Scalars["String"]>;
    /** Current state of this inquiry. */
    state: Scalars["String"];
    /** Current status of this inquiry. */
    status: Scalars["String"];
    /** The url of the post stay survey */
    surveyUrl: Scalars["String"];
    /** Tasks related to this booking */
    tomTasks: Array<Task>;
    /** Inquiry uniq_key (used for non-authenticated WWW URLs) */
    uniqKey: Scalars["String"];
    /** unique key of the booking  */
    uniqueKey: Scalars["String"];
    /** Unit where the inquiry is taking place. */
    unit: Unit;
    /** Name of the website where the booking is reserved for display */
    websiteName?: Maybe<Scalars["String"]>;
  };

export type InquiryEarlyCheckInRequestArgs = {
  manual?: InputMaybe<Scalars["Boolean"]>;
};

export type InquiryLateCheckOutRequestArgs = {
  manual?: InputMaybe<Scalars["Boolean"]>;
};

export type InquiryRevenueReceivableInvoicesArgs = {
  excludeRefunded?: InputMaybe<Scalars["Boolean"]>;
  excludeWithServiceInvoices?: InputMaybe<Scalars["Boolean"]>;
  paidOnly?: InputMaybe<Scalars["Boolean"]>;
  states?: InputMaybe<Array<InvoiceState>>;
};

export type InquiryTomTasksArgs = {
  includeIntrastayCleanTasks?: InputMaybe<Scalars["Boolean"]>;
};

export type InquiryAccess = {
  /** Building code for the inquiry. */
  buildingAccessCode?: Maybe<Scalars["String"]>;
  /** Building access type for the unit. */
  buildingAccessType?: Maybe<Scalars["String"]>;
  /** Elevator code for the unit. */
  elevatorAccessCode?: Maybe<Scalars["String"]>;
  /** Elevator access type for the unit. */
  elevatorAccessType?: Maybe<Scalars["String"]>;
  /** Indicates whether or not secured building access is required for the unit. */
  isBuildingAccessRequired: Scalars["Boolean"];
  /** Indicates whether or not secured elevator access is required for the unit. */
  isElevatorAccessRequired: Scalars["Boolean"];
  /** Indicates whether or not the unit will require an in person checkin. */
  isInPersonCheckin: Scalars["Boolean"];
  /** Indicates whether or not keys for the unit are in a lockbox */
  isLockboxRequired: Scalars["Boolean"];
  /** Code for keycafe, if present */
  keycafeCode?: Maybe<Scalars["String"]>;
  /** Lockbox code for the unit. */
  lockboxCode?: Maybe<Scalars["String"]>;
  /** The email to use to login to salto to access the mobile key. null if not available. */
  mobileKeyEmail?: Maybe<Scalars["String"]>;
  /** The label used to identify mobile keys. */
  mobileKeyLabel?: Maybe<Scalars["String"]>;
  /** The type of mobile key that is enabled for this inquiry. null if not available. */
  mobileKeyType?: Maybe<MobileKey>;
  /** Unit's auto door code or the currently programmed connected home auto door code. */
  unitAccessCode?: Maybe<Scalars["String"]>;
  /** Access information for the unit. */
  unitAccessType: Scalars["String"];
};

export type InquiryCheckoutConnections = {
  /** Index-based position of the search. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records. */
  hasMore: Scalars["Boolean"];
  /** The list of inquiries. */
  inquiries: Array<Inquiry>;
  /** How many items total. */
  total: Scalars["Int"];
};

/** filters */
export type InquiryCheckoutFilterInput = {
  buildingIds?: InputMaybe<Array<Scalars["ID"]>>;
  checkOutTimeFrom: Scalars["RFC3339DateTime"];
  checkOutTimeTo: Scalars["RFC3339DateTime"];
  checkoutStatuses?: InputMaybe<Array<InquiryCheckoutStatus>>;
  cityIds: Array<Scalars["ID"]>;
  /** Indicates inquiries that there is another inquiry with check-in-date is equal to check-out-date. */
  sameDayOnly?: InputMaybe<Scalars["Boolean"]>;
};

export enum InquiryCheckoutSortColumn {
  CheckOutTime = "check_out_time",
  UnitInternalRef = "unit_internal_ref",
}

/** Sort by column */
export type InquiryCheckoutSortInput = {
  column: InquiryCheckoutSortColumn;
  order: SortAscDesc;
};

export enum InquiryCheckoutStatus {
  CheckedOut = "checked_out",
  NotCheckedOut = "not_checked_out",
  PastCheckoutTime = "past_checkout_time",
}

export type InquiryHold = {
  /** The duration of a hold in minutes of the propositions */
  holdDurationInMinutes: Scalars["Int"];
  /** The datetime the hold will be released */
  holdEndDatetime: Scalars["RFC3339DateTime"];
};

export type InquiryResult = {
  draftReceivableInvoiceId?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  payPath: Scalars["String"];
  promoCodes?: Maybe<Array<Scalars["String"]>>;
  trackingInfo?: Maybe<Scalars["JSON"]>;
  uniqKey: Scalars["String"];
};

/** Inquiry search filters params */
export type InquirySearchFilterInput = {
  /** window end for filtering inquiries by checkin date */
  checkInEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window start for filtering inquiries by checkin date */
  checkInStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window end for filtering inquiries by checkout date */
  checkOutEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window start for filtering inquiries by checkout date */
  checkOutStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** filter inquiries for these city ids */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export enum InquiryState {
  /** Current time is >= 5AM on the day of check-in */
  DayOfArrival = "day_of_arrival",
  /** Current time is >= 5AM on the day of check-out; if mobex_day_of_departure_starts_at_midnight flag is on, it's >= 12am */
  DayOfDeparture = "day_of_departure",
  /** Current time is > the day of check-in */
  DuringStay = "during_stay",
  /** Current time is > check-in, on the same day */
  PostCheckIn = "post_check_in",
  /** Current time is > check-out */
  PostStay = "post_stay",
  /** Current time is <= 3 days out from check-in */
  PreCheckIn = "pre_check_in",
  /** Current time is > 3 days out from check-in */
  Upcoming = "upcoming",
}

export type Inspection = {
  googleFormUrl?: InputMaybe<Scalars["String"]>;
  inspectionDetails?: InputMaybe<Scalars["String"]>;
};

export type InternalHold = {
  /** Internal hold end time. */
  endAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Internal hold type. */
  holdType?: Maybe<Scalars["String"]>;
  /** Internal hold start time. */
  startAt?: Maybe<Scalars["RFC3339DateTime"]>;
};

export type InternalRef = {
  /** Unique ID */
  id: Scalars["String"];
  /** Internal ref */
  internalRef: Scalars["String"];
  /** Associated model for internal ref */
  resource: InternalRefResource;
};

/** Internal ref filter params */
export type InternalRefFilterInput = {
  /** City filter */
  cityId?: InputMaybe<Scalars["String"]>;
  /** Internal ref input (full/partial match) */
  internalRef?: InputMaybe<Scalars["String"]>;
};

/** Resources associated to internal refs */
export type InternalRefResource = Building | CufSpace | Unit;

export type InternalUnitTask = {
  /** Storage/drop-off location. */
  dropOffLocation?: InputMaybe<Scalars["String"]>;
  /** Item drop off time (HH:MM format). */
  dropOffTime?: InputMaybe<Scalars["String"]>;
  /** Item pick up time (HH:MM format). */
  pickUpTime?: InputMaybe<Scalars["String"]>;
  subType: InternalUnitTaskSubTypeEnum;
};

export enum InternalUnitTaskSubTypeEnum {
  Access = "access",
  AirConditioning = "air_conditioning",
  BrokenAppliance = "broken_appliance",
  BrokenFurnitureOrAmenities = "broken_furniture_or_amenities",
  BugsOrRodents = "bugs_or_rodents",
  Cable = "cable",
  Cleanliness = "cleanliness",
  Electrical = "electrical",
  GarbageCollection = "garbage_collection",
  Heat = "heat",
  Internet = "internet",
  MissingItemOrAmenity = "missing_item_or_amenity",
  OtherMaintenance = "other_maintenance",
  Plumbing = "plumbing",
  ShowingOrOpenHouse = "showing_or_open_house",
  StainedOrDamagedLinens = "stained_or_damaged_linens",
  UpdateCuf = "update_cuf",
}

export type IntrastayCleaningConfig = {
  /** List of available time slots for the given entity */
  availableTimes?: Maybe<Array<CleaningWindow>>;
  /** Unique ID of the related entity. */
  entityId: Scalars["ID"];
  /** The entity type (e.g. 'Building') */
  entityType: Scalars["String"];
  /** Unique identifier for the Intrastay cleaning config. */
  id: Scalars["ID"];
  /** Whether the guest can manually cancel their intrastay cleans */
  manualCancellation: Scalars["Boolean"];
  /**
   * The number of hours before check in where the unit is expected to be assigned
   * and an intrastay clean can be requested for a booking
   */
  maxHoursBeforeCheckIn?: Maybe<Scalars["Int"]>;
  /** The fewest number of hours before the cleaning date that an intrastay clean can be requested at for a given cleaning date. */
  minHoursBeforeCleaningDate?: Maybe<Scalars["Int"]>;
};

export type InventorySearchFilters = {
  amenityFilter: SearchAmenityFilter;
  availabilityFilter: SearchAvailabilityFilter;
  bathroomCountFilter: SearchRangeFilter;
  bedCountFilter: SearchRangeFilter;
  bedroomCountFilter: SearchRangeFilter;
  bizToggleFilter: SearchBizToggleFilter;
  cityFilter: SearchCityFilter;
  guestCountFilter: SearchGuestCountFilter;
  neighborhoodFilter: SearchNeighborhoodFilter;
  pricingFilter: SearchPricingFilter;
};

export type InventorySearchMetadata = {
  appliedOffers: Array<AppliedOffer>;
  appliedOffersTotal: AppliedOffer;
  biweeklyDiscount: Scalars["String"];
  buildingName?: Maybe<Scalars["String"]>;
  count: Scalars["Int"];
  currencySymbol: Scalars["String"];
  defaultDiscount: Scalars["String"];
  fortyFivePlusDiscount: Scalars["String"];
  maxPrice: Scalars["Float"];
  minPrice: Scalars["Float"];
  monthlyDiscount: Scalars["String"];
  totalCount: Scalars["Int"];
  weeklyDiscount: Scalars["String"];
};

export type InventorySearchResult = {
  listingToMarker: Scalars["JSON"];
  listings: Scalars["JSON"];
  listingsOrder: Array<Scalars["String"]>;
  markerToListings: Scalars["JSON"];
  markers: Scalars["JSON"];
  markersOrder: Array<Scalars["String"]>;
  similarListings: Array<Scalars["JSON"]>;
};

export type InventorySearchSorting = {
  options: Array<SearchFilterDropdownOption>;
  selected: SearchFilterDropdownOption;
};

export type Invoice = {
  /** Formatted balance */
  balance: Scalars["String"];
  /** Formatted check-in date */
  checkInTime: Scalars["RFC3339DateTime"];
  /** Formatted check-out date */
  checkOutTime: Scalars["RFC3339DateTime"];
  /**
   * WWW invoice URL for this inquiry
   * @deprecated To get the receipt, please use latest_receipt on Inquiry object instead
   */
  invoicePdfUrl: Scalars["String"];
  /** Stay night count */
  nightsCount: Scalars["Int"];
  /** Payments */
  payments: Array<InvoicePayment>;
  /** Supergroups (groups of groups of line items) */
  supergroups: Array<InvoiceSupergroup>;
  /** Formatted total amount */
  total: Scalars["String"];
  /** Unit location as 'Neighborhood, City' */
  unitLocation: Scalars["String"];
};

export type InvoiceDelivery = {
  externalUrl?: Maybe<Scalars["String"]>;
  method: InvoiceDeliveryMethod;
};

export enum InvoiceDeliveryMethod {
  ContactSupport = "CONTACT_SUPPORT",
  EmailAfterCheckout = "EMAIL_AFTER_CHECKOUT",
  ExternalUrl = "EXTERNAL_URL",
  SourceOfBooking = "SOURCE_OF_BOOKING",
}

export type InvoiceDetails = {
  currency: Scalars["String"];
  lineItemDetails: Array<LineItemDetail>;
  totalAmount: Scalars["Float"];
};

export type InvoiceGroup = Node & {
  /** Group description */
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Line items */
  items?: Maybe<Array<InvoiceItem>>;
  /** Group title */
  title: Scalars["String"];
  /** Formatted total for this group */
  total: Scalars["String"];
};

export type InvoiceInfo = {
  chargeType?: Maybe<Scalars["String"]>;
  discountCallout?: Maybe<InvoiceLineItem>;
  hasMemberDiscount: Scalars["Boolean"];
  lineItems: Array<InvoiceLineItem>;
  ltsBooking: Scalars["Boolean"];
  preAuthorizable: Scalars["Boolean"];
  receivableInvoiceId?: Maybe<Scalars["ID"]>;
  stripeCountryCode: Scalars["String"];
  total: InvoiceTotal;
  totalInBaseCurrency?: Maybe<InvoiceTotal>;
};

export type InvoiceItem = Node & {
  /** Formatted line item amount */
  amount: Scalars["String"];
  /** Item description */
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Item title */
  title: Scalars["String"];
};

export type InvoiceLineItem = {
  label: Scalars["String"];
  rawValue: Scalars["Float"];
  type: Scalars["String"];
  value: Scalars["String"];
};

export type InvoicePayment = Node & {
  /** Formatted amount */
  amount: Scalars["String"];
  id: Scalars["ID"];
  /** Formatted received date */
  receivedAt: Scalars["RFC3339DateTime"];
  /** Title */
  title: Scalars["String"];
};

export enum InvoiceState {
  Abandoned = "abandoned",
  Cancelled = "cancelled",
  Dead = "dead",
  Failed = "failed",
  Paid = "paid",
  Pending = "pending",
  Processing = "processing",
  Scheduled = "scheduled",
}

export type InvoiceSummary = {
  invoice: RevenueInvoice;
  summaryLineItems: Array<InvoiceSummaryLineItem>;
};

export type InvoiceSummaryLineItem = {
  formattedTotalAmount: Scalars["String"];
  totalAmount?: Maybe<Scalars["Float"]>;
  type: Scalars["String"];
};

export type InvoiceSupergroup = Node & {
  /** Groups of line items */
  groups: Array<InvoiceGroup>;
  id: Scalars["ID"];
  /** Group title */
  title: Scalars["String"];
};

export type InvoiceTotal = {
  currency?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  rawValue: Scalars["Float"];
  value: Scalars["String"];
};

export type Issue = {
  etaEnabled?: InputMaybe<FilterEtaEnabled>;
  guestUrgency?: InputMaybe<GuestUrgency>;
  permissionToEnter?: InputMaybe<FilterPte>;
};

export type Item = {
  /** Category of the consumables item */
  category: Scalars["String"];
  /** Unique ID of the consumables item */
  id: Scalars["ID"];
  /** Name (label) of the consumables item */
  name: Scalars["String"];
};

export type KeyValue = {
  /** key */
  key: Scalars["String"];
  /** value */
  value?: Maybe<Scalars["String"]>;
};

export type LateCheckOut = {
  /** Desired check-out time (HH:MM format). */
  desiredCheckOutTime: Scalars["String"];
};

export type LateCheckOutPromptFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type LateCheckOutRequest = Node & {
  /** Time approved by city */
  approvedTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Indicates how the modification was requested */
  channel: Scalars["String"];
  /** Time the modification request was created */
  createdAt: Scalars["RFC3339DateTime"];
  /** Desired modification time indicated by guest */
  desiredTime: Scalars["RFC3339DateTime"];
  /** The ID of the Tom::EciLcoRequest request without its class name prepended */
  eciLcoRequestId: Scalars["Int"];
  id: Scalars["ID"];
  /** Current status of this request */
  status: EciLcoStatus;
};

export type LaundryStats = {
  /** The number of different bathrooms we have checked-out in the past x days */
  bathCount: Scalars["Int"];
  /** The number of different bed types we have changed in the past x days */
  beds?: Maybe<ChangedBeds>;
  /** The number of kitchens we have checked-out in the past x days */
  kitchenCount: Scalars["Int"];
  /** The number of person that can sleep in checkouts for the past x days */
  sleepCount: Scalars["Int"];
};

/** Laundry stats filter */
export type LaundryStatsFilterInput = {
  /** City ID to analyse */
  city: Scalars["ID"];
  /** Date of the count. Laundry stats will computed for date range (count_date - nights.days)..count_date */
  countDate: Scalars["ISO8601Date"];
  /** Number of nights to calculate the laundry stats for */
  nights: Scalars["Int"];
};

export type LcoTimes = {
  /** The current checkout time for the inquiry */
  checkOutTime: Scalars["RFC3339DateTime"];
  /** Currency used for eci/lco fee */
  currency: Scalars["String"];
  /** the reason some lco times are unavailable */
  lcoReason: Scalars["String"];
  /** the lco times for the inquiry */
  lcoTimes: Array<EciLcoTime>;
};

export type LeaseDeal = Node & {
  /** Address */
  address?: Maybe<Scalars["String"]>;
  /** Business development rep of the deal. */
  bdr?: Maybe<User>;
  /** Building opening project manager of the deal. */
  bopm?: Maybe<User>;
  /** City */
  city?: Maybe<Scalars["String"]>;
  /** Comments */
  comments?: Maybe<Scalars["String"]>;
  /** Deal unit count */
  dealUnitCount?: Maybe<Scalars["Int"]>;
  /** Development manager of the deal. */
  devMgr?: Maybe<User>;
  /** Directus Lease id */
  directusId?: Maybe<Scalars["ID"]>;
  /** Underwriting model spreadsheet link */
  iaLink?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Interior design manager of the deal. */
  idm?: Maybe<User>;
  /** Lease commencement date */
  leaseCommencementDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Link to lease document */
  leaseDocLink?: Maybe<Scalars["String"]>;
  /** Lease execution date */
  leaseExecutionDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Lease handover date */
  leaseHandoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Lease inspection access date */
  leaseInspectionAccessDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Onboarding access period */
  leaseOnboardingAccessPeriod?: Maybe<Scalars["Int"]>;
  /** Sonder punchlist date */
  leaseSonderPunchlistDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Lease type */
  leaseType?: Maybe<Scalars["String"]>;
  /** Visual inspection access period */
  leaseVisualInspectionAccessPeriod?: Maybe<Scalars["Int"]>;
  /** Lease Deal Name. */
  name?: Maybe<Scalars["String"]>;
  /** Landlord partner */
  partner?: Maybe<Partner>;
  /** lease deal phases */
  phaseLifecycles?: Maybe<Array<PhaseLifecycle>>;
  /** Region */
  region?: Maybe<Scalars["String"]>;
  /** Scope */
  scope?: Maybe<Scalars["String"]>;
  /** ID of the deal from the source. */
  sourceId: Scalars["String"];
  /** Source of the deal. */
  sourceType: Source;
  /** Stage of the deal. */
  stage?: Maybe<Scalars["String"]>;
  /** Staggered commencement flag */
  staggeredCommencementFlag?: Maybe<Scalars["Boolean"]>;
  /** Status of the deal. */
  status?: Maybe<Status>;
  /** Unit arrangement */
  unitArrangement?: Maybe<Scalars["String"]>;
  /** Units belonging to this deal. */
  units: Array<Unit>;
  /** Last updated at. */
  updatedAt: Scalars["RFC3339DateTime"];
};

export type LeaseDealConnections = {
  /** The list of lease deals */
  leaseDeals: Array<LeaseDeal>;
};

/** lease deal filters */
export type LeaseDealFilterInput = {
  /** filter by whether all units are dead in this lease deal */
  allUnitsDead?: InputMaybe<Scalars["Boolean"]>;
  /** filter by bookable_at_latest date */
  bookableAtLatestDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** filter by city */
  city?: InputMaybe<Array<Scalars["String"]>>;
  /** filter by id */
  id?: InputMaybe<Array<Scalars["ID"]>>;
  /** filter by name */
  name?: InputMaybe<Scalars["String"]>;
  /** filter by region */
  region?: InputMaybe<Array<Scalars["String"]>>;
  /** filter by stage */
  stage?: InputMaybe<Array<Scalars["String"]>>;
  /** filter by status */
  status?: InputMaybe<Array<Status>>;
};

/** Lease Deal */
export type LeaseDealInput = {
  /** lease deal's building opening project manager */
  bopmId?: InputMaybe<Scalars["ID"]>;
  /** lease deal's comments */
  comments?: InputMaybe<Scalars["String"]>;
  /** lease deal's development manager */
  devMgrId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
  /** lease deal's interior design manager */
  idmId?: InputMaybe<Scalars["ID"]>;
  /** lease deal's lease type */
  leaseType?: InputMaybe<Scalars["String"]>;
  /** lease deal's name */
  name?: InputMaybe<Scalars["String"]>;
  /** lease deal's scope */
  scope?: InputMaybe<Scalars["String"]>;
  /** lease deal's unit arrangement */
  unitArrangement?: InputMaybe<Scalars["String"]>;
};

export type LeaseDealLifecycle = {
  /** Address */
  address?: Maybe<Scalars["String"]>;
  /** Whether the status of all units in this lease deal = 'dead' */
  allUnitsDead?: Maybe<Scalars["Boolean"]>;
  /** Business development rep of the deal. */
  bdr?: Maybe<User>;
  /** Latest Bookable_at date of any unit associated with the lease deal */
  bookableAtLatestDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Earliest 'Bookable - Earliest' date of any unit associated with the lease deal */
  bookableEarliestDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Earliest 'Bookable - Latest' date of any unit associated with the lease deal */
  bookableLatestDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Building opening project manager of the deal. */
  bopm?: Maybe<User>;
  /** Display name of the buildings. */
  buildingDisplayName?: Maybe<Scalars["String"]>;
  /** All building refs of units associated with the lease deal */
  buildingRefs?: Maybe<Scalars["String"]>;
  /** City */
  city?: Maybe<Scalars["String"]>;
  /** Comments */
  comments?: Maybe<Scalars["String"]>;
  /** Count of distinct 'Bookable - Earliest' dates for all units associated with the lease deal */
  countBookableEarliestDate?: Maybe<Scalars["Int"]>;
  /** Count of distinct 'Bookable - Latest' dates for all units associated with the lease deal */
  countBookableLatestDate?: Maybe<Scalars["Int"]>;
  /** Count of distinct FF&E Need By dates for all units associated with the lease deal */
  countFfeNeedByDate?: Maybe<Scalars["Int"]>;
  /** Count of distinct Handover dates for all units associated with the lease deal */
  countHandoverDate?: Maybe<Scalars["Int"]>;
  /** Count of distinct ID brief submission dates for all units associated with the lease deal */
  countIdBriefSubmissionDate?: Maybe<Scalars["Int"]>;
  /** Count of distinct Lease commencement dates for all units associated with the lease deal */
  countLeaseCommencementDate?: Maybe<Scalars["Int"]>;
  /** Count of distinct Original lease commencement dates for all units associated with the lease deal */
  countLeaseCommencementDateOriginal?: Maybe<Scalars["Int"]>;
  /** Count of distinct Listing dates for all units associated with the lease deal */
  countListingDate?: Maybe<Scalars["Int"]>;
  /** Count of distinct Punch dates for all units associated with the lease deal */
  countPunchDate?: Maybe<Scalars["Int"]>;
  /** Deal unit count */
  dealUnitCount?: Maybe<Scalars["Int"]>;
  /** Development manager of the deal. */
  devMgr?: Maybe<User>;
  /** Earliest FF&E Need By date of any unit associated with the lease deal */
  ffeNeedByDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Earliest Handover date of any unit associated with the lease deal */
  handoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Underwriting model spreadsheet link */
  iaLink?: Maybe<Scalars["String"]>;
  /** Lease deal id */
  id: Scalars["String"];
  /** Earliest ID Brief submission date of any unit associated with the lease deal */
  idBriefSubmissionDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Interior design manager of the deal. */
  idm?: Maybe<User>;
  /** Earliest Lease commencement date of any unit associated with the lease deal */
  leaseCommencementDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Earliest Original lease commencement date of any unit associated with the lease deal */
  leaseCommencementDateOriginal?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Lease type */
  leaseType?: Maybe<Scalars["String"]>;
  /** Earliest Listing date of any unit associated with the lease deal */
  listingDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Lease Deal Name. */
  name?: Maybe<Scalars["String"]>;
  /** Landlord partner */
  partner?: Maybe<Partner>;
  /** Earliest Punch date of any unit associated with the lease deal */
  punchDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Region */
  region?: Maybe<Scalars["String"]>;
  /** Scope */
  scope?: Maybe<Scalars["String"]>;
  /** ID of the deal from the source. */
  sourceId: Scalars["String"];
  /** Source of the deal. */
  sourceType: Source;
  /** Stage of the deal. */
  stage?: Maybe<Scalars["String"]>;
  /** Lease deal status. */
  status?: Maybe<Status>;
  /** Unit arrangement */
  unitArrangement?: Maybe<Scalars["String"]>;
  /** Last updated at. */
  updatedAt: Scalars["RFC3339DateTime"];
};

export type LeaseDealLifecycleConnections = {
  /** The list of lease deal lifecycles */
  leaseDeals: Array<LeaseDealLifecycle>;
};

export type LeaseDealLifecycleFilters = {
  /** Possible cities */
  city?: Maybe<Array<Scalars["String"]>>;
  /** Possible regions */
  region?: Maybe<Array<Scalars["String"]>>;
  /** Possible stages */
  stage?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Possible statuses */
  status?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type LeaseInquiry = Booking &
  Node & {
    /** Account which booked the inquiry */
    account?: Maybe<Account>;
    /** ID of the owner of the booking */
    accountId?: Maybe<Scalars["Int"]>;
    /** Actual arrival date time. */
    actualArrivalDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Actual departure date time. */
    actualDepartureDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** URL to the booking */
    bookingUrl?: Maybe<Scalars["String"]>;
    /** Check in time of the inquiry. */
    checkInTime: Scalars["RFC3339DateTime"];
    /** Check out time of the inquiry. */
    checkOutTime: Scalars["RFC3339DateTime"];
    /** the start date time of the cleaning window for check-out clean */
    cleaningWindowStartDateTime: Scalars["RFC3339DateTime"];
    /** confirmation code of the booking  */
    confirmationCode?: Maybe<Scalars["String"]>;
    /** The profile of the guest who owns the booking. */
    guestProfile?: Maybe<GuestProfile>;
    /** Unique inquiry identifier */
    id: Scalars["ID"];
    /** Intrastay cleaning config information for an entity. */
    intrastayCleaningConfig?: Maybe<IntrastayCleaningConfig>;
    /** Name of the guest. */
    name?: Maybe<Scalars["String"]>;
    /** Tasks related to this booking */
    tomTasks: Array<Task>;
    /** unique key of the booking  */
    uniqueKey: Scalars["String"];
    /** Unit where the inquiry is taking place. */
    unit: Unit;
  };

export type LeaseInquiryTomTasksArgs = {
  includeIntrastayCleanTasks?: InputMaybe<Scalars["Boolean"]>;
};

/** Lease Inquiry search filters params */
export type LeaseInquirySearchFilterInput = {
  /** filter lease inquiries for these city ids */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** window end for filtering lease inquiries by end date */
  endDateEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window start for filtering lease inquiries by end date */
  endDateStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window end for filtering lease inquiries by start date */
  startDateEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window start for filtering lease inquiries by start date */
  startDateStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
};

export enum LifeStatus {
  Complete = "complete",
  Dead = "dead",
  Dying = "dying",
  OnBoarding = "on_boarding",
  Signed = "signed",
}

export type LifecycleValidationWarning = Node & {
  /** Bookable earliest date message */
  bookableEarliestDate?: Maybe<Array<Scalars["String"]>>;
  /** Bookable latest date message */
  bookableLatestDate?: Maybe<Array<Scalars["String"]>>;
  id: Scalars["ID"];
  /** Lease commencement date message */
  leaseCommencementDate?: Maybe<Array<Scalars["String"]>>;
  /** Listing date message */
  listingDate?: Maybe<Array<Scalars["String"]>>;
  /** Punch date message */
  punchDate?: Maybe<Array<Scalars["String"]>>;
};

/** Line Item */
export type LineItem = Node & {
  description?: Maybe<Scalars["String"]>;
  displayName: Scalars["String"];
  formattedTotalAmount: Scalars["String"];
  id: Scalars["ID"];
  refundableOnCancellation?: Maybe<Scalars["Boolean"]>;
  totalAmount: Scalars["Float"];
  type: Scalars["String"];
};

export type LineItemDetail = {
  averageUnitPrice: Scalars["Float"];
  dailyRates?: Maybe<Array<DailyRate>>;
  description: Scalars["String"];
  quantity: Scalars["Int"];
  subtype: Scalars["String"];
  total: Scalars["Float"];
  type: Scalars["String"];
};

/** Line Item Input */
export type LineItemInput = {
  description?: InputMaybe<Scalars["String"]>;
  displayName: Scalars["String"];
  itemCategory: Scalars["String"];
  refundableOnCancellation?: InputMaybe<Scalars["Boolean"]>;
  totalAmount: Scalars["Float"];
};

export type Listing = {
  accessibilityInfo: Array<Scalars["String"]>;
  adaAccessibilityInfo?: Maybe<AdaAccessibilityInfo>;
  amenities: Array<Amenity>;
  basePriceRaw: Scalars["Float"];
  bathroomCount: Scalars["Int"];
  bedroomCount: Scalars["Int"];
  buildingAddress: Scalars["String"];
  buildingName: Scalars["String"];
  buildingPhotos: Array<Photo>;
  cityName: Scalars["String"];
  contactEmail: Scalars["String"];
  countryName: Scalars["String"];
  currency: Scalars["String"];
  displayPrice: Scalars["String"];
  displayPriceLabel: Scalars["String"];
  displayPriceRaw: Scalars["Float"];
  downtownDrivingInfo?: Maybe<Scalars["String"]>;
  featuredPhotos: Array<Photo>;
  geocode: GeoCoordinates;
  homeTruths?: Maybe<Scalars["String"]>;
  houseRules: Array<Scalars["String"]>;
  /** The collection ID */
  id: Scalars["ID"];
  inSuiteLaundry: Scalars["Boolean"];
  l1Url: Scalars["String"];
  location: Scalars["String"];
  longTermRental: Scalars["Boolean"];
  longTermRentalBookable: Scalars["Boolean"];
  minimumStayLength: Scalars["Int"];
  neighborhoodContent?: Maybe<Scalars["String"]>;
  neighborhoodDescription?: Maybe<Scalars["String"]>;
  neighborhoodName?: Maybe<Scalars["String"]>;
  neighborhoodTags: Array<Scalars["String"]>;
  parkingInfo: Array<Scalars["String"]>;
  photos: Array<Photo>;
  publicTransportationInfo?: Maybe<Scalars["String"]>;
  shortDescription?: Maybe<Scalars["String"]>;
  sleepCount?: Maybe<Scalars["Int"]>;
  squareFootage: Scalars["Int"];
  stateName: Scalars["String"];
  stockedKitchen: Scalars["Boolean"];
  title?: Maybe<Scalars["String"]>;
  url: Scalars["String"];
};

/** L1 or L2 Listing types */
export type Listings = BuildingListing | Listing;

export type LocalRecommendation = Node & {
  /** Address of this location */
  address: Scalars["String"];
  /** Category associated withh this recommendation */
  category: Scalars["String"];
  /** Guest-facing description for this location */
  description: Scalars["String"];
  id: Scalars["ID"];
  /** Latitude of the location */
  latitude: Scalars["Float"];
  /** Longitude of the location. */
  longitude: Scalars["Float"];
  /** Name of this location */
  name: Scalars["String"];
  /** URL for the associated image */
  photoUrl: Scalars["String"];
};

export type LocalRecommendationExperimentFeedItem = {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  /** Flag specifying whether this feed item should be displayed on the client */
  enabled: Scalars["Boolean"];
  /** Local recommendation info */
  recommendation: LocalRecommendation;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type LocalRecommendationFeedItem = {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  /**
   * Flag specifying whether this feed item should be displayed on the client
   * @deprecated No longer testing comparison between categories displayed on card
   */
  enabled: Scalars["Boolean"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type LocalRecommendationV2FeedItem = {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type LoyaltyInfo = {
  loyaltyProgramId?: Maybe<Scalars["String"]>;
  maskedGuestLoyaltyId?: Maybe<Scalars["String"]>;
};

/** Input for LoyaltyInfo */
export type LoyaltyInfoInput = {
  guestLoyaltyId: Scalars["String"];
  loyaltyProgramId: Scalars["String"];
};

export enum LoyaltyTier {
  AmbassadorElite = "ambassador_elite",
  CobaltElite = "cobalt_elite",
  GoldElite = "gold_elite",
  Member = "member",
  PlatinumElite = "platinum_elite",
  SilverElite = "silver_elite",
  TitaniumElite = "titanium_elite",
}

export type LtsInfo = {
  bookingAgreementId?: Maybe<Scalars["Int"]>;
  bookingAgreementText?: Maybe<Scalars["String"]>;
  ltsEnabled: Scalars["Boolean"];
};

export type LuggageStoragePromptFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

/** Autogenerated return type of ManageUser. */
export type ManageUserPayload = {
  user: User;
};

/** Attributes for updating marketing email preferences on account */
export type MarketingEmailPreferencesInput = {
  marketing?: InputMaybe<Scalars["Boolean"]>;
  promotional?: InputMaybe<Scalars["Boolean"]>;
};

/** Autogenerated return type of MassRecreateHolds. */
export type MassRecreateHoldsPayload = {
  /** Always returns true. If unsuccessful, it will raise an error. */
  success: Scalars["Boolean"];
};

/** The message object used for resolving messages and notes */
export type Message = {
  /** the body of the message */
  body: Scalars["String"];
  /** the title of the message */
  title?: Maybe<Scalars["String"]>;
};

export type MessagingConfiguration = {
  /** Open salesforce case id */
  openSalesforceCaseId?: Maybe<Scalars["String"]>;
  /** Configuration object for sendbird messaging */
  sendbirdConfiguration: SendbirdConfiguration;
};

/** Metric definition */
export type Metric = {
  /** Metric formatted value */
  formattedValue: Scalars["String"];
  /** Metric label */
  label: Scalars["String"];
  /** Optional Tooltip text */
  tooltip?: Maybe<Scalars["String"]>;
  /** Metric value (Integer representation of the formatted value) */
  value: Scalars["Int"];
};

/** Metric Header definition */
export type MetricHeader = {
  /** Display value */
  label: Scalars["String"];
  /** Optional Tooltip text */
  tooltip?: Maybe<Scalars["String"]>;
};

/** Metric Resource definition */
export type MetricResource = {
  /** Resource id */
  id?: Maybe<Scalars["ID"]>;
  /** Image Url */
  imageUrl?: Maybe<Scalars["String"]>;
  /** Display value */
  name?: Maybe<Scalars["String"]>;
};

/** Metric Row definition */
export type MetricRow = {
  /** Metric values related to the resource */
  metrics: Array<Metric>;
  /** Non-metric related custom attributes */
  resource: MetricResource;
};

/** Metrics Table definition */
export type MetricsTable = {
  /** Table display headers */
  metricHeaders: Array<MetricHeader>;
  /** Table display values */
  metricRows: Array<MetricRow>;
};

export type MinimumNights = {
  value: Scalars["Int"];
};

export type MiscService = Node & {
  /** Company who performed the service */
  company: CleaningCompany;
  /** User who created this service */
  creator: User;
  /** Service cost */
  hkCost?: Maybe<HkCost>;
  id: Scalars["ID"];
  /** Service notes */
  notes?: Maybe<Scalars["String"]>;
  /** Service date */
  serviceDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Related entity to the service */
  serviceable: Serviceable;
};

export type MiscServiceConnections = {
  /** Index-based position of the search. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records? */
  hasMore: Scalars["Boolean"];
  /** The list of misc services. */
  miscServices: Array<MiscService>;
  /** Total number of misc service records. */
  total: Scalars["Int"];
};

/** Misc Service input filters */
export type MiscServiceFilterInput = {
  cityId: Scalars["String"];
  companyIds?: InputMaybe<Array<Scalars["String"]>>;
  costApprovalStatuses?: InputMaybe<Array<Scalars["String"]>>;
  isInternal?: InputMaybe<Scalars["Boolean"]>;
  serviceDateFrom?: InputMaybe<Scalars["RFC3339DateTime"]>;
  serviceDateTo?: InputMaybe<Scalars["RFC3339DateTime"]>;
};

export enum MobileKey {
  AssaAbloy = "assa_abloy",
  Salto = "salto",
}

/** Autogenerated return type of MoveScheduledPayment. */
export type MoveScheduledPaymentPayload = {
  response: MoveScheduledPaymentStatus;
};

export type MoveScheduledPaymentStatus = {
  /** associated status message */
  message?: Maybe<Scalars["String"]>;
  /** boolean of moveScheduledPayment success/fail */
  status: Scalars["Boolean"];
};

/** Root GraphQL Mutation. */
export type Mutation = {
  /** Approve an hk cost */
  approveHkCost?: Maybe<ApproveHkCostPayload>;
  /** Associate booking to a different account. maybe guest made a mistake, or duplicate account */
  associateAccount?: Maybe<AssociateAccountPayload>;
  /** Associate a guest account */
  associateGuestAccount?: Maybe<AssociateGuestAccountPayload>;
  /**
   * Associate booking to the current account. This is used for OTA bookings and
   * logic is migrated from
   * Www::BookingAccountAssociationController#associate_inquiry
   */
  associateInquiry?: Maybe<AssociateInquiryPayload>;
  /** Attaches a PaymentMethod to a Customer */
  attachPaymentMethod?: Maybe<AttachPaymentMethodPayload>;
  /** Create tasks in bulk for the given subjects */
  batchCreateTasks?: Maybe<BatchCreateTasksPayload>;
  /** Updates units in bulk with the given changes */
  batchUpdateUnits?: Maybe<BatchUpdateUnitsPayload>;
  /** Cancel an early check-in or late check-out request */
  cancelEciLcoRequest?: Maybe<CancelEciLcoRequestPayload>;
  /** Cancel an Intra-stay Clean */
  cancelIntrastayClean?: Maybe<CancelIntrastayCleanPayload>;
  /** Delete a SpotHero parking reservation */
  cancelParkingReservation?: Maybe<CancelParkingReservationPayload>;
  /** Guest request to cancel a pending alteration. */
  cancelPendingAlteration?: Maybe<CancelPendingAlterationPayload>;
  /** Cancel the provided active relocation request */
  cancelRelocation?: Maybe<CancelRelocationPayload>;
  /** Manual charge for a group booking */
  chargeGroup?: Maybe<ChargeGroupPayload>;
  /** Claim a gift card against an account */
  claimGiftCard?: Maybe<ClaimGiftCardPayload>;
  /** Relocate the inquiry unit into another unit that is available and part of the same collection */
  completeAutomatedRelocation?: Maybe<CompleteAutomatedRelocationPayload>;
  /** Configure a mobile key for an inquiry */
  configureMobileKey?: Maybe<ConfigureMobileKeyPayload>;
  /** Add and confirm a PaymentMethod to a Customer */
  confirmPaymentMethod?: Maybe<ConfirmPaymentMethodPayload>;
  /** Triggers confirming phone verification code */
  confirmPhoneVerificationCode?: Maybe<ConfirmPhoneVerificationCodePayload>;
  /** Executes the relocation with the confirmed relocation option */
  confirmRelocationProposition?: Maybe<ConfirmRelocationPropositionPayload>;
  /** Executes the temporary relocation with the confirmed relocation option */
  confirmTemporaryRelocationProposition?: Maybe<ConfirmTemporaryRelocationPropositionPayload>;
  /** Create an account and sign in */
  createAccount?: Maybe<CreateAccountPayload>;
  /** Create an account with phone and address as an admin */
  createAccountAsAdmin?: Maybe<CreateAccountAsAdminPayload>;
  /** Create an account and sign in */
  createAccountWithInquiryToken?: Maybe<CreateAccountWithInquiryTokenPayload>;
  /** Create an account with oauth credentials */
  createAccountWithOauth?: Maybe<CreateAccountWithOauthPayload>;
  /** Creates a new attachment */
  createAttachment?: Maybe<CreateAttachmentPayload>;
  createBookingAndPaymentLink: BookingWithPaymentLinkResponse;
  /** Create Cleaning Request Cost Adjustment */
  createCleaningRequestCostAdjustment?: Maybe<CreateCleaningRequestCostAdjustmentPayload>;
  /** Creates a new comment */
  createComment?: Maybe<CreateCommentPayload>;
  /** Creates a company */
  createCompany?: Maybe<CreateCompanyPayload>;
  /** Creates a flex-lease inquiry */
  createFlexLeaseInquiry?: Maybe<CreateFlexLeaseInquiryPayload>;
  /** Create/update a group inquiry */
  createGroupInquiry?: Maybe<CreateGroupInquiryPayload>;
  /** Create Miscellaneous Service */
  createHkMiscService?: Maybe<CreateMiscServicePayload>;
  /** Creates an inquiry */
  createInquiry?: Maybe<InquiryResult>;
  /** Create an Intra-stay Clean */
  createIntrastayClean?: Maybe<CreateIntrastayCleanPayload>;
  /** Create or update a guest account */
  createOrUpdateGuestAccount?: Maybe<CreateOrUpdateGuestAccountPayload>;
  /** Create or update a relocation request */
  createOrUpdateRelocationRequest?: Maybe<CreateOrUpdateRelocationRequestPayload>;
  /** Create a SpotHero parking reservation */
  createParkingReservation?: Maybe<CreateParkingReservationPayload>;
  /** Create a phase lifecycle */
  createPhaseLifecycle?: Maybe<PhaseLifecycle>;
  /** Creates multiple relocation options for the given inquiry for each chosen unit and a given start/end date range. */
  createRelocationPropositions?: Maybe<CreateRelocationPropositionsPayload>;
  /** Creates a new saved filter */
  createSavedTomFilter?: Maybe<CreateFilterPayload>;
  /** Subscribe to notifications of a resource as a follower */
  createSubscription?: Maybe<CreateSubscriptionPayload>;
  /** Creates a TOM task */
  createTask?: Maybe<CreateTaskPayload>;
  /** creates a tom task checklist item */
  createTaskChecklistItem?: Maybe<CreateItemPayload>;
  /** Update the inquiry to set the provided rate plan */
  croUpdateInquiryRatePlan?: Maybe<CroUpdateInquiryRatePlanPayload>;
  /** Delete an account and erase all related data */
  deleteAccount?: Maybe<DeleteAccountPayload>;
  /** Remove all PII from accounts generated by 4FA or Bonvoy Login */
  deleteAccountData?: Maybe<DeleteAccountDataPayload>;
  /** Deletes an attachment */
  deleteAttachment?: Maybe<Scalars["DeleteAttachmentPayload"]>;
  deleteCustomAccessCode: Scalars["Boolean"];
  /** Delete a saved filter */
  deleteSavedTomFilter?: Maybe<DeleteFilterPayload>;
  /** Unsubscribe to notifications of a resource as a follower */
  deleteSubscription?: Maybe<DeleteSubscriptionPayload>;
  /** Detaches PaymentMethods from Customer */
  detachPaymentMethod?: Maybe<DetachPaymentMethodPayload>;
  /** Remove the relocation option */
  discardRelocationPropositions?: Maybe<DiscardRelocationPropositionsPayload>;
  /** Enqueues a failed deposit (pre-booking payment) to be processed asynchronously. */
  enqueueFailedPreBookingPayment?: Maybe<EnqueueFailedPreBookingPaymentPayload>;
  generatePaymentMethodIFrame?: Maybe<PaymentMethodIFrame>;
  /** Completes payment for a booking asynchronously */
  makeAsyncBookingPayment?: Maybe<AsyncBookingPaymentPayload>;
  /** Completes payment for an orderable */
  makeOrderablePayment?: Maybe<OrderablePaymentPayload>;
  /** Make a payment */
  makePayment?: Maybe<PaymentPayload>;
  /** Mutation allowing leads to manage users */
  manageUser?: Maybe<ManageUserPayload>;
  /** Trigger a mass cancellation of existing group holds and a recreation */
  massRecreateHolds?: Maybe<MassRecreateHoldsPayload>;
  /** Move scheduled payment from source to target inquiry */
  moveScheduledPayment?: Maybe<MoveScheduledPaymentPayload>;
  /** Override shell account credentials */
  overrideShellAccount?: Maybe<OverrideShellAccountPayload>;
  /** Pre-authorize customer credit card for given inquiry */
  preAuthorizeCard?: Maybe<PreAuthorizeCardPayload>;
  /** Create and return an invoice for addons */
  prepareAddonInvoice?: Maybe<PrepareAddonInvoicePayload>;
  /** Create and return an invoice for early check-in/late check-out service */
  prepareEciLcoInvoice?: Maybe<PrepareEciLcoInvoicePayload>;
  /** Create and return an invoice for a service */
  prepareServiceInvoice?: Maybe<PrepareServiceInvoicePayload>;
  /** Record a manually charged deposit for a GMB group (obsolete, marked for deletion) */
  recordGroupDeposit?: Maybe<RecordGroupDepositPayload>;
  /** generate jwt using a refresh token of an account */
  refreshToken?: Maybe<RefreshTokenPayload>;
  /** Register a device token to a resource. Defaults to current_account */
  registerPushClient?: Maybe<RegisterPushClientPayload>;
  /** Reject an hk cost */
  rejectHkCost?: Maybe<RejectHkCostPayload>;
  /** Remove info about a pet staying with a guest */
  removePet?: Maybe<RemovePetPayload>;
  /** Guest request to make an alteration. */
  requestAlteration?: Maybe<RequestAlterationPayload>;
  /** Guest request to cancel a booking. */
  requestCancellation?: Maybe<RequestCancellationPayload>;
  /** Guest request for an early check-in time. */
  requestEarlyCheckin?: Maybe<RequestEarlyCheckinPayload>;
  /** Guest request to order groceries. */
  requestGroceries?: Maybe<RequestGroceriesPayload>;
  /** Guest request for an later check-out time. */
  requestLateCheckout?: Maybe<RequestLateCheckoutPayload>;
  /** Triggers sending a verification code for a non-registered guest. */
  requestPhoneVerificationCode?: Maybe<RequestPhoneVerificationCodePayload>;
  /** Rescheduled a failed scheduled payment */
  rescheduleFailedScheduledPayment?: Maybe<RescheduleFailedScheduledPaymentPayload>;
  resendConfirmationEmail?: Maybe<ResendConfirmationEmailPayload>;
  /** Resend a new verification code */
  resendPhoneVerificationCode?: Maybe<ResendPhoneVerificationCodePayload>;
  /** Respond to a PreStaySurvey question */
  respondToPreStaySurvey?: Maybe<RespondToPreStaySurveyPayload>;
  /** Revoke guest account access */
  revokeGuestAccount?: Maybe<RevokeGuestAccountPayload>;
  /** Schedules tasks for the given city and date range */
  scheduleTasks?: Maybe<ScheduleTasksPayload>;
  sendAppDownloadLink?: Maybe<SendAppDownloadLinkPayload>;
  /** Triggers a phone verification from a booking confirmation code */
  sendPhoneVerificationViaConfirmationCode?: Maybe<SendPhoneVerificationViaConfirmationCodePayload>;
  /** Triggers reset password email */
  sendResetPasswordInstructionsEmail?: Maybe<SendResetPasswordInstructionsEmailPayload>;
  /** Call to store the guest_actual_departure_time and update the check-out time of the inquiry if it is allowed */
  setGuestActualDepartureTime?: Maybe<SetGuestActualDepartureTimePayload>;
  /** Shares the access details of an inquiry with another guest */
  shareAccessInformation?: Maybe<Scalars["ShareAccessInformationPayload"]>;
  /** Sign into an account using email and password */
  signInWithEmail?: Maybe<SignInWithEmailPayload>;
  /** Verify a users code/token, and return a valid token for the GraphQL API */
  signInWithOauth?: Maybe<SignInWithOauthPayload>;
  /** Sign into an account using confirmation code and phone verification */
  signInWithVerifiedConfirmationCode?: Maybe<SignInWithVerifiedConfirmationCodePayload>;
  /** Sign out of an account */
  signOut?: Maybe<Scalars["SignOutPayload"]>;
  /** Begin a PreStaySurvey */
  startPreStaySurvey?: Maybe<StartPreStaySurveyPayload>;
  /** Submit CSAT survey feedback */
  submitCsatFeedback?: Maybe<SubmitCsatFeedbackPayload>;
  tokenizeCreditCard: Scalars["Boolean"];
  /** Track analytics event */
  trackEvent?: Maybe<TrackEventPayload>;
  /** Track user analytics event */
  trackUserEvent?: Maybe<TrackUserEventPayload>;
  /** Updates account information */
  updateAccount?: Maybe<UpdateAccountPayload>;
  /** Update account email address */
  updateAccountEmail?: Maybe<UpdateAccountEmailPayload>;
  /** Updates account password */
  updateAccountPassword?: Maybe<UpdateAccountPasswordPayload>;
  /** Update account phone number */
  updateAccountPhone?: Maybe<UpdateAccountPhonePayload>;
  /** Updates account settings */
  updateAccountSettings?: Maybe<UpdateAccountSettingsPayload>;
  /** Update a building project */
  updateBuildingProject?: Maybe<BuildingProject>;
  /** Updating cleaning supervisors of a building */
  updateBuildingSupervisors?: Maybe<UpdateBuildingSupervisorsPayload>;
  /** Call to update the check in or out times for a booking. */
  updateCheckInOutTimes?: Maybe<UpdateCheckInOutTimesPayload>;
  /** Update Cleaning Request Cost Adjustment */
  updateCleaningRequestCostAdjustment?: Maybe<UpdateCleaningRequestCostAdjustmentPayload>;
  /** Updates a comment */
  updateComment?: Maybe<UpdateCommentPayload>;
  /** Updates a company */
  updateCompany?: Maybe<UpdateCompanyPayload>;
  /** Update an early check-in or late check-out request */
  updateEciLcoRequest?: Maybe<UpdateEciLcoRequestPayload>;
  /** Create or update payer's payment details for related group booking. */
  updateGroupPayerPaymentDetails?: Maybe<UpdateGroupPayerPaymentDetailsPayload>;
  /** Update Miscellaneous Service */
  updateHkMiscService?: Maybe<UpdateMiscServicePayload>;
  /** Update a lease deal */
  updateLeaseDeal?: Maybe<UpdateLeaseDealPayload>;
  /** Updates a license plate to SpotHero */
  updateLicensePlate?: Maybe<UpdateLicensePlatePayload>;
  /** Updates read_at timestamp for successfully fetched notifications */
  updateNotificationsAsRead?: Maybe<UpdateNotificationsAsReadPayload>;
  /** Update OTA guest details. */
  updateOtaGuestDetails?: Maybe<UpdateOtaGuestDetailsPayload>;
  /** Updates PaymentMethods attached to a Customer */
  updatePaymentMethod?: Maybe<UpdatePaymentMethodPayload>;
  /** Add or update info about a pet staying with a guest */
  updatePet?: Maybe<UpdatePetPayload>;
  /** Update a phase lifecycle */
  updatePhaseLifecycle?: Maybe<PhaseLifecycle>;
  /** Upsert phased unit associations and dates */
  updatePhaseUnitDates?: Maybe<PhaseUnitDatesUpdate>;
  updatePhoneNumber?: Maybe<UpdatePhoneNumberPayload>;
  /** add/removes companies of a user for qa emails */
  updateQaEmailConfiguration?: Maybe<UpdateQaEmailConfigurationPayload>;
  /** Update a scheduled payment amount */
  updateScheduledPaymentAmount?: Maybe<UpdateScheduledPaymentAmountPayload>;
  /** Updates a TOM task, statuses: [deleted, canceled, waiting, ready, enroute, inprogress, complete] */
  updateTask?: Maybe<UpdateTaskPayload>;
  /** Updates a tom task checklist item */
  updateTaskChecklistItem?: Maybe<UpdateItemPayload>;
  /** Updates TOM tasks in bulk */
  updateTasks?: Maybe<UpdateTasksPayload>;
  /** Updates travel survey answers */
  updateTravelSurvey?: Maybe<UpdateTravelSurveyPayload>;
  /** Mutation allowing users to edit their own profile */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a user notification */
  updateUserNotification?: Maybe<UpdateNotificationPayload>;
  /** Updates all user notification */
  updateUserNotifications?: Maybe<UpdateNotificationsPayload>;
  /** Uploads files to Cloudinary */
  uploadFiles?: Maybe<UploadFilesPayload>;
  upsertCustomAccessCode?: Maybe<UpsertCustomAccessCodePayload>;
  /** Create/update a group and all it's relations. (trip, members, blocks, inquiries) */
  upsertGroup?: Maybe<UpsertGroupPayload>;
  /** Send all the deposits (pre-booking payments) of a group and let the backend consolidate */
  upsertGroupDeposits?: Maybe<UpsertGroupDepositsPayload>;
  /** Create/update a sales account */
  upsertSalesAccount?: Maybe<UpsertSalesAccountPayload>;
  /** Returns an inquiry token on verification to link inquiry to new account */
  verifyConfirmationCodeForInquiryToken?: Maybe<VerifyConfirmationCodeForInquiryTokenPayload>;
  /** Verifies an unverified phone number on an account */
  verifyPhone?: Maybe<Scalars["VerifyPhonePayload"]>;
  /** Verifies an unverified phone number on an account */
  verifyPhoneV2?: Maybe<VerifyPhoneV2Payload>;
};

/** Root GraphQL Mutation. */
export type MutationApproveHkCostArgs = {
  hkCostId: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationAssociateAccountArgs = {
  accountEmail: Scalars["String"];
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationAssociateGuestAccountArgs = {
  bookingUniqKey: Scalars["String"];
  id: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationAssociateInquiryArgs = {
  bookingUniqKey: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationAttachPaymentMethodArgs = {
  paymentMethodId: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationBatchCreateTasksArgs = {
  assigneeId?: InputMaybe<Scalars["ID"]>;
  attachments?: InputMaybe<Array<TaskAttachmentInput>>;
  channel?: InputMaybe<Scalars["String"]>;
  dueAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  name: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  priority?: InputMaybe<Scalars["Int"]>;
  recurrenceSettings?: InputMaybe<TaskRecurrenceSettingsInput>;
  status?: InputMaybe<FilterStatus>;
  subjectIds: Array<Scalars["ID"]>;
  subjectType: SubjectTypeEnum;
  tomTaskContextCustomUniqueRef?: InputMaybe<Scalars["String"]>;
  tomTaskContextId?: InputMaybe<Scalars["ID"]>;
  type: TypeEnum;
  typeStructuredMetadata?: InputMaybe<TypeStructuredMetadata>;
};

/** Root GraphQL Mutation. */
export type MutationBatchUpdateUnitsArgs = {
  unitChanges: Array<UnitChangeInput>;
};

/** Root GraphQL Mutation. */
export type MutationCancelEciLcoRequestArgs = {
  requestId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCancelIntrastayCleanArgs = {
  cleaningRequestId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCancelParkingReservationArgs = {
  reservationId: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationCancelPendingAlterationArgs = {
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCancelRelocationArgs = {
  relocationRequestId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationChargeGroupArgs = {
  amount: Scalars["Float"];
  chargedUntil?: InputMaybe<Scalars["String"]>;
  groupId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationClaimGiftCardArgs = {
  code: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationCompleteAutomatedRelocationArgs = {
  inquiryId: Scalars["ID"];
  reason?: InputMaybe<Scalars["String"]>;
  reasonDetails?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationConfigureMobileKeyArgs = {
  deviceId: Scalars["String"];
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationConfirmPaymentMethodArgs = {
  bookingUniqKey: Scalars["String"];
  paymentMethodId: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationConfirmPhoneVerificationCodeArgs = {
  countryCode: Scalars["String"];
  phoneNumber: Scalars["String"];
  verificationCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationConfirmRelocationPropositionArgs = {
  guestLiable?: InputMaybe<Scalars["String"]>;
  originalInquiryCheckOutDatetime?: InputMaybe<Scalars["ISO8601DateTime"]>;
  refundOption?: InputMaybe<Scalars["String"]>;
  relocationInquiryCheckInDatetime?: InputMaybe<Scalars["ISO8601DateTime"]>;
  relocationPropositionKey: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationConfirmTemporaryRelocationPropositionArgs = {
  checkInDatetime: Scalars["ISO8601DateTime"];
  checkOutDatetime: Scalars["ISO8601DateTime"];
  relocationPropositionKey: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCreateAccountArgs = {
  createAccountInput: CreateAccountInput;
};

/** Root GraphQL Mutation. */
export type MutationCreateAccountAsAdminArgs = {
  createAccountInput: CreateAccountAsAdminInput;
};

/** Root GraphQL Mutation. */
export type MutationCreateAccountWithInquiryTokenArgs = {
  createAccountInput: CreateAccountInput;
  inquiryToken: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationCreateAccountWithOauthArgs = {
  createAccountInput: CreateAccountWithOauthInput;
};

/** Root GraphQL Mutation. */
export type MutationCreateAttachmentArgs = {
  attachToNewComment?: InputMaybe<Scalars["Boolean"]>;
  format: Format;
  host?: InputMaybe<Host>;
  markAllRead?: InputMaybe<Scalars["Boolean"]>;
  publicId: Scalars["String"];
  resourceType: Resource;
  targetId: Scalars["ID"];
  targetType: Attachable;
};

/** Root GraphQL Mutation. */
export type MutationCreateBookingAndPaymentLinkArgs = {
  input: CreateBookingBeforePaymentInput;
};

/** Root GraphQL Mutation. */
export type MutationCreateCleaningRequestCostAdjustmentArgs = {
  amount: Scalars["Float"];
  cleaningRequestId: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationCreateCommentArgs = {
  body: Scalars["String"];
  markAllRead?: InputMaybe<Scalars["Boolean"]>;
  richContent?: InputMaybe<RichContentInput>;
  targetId: Scalars["ID"];
  targetType: Commentable;
};

/** Root GraphQL Mutation. */
export type MutationCreateCompanyArgs = {
  address?: InputMaybe<Scalars["String"]>;
  cityId: Scalars["ID"];
  isInternal: Scalars["Boolean"];
  managerId: Scalars["ID"];
  minPhotosRequiredForCleaningCompletion: Scalars["Int"];
  name: Scalars["String"];
  phone: Scalars["String"];
  unitIds?: InputMaybe<Array<Scalars["ID"]>>;
};

/** Root GraphQL Mutation. */
export type MutationCreateFlexLeaseInquiryArgs = {
  bedrooms?: InputMaybe<Scalars["Int"]>;
  city?: InputMaybe<Scalars["String"]>;
  dealBreakers: Scalars["String"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  initialReferrer?: InputMaybe<Scalars["String"]>;
  lastName: Scalars["String"];
  listingId?: InputMaybe<Scalars["ID"]>;
  moveInOn?: InputMaybe<Scalars["String"]>;
  moveOutOn?: InputMaybe<Scalars["String"]>;
  occupation: Scalars["String"];
  phone: Scalars["String"];
  sleeps?: InputMaybe<Scalars["Int"]>;
  source?: InputMaybe<Scalars["String"]>;
  utmCampaign?: InputMaybe<Scalars["String"]>;
  utmContent?: InputMaybe<Scalars["String"]>;
  utmMedium?: InputMaybe<Scalars["String"]>;
  utmSource?: InputMaybe<Scalars["String"]>;
  utmTerm?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationCreateGroupInquiryArgs = {
  groupBlockId: Scalars["ID"];
  groupInquiryInput: GroupInquiryInput;
};

/** Root GraphQL Mutation. */
export type MutationCreateHkMiscServiceArgs = {
  amount: Scalars["Float"];
  companyId: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  serviceDate: Scalars["RFC3339DateTime"];
  serviceableId: Scalars["String"];
  serviceableType: HkServiceableType;
};

/** Root GraphQL Mutation. */
export type MutationCreateInquiryArgs = {
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  collectionId?: InputMaybe<Scalars["ID"]>;
  guestNb?: InputMaybe<Scalars["Int"]>;
  listingId: Scalars["ID"];
  promoCodes: Array<Scalars["String"]>;
  referralPartnerId?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationCreateIntrastayCleanArgs = {
  cleanDate: Scalars["RFC3339DateTime"];
  cleaningWindow: CleaningWindow;
  inquiryId: Scalars["ID"];
  receivableInvoiceId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCreateOrUpdateGuestAccountArgs = {
  bookingUniqKey: Scalars["String"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationCreateOrUpdateRelocationRequestArgs = {
  inquiryId: Scalars["ID"];
  reason: Scalars["String"];
  reasonDetails?: InputMaybe<Scalars["String"]>;
  relocationCheckInDate?: InputMaybe<Scalars["String"]>;
  sourceType: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationCreateParkingReservationArgs = {
  licensePlate?: InputMaybe<Scalars["String"]>;
  quote: Scalars["String"];
  receivableInvoiceId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCreatePhaseLifecycleArgs = {
  createPhaseLifecycleInput: CreatePhaseLifecycleInput;
};

/** Root GraphQL Mutation. */
export type MutationCreateRelocationPropositionsArgs = {
  inquiryId: Scalars["ID"];
  relocationPropositionInputsGroups?: InputMaybe<
    Array<RelocationPropositionInputGroup>
  >;
};

/** Root GraphQL Mutation. */
export type MutationCreateSavedTomFilterArgs = {
  description?: InputMaybe<Scalars["String"]>;
  filter: TaskFilterInput;
  name: Scalars["String"];
  ownerId: Scalars["ID"];
  ownerType: FilterOwner;
};

/** Root GraphQL Mutation. */
export type MutationCreateSubscriptionArgs = {
  resourceId: Scalars["ID"];
  resourceType: NotificationResource;
  userId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCreateTaskArgs = {
  assigneeId?: InputMaybe<Scalars["String"]>;
  attachments?: InputMaybe<Array<TaskAttachmentInput>>;
  channel?: InputMaybe<Scalars["String"]>;
  communicationMethod?: InputMaybe<Scalars["String"]>;
  companyId?: InputMaybe<Scalars["ID"]>;
  dueAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  earliestStartAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  latestEndAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  name: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  permissionToEnter?: InputMaybe<FilterPte>;
  preferredCommunicationMethod?: InputMaybe<Scalars["String"]>;
  priority?: InputMaybe<Scalars["Int"]>;
  recurrenceSettings?: InputMaybe<TaskRecurrenceSettingsInput>;
  scheduledStartAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  sourceTaskId?: InputMaybe<Scalars["ID"]>;
  status?: InputMaybe<FilterStatus>;
  subjectId: Scalars["ID"];
  tagIds?: InputMaybe<Array<Scalars["ID"]>>;
  taskDependencies?: InputMaybe<Array<TaskDependencyInput>>;
  tomTaskContextCustomUniqueRef?: InputMaybe<Scalars["String"]>;
  tomTaskContextId?: InputMaybe<Scalars["Int"]>;
  type: TypeEnum;
  typeStructuredMetadata?: InputMaybe<TypeStructuredMetadata>;
};

/** Root GraphQL Mutation. */
export type MutationCreateTaskChecklistItemArgs = {
  name: Scalars["String"];
  required?: InputMaybe<Scalars["Boolean"]>;
  tomTaskId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationCroUpdateInquiryRatePlanArgs = {
  inquiryUniqKey: Scalars["String"];
  ratePlanId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationDeleteAccountArgs = {
  deleteAccountInput: DeleteAccountInput;
};

/** Root GraphQL Mutation. */
export type MutationDeleteAccountDataArgs = {
  bookingIds?: InputMaybe<Array<Scalars["String"]>>;
  guestLoyaltyIds?: InputMaybe<Array<Scalars["String"]>>;
};

/** Root GraphQL Mutation. */
export type MutationDeleteAttachmentArgs = {
  attachmentId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationDeleteSavedTomFilterArgs = {
  id: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationDeleteSubscriptionArgs = {
  resourceId: Scalars["ID"];
  resourceType?: InputMaybe<NotificationResource>;
  userId?: InputMaybe<Scalars["ID"]>;
};

/** Root GraphQL Mutation. */
export type MutationDetachPaymentMethodArgs = {
  paymentMethodId: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationDiscardRelocationPropositionsArgs = {
  originalInquiryId: Scalars["ID"];
  relocationPropositionKeys: Array<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationEnqueueFailedPreBookingPaymentArgs = {
  groupId: Scalars["ID"];
  scheduleId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationGeneratePaymentMethodIFrameArgs = {
  buttonType?: InputMaybe<Scalars["String"]>;
  locale?: InputMaybe<Scalars["String"]>;
  styles?: InputMaybe<Scalars["String"]>;
  uniqueCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationMakeAsyncBookingPaymentArgs = {
  accountId?: InputMaybe<Scalars["ID"]>;
  ancillaryServices?: InputMaybe<Array<AncillaryServiceInput>>;
  bookingAgreementId?: InputMaybe<Scalars["ID"]>;
  collectionId?: InputMaybe<Scalars["ID"]>;
  currency?: InputMaybe<Scalars["String"]>;
  guestInfo: GuestInfoInput;
  inquiryPaymentKey: Scalars["String"];
  loyaltyInfo?: InputMaybe<LoyaltyInfoInput>;
  metadata?: InputMaybe<Scalars["String"]>;
  orderables?: InputMaybe<Array<OrderableInput>>;
  paymentInfo: PaymentInfoInput;
  promoCodes: Array<Scalars["String"]>;
  ratePlanId?: InputMaybe<Scalars["ID"]>;
  receivableInvoiceId?: InputMaybe<Scalars["ID"]>;
  redirectUri?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationMakeOrderablePaymentArgs = {
  accountId?: InputMaybe<Scalars["ID"]>;
  currency: Scalars["String"];
  guestInfo: GuestInfoInput;
  metadata?: InputMaybe<Scalars["String"]>;
  orderables: Array<OrderableInput>;
  paymentInfo: PaymentInfoInput;
  receivableInvoiceId?: InputMaybe<Scalars["ID"]>;
  redirectUri?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationMakePaymentArgs = {
  customerId?: InputMaybe<Scalars["ID"]>;
  paymentSource?: InputMaybe<Scalars["String"]>;
  receivableInvoiceId?: InputMaybe<Scalars["ID"]>;
  returnUrl?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationManageUserArgs = {
  addRoles?: InputMaybe<Array<DispatchRoleName>>;
  addTags?: InputMaybe<Array<Scalars["ID"]>>;
  cityId?: InputMaybe<Scalars["ID"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  lastName?: InputMaybe<Scalars["String"]>;
  removeRoles?: InputMaybe<Array<DispatchRoleName>>;
  removeTags?: InputMaybe<Array<Scalars["ID"]>>;
};

/** Root GraphQL Mutation. */
export type MutationMassRecreateHoldsArgs = {
  groupBlockId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationMoveScheduledPaymentArgs = {
  sourceId: Scalars["ID"];
  targetId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationOverrideShellAccountArgs = {
  overrideShellAccountInput: CreateAccountInput;
  resetPasswordToken: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationPreAuthorizeCardArgs = {
  bookingUniqKey: Scalars["String"];
  intention: PreAuthorizationIntention;
  paymentMethodId: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationPrepareAddonInvoiceArgs = {
  ancillaryServices: Array<AncillaryServiceInput>;
  inquiryKey: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationPrepareEciLcoInvoiceArgs = {
  earlyCheckIn?: InputMaybe<Scalars["RFC3339DateTime"]>;
  lateCheckOut?: InputMaybe<Scalars["RFC3339DateTime"]>;
  missingDesiredCheckInTime?: InputMaybe<Scalars["Boolean"]>;
  missingDesiredCheckOutTime?: InputMaybe<Scalars["Boolean"]>;
  paymentFlowType?: InputMaybe<Scalars["String"]>;
  paymentWaiveReason?: InputMaybe<Scalars["String"]>;
  paymentWaiveReasonDetails?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
  subjectId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationPrepareServiceInvoiceArgs = {
  currency: Scalars["String"];
  lineItems: Array<LineItemInput>;
  serviceKey: Scalars["String"];
  serviceProviderKey?: InputMaybe<Scalars["String"]>;
  subjectId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationRecordGroupDepositArgs = {
  amount: Scalars["Float"];
  currency: Currency;
  externalIdentifier: Scalars["String"];
  groupId: Scalars["ID"];
  paymentType: DepositPayment;
  succeededAt: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationRefreshTokenArgs = {
  jwtToken: Scalars["String"];
  refreshToken: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationRegisterPushClientArgs = {
  deviceToken: Scalars["String"];
  platform: Scalars["String"];
  version?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationRejectHkCostArgs = {
  hkCostId: Scalars["String"];
  rejectionReason: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationRemovePetArgs = {
  inquiryKey: Scalars["String"];
  petId: Scalars["Int"];
};

/** Root GraphQL Mutation. */
export type MutationRequestAlterationArgs = {
  inquiryId: Scalars["ID"];
  newCheckInDate?: InputMaybe<Scalars["String"]>;
  newCheckOutDate?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationRequestCancellationArgs = {
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationRequestEarlyCheckinArgs = {
  extendTo: Scalars["RFC3339DateTime"];
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationRequestGroceriesArgs = {
  inquiryId: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
  requestedItems: Array<GroceryOrder>;
};

/** Root GraphQL Mutation. */
export type MutationRequestLateCheckoutArgs = {
  extendTo: Scalars["RFC3339DateTime"];
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationRequestPhoneVerificationCodeArgs = {
  countryCode: Scalars["String"];
  phoneNumber: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationRescheduleFailedScheduledPaymentArgs = {
  id: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationResendConfirmationEmailArgs = {
  confirmationCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationRespondToPreStaySurveyArgs = {
  body?: InputMaybe<Scalars["String"]>;
  questionId: Scalars["ID"];
  skipped?: InputMaybe<Scalars["Boolean"]>;
  surveyId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationRevokeGuestAccountArgs = {
  bookingUniqKey: Scalars["String"];
  id: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationScheduleTasksArgs = {
  cityId: Scalars["ID"];
  endAt: Scalars["RFC3339DateTime"];
  startAt: Scalars["RFC3339DateTime"];
  taskIds: Array<Scalars["ID"]>;
};

/** Root GraphQL Mutation. */
export type MutationSendAppDownloadLinkArgs = {
  confirmationCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationSendPhoneVerificationViaConfirmationCodeArgs = {
  confirmationCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationSendResetPasswordInstructionsEmailArgs = {
  email: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationSetGuestActualDepartureTimeArgs = {
  actualDepartureTime?: InputMaybe<Scalars["RFC3339DateTime"]>;
  channel?: InputMaybe<Scalars["String"]>;
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationShareAccessInformationArgs = {
  email: Scalars["String"];
  firstName: Scalars["String"];
  inquiryId: Scalars["ID"];
  lastName: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationSignInWithEmailArgs = {
  email: Scalars["String"];
  password: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationSignInWithOauthArgs = {
  code: Scalars["String"];
  provider: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationSignInWithVerifiedConfirmationCodeArgs = {
  confirmationCode: Scalars["String"];
  phoneVerificationCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationSignOutArgs = {
  refreshToken?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationStartPreStaySurveyArgs = {
  inquiryId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationSubmitCsatFeedbackArgs = {
  input: CsatFeedbackInput;
};

/** Root GraphQL Mutation. */
export type MutationTokenizeCreditCardArgs = {
  cardIssuer: Scalars["String"];
  expirationDate: Scalars["String"];
  maskedCardNumber: Scalars["String"];
  paymentKey: Scalars["String"];
  sessionKey: Scalars["String"];
  uniqueCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationTrackEventArgs = {
  anonymousId: Scalars["String"];
  context: Scalars["String"];
  environment: Scalars["String"];
  eventName: Scalars["String"];
  eventPayload: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationTrackUserEventArgs = {
  eventName: Scalars["String"];
  eventPayload: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateAccountArgs = {
  accountId?: InputMaybe<Scalars["ID"]>;
  updateAccountInput: UpdateAccountInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdateAccountEmailArgs = {
  currentEmail: Scalars["String"];
  newEmail: Scalars["String"];
  skipConfirmation?: InputMaybe<Scalars["Boolean"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateAccountPasswordArgs = {
  password: Scalars["String"];
  passwordConfirmation: Scalars["String"];
  resetPasswordToken: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateAccountPhoneArgs = {
  accountEmail: Scalars["String"];
  phone: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateAccountSettingsArgs = {
  accountId?: InputMaybe<Scalars["ID"]>;
  accountSettingsInput: AccountSettingsInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdateBuildingProjectArgs = {
  input: BuildingProjectInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdateBuildingSupervisorsArgs = {
  addedSupervisors?: InputMaybe<Array<Scalars["ID"]>>;
  buildingId: Scalars["String"];
  removedSupervisors?: InputMaybe<Array<Scalars["ID"]>>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateCheckInOutTimesArgs = {
  eci?: InputMaybe<Scalars["RFC3339DateTime"]>;
  inquiryId: Scalars["ID"];
  lco?: InputMaybe<Scalars["RFC3339DateTime"]>;
  missingDesiredCiTime?: InputMaybe<Scalars["Boolean"]>;
  missingDesiredCoTime?: InputMaybe<Scalars["Boolean"]>;
  selfCheckOut?: InputMaybe<Scalars["Boolean"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateCleaningRequestCostAdjustmentArgs = {
  amount: Scalars["Float"];
  costAdjustmentId: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateCommentArgs = {
  commentId: Scalars["ID"];
  newBody?: InputMaybe<Scalars["String"]>;
  newDeleted?: InputMaybe<Scalars["Boolean"]>;
  newMentions?: InputMaybe<Array<Scalars["ID"]>>;
  newRichBody?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateCompanyArgs = {
  active?: InputMaybe<Scalars["Boolean"]>;
  addedEmployeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  addedGeneralUnitCleaningPricing?: InputMaybe<
    Array<CreateGeneralUnitCleaningPricingInput>
  >;
  addedIndividualUnitCleaningPricing?: InputMaybe<
    Array<CreateIndividualUnitCleaningPricingInput>
  >;
  addedUnitIds?: InputMaybe<Array<Scalars["ID"]>>;
  address?: InputMaybe<Scalars["String"]>;
  cityId?: InputMaybe<Scalars["ID"]>;
  deletedGeneralUnitCleaningPricing?: InputMaybe<Array<Scalars["ID"]>>;
  deletedIndividualUnitCleaningPricing?: InputMaybe<Array<Scalars["ID"]>>;
  id: Scalars["ID"];
  isInternal?: InputMaybe<Scalars["Boolean"]>;
  managerId?: InputMaybe<Scalars["ID"]>;
  minPhotosRequiredForCleaningCompletion?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  removedEmployeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  removedUnitIds?: InputMaybe<Array<Scalars["ID"]>>;
  updatedGeneralUnitCleaningPricing?: InputMaybe<
    Array<UpdateGeneralUnitCleaningPricingInput>
  >;
  updatedIndividualUnitCleaningPricing?: InputMaybe<
    Array<UpdateIndividualUnitCleaningPricingInput>
  >;
};

/** Root GraphQL Mutation. */
export type MutationUpdateEciLcoRequestArgs = {
  desiredTime: Scalars["RFC3339DateTime"];
  requestId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateGroupPayerPaymentDetailsArgs = {
  paymentMethodId: Scalars["String"];
  slug: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateHkMiscServiceArgs = {
  amount: Scalars["Float"];
  hkMiscServiceId: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateLeaseDealArgs = {
  leaseDeal: LeaseDealInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdateLicensePlateArgs = {
  licensePlate: Scalars["String"];
  reservationId: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateNotificationsAsReadArgs = {
  accountNotificationIds: Array<Scalars["ID"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateOtaGuestDetailsArgs = {
  inquiryId: Scalars["ID"];
  otaGuestDetailsInput: OtaGuestDetailsInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdatePaymentMethodArgs = {
  paymentMethodId: Scalars["String"];
  paymentMethodInput: PaymentMethodInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdatePetArgs = {
  breed: Scalars["String"];
  inquiryKey: Scalars["String"];
  kind: PetKind;
  name: Scalars["String"];
  petId?: InputMaybe<Scalars["Int"]>;
  weight: Scalars["Int"];
};

/** Root GraphQL Mutation. */
export type MutationUpdatePhaseLifecycleArgs = {
  phaseLifecycle: PhaseLifecycleInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdatePhaseUnitDatesArgs = {
  phaseUnitDatesInput: PhaseUnitDatesInput;
};

/** Root GraphQL Mutation. */
export type MutationUpdatePhoneNumberArgs = {
  countryCode: Scalars["String"];
  phoneNumber: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateQaEmailConfigurationArgs = {
  addedCompanyIds?: InputMaybe<Array<Scalars["ID"]>>;
  removedCompanyIds?: InputMaybe<Array<Scalars["ID"]>>;
  userId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateScheduledPaymentAmountArgs = {
  amount: Scalars["Float"];
  id: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateTaskArgs = {
  addTags?: InputMaybe<Array<Scalars["ID"]>>;
  changeReason?: InputMaybe<TomChangeReason>;
  eta?: InputMaybe<Scalars["RFC3339DateTime"]>;
  etaRangeEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  etaRangeStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  newAssigneeId?: InputMaybe<Scalars["String"]>;
  newAssigneeIds?: InputMaybe<Array<Scalars["String"]>>;
  newCleaningCompanyId?: InputMaybe<Scalars["ID"]>;
  newComplete?: InputMaybe<Scalars["Boolean"]>;
  newDueAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  newEarliestStartAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  newEstimatedDuration?: InputMaybe<Scalars["Int"]>;
  newLastViewedAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  newLatestEndAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  newName?: InputMaybe<Scalars["String"]>;
  newNotes?: InputMaybe<Scalars["String"]>;
  newPriority?: InputMaybe<Scalars["Int"]>;
  newScheduledStartAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  newStatus?: InputMaybe<Scalars["String"]>;
  permissionToEnter?: InputMaybe<FilterPte>;
  recurrenceSettings?: InputMaybe<TaskRecurrenceSettingsInput>;
  removeTags?: InputMaybe<Array<Scalars["ID"]>>;
  statusUpdatedAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  tomTaskId: Scalars["ID"];
  typeStructuredMetadata?: InputMaybe<TypeStructuredMetadata>;
  updateEtaReason?: InputMaybe<Scalars["String"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateTaskChecklistItemArgs = {
  checklistItemId: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  required?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<ChecklistItemStatus>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateTasksArgs = {
  addFollowers?: InputMaybe<Array<Scalars["ID"]>>;
  addTags?: InputMaybe<Array<Scalars["ID"]>>;
  assigneeId?: InputMaybe<Scalars["ID"]>;
  assigneeIds?: InputMaybe<Array<Scalars["ID"]>>;
  dueAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  priority?: InputMaybe<Scalars["Int"]>;
  removeTags?: InputMaybe<Array<Scalars["ID"]>>;
  status?: InputMaybe<TaskStatus>;
  taskIds: Array<Scalars["ID"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateTravelSurveyArgs = {
  csatScore: Scalars["Int"];
  uniqKey: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateUserArgs = {
  avatarId?: InputMaybe<Scalars["ID"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  lastName?: InputMaybe<Scalars["String"]>;
  tomTeamMemberCityId?: InputMaybe<Scalars["ID"]>;
};

/** Root GraphQL Mutation. */
export type MutationUpdateUserNotificationArgs = {
  archive?: InputMaybe<Scalars["Boolean"]>;
  notificationId: Scalars["ID"];
};

/** Root GraphQL Mutation. */
export type MutationUpdateUserNotificationsArgs = {
  archive: Scalars["Boolean"];
  notificationIds?: InputMaybe<Array<Scalars["ID"]>>;
};

/** Root GraphQL Mutation. */
export type MutationUploadFilesArgs = {
  attachableId: Scalars["ID"];
  attachableType: FilesAttachable;
  files?: InputMaybe<Array<Scalars["Upload"]>>;
};

/** Root GraphQL Mutation. */
export type MutationUpsertCustomAccessCodeArgs = {
  code: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationUpsertGroupArgs = {
  groupBlockInputs?: InputMaybe<Array<GroupBlockInput>>;
  groupTripInput: GroupTripInput;
  groupTripMemberInputs: Array<GroupTripMemberInput>;
};

/** Root GraphQL Mutation. */
export type MutationUpsertGroupDepositsArgs = {
  groupId: Scalars["ID"];
  preBookingPaymentSchedule: Array<PreBookingPaymentScheduleInput>;
};

/** Root GraphQL Mutation. */
export type MutationUpsertSalesAccountArgs = {
  salesAccountInput: SalesAccountInput;
};

/** Root GraphQL Mutation. */
export type MutationVerifyConfirmationCodeForInquiryTokenArgs = {
  confirmationCode: Scalars["String"];
  phoneVerificationCode: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationVerifyPhoneArgs = {
  code: Scalars["String"];
  phoneNumber: Scalars["String"];
};

/** Root GraphQL Mutation. */
export type MutationVerifyPhoneV2Args = {
  code: Scalars["String"];
  phoneNumber: Scalars["String"];
};

export type NameChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New task name. */
  newName: Scalars["String"];
  /** Previous task name. */
  previousName: Scalars["String"];
};

export type Neighborhood = Node & {
  /** Description of the neighborhood. */
  description: Scalars["String"];
  id: Scalars["ID"];
  /**
   * Recommendations for this neighborhood
   * @deprecated Deprecated in favor of Pois
   */
  localRecommendations: Array<LocalRecommendation>;
  /** Name of the neighborhood. */
  name: Scalars["String"];
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars["ID"];
};

export type NotesChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New notes. */
  newNotes: Scalars["String"];
  /** Previous notes. */
  previousNotes: Scalars["String"];
};

export type Notification = {
  /** Body information for the notification */
  body?: Maybe<Scalars["String"]>;
  /** Header information for the notification */
  heading?: Maybe<Scalars["String"]>;
  /** The name of the notification */
  name: Scalars["String"];
  /** The type of notification (info, error, warning, success) */
  type: Scalars["String"];
};

export type NotificationFeedItem = Node & {
  id: Scalars["ID"];
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export enum NotificationReason {
  Assignee = "assignee",
  BuildingSupervisor = "buildingSupervisor",
  HkManager = "hkManager",
  Lead = "lead",
  Mention = "mention",
  ParentAssignee = "parentAssignee",
  PreviousAssignee = "previousAssignee",
  Subscriber = "subscriber",
}

export enum NotificationResource {
  Task = "task",
  Unit = "unit",
}

export type OtaBooking = {
  /** ... */
  guestInfo: OtaGuestInfo;
  /** ... */
  inquiry: Inquiry;
  /** ... */
  productInfo: ProductInfo;
};

export type OtaGuestInfo = {
  countryAlpha2?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  dateOfBirth?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  isBgcNeeded?: Maybe<Scalars["Boolean"]>;
  lastName?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
};

export type OpenInfo = {
  /** human-readable representation of when this poi is open */
  hoursAsString: Scalars["String"];
  /** representation of hours of operation */
  openPeriods: Array<Period>;
};

export type OrderInfo = {
  metadata?: Maybe<Scalars["JSON"]>;
};

/** Input for an Orderable */
export type OrderableInput = {
  amountEach?: InputMaybe<Scalars["Float"]>;
  orderableId?: InputMaybe<Scalars["Int"]>;
  orderableType: Scalars["String"];
  quantity: Scalars["Int"];
};

export type OrderableInvoiceInfo = {
  lineItems: Array<InvoiceLineItem>;
  receivableInvoiceId?: Maybe<Scalars["ID"]>;
  total: InvoiceTotal;
};

/** Autogenerated return type of OrderablePayment. */
export type OrderablePaymentPayload = {
  response: PaymentResponse;
};

/** Attributes for updating an OTA guest's details. */
export type OtaGuestDetailsInput = {
  addressApt?: InputMaybe<Scalars["String"]>;
  addressCity?: InputMaybe<Scalars["String"]>;
  addressCountry?: InputMaybe<Scalars["String"]>;
  addressState?: InputMaybe<Scalars["String"]>;
  addressStreet?: InputMaybe<Scalars["String"]>;
  addressZipcode?: InputMaybe<Scalars["String"]>;
  countryAlpha2: Scalars["String"];
  countryCode: Scalars["String"];
  dateOfBirth: Scalars["String"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  phoneNumber: Scalars["String"];
};

/** Autogenerated return type of OverrideShellAccount. */
export type OverrideShellAccountPayload = {
  account: Account;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]>;
};

/** How to paginate */
export type Pagination = {
  /** pass this back if previous response gave it to you */
  cursor: Scalars["String"];
  limit: Scalars["Int"];
};

export type ParkingAddonInfo = {
  /** Where can the guest customize their parking? */
  checkoutUrl?: Maybe<Scalars["String"]>;
  /** Does the property charge for private parking? */
  offered: Scalars["Boolean"];
  /** Did the guest purchase private parking? */
  purchased: Scalars["Boolean"];
};

export type ParkingFacility = {
  /** Wheelchair accessible */
  accessible: Scalars["Boolean"];
  /** Display string. e.g. 21 USD/day */
  address: ServicesAddress;
  /** Always open */
  alwaysOpen: Scalars["Boolean"];
  /** On site staff */
  attendant: Scalars["Boolean"];
  /** Can this be canceled prior to arrival */
  cancellable: Scalars["Boolean"];
  /** Max height of vehicle in inches */
  clearanceInches?: Maybe<Scalars["Int"]>;
  /** Spot is covered */
  covered: Scalars["Boolean"];
  /** Spot Hero facility id */
  facilityId: Scalars["String"];
  /** url of an image of this facility */
  imageUrls?: Maybe<Array<Scalars["String"]>>;
  /** Allows in/out, aka re-entry */
  inOutAllowed: Scalars["Boolean"];
  /** License plate is required */
  licensePlateRequired: Scalars["Boolean"];
  /** Self parking */
  selfPark: Scalars["Boolean"];
  /** Spot Hero facility name */
  title: Scalars["String"];
  /** Valet parking */
  valet: Scalars["Boolean"];
  /** Approximation of walk time between location and this facility.  Null means unknown */
  walkTimeMinutes?: Maybe<Scalars["Int"]>;
};

export enum ParkingPaymentStatus {
  Disputed = "disputed",
  RefundPending = "refund_pending",
  Refunded = "refunded",
  Succeeded = "succeeded",
}

export type ParkingRate = {
  /** Currency.  e.g. USD, CAD */
  currency: Currency;
  /** Quote to pass back for reservation, don't mutate */
  quote: Scalars["String"];
  /** Total cost including taxes/fees e.g. 1700 */
  rate: Scalars["Int"];
};

export type ParkingReservation = {
  /** end time of reservation */
  ends: Scalars["RFC3339DateTime"];
  /** Spot Hero parking facility, retrieved with additional API call to SpotHero */
  facility?: Maybe<ParkingFacility>;
  /** SpotHero parking facility id */
  facilityId: Scalars["String"];
  /** license plate on file */
  licensePlate?: Maybe<Scalars["String"]>;
  /** SpotHero parking pass URL */
  parkingPassUrl: Scalars["String"];
  /** status of the payment */
  paymentStatus: ParkingPaymentStatus;
  /** email of renter on file */
  renterEmail: Scalars["String"];
  /** SpotHero reservation id */
  reservationId: Scalars["String"];
  /** status of the reservation */
  reservationStatus: ParkingReservationStatus;
  /** start time of reservation */
  starts: Scalars["RFC3339DateTime"];
};

export enum ParkingReservationStatus {
  Cancelled = "cancelled",
  Invalid = "invalid",
  Pending = "pending",
  Valid = "valid",
}

export type ParkingSearchResult = {
  /** Spot Hero facility */
  facility: ParkingFacility;
  /** Rate info */
  rate: ParkingRate;
};

export type ParkingTypes = {
  /** Free nearby parking lot details available */
  freeParkingLotDetails?: Maybe<Scalars["String"]>;
  /** Are there free parking lots near the unit? */
  freeParkingLotsNearby: Scalars["Boolean"];
  /** Is there free street parking near the unit? */
  freeStreetParking: Scalars["Boolean"];
  /** Free street parking details available */
  freeStreetParkingDetails?: Maybe<Scalars["String"]>;
  /** Paid nearby parking lot details available */
  paidParkingLotDetails?: Maybe<Scalars["String"]>;
  /** Are there paid parking lots near the unit? */
  paidParkingLotsNearby: Scalars["Boolean"];
  /** Is there paid street parking near the unit? */
  paidStreetParking: Scalars["Boolean"];
  /** Paid street parking details available */
  paidStreetParkingDetails?: Maybe<Scalars["String"]>;
  /** Private parking details available */
  privateParkingDetails?: Maybe<Scalars["String"]>;
  /** Is there free private parking included with the unit? */
  privateParkingWithUnitFree: Scalars["Boolean"];
  /** Is there paid private parking available to the unit? */
  privateParkingWithUnitPaid: Scalars["Boolean"];
};

/** Lease and Landlord partners */
export type Partner = Node & {
  /** Is active */
  active?: Maybe<Scalars["Boolean"]>;
  /** Email */
  email?: Maybe<Scalars["String"]>;
  /** First name */
  firstName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Last name */
  lastName?: Maybe<Scalars["String"]>;
  /** Phone */
  phone?: Maybe<Scalars["String"]>;
  /** Source */
  source?: Maybe<PartnerSource>;
  /** External source organization id */
  sourceOrgId?: Maybe<Scalars["Int"]>;
  /** External source organization name */
  sourceOrgName?: Maybe<Scalars["String"]>;
};

export enum PartnerSource {
  ColdContact = "cold_contact",
  Organic = "organic",
  Pipedrive = "pipedrive",
  Referral = "referral",
  Website = "website",
}

export type PayerPaymentDetails = {
  /** Group booking's concatenated label for check-in and check-out dates. */
  bookingDatesLabel: Scalars["String"];
  /** Name of the city. */
  city: Scalars["String"];
};

export type Payment = {
  /** the amount charged */
  amountCharged: Scalars["Float"];
  /** the currency of the amount charged */
  currency: Currency;
  /** the symbol of the currency of the amount charged */
  currencySymbol: Scalars["String"];
  /** payment type and ID */
  description: Scalars["String"];
  /** whether or not the payment was collected as a deposit */
  isDeposit: Scalars["Boolean"];
  /** whether or not the payment was a scheduled payment (not implemented) */
  isScheduledPayment: Scalars["Boolean"];
  /** the payment method */
  paymentMethod?: Maybe<Scalars["String"]>;
  /** when the payment is scheduled to be processed */
  scheduledAt?: Maybe<Scalars["String"]>;
  /** when the payment was successfully processed */
  succeededAt?: Maybe<Scalars["String"]>;
};

export type PaymentCreationDetails = {
  details?: Maybe<Scalars["String"]>;
  gatewayName?: Maybe<PaymentGateway>;
};

export enum PaymentGateway {
  Adyen = "ADYEN",
  AdyenPaypal = "ADYEN_PAYPAL",
  Stripe = "STRIPE",
}

export type PaymentInfo = {
  brand?: Maybe<Scalars["String"]>;
  cardholderName?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  last4?: Maybe<Scalars["String"]>;
  paidDate?: Maybe<Scalars["String"]>;
  paymentCreationDetails?: Maybe<Array<PaymentCreationDetails>>;
  paymentGateway?: Maybe<PaymentGateway>;
  paymentMethodId?: Maybe<Scalars["String"]>;
  savedPaymentMethods?: Maybe<Array<PaymentMethod>>;
  type?: Maybe<Scalars["String"]>;
};

/** Payment Info */
export type PaymentInfoInput = {
  billingFirstName?: InputMaybe<Scalars["String"]>;
  billingLastName?: InputMaybe<Scalars["String"]>;
  billingZipcode?: InputMaybe<Scalars["String"]>;
  paymentIntentId?: InputMaybe<Scalars["String"]>;
  paymentMethodDetails?: InputMaybe<Scalars["String"]>;
  paymentMethodId?: InputMaybe<Scalars["String"]>;
  savePaymentMethod?: InputMaybe<Scalars["Boolean"]>;
};

export type PaymentMethod = {
  /** Card brand. Can be amex, diners, discover, jcb, mastercard, unionpay, visa, or unknown. */
  brand: Scalars["String"];
  /** Flag that indicates the PaymentMethod is set as Customer's default. */
  default: Scalars["Boolean"];
  /** Two-digit number representing the card’s expiration month. */
  expMonth: Scalars["Int"];
  /** Four-digit number representing the card’s expiration year. */
  expYear: Scalars["Int"];
  /** Stripe's unique identifier for the PaymentMethod object. */
  id: Scalars["String"];
  /** The last four digits of the card. */
  last4: Scalars["String"];
  /** The type of the PaymentMethod. Can be 'card', 'ideal', or 'sepa_debit'. */
  type: Scalars["String"];
};

/** PaymentMethod card details. */
export type PaymentMethodCardInput = {
  expMonth?: InputMaybe<Scalars["String"]>;
  expYear?: InputMaybe<Scalars["String"]>;
};

export type PaymentMethodIFrame = {
  iframe?: Maybe<Scalars["String"]>;
  sessionKey?: Maybe<Scalars["String"]>;
};

/** Attributes for updating account settings on account */
export type PaymentMethodInput = {
  card: PaymentMethodCardInput;
};

/** Autogenerated return type of Payment. */
export type PaymentPayload = {
  response: RevenuePaymentResponse;
};

export type PaymentResponse = {
  error?: Maybe<Scalars["String"]>;
  jwt?: Maybe<Scalars["String"]>;
  paymentIntentClientSecret?: Maybe<Scalars["String"]>;
  redirectUri?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
  trackingInfo?: Maybe<Scalars["JSON"]>;
};

export enum PaymentStatus {
  NotPaid = "NOT_PAID",
  Paid = "PAID",
}

export type PaymentVerification = {
  /** Name on the card that used for Payment when Sonder is MoR */
  cardholderName?: Maybe<Scalars["String"]>;
  /** Indicate whether this steps is completed or not */
  completed: Scalars["Boolean"];
  /** Indicate whether Sonder is the merchant of record */
  isSonderMor: Scalars["Boolean"];
  paymentInfo?: Maybe<PaymentInfo>;
  /** Indicate whether there is unpaid charges on this booking */
  unpaidCharges: Scalars["Boolean"];
};

export type PendingAlterationNoteFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type PendingAlterationPromptFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type PendingExtensionPromptFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type PerBed = {
  /** How many pillows per california bed */
  california: Scalars["Int"];
  /** How many pillows per double bed */
  double: Scalars["Int"];
  /** How many pillows per king bed */
  king: Scalars["Int"];
  /** How many pillows per queen bed */
  queen: Scalars["Int"];
  /** How many pillows per single bed */
  single: Scalars["Int"];
};

export type Period = {
  /** day for the end of this period */
  closeDay?: Maybe<Scalars["Int"]>;
  /** time for the end of this period */
  closeTime?: Maybe<Scalars["String"]>;
  /** day for the start of this period */
  openDay: Scalars["Int"];
  /** time for the start of this period */
  openTime: Scalars["String"];
};

export type PermissionToEnterChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New permission to enter value */
  newPte: Scalars["String"];
  /** Previous permission to enter value */
  previousPte: Scalars["String"];
};

export type Persona = {
  /** Template id for Persona dynamic flow */
  dynamicFlowTemplateId?: Maybe<Scalars["String"]>;
  /** Risk level for the booking */
  riskLevel?: Maybe<Scalars["String"]>;
  /** Template id for the Persona inquiries */
  templateId?: Maybe<Scalars["String"]>;
};

export type PersonalInfoVerification = {
  /** Indicate whether this steps is completed or not */
  completed: Scalars["Boolean"];
  guestInfo: GuestInfo;
};

export type Pet = {
  breed: Scalars["String"];
  id: Scalars["Int"];
  kind: PetKind;
  name: Scalars["String"];
  weight: Scalars["Int"];
};

export enum PetKind {
  Dog = "dog",
}

/** Phase for lease deals */
export type PhaseLifecycle = Node & {
  /** JSON audit log of the phase */
  audits?: Maybe<Scalars["String"]>;
  /** phase latest bookable date */
  bookableLatestDate?: Maybe<Scalars["String"]>;
  /** phase comments */
  comment?: Maybe<Scalars["String"]>;
  /** phase handover date */
  handoverDate?: Maybe<Scalars["String"]>;
  /** handover final */
  handoverDateFinal?: Maybe<Scalars["Boolean"]>;
  /** phase hold reason */
  holdReason?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** phase lcd revised date */
  lcdRevisedDate?: Maybe<Scalars["String"]>;
  /** lcd final */
  lcdRevisedDateFinal?: Maybe<Scalars["Boolean"]>;
  /** phase name */
  name?: Maybe<Scalars["String"]>;
  /** phase status */
  status?: Maybe<Scalars["String"]>;
};

/** PhaseLifecycle */
export type PhaseLifecycleInput = {
  /** phase lifecycle's latest bookable date */
  bookableLatestDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** phase lifecycle latest bookable date is final */
  bookableLatestDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** phase lifecycle's comments */
  comment?: InputMaybe<Scalars["String"]>;
  /** reason for handover change */
  handoverChangeReason?: InputMaybe<Scalars["String"]>;
  /** phase lifecycle's handover date */
  handoverDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** phase lifecycle handover date is final */
  handoverDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** phase lifecycle handover documentation */
  handoverDocUrl?: InputMaybe<Scalars["String"]>;
  /** hold reason */
  holdReason?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** reason for lcd change */
  lcdChangeReason?: InputMaybe<Scalars["String"]>;
  /** phase lifecycle lcd documentation */
  lcdDocUrl?: InputMaybe<Scalars["String"]>;
  /** phase lifecycle's lcd revised date */
  lcdRevisedDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** phase lifecycle lcd revised date is final */
  lcdRevisedDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** phase lifecycle's name */
  name?: InputMaybe<Scalars["String"]>;
  /** phase status */
  status?: InputMaybe<Scalars["String"]>;
  /** email of user making the update */
  user?: InputMaybe<Scalars["String"]>;
};

export type PhaseUnitDates = Node & {
  /** Phase abatement */
  abatement?: Maybe<Scalars["Int"]>;
  /** Phase abatement doc url */
  abatementDocUrl?: Maybe<Scalars["String"]>;
  /** Flag for whether the phase abatement is finalized */
  abatementFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase bookable date */
  bookableDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase bookable date is finalized */
  bookableDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase construction/renovation start date */
  constructionStartDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase construction start date is finalized */
  constructionStartDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase construction status */
  constructionStatus?: Maybe<Scalars["String"]>;
  /** Phase early access date */
  earlyAccessDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase early access date is finalized */
  earlyAccessDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase FF&E need by date */
  ffeNeedByDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Phase handover date */
  handoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase handover date is finalized */
  handoverDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Handover document url */
  handoverDocUrl?: Maybe<Scalars["String"]>;
  /** Hold reason */
  holdReason?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Phase ID brief submission date */
  idBriefSubmissionDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase id brief submission date is finalized */
  idBriefSubmissionDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase revised lease commencement date */
  lcdRevisedDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase lcd revised date is finalized */
  lcdRevisedDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase listings date */
  listingsDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Phase openings complete date */
  openingsCompleteDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase openings complete date is finalized */
  openingsCompleteDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase punch date */
  punchDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase punch date is finalized */
  punchDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Phase units */
  units: Array<Unit>;
};

/** PhaseUnitDates params */
export type PhaseUnitDatesFilterInput = {
  /** Building id */
  buildingId: Scalars["ID"];
  /** Flag to include live units */
  includeLive?: InputMaybe<Scalars["Boolean"]>;
  /** Phase lifecycle id */
  phaseId?: InputMaybe<Scalars["ID"]>;
};

/** PhaseUnitDates update params */
export type PhaseUnitDatesInput = {
  /** Phase abatement */
  abatement?: InputMaybe<Scalars["Int"]>;
  /** Phase abatement doc url */
  abatementDocUrl?: InputMaybe<Scalars["String"]>;
  /** Flag for whether the phase abatement is finalized */
  abatementFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Phase bookable date */
  bookableDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase bookable date is finalized */
  bookableDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Building id */
  buildingId: Scalars["ID"];
  /** Phase construction/renovation start date */
  constructionStartDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase construction start date is finalized */
  constructionStartDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Phase construction status */
  constructionStatus?: InputMaybe<Scalars["String"]>;
  /** Phase bookable date */
  earlyAccessDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase bookable date is finalized */
  earlyAccessDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Phase FF&E need by date */
  ffeNeedByDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Phase handover change reason */
  handoverChangeReason?: InputMaybe<Scalars["String"]>;
  /** Phase handover date */
  handoverDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase handover date is finalized */
  handoverDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Phase handover doc url */
  handoverDocUrl?: InputMaybe<Scalars["String"]>;
  /** Phase hold reason */
  holdReason?: InputMaybe<Scalars["String"]>;
  /** Phase ID brief submission date */
  idBriefSubmissionDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase id brief submission date is finalized */
  idBriefSubmissionDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Phase revised lease commencement date */
  lcdRevisedDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase lcd revised date is finalized */
  lcdRevisedDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Phase listings date */
  listingDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Phase openings complete date */
  openingsCompleteDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase openings complete date is finalized */
  openingsCompleteDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Phase lifecycle id */
  phaseId?: InputMaybe<Scalars["ID"]>;
  /** Phase punch date */
  punchDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Flag for whether the phase punch date is finalized */
  punchDateFinal?: InputMaybe<Scalars["Boolean"]>;
  /** Unit ids to group in the phase of dates */
  unitIds: Array<Scalars["ID"]>;
};

export type PhaseUnitDatesUpdate = Node & {
  /** Batch job record of unit bulk update */
  batchJob?: Maybe<UnitBatchJob>;
  id: Scalars["ID"];
  /** Updated phase id */
  phaseId: Scalars["ID"];
};

/** Phone Number Output */
export type PhoneNumber = Node & {
  /** Country code */
  countryCode: Scalars["String"];
  id: Scalars["ID"];
  /** Phone number */
  national: Scalars["String"];
  /** Primary SMS notification contact */
  primarySmsNotificationContact?: Maybe<Scalars["Boolean"]>;
  /** SMS compatible */
  smsCompatible?: Maybe<Scalars["Boolean"]>;
  /** Verified */
  verified?: Maybe<Scalars["Boolean"]>;
};

/** Phone Number Input */
export type PhoneNumberInput = {
  countryCode: Scalars["String"];
  national: Scalars["String"];
  primarySmsNotificationContact?: Scalars["Boolean"];
  smsCompatible?: InputMaybe<Scalars["Boolean"]>;
  verified?: InputMaybe<Scalars["Boolean"]>;
};

export type PhoneVerification = {
  /** Indicate whether this steps is completed or not */
  completed: Scalars["Boolean"];
};

/** Phone verification error with details */
export type PhoneVerificationDetailedError = PhoneVerificationError & {
  /** Phone verification error code */
  errorCode: Scalars["String"];
  /** Details about the phone verification result or error. */
  message: Scalars["String"];
};

/** Interface to PhoneVerificationError */
export type PhoneVerificationError = {
  /** Phone verification error code */
  errorCode: Scalars["String"];
  /** Details about the phone verification result or error. */
  message: Scalars["String"];
};

export type PhoneVerificationResult = {
  /** Details about the phone verification errors. */
  errors: Array<PhoneVerificationError>;
  /**
   * Whether the phone verification was successful. If this is false and there is
   * no error code or message, then the input verification code was wrong.
   */
  success: Scalars["Boolean"];
};

export type Photo = {
  caption?: Maybe<Scalars["String"]>;
  indexPosition?: Maybe<Scalars["Int"]>;
  largeSrc: Scalars["String"];
  mediumSrc: Scalars["String"];
  smallSrc: Scalars["String"];
  tag?: Maybe<Scalars["String"]>;
  xlargeSrc: Scalars["String"];
};

export type Place = {
  city: Scalars["String"];
  geoCoordinates: GeoCoordinates;
  name: Scalars["String"];
};

export type Poi = Node & {
  address: Address;
  /** Category associated withh this recommendation */
  category: Scalars["String"];
  /** City in which this POI resides */
  city: City;
  description: Scalars["String"];
  id: Scalars["ID"];
  /** URL for the associated image */
  imageUrl: Scalars["String"];
  /** Name of this location */
  name: Scalars["String"];
  /** information about when this point of interest is open */
  openInfo?: Maybe<OpenInfo>;
  /** phone number associated with this point of interest */
  phoneNumber?: Maybe<Scalars["String"]>;
  postmatesUrl?: Maybe<Scalars["String"]>;
  /** price level associated with this point of interest */
  priceLevel?: Maybe<Scalars["Int"]>;
  /** Static Google Map image for the poi's location */
  staticMapImage: Scalars["String"];
  /** tags associated with this point of interest */
  tags: Array<PoiTag>;
  /** website associated with this point of interest */
  website?: Maybe<Scalars["String"]>;
};

export type PoiImageUrlArgs = {
  maxheight?: InputMaybe<Scalars["Int"]>;
  maxwidth?: InputMaybe<Scalars["Int"]>;
};

export type PoiStaticMapImageArgs = {
  height: Scalars["Int"];
  scale: Scalars["Int"];
  width: Scalars["Int"];
  zoom: Scalars["Int"];
};

/** filters for point of interest query */
export type PoiFilterInput = {
  categories?: InputMaybe<Array<Scalars["String"]>>;
  distanceLimit: Scalars["Float"];
};

export type PoiTag = Node & {
  id: Scalars["ID"];
  /** human-readable tag */
  tag: Scalars["String"];
};

/** Pre-authorization hold for customer credit card */
export type PreAuthorizationHold = {
  /** Amount of the pre-authorization hold */
  amount: Scalars["Float"];
  /** Whether the pre-authorization hold has been completed */
  completed: Scalars["Boolean"];
  /** Formatted amount of the pre-authorization hold */
  formattedAmount: Scalars["String"];
};

export enum PreAuthorizationIntention {
  Damage = "DAMAGE",
  SonderPayLater = "SONDER_PAY_LATER",
}

/** Autogenerated return type of PreAuthorizeCard. */
export type PreAuthorizeCardPayload = {
  /** Always returns true. If unsuccessful, it will raise an error. */
  success: Scalars["Boolean"];
};

export type PreBookingPaymentSchedule = {
  /** the amount that should be charged */
  amount: Scalars["Float"];
  /** id of the asana task reminder */
  asanaTaskId?: Maybe<Scalars["String"]>;
  /** the currency code the amount is in */
  currency: Scalars["String"];
  /** the symbol of the currency the amount is in */
  currencySymbol: Scalars["String"];
  /** date on which this should be charged */
  date: Scalars["String"];
  /** charge id */
  externalId?: Maybe<Scalars["String"]>;
  /** id of this scheduled charge */
  id: Scalars["Int"];
  /** Stripe or Adyen */
  paymentGateway?: Maybe<Scalars["String"]>;
  /** date and time of payment */
  paymentTimestamp?: Maybe<Scalars["RFC3339DateTime"]>;
  /** paid or pending */
  status: Scalars["String"];
};

/** Group trip scheduled charge to be collected held until bookings as entered */
export type PreBookingPaymentScheduleInput = {
  amount?: InputMaybe<Scalars["Float"]>;
  currency?: InputMaybe<Scalars["String"]>;
  date?: InputMaybe<Scalars["String"]>;
  externalId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  paymentGateway?: InputMaybe<Scalars["String"]>;
  paymentTimestamp?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export type PreStayQuestion = Node & {
  id: Scalars["ID"];
  /** The past response for the question, if it was answered before. */
  response?: Maybe<PreStayResponse>;
  /** A unique semi-readable string identifying the question. */
  slug: Scalars["String"];
  /** The human readable question text. */
  title: Scalars["String"];
};

export type PreStayResponse = Node & {
  /** The JSON value of the question response. */
  body?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Whether or not the question was skipped */
  skipped: Scalars["Boolean"];
};

export type PreStaySurvey = Node & {
  /** Whether or not the survey has been completed */
  completed: Scalars["Boolean"];
  id: Scalars["ID"];
  /** The questions on the survey */
  questions: Array<PreStayQuestion>;
};

export type PreStaySurveyEditFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type PreStaySurveyFeedItem = Node & {
  /** Body copy to display on the feed item */
  body: Scalars["String"];
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type PrepKit = {
  /** Bed types and their counts. */
  bedTypes: Array<Metric>;
  /** Mat types and their counts. */
  matTypes: Array<Metric>;
  /** Count of sleeps grouped by sleeps size. */
  sleepTypes: Array<Metric>;
  /** Total number of pillow cases. */
  totalPillowCases: Scalars["Int"];
  /** Towel types and their counts. */
  towelTypes: Array<Metric>;
};

export type PrepKitReference = {
  /** How many bath mats per bathroom */
  bathMatsPerBathroom: Scalars["Int"];
  /** How many bath towels per beds */
  bathTowelsPerBed: Scalars["Int"];
  /** How many dish towels per kitchen */
  dishTowelsPerKitchen: Scalars["Int"];
  /** How many face towels per beds */
  faceTowelsPerBed: Scalars["Int"];
  /** How many hand towels per beds */
  handTowelsPerBed: Scalars["Int"];
  /** How many hand towels per half bathroom */
  handTowelsPerHalfBathroom: Scalars["Int"];
  /** How many perishable kits per units */
  perishableKitsPerUnit: Scalars["Int"];
  /** How many pillow for each type of bed */
  pillowsPerBedType: PerBed;
  /** How many sheet sets for each type of bed */
  sheetsPerBedType: PerBed;
};

/** Autogenerated return type of PrepareAddonInvoice. */
export type PrepareAddonInvoicePayload = {
  invoice?: Maybe<RevenueInvoice>;
};

/** Autogenerated return type of PrepareEciLcoInvoice. */
export type PrepareEciLcoInvoicePayload = {
  invoice?: Maybe<RevenueInvoice>;
  redirectUrl?: Maybe<Scalars["String"]>;
};

/** Autogenerated return type of PrepareServiceInvoice. */
export type PrepareServiceInvoicePayload = {
  invoice: RevenueInvoice;
};

export type PriceFormula = {
  adjustmentBasisPoints: Scalars["Int"];
};

export type PricePreview = {
  /** Amount difference compared to the original booking */
  amountDifference: Scalars["Float"];
  /** Base fee for the relocation inquiry */
  baseFee: Scalars["Float"];
  /** Cleaning fee for the relocation inquiry */
  cleaningFee: Scalars["Float"];
  /** Price currency */
  currency: Scalars["String"];
  /** Relocation total quote */
  newQuote: Scalars["Float"];
  /** Original booking quote price */
  originalQuote: Scalars["Float"];
  /** Percentage difference compared to the original booking */
  percentageDifference: Scalars["Float"];
  /** Total tax for the relocation inquiry */
  taxTotal: Scalars["Float"];
};

export type PricingPlan = {
  description: Scalars["String"];
  id: Scalars["String"];
  invoiceDetails: InvoiceDetails;
  name: Scalars["String"];
};

export type PriorityChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New priority. */
  newPriority?: Maybe<Scalars["Int"]>;
  /** Previous priority. */
  previousPriority?: Maybe<Scalars["Int"]>;
};

export type ProductDetails = {
  description: Scalars["String"];
  image?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type ProductInfo = {
  airbnbBooking?: Maybe<Scalars["Boolean"]>;
  building: Scalars["String"];
  checkInDate?: Maybe<Scalars["String"]>;
  checkInDateLabel?: Maybe<Scalars["String"]>;
  checkInDow?: Maybe<Scalars["String"]>;
  checkOutDate?: Maybe<Scalars["String"]>;
  checkOutDateLabel?: Maybe<Scalars["String"]>;
  checkOutDow?: Maybe<Scalars["String"]>;
  city: Scalars["String"];
  country: Scalars["String"];
  gdsBooking?: Maybe<Scalars["Boolean"]>;
  image?: Maybe<Scalars["String"]>;
  listingId?: Maybe<Scalars["String"]>;
  numberOfGuests?: Maybe<Scalars["Int"]>;
  numberOfNights?: Maybe<Scalars["Int"]>;
  productId: Scalars["String"];
  ratingAverage?: Maybe<Scalars["Float"]>;
  ratingState?: Maybe<Scalars["String"]>;
  ratingTotal?: Maybe<Scalars["Int"]>;
  state: Scalars["String"];
  stayLength?: Maybe<Scalars["Int"]>;
  stayLengthLabel?: Maybe<Scalars["String"]>;
  stayType: Scalars["String"];
  subtitle: Scalars["String"];
  title: Scalars["String"];
  unitId: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
};

export type ProgressionInfo = {
  /** Disclaimer provided to HAs */
  disclaimer?: Maybe<Scalars["String"]>;
  /** Details about task progression */
  subtext?: Maybe<Scalars["String"]>;
  /** Title for task progression */
  text?: Maybe<Scalars["String"]>;
};

export type PromoOffer = {
  active: Scalars["Boolean"];
  blackoutDates?: Maybe<Array<Scalars["String"]>>;
  buildingNames?: Maybe<Array<Scalars["String"]>>;
  buildingScopeIds?: Maybe<Array<Scalars["String"]>>;
  city?: Maybe<Scalars["String"]>;
  cityScopeId?: Maybe<Scalars["Int"]>;
  code?: Maybe<Scalars["String"]>;
  createdAt: Scalars["String"];
  displayLabel?: Maybe<Scalars["String"]>;
  expiryDate?: Maybe<Scalars["String"]>;
  filterKey?: Maybe<Scalars["String"]>;
  firstCheckinDate?: Maybe<Scalars["String"]>;
  flatRateDiscount?: Maybe<Scalars["Float"]>;
  id: Scalars["Int"];
  lastCheckinDate?: Maybe<Scalars["String"]>;
  maxLos?: Maybe<Scalars["Int"]>;
  minLos?: Maybe<Scalars["Int"]>;
  percentDiscount?: Maybe<Scalars["Float"]>;
  promoTypeId: Scalars["Int"];
  promoTypeType: Scalars["String"];
  revenueLineItemTypeId: Scalars["Int"];
  updatedAt?: Maybe<Scalars["String"]>;
  weekdayOnly?: Maybe<Scalars["Boolean"]>;
};

export type QaEmailConfiguration = Node & {
  /** The cleaning company which the user receives qa emails. */
  company?: Maybe<CleaningCompany>;
  id: Scalars["ID"];
  /** The user who receives qa emails. */
  user: User;
};

export type QaEmailConfigurationConnections = {
  /** Index-based position of the search. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records? */
  hasMore: Scalars["Boolean"];
  /** The list of qa email configurations. */
  qaEmailConfigurations: Array<QaEmailConfiguration>;
  /** Total number of records. */
  total: Scalars["Int"];
};

/** QA email configuration input filters */
export type QaEmailConfigurationFilterInput = {
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  companyIds?: InputMaybe<Array<Scalars["ID"]>>;
  userIds?: InputMaybe<Array<Scalars["ID"]>>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type Query = {
  acceptedReferrals?: Maybe<Array<AcceptedReferral>>;
  account: Account;
  accountExists: Scalars["Boolean"];
  accounts: AccountPageResult;
  /** List of accounts matching the specified tags */
  accountsWithTags: Array<Account>;
  /** Revenue event sources associated with an inquiry */
  allRevenueEventSources: RevenueEventSourceList;
  alterationAvailability?: Maybe<AlterationAvailability>;
  alterationPreviewPricing: ExtensionPreview;
  ancillaryServices: Array<AncillaryService>;
  /** App feature flags */
  appFlags: AppFlags;
  availabilities: Array<Availability>;
  availableEciLcoTimes: EciLcoTimes;
  availableEciTimes: EciTimes;
  availableLcoTimes: LcoTimes;
  batchJob?: Maybe<BatchJob>;
  bed: UnitBed;
  booking: Inquiry;
  bookingExistByConfirmationCode: Scalars["Boolean"];
  bookingPromoOffers: Array<PromoOffer>;
  bookingVerificationRedirection: BookingVerificationRedirection;
  bookings: Array<Inquiry>;
  /** Get context to boot BENI */
  bootstrapBeniContext?: Maybe<BeniContext>;
  building: Building;
  buildingCollectionsAvailability: BuildingCollectionsAvailability;
  buildingCollectionsCalendarAvailabilities: Array<CalendarAvailability>;
  /** Buildings filter */
  buildingConnections: BuildingConnections;
  buildingFeaturedCollections: BuildingCollectionsAvailability;
  buildingFeaturedStays: Array<BuildingListing>;
  buildingListing: Listings;
  /** Building phase lifecycle summaries */
  buildingPhaseSummaries: Array<BuildingPhaseSummary>;
  /** Building phase lifecycles */
  buildingPhases: BuildingPhases;
  /** Building project */
  buildingProject: BuildingProject;
  buildingSearch: Search;
  cancellationPreview?: Maybe<CancellationPayload>;
  checkout: CheckoutInquiry;
  /** The number of checkouts for this unit in the given time period */
  checkoutCountPerUnit: Array<CheckoutCountPerUnit>;
  checkoutInvoice: CheckoutInvoice;
  checkoutProcess: CheckoutProcess;
  /** cities */
  cities: Array<City>;
  city: City;
  citySearch: Array<City>;
  /** City Task Metrics */
  cityTaskMetrics?: Maybe<TaskMetrics>;
  /** Cleaning Companies */
  cleaningCompany: Array<CleaningCompany>;
  /** Get cleaning request connections */
  cleaningRequestConnections: CleaningRequestConnections;
  collection?: Maybe<Collection>;
  /** The comparable options based on the provided search filters */
  comparableOptions: Array<ComparableOption>;
  /** The search filters to build comparable search interface */
  comparableSearchFilters: Array<ComparableSearchFilter>;
  confirmation: ConfirmationBooking;
  confirmationOrderable: ConfirmationOrderable;
  /** Get all consumables items available */
  consumables: Array<Item>;
  costarSftp: CostarFiles;
  countryCodes: Array<CountryCode>;
  /**
   * To get the rate plan returning the invoice, we need to create an inquiry from
   * the first available unit of the collection.  To generate an invoice, we
   * absolutely need an inquiry.The creation of the inquiry will be removed in the
   * next Cro phase to only use pacmaninformations to build the pricing output.
   * Pacman resposne contains all the pricing infoit's just the format that is
   * different from what we display on sonder.com, so we've for phase 1 of Cro to
   * use the same logic used on sonder.com to make sure we havethe same information.
   */
  croAvailableRatePlans: CroCheckoutInvoice;
  croBuildingCollectionsAvailability: CroBuildingCollectionsAvailability;
  croBuildingSearch: Search;
  csatFeedback?: Maybe<CsatFeedbackResponse>;
  cufSpace: CufSpace;
  customAccessCode: CustomAccessCode;
  /** Daily aggregate housekeeping metrics */
  dailyAggregateHousekeepingMetrics: Array<DailyAggregateHousekeepingMetrics>;
  emailHasBeenTaken: EmailUsed;
  featuredCities: Array<FeaturedCity>;
  featuredStays: Array<Listing>;
  featuredStaysWithPricing: Array<FeaturedStayWithPricing>;
  fetchCheckoutDetails: CheckoutDetailsInfo;
  /** reservation info from SpotHero, also fetches facility_info in a 2nd inline api call if requested */
  fetchReservation: ParkingReservation;
  getFlipperValues: Array<FlipperValue>;
  groceryItems: Array<GroceryItem>;
  /** Internal: Check if this group has availability for dates, this will eventually move to AvS */
  groupAvailability: Scalars["Boolean"];
  /**
   * The group block informations
   * @deprecated use group_blocks instead
   */
  groupBlock: GroupBlock;
  /** The group block informations */
  groupBlocks: Array<GroupBlock>;
  /** The information to populate the payer's payment details page related to a group booking. */
  groupPayerPaymentDetails: PayerPaymentDetails;
  /** The group trip informations */
  groupTrip: GroupTrip;
  /** The group trip info for external guests */
  groupTripExternal: GroupTripExternal;
  /** The group trips based on the provided search filters */
  groupTripSearch?: Maybe<Array<GroupTrip>>;
  guestTaskEta?: Maybe<EtaInfo>;
  /** Signed S3 bucket url */
  handoverDocUploadUrl: Scalars["String"];
  /** Get housekeeping misc service connections */
  hkMiscServiceConnections: MiscServiceConnections;
  hosOpsBooking?: Maybe<Booking>;
  /** Inquiries container */
  inquiryCheckoutConnections: InquiryCheckoutConnections;
  /** Get internal refs */
  internalRefs: Array<InternalRef>;
  /** Retrieve available intrastay cleaning windows for given entity, such as a Sonder Building */
  intrastayCleaningTimes: IntrastayCleaningConfig;
  /** Laundry stats for a given city, for the given number of nights */
  laundryStats: LaundryStats;
  /** Lease deal */
  leaseDeal: LeaseDeal;
  /** Lease Deals */
  leaseDealConnections: LeaseDealConnections;
  /** Lease deal lifecycles */
  leaseDealLifecycleConnections: LeaseDealLifecycleConnections;
  /** Lease deal lifecycle filters */
  leaseDealLifecycleFilters: LeaseDealLifecycleFilters;
  leaseInquiry: LeaseInquiry;
  listing: Listing;
  minimumNights: MinimumNights;
  /** User Notifications */
  notificationConnections: UserNotificationConnections;
  otaBooking: OtaBooking;
  /** List of parking options */
  parkingSearch: Array<ParkingSearchResult>;
  passwordResetTokenValid: ResetPasswordTokenValidity;
  /** Info about the pets staying with a guest, if any */
  pets?: Maybe<Array<Pet>>;
  /** Phase units & dates */
  phaseUnitDates: PhaseUnitDates;
  places: Array<Place>;
  /** Point of interest lookup */
  pointOfInterest: Poi;
  preAuthorizationHold: PreAuthorizationHold;
  /** Static configuration data for prep kits */
  prepKitReference: PrepKitReference;
  /** Get qa email configuration connections */
  qaEmailConfigurationConnections: QaEmailConfigurationConnections;
  /** The inquiry top 2 recommended options for relocation */
  recommendedOptions?: Maybe<Array<RecommendedOption>>;
  referralCode: ReferralCode;
  referrer?: Maybe<Referrer>;
  /** The relocation related information */
  relocation: Relocation;
  /** The inquiry to check if both automatic and manual relocation is enable/eligible */
  relocationEligibility: RelocationEligibility;
  /**
   * The invoice summary for the relocation proposition
   * @deprecated Replaced by the invoiceSummary field on the RelocationProposition object
   */
  relocationInvoiceSummary?: Maybe<Array<InvoiceSummary>>;
  /** The metadata needed to build interfaces */
  relocationMetadata: RelocationMetadata;
  /** The relocation request associated to a original inquiry */
  relocationRequest?: Maybe<RelocationRequest>;
  /** return list of Users filtered on user role */
  retoolUsers: Array<User>;
  roomUpgrades: Upgrades;
  /** The sales account related information */
  salesAccount: SalesAccount;
  /** Available sales POC users */
  salesPocs: Array<User>;
  /** List of filters belonging to owner */
  savedTomFilters?: Maybe<Array<SavedTomFilter>>;
  /** The scheduled payment based on the provided search filters */
  scheduledPaymentsSearch: RevenueScheduledPaymentsList;
  /**
   * this is old search api
   * @deprecated Use search_with_metadata instead
   */
  search: AllTypesFeed;
  /** search for data and return search metadata plus the associated result_type model */
  searchWithMetadata: SearchFeedItemConnections;
  task?: Maybe<Task>;
  /** task categories */
  taskCategories: Array<TaskCategory>;
  /** Tasks container */
  taskConnections: TaskConnections;
  /** Task context connections */
  taskContextConnections: TaskContextConnections;
  /** task locations */
  taskLocations: Array<TaskLocation>;
  /** Task scheduler connections */
  taskSchedulerConnections: TaskSchedulerConnections;
  /** Scheduler metrics */
  taskSchedulerMetrics: SchedulerMetrics;
  /** find tags by type */
  tomTags: Array<TomTag>;
  /** Get total number of tasks */
  tomTasksCount: Scalars["String"];
  travelSurveyQuestion: TravelSurveyQuestion;
  unit: Unit;
  unitBatchJob?: Maybe<UnitBatchJob>;
  /** return list of Units */
  unitConnections: UnitConnections;
  /** unit los policies */
  unitLosPolicies: Array<UnitLosPolicy>;
  /** The unit ids to get at what time they will be available today */
  unitsAvailabilityTime: Array<UnitAvailabilityTime>;
  upgradeService: Array<UpgradeService>;
  user: User;
  /** return list of Users */
  userConnections: UserConnections;
  /** User Notification Total */
  userNotificationTotal: UserNotificationTotal;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAcceptedReferralsArgs = {
  accountId: Scalars["ID"];
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAccountArgs = {
  id?: InputMaybe<Scalars["ID"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAccountExistsArgs = {
  email: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filter: AccountsFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAccountsWithTagsArgs = {
  bookingIds?: InputMaybe<Array<Scalars["String"]>>;
  guestLoyaltyIds?: InputMaybe<Array<Scalars["String"]>>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAllRevenueEventSourcesArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAlterationAvailabilityArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAlterationPreviewPricingArgs = {
  inquiryId: Scalars["ID"];
  newCheckInDate?: InputMaybe<Scalars["String"]>;
  newCheckOutDate?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAncillaryServicesArgs = {
  bookingUniqKey?: InputMaybe<Scalars["String"]>;
  buildingInternalRef?: InputMaybe<Scalars["String"]>;
  inquiryId?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAvailabilitiesArgs = {
  checkOutDate?: InputMaybe<Scalars["String"]>;
  cursor?: InputMaybe<Scalars["String"]>;
  listingId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAvailableEciLcoTimesArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAvailableEciTimesArgs = {
  uniqKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryAvailableLcoTimesArgs = {
  uniqKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBatchJobArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBedArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBookingArgs = {
  confirmationCode?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  uniqKey?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBookingExistByConfirmationCodeArgs = {
  confirmationCode: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBookingPromoOffersArgs = {
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBookingVerificationRedirectionArgs = {
  uniqKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBookingsArgs = {
  ids: Array<Scalars["ID"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingCollectionsAvailabilityArgs = {
  checkInDate?: InputMaybe<Scalars["String"]>;
  checkOutDate?: InputMaybe<Scalars["String"]>;
  listingId: Scalars["ID"];
  prices?: InputMaybe<Array<Scalars["Int"]>>;
  sleeps?: InputMaybe<Scalars["Int"]>;
  source?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingCollectionsCalendarAvailabilitiesArgs = {
  checkInDate?: InputMaybe<Scalars["String"]>;
  endCursor?: InputMaybe<Scalars["String"]>;
  guestCount?: InputMaybe<Scalars["Int"]>;
  id: Scalars["ID"];
  startCursor?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingConnectionsArgs = {
  filter?: InputMaybe<BuildingFilterInput>;
  sort?: InputMaybe<Array<BuildingSortInput>>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingFeaturedCollectionsArgs = {
  listingId: Scalars["ID"];
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingListingArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingPhaseSummariesArgs = {
  filter?: InputMaybe<BuildingPhaseSummariesInput>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingPhasesArgs = {
  filter?: InputMaybe<BuildingPhasesInput>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingProjectArgs = {
  filter: BuildingProjectFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryBuildingSearchArgs = {
  context?: InputMaybe<Scalars["String"]>;
  environment?: InputMaybe<Scalars["String"]>;
  query?: InputMaybe<SearchQueryInput>;
  queryString: Scalars["String"];
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCancellationPreviewArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCheckoutArgs = {
  clientInfo: ClientInfoInput;
  collectionId?: InputMaybe<Scalars["String"]>;
  inquiryId?: InputMaybe<Scalars["String"]>;
  inquiryPaymentKey: Scalars["String"];
  promoCodes: Array<Scalars["String"]>;
  receivableInvoiceId?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCheckoutCountPerUnitArgs = {
  filter: CheckoutCountPerUnitFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCheckoutInvoiceArgs = {
  ancillaryServices?: InputMaybe<Array<AncillaryServiceInput>>;
  clientInfo: ClientInfoInput;
  collectionId?: InputMaybe<Scalars["String"]>;
  inquiryId?: InputMaybe<Scalars["String"]>;
  inquiryPaymentKey: Scalars["String"];
  promoCodes: Array<Scalars["String"]>;
  receivableInvoiceId?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCheckoutProcessArgs = {
  checkoutProcessId: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCitiesArgs = {
  withAsanaOpsProjectIdOnly?: InputMaybe<Scalars["Boolean"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCityArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCitySearchArgs = {
  query?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCleaningCompanyArgs = {
  filters: CleaningCompanyFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCleaningRequestConnectionsArgs = {
  filters: CleaningRequestFilterInput;
  pagination?: InputMaybe<Pagination>;
  sorting?: InputMaybe<Sorting>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCollectionArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryComparableOptionsArgs = {
  inquiryId: Scalars["ID"];
  searchFilters: ComparableSearchInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryComparableSearchFiltersArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryConfirmationArgs = {
  actionableTypes?: InputMaybe<Array<Scalars["String"]>>;
  clientInfo: ClientInfoInput;
  inquiryPaymentKey: Scalars["String"];
  receivableInvoiceId?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryConfirmationOrderableArgs = {
  orderableType: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCountryCodesArgs = {
  requiredStatesFor?: InputMaybe<Array<Scalars["String"]>>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCroAvailableRatePlansArgs = {
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  collectionId: Scalars["String"];
  listingId?: InputMaybe<Scalars["ID"]>;
  paymentTerm?: InputMaybe<Scalars["String"]>;
  promoCodes: Array<Scalars["String"]>;
  sleeps: Scalars["Int"];
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCroBuildingCollectionsAvailabilityArgs = {
  checkInDate?: InputMaybe<Scalars["String"]>;
  checkOutDate?: InputMaybe<Scalars["String"]>;
  listingId: Scalars["ID"];
  prices?: InputMaybe<Array<Scalars["Int"]>>;
  sleeps: Scalars["Int"];
  source?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCroBuildingSearchArgs = {
  query: SearchQueryInput;
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCsatFeedbackArgs = {
  uniqKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryCufSpaceArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryDailyAggregateHousekeepingMetricsArgs = {
  filters: DailyAggregateHousekeepingMetricsFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryEmailHasBeenTakenArgs = {
  email: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryFeaturedStaysWithPricingArgs = {
  showMonthlyPricing?: InputMaybe<Scalars["Boolean"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryFetchCheckoutDetailsArgs = {
  input: FetchCheckoutDetailsInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryFetchReservationArgs = {
  reservationId: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGetFlipperValuesArgs = {
  flipperNames: Array<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGroupAvailabilityArgs = {
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  groupTripId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGroupBlockArgs = {
  groupBlockId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGroupBlocksArgs = {
  groupBlockIds: Array<Scalars["ID"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGroupPayerPaymentDetailsArgs = {
  slug: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGroupTripArgs = {
  groupTripId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGroupTripExternalArgs = {
  groupCode: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGroupTripSearchArgs = {
  searchFilters: GroupTripSearchInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryGuestTaskEtaArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryHandoverDocUploadUrlArgs = {
  fileName: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryHkMiscServiceConnectionsArgs = {
  filters: MiscServiceFilterInput;
  pagination?: InputMaybe<Pagination>;
  sorting?: InputMaybe<Sorting>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryHosOpsBookingArgs = {
  uniqueKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryInquiryCheckoutConnectionsArgs = {
  filters: InquiryCheckoutFilterInput;
  sort?: InputMaybe<Array<InquiryCheckoutSortInput>>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryInternalRefsArgs = {
  filter?: InputMaybe<InternalRefFilterInput>;
  maxResultCount?: InputMaybe<Scalars["Int"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryIntrastayCleaningTimesArgs = {
  entityId: Scalars["ID"];
  entityType: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryLaundryStatsArgs = {
  filter: LaundryStatsFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryLeaseDealArgs = {
  id: Scalars["ID"];
  includeDeadUnits?: InputMaybe<Scalars["Boolean"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryLeaseDealConnectionsArgs = {
  filter?: InputMaybe<LeaseDealFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryLeaseDealLifecycleConnectionsArgs = {
  filter?: InputMaybe<LeaseDealFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryLeaseInquiryArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryListingArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryMinimumNightsArgs = {
  checkInDate: Scalars["String"];
  city: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryNotificationConnectionsArgs = {
  pagination?: InputMaybe<Pagination>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryOtaBookingArgs = {
  bookingUniqKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryParkingSearchArgs = {
  buildingId?: InputMaybe<Scalars["ID"]>;
  ends: Scalars["RFC3339DateTime"];
  facilityId?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  starts: Scalars["RFC3339DateTime"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryPasswordResetTokenValidArgs = {
  passwordResetToken: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryPetsArgs = {
  inquiryKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryPhaseUnitDatesArgs = {
  filter?: InputMaybe<PhaseUnitDatesFilterInput>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryPlacesArgs = {
  city: Scalars["String"];
  queryString: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryPointOfInterestArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryPreAuthorizationHoldArgs = {
  bookingUniqKey: Scalars["String"];
  intention: PreAuthorizationIntention;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryQaEmailConfigurationConnectionsArgs = {
  filters?: InputMaybe<QaEmailConfigurationFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRecommendedOptionsArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryReferralCodeArgs = {
  accountId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryReferrerArgs = {
  referralCode: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRelocationArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRelocationEligibilityArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRelocationInvoiceSummaryArgs = {
  relocationPropositionKey: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRelocationMetadataArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRelocationRequestArgs = {
  inquiryId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRetoolUsersArgs = {
  filter?: InputMaybe<UserRolesFilterInput>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryRoomUpgradesArgs = {
  bookingUniqKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QuerySalesAccountArgs = {
  salesAccountId: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QuerySavedTomFiltersArgs = {
  ownerId: Scalars["ID"];
  ownerType: FilterOwner;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryScheduledPaymentsSearchArgs = {
  searchFilters: ScheduledPaymentSearchInput;
  sorting: ScheduledPaymentSortInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QuerySearchArgs = {
  filters?: InputMaybe<SearchFilterInput>;
  resultTypes: Array<Result>;
  searchTerm: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QuerySearchWithMetadataArgs = {
  filters?: InputMaybe<SearchFilterInput>;
  pagination?: InputMaybe<Pagination>;
  resultType?: InputMaybe<Result>;
  resultTypes?: InputMaybe<Array<Result>>;
  searchTerm: Scalars["String"];
  sorting?: InputMaybe<Sorting>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTaskArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTaskCategoriesArgs = {
  filters: TaskCategoryFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTaskConnectionsArgs = {
  cursor?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<TaskFilterInput>;
  filterAssignee?: InputMaybe<Array<Scalars["String"]>>;
  filterCity?: InputMaybe<Scalars["String"]>;
  filterDueAtEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  filterDueAtStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  filterDuringStay?: InputMaybe<Scalars["Boolean"]>;
  filterOccupancy?: InputMaybe<Array<Scalars["String"]>>;
  filterPriority?: InputMaybe<Array<Scalars["Int"]>>;
  filterStatus?: InputMaybe<Array<Scalars["String"]>>;
  filterTaskType?: InputMaybe<Array<TypeEnum>>;
  filterTriaged?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Array<TaskSortInput>>;
  sortBy?: InputMaybe<Array<Scalars["String"]>>;
  sortOrder?: InputMaybe<Array<Scalars["String"]>>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTaskContextConnectionsArgs = {
  filters: TaskContextFilterInput;
  pagination?: InputMaybe<Pagination>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTaskLocationsArgs = {
  filters: TaskLocationFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTaskSchedulerConnectionsArgs = {
  filters: TaskSchedulerFilterInput;
  pagination?: InputMaybe<Pagination>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTaskSchedulerMetricsArgs = {
  filters: SchedulerMetricsFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTomTagsArgs = {
  tagType?: InputMaybe<Scalars["String"]>;
  tagTypes?: InputMaybe<Array<Scalars["String"]>>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTomTasksCountArgs = {
  filter?: TaskFilterInput;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryTravelSurveyQuestionArgs = {
  uniqKey: Scalars["String"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUnitArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUnitBatchJobArgs = {
  id: Scalars["ID"];
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUnitConnectionsArgs = {
  filter: UnitFilterInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<UnitSortInput>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUnitLosPoliciesArgs = {
  unitIds: Array<Scalars["ID"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUnitsAvailabilityTimeArgs = {
  unitIds: Array<Scalars["ID"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUpgradeServiceArgs = {
  bookingUniqKey?: InputMaybe<Scalars["String"]>;
  collectionId?: InputMaybe<Scalars["Int"]>;
  inquiryId?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUserArgs = {
  id?: InputMaybe<Scalars["ID"]>;
};

/** Root entry point for Sonder's GraphQL schema. */
export type QueryUserConnectionsArgs = {
  cityId?: InputMaybe<Scalars["ID"]>;
  filter?: InputMaybe<UserFilterInput>;
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Array<UserSortInput>>;
};

export type QuoteLineItem = {
  key: Scalars["String"];
  label: Scalars["String"];
  primary: Scalars["Boolean"];
  value: Scalars["String"];
};

export type RateInfo = {
  memberRate?: Maybe<Scalars["String"]>;
  ratePlans?: Maybe<Array<RatePlan>>;
};

export type RatePlan = {
  /** @deprecated Currently unused on the frontend */
  bookingQualifiers?: Maybe<Array<Scalars["String"]>>;
  capabilityMessages: Array<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  effectiveNightlyRateLabel?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  invoiceInfo: InvoiceInfo;
  markedUpNightlyRateLabel?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  shortDescription?: Maybe<Scalars["String"]>;
};

export enum ReasonForBan {
  AbusiveBehavior = "abusive_behavior",
  AssaultPhysicalViolence = "assault_physical_violence",
  CommercialActivity = "commercial_activity",
  FailedBackgroundCheck = "failed_background_check",
  FirearmsOtherWeaponsPossession = "firearms_other_weapons_possession",
  Fraud = "fraud",
  HeavyPhysicalDamage = "heavy_physical_damage",
  IllegalDrugActivity = "illegal_drug_activity",
  LightPhysicalDamage = "light_physical_damage",
  Party = "party",
  Pets = "pets",
  Smoking = "smoking",
  TheftBreakInTrespassing = "theft_break_in_trespassing",
}

export enum ReasonForClean {
  Deferred = "deferred",
  GroupStay = "group_stay",
}

export enum ReasonForEjection {
  Damages = "damages",
  Fraud = "fraud",
  InappropriateGuestBehavior = "inappropriate_guest_behavior",
  ViolationOfSonderHouseRules = "violation_of_sonder_house_rules",
}

export enum ReasonForManualCompletion {
  AppError = "app_error",
  CleanerForgot = "cleaner_forgot",
  CleanerHasNoPhone = "cleaner_has_no_phone",
  CleanerNotTrained = "cleaner_not_trained",
  ManagerNotTrained = "manager_not_trained",
}

export enum ReasonForRelocation {
  Access = "access",
  AccommodatingBookingExtension = "accommodating_booking_extension",
  BedBugOrVermin = "bed_bug_or_vermin",
  Cleanliness = "cleanliness",
  DoubleBooked = "double_booked",
  FloorRequest = "floor_request",
  MissingOrBrokenItemAppliance = "missing_or_broken_item_appliance",
  NeedToAccommodateLtr = "need_to_accommodate_ltr",
  OffBoarding = "off_boarding",
  OtherReasonSpecify = "other_reason_specify",
  PendingMaintenanceRepairs = "pending_maintenance_repairs",
  PlumbingHvacIssue = "plumbing_hvac_issue",
  ShufflingUnitDoesNotMeetGuestExpectations = "shuffling_unit_does_not_meet_guest_expectations",
  SpecificUnitDesired = "specific_unit_desired",
  SwitchBuildingsLocations = "switch_buildings_locations",
  ToDowngradeSpace = "to_downgrade_space",
  ToUpgradeSpace = "to_upgrade_space",
}

export type ReceivableInvoice = {
  /** Formatted balance */
  balance: Scalars["String"];
  /** Formatted check-in date */
  checkInTime: Scalars["RFC3339DateTime"];
  /** Formatted check-out date */
  checkOutTime: Scalars["RFC3339DateTime"];
  /** Formatted Id */
  id: Scalars["ID"];
  /**
   * WWW invoice URL for this inquiry
   * @deprecated To get the receipt, please use latest_receipt on Inquiry object instead
   */
  invoicePdfUrl: Scalars["String"];
  /** Stay night count */
  nightsCount: Scalars["Int"];
  /** Payments */
  payments: Array<InvoicePayment>;
  /** Supergroups (groups of groups of line items) */
  supergroups: Array<InvoiceSupergroup>;
  /** Formatted total amount */
  total: Scalars["String"];
  /** Unit location as 'Neighborhood, City' */
  unitLocation: Scalars["String"];
};

export type RecommendedOption = {
  /** Start and end date of the unit availability based on the provided dates */
  availabilityDateRanges: Array<Array<Scalars["String"]>>;
  /** The distance in miles from the original inquiry unit */
  distance?: Maybe<Scalars["Float"]>;
  /** If the unit is fully available for the provided dates or not */
  fullyAvailable: Scalars["Boolean"];
  /** Any notifications related to the recommended option. */
  notifications: Array<Notification>;
  /** The type of recommendation (MostSimilar or Upgrade). */
  type: Scalars["String"];
  /** A unit of the collection is available. */
  unit: Unit;
};

/** Autogenerated return type of RecordGroupDeposit. */
export type RecordGroupDepositPayload = {
  /** Always returns true. If unsuccessful, it will raise an error. */
  success: Scalars["Boolean"];
};

export type RecurrenceChangeMetadata = Node & {
  /** days on which this task recurs weekly. */
  daysOfWeek: Array<DaysOfWeek>;
  id: Scalars["ID"];
  /** interval scalar, null if deleted */
  intervalAmt?: Maybe<Scalars["Int"]>;
  /** the unit of time for recurrence, null if deleted */
  intervalUnit?: Maybe<RecurrenceIntervalUnit>;
};

export enum RecurrenceIntervalUnit {
  Day = "day",
  Month = "month",
  Week = "week",
}

export type ReferralCode = {
  accountId: Scalars["ID"];
  code: Scalars["String"];
  id: Scalars["ID"];
};

export type Referrer = {
  referralCode: Scalars["String"];
  referralId: Scalars["ID"];
  referrerId: Scalars["ID"];
  referrerName: Scalars["String"];
};

/** Autogenerated return type of RefreshToken. */
export type RefreshTokenPayload = {
  accountJwt: Scalars["String"];
};

export type Refund = Node & {
  /** The currency that the payment is owed in */
  currency: Scalars["String"];
  id: Scalars["ID"];
  /** The method of Refund (ie. cash or sonder credit) */
  refundMethod: RefundMethod;
  /** The total refund for the cancellation */
  total: Scalars["Float"];
};

export type RefundContext = {
  /** If the booking can get a relocation refund. */
  eligible: Scalars["Boolean"];
  /** If the refund must be processed on the OTA. */
  processOnOta: Scalars["Boolean"];
};

export enum RefundMethod {
  Cash = "CASH",
  SonderCredit = "SONDER_CREDIT",
}

/** Autogenerated return type of RegisterPushClient. */
export type RegisterPushClientPayload = {
  error?: Maybe<Scalars["String"]>;
};

/** Autogenerated return type of RejectHkCost. */
export type RejectHkCostPayload = {
  hkCost: HkCost;
};

export type RelatedScheduleFilterInput = {
  /** end at */
  endAt: Scalars["RFC3339DateTime"];
  /** start at */
  startAt: Scalars["RFC3339DateTime"];
};

export type Relocation = {
  /**
   * The default check-in datetime into the proposition unit
   * @deprecated Use the default_check_in_datetime on relocation_propositions instead
   */
  defaultCheckInDatetime: Scalars["RFC3339DateTime"];
  /** The inquiry to relocate. */
  inquiry: Inquiry;
  /** Whether the relocation can be processed using P49 to calculate the cost difference and to complete the relocation. */
  p49Enabled: Scalars["Boolean"];
  /** The relocated inquiry */
  relocationInquiry?: Maybe<Inquiry>;
  /** All relocation propositions created for this relocation */
  relocationPropositions: Array<RelocationProposition>;
  /** The relocation request information when the relocation is initiated already. */
  relocationRequest?: Maybe<RelocationRequest>;
};

export type RelocationEligibility = {
  /** The automated relocation eligibility. */
  automatedRelocationEligibility?: Maybe<AutomatedRelocationEligibility>;
  /** Permission to perform automated and manual relocation. */
  permitted: Scalars["Boolean"];
};

export type RelocationMetadata = {
  /**
   * The concurrent access options information
   * @deprecated Now regrouped per source type into field sourceTypeMetadata
   */
  concurrentAccessOptions: ConcurrentAccessOptions;
  /**
   * The reason
   * @deprecated Now regrouped per source type into field sourceTypeMetadata
   */
  reasonOptions: Array<RelocationReasonOption>;
  /** Information on a refund eligibility for the booking */
  refundContext?: Maybe<RefundContext>;
  /** The options available for a refund */
  refundOptions?: Maybe<Array<RelocationRefundOption>>;
  /** Metadata that are different per relocation source type */
  sourceTypeMetadata: Array<SourceTypeMetadata>;
};

export type RelocationProposition = {
  /** When the relocation proposition was updated. */
  createdAt: Scalars["ISO8601DateTime"];
  /** The default check-in datetime into the proposition unit */
  defaultCheckInDatetime: Scalars["RFC3339DateTime"];
  /**
   * Information on the hold duration
   * @deprecated Use `relocation_proposition_inquiries.inquiry_hold` instead
   */
  holdDetails: InquiryHold;
  /** Relocation proposition internal ID */
  id: Scalars["ID"];
  /** The invoice summary for the relocation proposition */
  invoiceSummary?: Maybe<Array<InvoiceSummary>>;
  /** The invoice summary preview for the relocation proposition */
  invoiceSummaryPreview?: Maybe<Array<InvoiceSummary>>;
  /** Original inquiry to be relocated */
  originalInquiry: Inquiry;
  /** The check-out time of the original inquiry */
  originalInquiryCheckOutDatetime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Price comparison details for this relocation proposition. */
  priceComparison: PricePreview;
  /**
   * Unit data for this relocation proposition
   * @deprecated Use `relocation_proposition_inquiries.proposition_unit` instead
   */
  propositionUnit: RecommendedOption;
  /**
   * New inquiry that is being proposed
   * @deprecated Use `relocation_proposition_inquiries` instead
   */
  relocationInquiry: Inquiry;
  /** The check-in time of the relocation inquiry */
  relocationInquiryCheckInDatetime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** The new inquiries that will be created */
  relocationPropositionInquiries: Array<RelocationPropositionInquiry>;
  /** Public unique identifier */
  uniqKey: Scalars["String"];
  /** When the relocation proposition was updated. */
  updatedAt: Scalars["ISO8601DateTime"];
};

/** Relocation Proposition Input */
export type RelocationPropositionInput = {
  dateRange: Array<Scalars["String"]>;
  unitId: Scalars["ID"];
};

/** Groups inputs for a creating a relocation proposition */
export type RelocationPropositionInputGroup = {
  proposition: Array<RelocationPropositionInput>;
};

export type RelocationPropositionInquiry = {
  /** Information about the hold that was placed */
  inquiryHold: InquiryHold;
  /** Unit data for this relocation proposition */
  propositionUnit: RelocationPropositionUnit;
  /** The relocation inquiry details */
  relocationInquiry: Inquiry;
};

export type RelocationPropositionUnit = {
  /** The distance in miles from the original inquiry unit */
  distanceMiles: Scalars["Float"];
  /** Details of the unit */
  unit: Unit;
};

export type RelocationReason = {
  /** The description */
  description: Scalars["String"];
  /** Flag indicating if the details for the reason is required */
  isDetailRequired?: Maybe<Scalars["Boolean"]>;
  /** The reason type for relocating the guest */
  type: Scalars["String"];
};

export type RelocationReasonOption = {
  /** The reason */
  reasons: Array<RelocationReason>;
  /** The source who can use this reason */
  sourceType: RelocationSource;
};

export type RelocationRefundOption = {
  /** Extra text to display with the refund option */
  description: Scalars["String"];
  /** The label of the refund option */
  label: Scalars["String"];
  /** The name of the parameter to return */
  paramName?: Maybe<Scalars["String"]>;
  /** The parameter value to return when selected */
  paramValue?: Maybe<Scalars["String"]>;
  /** If the option should be selected by default */
  selected?: Maybe<Scalars["Boolean"]>;
  /** The type of field related to the option. (notice, radio or checkbox) */
  type: Scalars["String"];
};

export type RelocationRequest = {
  /** the relocation request unique identifier */
  id: Scalars["ID"];
  /** The reason for the relocation */
  reason?: Maybe<RelocationReason>;
  /** The specific reason for the relocation when other is seleced in the reason */
  reasonDetails?: Maybe<Scalars["String"]>;
  /** The date that the guest will check-in to the relocation unit */
  relocationCheckInDate?: Maybe<Scalars["String"]>;
  /**
   * Relocation inquiry id
   * @deprecated use relocation_inquiries from the confirmRelocationProposition instead
   */
  relocationInquiryId?: Maybe<Scalars["ID"]>;
  /** The selected relocation proposition created for this relocation */
  selectedRelocationProposition?: Maybe<RelocationProposition>;
  /** Source of the relocation request */
  sourceType?: Maybe<RelocationSource>;
  /** The state of the relocation */
  state: RelocationState;
  /** The status of the relocation */
  status: RelocationStatus;
};

export enum RelocationSource {
  Guest = "guest",
  Sonder = "sonder",
}

export enum RelocationState {
  Cancelled = "cancelled",
  Completed = "completed",
  InProgress = "in_progress",
}

export enum RelocationStatus {
  AutoComplete = "auto_complete",
  AwaitingPayment = "awaiting_payment",
  GetComplete = "get_complete",
  GuestComplete = "guest_complete",
  Initiated = "initiated",
  PropositionInitiated = "proposition_initiated",
}

/** Autogenerated return type of RemovePet. */
export type RemovePetPayload = {
  response: BaseResponse;
};

export type Request = {
  barSoap?: InputMaybe<Scalars["Int"]>;
  bathMat?: InputMaybe<Scalars["Int"]>;
  blanket?: InputMaybe<Scalars["Int"]>;
  bodyLotion?: InputMaybe<Scalars["Int"]>;
  coffeeCreamer?: InputMaybe<Scalars["Int"]>;
  coffeeFilter?: InputMaybe<Scalars["Int"]>;
  coffeePacket?: InputMaybe<Scalars["Int"]>;
  conditioner?: InputMaybe<Scalars["Int"]>;
  detailsOfReasonForRelocation?: InputMaybe<Scalars["String"]>;
  dishwasherPod?: InputMaybe<Scalars["Int"]>;
  dropOffLocation?: InputMaybe<FilterDropOffLocation>;
  /** Item drop off time (HH:MM format). */
  dropOffTime?: InputMaybe<Scalars["String"]>;
  etaEnabled?: InputMaybe<FilterEtaEnabled>;
  facialTissue?: InputMaybe<Scalars["Int"]>;
  fallbackRelocationUnit?: InputMaybe<Scalars["String"]>;
  followedByGuestServices?: InputMaybe<Scalars["String"]>;
  garbageBagLarge?: InputMaybe<Scalars["Int"]>;
  garbageBagSmall?: InputMaybe<Scalars["Int"]>;
  guestUrgency?: InputMaybe<GuestUrgency>;
  laundryDetergentPod?: InputMaybe<Scalars["Int"]>;
  oliveOil?: InputMaybe<Scalars["Int"]>;
  permissionToEnter?: InputMaybe<FilterPte>;
  /** Item pick up time (HH:MM format). */
  pickUpTime?: InputMaybe<Scalars["String"]>;
  preferredRelocationUnit?: InputMaybe<Scalars["String"]>;
  /** Preferred time window (HH:MM - HH:MM format). */
  preferredTimeWindow?: InputMaybe<Scalars["String"]>;
  quantity?: InputMaybe<Scalars["Int"]>;
  reasonForRelocation?: InputMaybe<ReasonForRelocation>;
  relocationIntendedTime?: InputMaybe<Scalars["RFC3339DateTime"]>;
  requestedCleaningDate?: InputMaybe<Scalars["RFC3339DateTime"]>;
  requestedCleaningTimeSlot?: InputMaybe<RequestedCleaningTimeSlot>;
  shampoo?: InputMaybe<Scalars["Int"]>;
  sheetSet?: InputMaybe<Scalars["Int"]>;
  /** Standard operation policy exception notes */
  sopExceptionNotes?: InputMaybe<Scalars["String"]>;
  sourceOfRelocationRequest?: InputMaybe<SourceOfRelocationRequest>;
  sugarRegular?: InputMaybe<Scalars["Int"]>;
  sugarZing?: InputMaybe<Scalars["Int"]>;
  teaBlack?: InputMaybe<Scalars["Int"]>;
  teaGreen?: InputMaybe<Scalars["Int"]>;
  teaMint?: InputMaybe<Scalars["Int"]>;
  toiletPaper?: InputMaybe<Scalars["Int"]>;
  towelBath?: InputMaybe<Scalars["Int"]>;
  towelFacial?: InputMaybe<Scalars["Int"]>;
  towelHand?: InputMaybe<Scalars["Int"]>;
  towelPaper?: InputMaybe<Scalars["Int"]>;
};

/** Autogenerated return type of RequestAlteration. */
export type RequestAlterationPayload = {
  followupRequired?: Maybe<Scalars["Boolean"]>;
  inquiry?: Maybe<Inquiry>;
  invoiceId?: Maybe<Scalars["String"]>;
  paymentLink?: Maybe<Scalars["String"]>;
  refundOwed?: Maybe<Scalars["Boolean"]>;
};

/** Autogenerated return type of RequestCancellation. */
export type RequestCancellationPayload = {
  followupRequired?: Maybe<Scalars["Boolean"]>;
  refundOwed?: Maybe<Scalars["Boolean"]>;
};

/** Autogenerated return type of RequestEarlyCheckin. */
export type RequestEarlyCheckinPayload = {
  error?: Maybe<Scalars["String"]>;
  inquiry?: Maybe<Inquiry>;
};

/** Autogenerated return type of RequestGroceries. */
export type RequestGroceriesPayload = {
  inquiry: Inquiry;
};

/** Autogenerated return type of RequestLateCheckout. */
export type RequestLateCheckoutPayload = {
  error?: Maybe<Scalars["String"]>;
  inquiry?: Maybe<Inquiry>;
};

/** Autogenerated return type of RequestPhoneVerificationCode. */
export type RequestPhoneVerificationCodePayload = {
  response: BaseResponse;
};

export enum RequestedCleaningTimeSlot {
  EarlyAfternoon = "early_afternoon",
  LateAfternoon = "late_afternoon",
  Morning = "morning",
}

/** Autogenerated return type of RescheduleFailedScheduledPayment. */
export type RescheduleFailedScheduledPaymentPayload = {
  response: RescheduleFailedScheduledPaymentStatus;
};

export type RescheduleFailedScheduledPaymentStatus = {
  /** Associated status message */
  message?: Maybe<Scalars["String"]>;
  /** Boolean of rescheduleFailedScheduledPayment success/fail */
  status: Scalars["Boolean"];
};

/** Autogenerated return type of ResendConfirmationEmail. */
export type ResendConfirmationEmailPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of ResendPhoneVerificationCode. */
export type ResendPhoneVerificationCodePayload = {
  response: BaseResponse;
};

export type ReservationFeedItem = Node & {
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
};

export type ResetPasswordTokenValidity = {
  /** Validity of the given token */
  valid: Scalars["Boolean"];
};

export enum Resource {
  Image = "image",
  Video = "video",
}

/** Autogenerated return type of RespondToPreStaySurvey. */
export type RespondToPreStaySurveyPayload = Node & {
  /** Whether or not the survey has been completed */
  completed: Scalars["Boolean"];
  id: Scalars["ID"];
  /** The questions on the survey */
  questions: Array<PreStayQuestion>;
};

export enum Result {
  /** returns Building */
  Building = "building",
  /** returns City */
  City = "city",
  /** returns Inquiry */
  Inquiry = "inquiry",
  /** returns Lease Inquiry */
  LeaseInquiry = "lease_inquiry",
  /** returns Space */
  Space = "space",
  /** returns Task */
  Task = "task",
  /** returns Task Context */
  TaskContext = "task_context",
  /** returns Task Type Configuration */
  TaskTypeConfiguration = "task_type_configuration",
  /** returns Tom Booking */
  TomBooking = "tom_booking",
  /** returns Unit */
  Unit = "unit",
  /** returns User */
  User = "user",
}

export type RevenueEventSource = {
  /** the id of source that initiated the event */
  sourceId: Scalars["String"];
  /** the type of source that initiated the event */
  type: Scalars["String"];
};

export type RevenueEventSourceList = {
  /** The type of inquiry */
  inquiryType?: Maybe<Scalars["String"]>;
  /** If parent inquiry if P49 or not */
  p49Inquiry: Scalars["Boolean"];
  /** A list of associated events with a parent inquiry */
  revenueEventSources: Array<RevenueEventSource>;
};

export type RevenueInfo = {
  /** balance in range */
  balanceDue: Scalars["Float"];
  currency: Scalars["String"];
  currencySymbol: Scalars["String"];
  /** grand total revenue in range */
  grandTotal: Scalars["Float"];
  /** line items excluding taxes */
  lineItems: Array<RevenueInfoLineItem>;
  /** amount paid in range */
  paidAmount: Scalars["Float"];
  /** Payments on this group (not restricted to a certain date range) */
  payments: Array<Payment>;
  /** total amount for tax (only for charge preview) */
  totalTax?: Maybe<Scalars["Float"]>;
};

export type RevenueInfoLineItem = {
  /** Last night included in revenue info */
  endDate: Scalars["String"];
  /** Line item name, e.g. collection name or tax name */
  itemName: Scalars["String"];
  /** Number of items included */
  quantity: Scalars["Int"];
  /** Amount of revenue */
  revenue: Scalars["Float"];
  /** First night included in revenue info */
  startDate?: Maybe<Scalars["String"]>;
  /** Description of type of charge */
  typeDescription?: Maybe<Scalars["String"]>;
  /** Type of charge - TODO enum */
  typeKey: Scalars["String"];
};

/** Invoice attributes */
export type RevenueInvoice = Node & {
  /** The URL to pay the invoice. */
  checkoutUrl?: Maybe<Scalars["String"]>;
  /** The date and time this record was created */
  createdAt: Scalars["RFC3339DateTime"];
  /** Currency.  e.g. USD, CAD */
  currency: Currency;
  id: Scalars["ID"];
  lineItems: Array<LineItem>;
  serviceProvider?: Maybe<ServiceProvider>;
  /** The Service Provider ID for the associated record */
  serviceProviderExternalId?: Maybe<Scalars["String"]>;
  serviceProviderReservation?: Maybe<ServiceProviderReservation>;
  /** The current state of the invoice, e.g. 'pending', 'paid', 'cancelled' */
  state: InvoiceState;
  totalAmount: Scalars["Float"];
};

export type RevenuePaymentResponse = {
  authenticationUrl?: Maybe<Scalars["String"]>;
  error?: Maybe<Scalars["String"]>;
  invoice?: Maybe<RevenueInvoice>;
  paymentIntentClientSecret?: Maybe<Scalars["String"]>;
  requiresAction: Scalars["Boolean"];
  success: Scalars["Boolean"];
  trackingInfo?: Maybe<Scalars["JSON"]>;
};

export type RevenueScheduledPaymentsList = {
  /** A list of scheduled payments */
  revenueScheduledPayments: Array<ScheduledPayment>;
  /** The number of scheduled payments */
  totalCount: Scalars["Int"];
};

/** Autogenerated return type of RevokeGuestAccount. */
export type RevokeGuestAccountPayload = {
  response: BaseResponse;
};

/** fields to describe rich content */
export type RichContentInput = {
  html: Scalars["String"];
  mentions?: InputMaybe<Array<Scalars["ID"]>>;
};

export type SalesAccount = Node & {
  id: Scalars["ID"];
  name: Scalars["String"];
  /** The sales person of contact at sonder */
  salesPocUser?: Maybe<User>;
  /** corporate or leisure */
  segment?: Maybe<SalesAccountSegment>;
  slug?: Maybe<Scalars["String"]>;
};

/** Sales account upsert input */
export type SalesAccountInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  salesPocUserId?: InputMaybe<Scalars["Int"]>;
  segment?: InputMaybe<SalesAccountSegment>;
};

export enum SalesAccountSegment {
  Corporate = "corporate",
  Leisure = "leisure",
}

export type SalesforceAssociation = Node & {
  id: Scalars["ID"];
  /** Name of the Association. */
  name: Scalars["String"];
  /** The ID in Salesforce. */
  salesforceId?: Maybe<Scalars["String"]>;
  /** The URL in Salesforce. */
  salesforceUrl?: Maybe<Scalars["String"]>;
};

export type SavedTomFilter = {
  /** Description of the filter. */
  description?: Maybe<Scalars["String"]>;
  /** Filter Criteria */
  filter: SavedTomFilterCriteria;
  /** Unique identifier */
  id: Scalars["ID"];
  /** Name of the filter. */
  name: Scalars["String"];
  /** ID of filter owner. */
  ownerId: Scalars["ID"];
  /** Type of filter owner (ex. City). */
  ownerType: FilterOwner;
};

/** filters */
export type SavedTomFilterCriteria = {
  assignee?: Maybe<Array<Scalars["String"]>>;
  buildingIds?: Maybe<Array<Scalars["String"]>>;
  city?: Maybe<Scalars["ID"]>;
  /** city ids */
  cityIds?: Maybe<Array<Scalars["ID"]>>;
  /** cleaning company ids */
  cleaningCompanyIds?: Maybe<Array<Scalars["String"]>>;
  /** if tasks are associated to a cleaning request then filter them by category */
  cleaningRequestCategory?: Maybe<Array<CleaningRequestCategory>>;
  /** tasks relevant to certain client roles */
  clientType?: Maybe<FilterClient>;
  /** Filter status must be set to complete */
  completedAtEnd?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Filter status must be set to complete */
  completedAtStart?: Maybe<Scalars["RFC3339DateTime"]>;
  createdAtEnd?: Maybe<Scalars["RFC3339DateTime"]>;
  createdAtStart?: Maybe<Scalars["RFC3339DateTime"]>;
  /** ignored if filter_triaged == new */
  dueAtEnd?: Maybe<Scalars["RFC3339DateTime"]>;
  /** ignored if filter_triaged == new */
  dueAtStart?: Maybe<Scalars["RFC3339DateTime"]>;
  dueOrLatestEndAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** tasks created during an booking, not implemented yet */
  duringStay?: Maybe<FilterDuringStay>;
  /** loyalty tiers of the guests associated with the booking tasks */
  guestLoyaltyTiers?: Maybe<Array<LoyaltyTier>>;
  /** occupied or vacant */
  occupancy?: Maybe<Array<FilterOccupancy>>;
  /** can pass in -1 for tasks without priorities set */
  priority?: Maybe<Array<Scalars["Int"]>>;
  /** Boolean to indicate cleaning turnover end is same as the next checkin for a unit (for Clean tasks only) */
  sameDayCleansOnly?: Maybe<Scalars["Boolean"]>;
  /** schedula status of the task (scheduled/unscheduled/all) */
  scheduleStatus?: Maybe<TaskScheduleStatusEnum>;
  scheduledOrEarliestStartAt?: Maybe<Scalars["RFC3339DateTime"]>;
  spaceIds?: Maybe<Array<Scalars["ID"]>>;
  status?: Maybe<Array<FilterStatus>>;
  subjectIds?: Maybe<Array<Scalars["ID"]>>;
  /** by task type */
  taskType?: Maybe<Array<TypeEnum>>;
  /** by tags */
  tomTags?: Maybe<Array<Scalars["ID"]>>;
  /** new or triaged */
  triaged?: Maybe<FilterTriaged>;
  unitIds?: Maybe<Array<Scalars["ID"]>>;
};

export type Schedule = {
  /** Inquiry or LeaseInquiry tied to this schedule */
  booking?: Maybe<Booking>;
  /** end time */
  endTime: Scalars["RFC3339DateTime"];
  /** id */
  id: Scalars["ID"];
  /** 'Inquiry' or 'LeaseInquiry' or 'InternalHold' */
  objectType: Scalars["String"];
  /** start time */
  startTime: Scalars["RFC3339DateTime"];
  /** target object id */
  targetObjectId: Scalars["ID"];
  /** the type of the target object */
  targetObjectType: Scalars["String"];
};

export type ScheduleChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New due at value. */
  newDueAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** New scheduled start at value. */
  newScheduledStartAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Previous assignees for a task that got unscheduled. */
  prevAssignees?: Maybe<Array<User>>;
  /** Previous due at value. */
  prevDueAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Previous scheduled start at value. */
  prevScheduledStartAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Reason for schedule change. */
  reason?: Maybe<Scalars["String"]>;
};

/** Autogenerated return type of ScheduleTasks. */
export type ScheduleTasksPayload = {
  success: Scalars["Boolean"];
};

/** Scheduled Payment */
export type ScheduledPayment = {
  amount?: Maybe<Scalars["Float"]>;
  channel?: Maybe<Scalars["String"]>;
  chargeDate?: Maybe<Scalars["ISO8601Date"]>;
  currency?: Maybe<Scalars["String"]>;
  customerId?: Maybe<Scalars["String"]>;
  failedReason?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  inquiryId?: Maybe<Scalars["Int"]>;
  invoiceId?: Maybe<Scalars["Int"]>;
  state?: Maybe<Scalars["String"]>;
};

/** Scheduled Payment Search Query */
export type ScheduledPaymentSearchInput = {
  cursor?: InputMaybe<Scalars["Int"]>;
  endDate?: InputMaybe<Scalars["String"]>;
  inquiryId?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  startDate?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
};

/** Sort by column */
export type ScheduledPaymentSortInput = {
  column?: InputMaybe<SpSortColumn>;
  order?: InputMaybe<SortAscDesc>;
};

export type ScheduledPaymentUpdateStatus = {
  /** Associated status message */
  message?: Maybe<Scalars["String"]>;
  /** Boolean of the update success(true) or fail(false) */
  status: Scalars["Boolean"];
};

/** Scheduler metrics */
export type SchedulerMetrics = {
  /** Assignees contributing to the cleans */
  totalAssignees: Array<User>;
  /** Total number of baths */
  totalBaths: Scalars["Float"];
  /** Count of beds grouped by bed size */
  totalBedTypes: Array<Metric>;
  /** Total number of beds */
  totalBeds: Scalars["Int"];
  /** Count of cleans grouped by clean categories */
  totalCleanTypes: Array<Metric>;
  /** Total number of cleans */
  totalCleans: Scalars["Int"];
  /** Total number of cleans not assigned to a company */
  totalCleansWithNoCompanyAssigned: Scalars["Int"];
  /** Total number of cleans completed */
  totalCompletedCleans: Scalars["Int"];
  /** Total hours for cleans */
  totalHours: Scalars["Float"];
  /** Total number of cleans in progress */
  totalInProgressCleans: Scalars["Int"];
  /** Count of mats grouped by type */
  totalMatTypes: Array<Metric>;
  /** Total number of pillow cases */
  totalPillowCases: Scalars["Int"];
  /** Total number of cleans which are ready */
  totalReadyCleans: Scalars["Int"];
  /** Total number of scheduled cleans */
  totalScheduledCleans: Scalars["Int"];
  /** Count of sleeps grouped by sleeps size */
  totalSleepTypes: Array<Metric>;
  /** Total number of sleeps */
  totalSleeps: Scalars["Int"];
  /** Count of towels grouped by type */
  totalTowelTypes: Array<Metric>;
  /** Total number of unscheduled cleans */
  totalUnscheduledCleans: Scalars["Int"];
};

/** Scheduler metrics input filters */
export type SchedulerMetricsFilterInput = {
  /** assignee ids */
  assignee?: InputMaybe<Array<Scalars["String"]>>;
  /** building ids */
  buildingIds?: InputMaybe<Array<Scalars["String"]>>;
  /** [DEPRECATED] city id */
  city?: InputMaybe<Scalars["ID"]>;
  /** city ids */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** cleaning company ids */
  cleaningCompanyIds?: InputMaybe<Array<Scalars["String"]>>;
  /** cleaning request category */
  cleaningRequestCategory?: InputMaybe<Array<CleaningRequestCategory>>;
  /** end date in the date range */
  dueOrLatestEndAt: Scalars["RFC3339DateTime"];
  /**
   * Boolean to indicate cleaning turnover end is same as
   *                     the next checkin for a unit (for Clean tasks only)
   */
  sameDayCleansOnly?: InputMaybe<Scalars["Boolean"]>;
  /** schedule status of the task (scheduled/unscheduled/all) */
  scheduleStatus?: InputMaybe<TaskScheduleStatusEnum>;
  /** start date in the date range */
  scheduledOrEarliestStartAt: Scalars["RFC3339DateTime"];
  /** task status */
  status?: InputMaybe<Array<FilterStatus>>;
  /** task types */
  taskType?: InputMaybe<Array<TypeEnum>>;
};

export type Search = {
  inventorySearchFilters: InventorySearchFilters;
  inventorySearchMetadata: InventorySearchMetadata;
  inventorySearchResult: InventorySearchResult;
  inventorySearchSorting: InventorySearchSorting;
};

export type SearchAmenityFilter = {
  options: Array<SearchFilterDropdownOption>;
  selected: Array<SearchFilterDropdownOption>;
};

export type SearchAvailabilityFilter = {
  selected: SearchDateTuple;
};

export type SearchBizToggleFilter = {
  selected: Scalars["Boolean"];
};

export type SearchCityFilter = {
  options: Array<SearchFilterDropdownOption>;
  selected: SearchFilterDropdownOption;
};

export type SearchDateTuple = {
  checkInDate?: Maybe<Scalars["String"]>;
  checkOutDate?: Maybe<Scalars["String"]>;
};

export type SearchFeedItem = {
  /** Description for each of the search result */
  description: Scalars["String"];
  /** id used for caching */
  id: Scalars["ID"];
  /** Associated model to the search result type */
  resource: SearchResult;
  /** Sub-title for each of the search result */
  subtitle: Scalars["String"];
  /** Title for each of the search result */
  title: Scalars["String"];
};

/** returns search results matching a query */
export type SearchFeedItemConnections = {
  /** Index-based position of the search. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records. */
  hasMore: Scalars["Boolean"];
  /** Search Feed items */
  items: Array<SearchFeedItem>;
  /** How many items total. */
  total: Scalars["Int"];
};

export type SearchFilterDropdownOption = {
  label: Scalars["String"];
  value: Scalars["String"];
};

/** fields to describe user/unit content */
export type SearchFilterInput = {
  building?: InputMaybe<BuildingSearchFilterInput>;
  inquiry?: InputMaybe<InquirySearchFilterInput>;
  leaseInquiry?: InputMaybe<LeaseInquirySearchFilterInput>;
  space?: InputMaybe<SpaceSearchFilterInput>;
  task?: InputMaybe<TasksSearchFilterInput>;
  taskContext?: InputMaybe<TaskContextSearchFilterInput>;
  tomBooking?: InputMaybe<TomBookingSearchFilterInput>;
  unit?: InputMaybe<UnitSearchFilterInput>;
  user?: InputMaybe<UserSearchFilterInput>;
};

export type SearchGuestCountFilter = {
  options: SearchRangeFilterOptions;
  selected: Scalars["Int"];
};

export type SearchNeighborhoodFilter = {
  options: Array<SearchFilterDropdownOption>;
  selected: Array<SearchFilterDropdownOption>;
};

export type SearchPricingFilter = {
  options: SearchRangeFilterOptions;
  selected: SearchRangeFilterOptions;
};

/** Search Query */
export type SearchQueryInput = {
  amenities?: InputMaybe<Array<Scalars["String"]>>;
  bathroomCount?: InputMaybe<Scalars["Float"]>;
  bedCount?: InputMaybe<Scalars["Float"]>;
  bedroomCount?: InputMaybe<Scalars["Float"]>;
  bizToggle?: InputMaybe<Scalars["Boolean"]>;
  buildingId?: InputMaybe<Scalars["Int"]>;
  checkInDate?: InputMaybe<Scalars["String"]>;
  checkOutDate?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  geoBoundingBox?: InputMaybe<GeoBoundingBoxInput>;
  geoDistance?: InputMaybe<GeoDistanceInput>;
  guestCount?: InputMaybe<Scalars["Float"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  maxPrice?: InputMaybe<Scalars["Float"]>;
  minPrice?: InputMaybe<Scalars["Float"]>;
  neighborhoods?: InputMaybe<Array<Scalars["String"]>>;
  offset?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<Scalars["String"]>;
};

export type SearchRangeFilter = {
  options: SearchRangeFilterOptions;
  selected?: Maybe<Scalars["Float"]>;
};

export type SearchRangeFilterOptions = {
  max?: Maybe<Scalars["Float"]>;
  min?: Maybe<Scalars["Float"]>;
};

/** All search result types that can be returned. The Id of each object can either by string (String!) or integer (ID!) */
export type SearchResult =
  | Building
  | City
  | CufSpace
  | Inquiry
  | LeaseInquiry
  | Task
  | TaskContext
  | TaskTypeConfiguration
  | TomBooking
  | Unit
  | User;

export enum SecurityOnsite {
  No = "no",
  Yes = "yes",
}

/** Autogenerated return type of SendAppDownloadLink. */
export type SendAppDownloadLinkPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of SendPhoneVerificationViaConfirmationCode. */
export type SendPhoneVerificationViaConfirmationCodePayload = {
  censoredNumber: Scalars["String"];
  hasAccount: Scalars["Boolean"];
};

/** Autogenerated return type of SendResetPasswordInstructionsEmail. */
export type SendResetPasswordInstructionsEmailPayload = {
  success?: Maybe<Scalars["Boolean"]>;
};

export type SendbirdConfiguration = {
  /** Open salesforce case id */
  sendbirdApplicationId: Scalars["String"];
  /** Id of a Sendbird Channel */
  sendbirdChannelId: Scalars["String"];
  /** Session Token of Sendbird User */
  sendbirdSessionToken: Scalars["String"];
  /** Id of a Sendbird User */
  sendbirdUserId: Scalars["String"];
};

export type ServicePartner = {
  /** Service partner category internal key */
  categoryKey: Scalars["String"];
  /** Service partner category name */
  categoryName: Scalars["String"];
  /** Long description */
  descriptionLong: Scalars["String"];
  /** Short description (two or three words) */
  descriptionShort: Scalars["String"];
  /** Display name */
  displayName: Scalars["String"];
  /** Unique identifier */
  id: Scalars["ID"];
  /** Promo code */
  promoCode?: Maybe<Scalars["String"]>;
  /** URL */
  url: Scalars["String"];
};

export type ServiceProvider = Node & {
  id: Scalars["ID"];
  name: Scalars["String"];
  slug: Scalars["String"];
};

/** All reservation types from 3rd party service providers */
export type ServiceProviderReservation = ParkingReservation;

/** Serviceables that can be returned */
export type Serviceable = Building | CufSpace | Unit;

export type ServicesAddress = {
  /** 111 Main St */
  address: Scalars["String"];
  /** San Francisco */
  city: Scalars["String"];
  /** US */
  countryCode: Scalars["String"];
  /** latitude */
  latitude?: Maybe<Scalars["Float"]>;
  /** longitude */
  longitude?: Maybe<Scalars["Float"]>;
  /** CA */
  state: Scalars["String"];
  /** 94404 */
  zipcode: Scalars["String"];
};

/** Autogenerated return type of SetGuestActualDepartureTime. */
export type SetGuestActualDepartureTimePayload = {
  inquiry: Inquiry;
};

/** Autogenerated return type of SignInWithEmail. */
export type SignInWithEmailPayload = {
  accountJwt: Scalars["String"];
  refreshJwt: Scalars["String"];
};

/** Autogenerated return type of SignInWithOauth. */
export type SignInWithOauthPayload = {
  accountJwt: Scalars["String"];
  refreshJwt: Scalars["String"];
};

/** Autogenerated return type of SignInWithVerifiedConfirmationCode. */
export type SignInWithVerifiedConfirmationCodePayload = {
  accountJwt: Scalars["String"];
  refreshJwt: Scalars["String"];
  resetPasswordToken?: Maybe<Scalars["String"]>;
};

export enum SortAscDesc {
  Asc = "asc",
  Desc = "desc",
}

export enum SortColumn {
  CleaningActualEndAt = "cleaning_actual_end_at",
  CleaningCompanyName = "cleaning_company_name",
  CreatedAt = "created_at",
  HkMiscServiceDate = "hk_misc_service_date",
}

/** Determine the sorting strategy */
export type Sorting = {
  /** sorting column name */
  column: SortColumn;
  /** sort asc/desc */
  order?: InputMaybe<SortAscDesc>;
};

export enum Source {
  Pipedrive = "pipedrive",
  Sfdc = "sfdc",
}

export enum SourceOfRelocationRequest {
  Guest = "guest",
  Sonder = "sonder",
}

export type SourceTypeMetadata = {
  /** The concurrent access options information */
  concurrentAccessOptions: ConcurrentAccessOptions;
  /** The maximum duration of a hold in minutes for a proposition */
  holdDurationInMinutes: Scalars["Int"];
  /** The maximum number of proposition(s) allowed */
  maxPropositions: Scalars["Int"];
  /** Notifications to display when this source type is selected */
  notifications: Array<Notification>;
  /** The reasons */
  reasonOptions: Array<RelocationReason>;
  /** The options available for a refund */
  refundOptions?: Maybe<Array<RelocationRefundOption>>;
  /** The source type the metadata are related to (sonder, guest) */
  sourceType: Scalars["String"];
};

export enum SpSortColumn {
  FailedReason = "failed_reason",
  Id = "id",
  InquiryId = "inquiry_id",
  InvoiceId = "invoice_id",
  ScheduledDate = "scheduled_date",
  State = "state",
}

/** Space search filters params */
export type SpaceSearchFilterInput = {
  /** Space city IDs (through buildings) */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export enum SquadTag {
  Dispatch = "Dispatch",
  ExternalHousekeeping = "ExternalHousekeeping",
  Get = "GET",
  Hotel = "Hotel",
  Housekeeping = "Housekeeping",
  It = "IT",
  InternalHousekeeping = "InternalHousekeeping",
  Landlord = "Landlord",
  MaintenancePm = "MaintenancePM",
  Onboarding = "Onboarding",
  Procurement = "Procurement",
  Warehouse = "Warehouse",
}

/** Autogenerated return type of StartPreStaySurvey. */
export type StartPreStaySurveyPayload = Node & {
  /** Whether or not the survey has been completed */
  completed: Scalars["Boolean"];
  id: Scalars["ID"];
  /** The questions on the survey */
  questions: Array<PreStayQuestion>;
};

export type State = {
  alpha2: Scalars["String"];
  /** Unique identifier */
  id: Scalars["ID"];
  name: Scalars["String"];
};

export enum Status {
  Deleted = "deleted",
  Lost = "lost",
  None = "none",
  Open = "open",
  Won = "won",
}

export type StatusChangeMetadata = Node & {
  id: Scalars["ID"];
  /** New task status. */
  newStatus: FilterStatus;
  /** Previous task status. */
  prevStatus: FilterStatus;
};

export type StorageLocation = {
  /**
   * Storage location address
   * @deprecated Use CufStorageLocation
   */
  address: Address;
  /**
   * Unique identifier
   * @deprecated Use CufStorageLocation
   */
  id: Scalars["ID"];
  /**
   * Storage instructions and location info
   * @deprecated Use CufStorageLocation
   */
  instructions: Scalars["String"];
  /**
   * Display name
   * @deprecated Use CufStorageLocation
   */
  name: Scalars["String"];
};

export type StructuredMetadataBooking = {
  followedByGuestServices?: InputMaybe<Scalars["String"]>;
};

export enum SubjectTypeEnum {
  Building = "Building",
  City = "City",
  CufSpace = "Cuf_Space",
  FlexLeasesCharge = "FlexLeases_Charge",
  HkCleaningRequest = "Hk_CleaningRequest",
  Inquiry = "Inquiry",
  InternalHold = "InternalHold",
  LeaseInquiry = "LeaseInquiry",
  TomBooking = "Tom_Booking",
  TomUnitAvailabilityHold = "Tom_UnitAvailabilityHold",
  Unit = "Unit",
}

/** Autogenerated return type of SubmitCsatFeedback. */
export type SubmitCsatFeedbackPayload = {
  response: CsatFeedbackResponse;
};

export enum TomChangeReason {
  DoorCodeNotWorking = "door_code_not_working",
  GuestDeclined = "guest_declined",
  GuestInUnit = "guest_in_unit",
}

export type Task = CommentTarget &
  Node &
  TaskFeedItem &
  UserNotificationResource & {
    /** The actionable that's connected to this task.  Used for linking */
    actionableId?: Maybe<Scalars["String"]>;
    /** The actionable type */
    actionableType?: Maybe<Scalars["String"]>;
    /** URL to asana task */
    asanaUrl?: Maybe<Scalars["String"]>;
    /** Who this task is assigned to. */
    assignee?: Maybe<User>;
    /** Who this task is assigned for tasks that support multi-assignees. */
    assignees?: Maybe<Array<User>>;
    /** Attachments for this task */
    attachments?: Maybe<Array<Attachment>>;
    /** creator of the task */
    author?: Maybe<User>;
    /** default body text for task */
    body: Scalars["String"];
    /** Inquiry or LeaseInquiry tied to this task */
    booking?: Maybe<Booking>;
    /** The building if applicable. */
    building?: Maybe<Building>;
    /** Channel the task was created on */
    channel: Scalars["String"];
    /** Associated checklist items */
    checklistItems?: Maybe<Array<TaskChecklistItem>>;
    /** The city. */
    city?: Maybe<City>;
    /** Cleaning associated with the task. Used for QA Tasks only */
    cleaning?: Maybe<Cleaning>;
    /**
     * Cleaning request associated with the task. Task types:
     * GuestInUnitAfterCheckout HoldSecurityDeposit InternalHoldChecklist PickupTask
     * QualityAudit SpaceClean Clean
     */
    cleaningRequest?: Maybe<CleaningRequest>;
    /** The method that user (guest) communicated with us. */
    communicationMethod?: Maybe<Scalars["String"]>;
    /**
     * Is this task already completed.
     * @deprecated use status instead
     */
    complete?: Maybe<Scalars["Boolean"]>;
    /** When this task was completed */
    completedAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** When the task was created. */
    createdAt: Scalars["RFC3339DateTime"];
    /** Space in building being cleaned. Task types: SpaceClean */
    cufSpace?: Maybe<CufSpace>;
    /** URL to DD task */
    ddUrl?: Maybe<Scalars["String"]>;
    /** Upstream tasks of this task */
    dependencyTasks?: Maybe<Array<Task>>;
    /** Task type in human-readable format (n+1 query) */
    displayType?: Maybe<Scalars["String"]>;
    /** When the task is due. */
    dueAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** If this task was created for the guest currently in the unit */
    duringStay: Scalars["Boolean"];
    /** the earliest start time that a task can be started/scheduled. */
    earliestStartAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** an estimation of the task duration in minutes. */
    estimatedDuration?: Maybe<Scalars["Int"]>;
    /** ETA reported by HA */
    eta?: Maybe<Scalars["RFC3339DateTime"]>;
    /** End range for ETA reported by HA */
    etaRangeEnd?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Start range for ETA reported by HA */
    etaRangeStart?: Maybe<Scalars["RFC3339DateTime"]>;
    /** This is a formatted string of the due at timestamp */
    formattedDueAt?: Maybe<Scalars["String"]>;
    /** ID of the resource */
    id: Scalars["ID"];
    /** Internal hold associated with the task. Task types: InternalHoldChecklist */
    internalHold?: Maybe<InternalHold>;
    /** the latest end time that a task can be finished/scheduled. */
    latestEndAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** All the metadata for a tom task */
    metadata?: Maybe<Array<KeyValue>>;
    /** Name of the task. */
    name?: Maybe<Scalars["String"]>;
    /** the task after this one in the recurrence thread */
    nextRecurrenceTask?: Maybe<Task>;
    /** The next expected status for this task */
    nextStatus?: Maybe<Scalars["String"]>;
    /** The next expected status for this task */
    nextStatusDisplay?: Maybe<Scalars["String"]>;
    /** Notes. */
    notes?: Maybe<Scalars["String"]>;
    /** Parent task if exists */
    parentTask?: Maybe<Task>;
    /** If the guest gave permission to enter their unit */
    permissionToEnter?: Maybe<FilterPte>;
    /** The method that user (guest) prefers we use to communicated with her. */
    preferredCommunicationMethod?: Maybe<Scalars["String"]>;
    /** the task before this one in the recurrence thread */
    previousRecurrenceTask?: Maybe<Task>;
    /** Priority of the task.  1 is highest. 5 is lowest. */
    priority?: Maybe<Scalars["Int"]>;
    /** Status progression information */
    progressionInfo: ProgressionInfo;
    /** QA ID. Task types: QualityAudit */
    qaId?: Maybe<Scalars["String"]>;
    /** the start time of the task schedule. */
    scheduledStartAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Checklist items associated with the task, TaskTypes: HoldSecurityDeposit */
    securityDepositItems?: Maybe<Array<Task>>;
    /** When this task was started */
    startedAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Status going forward... complete will be deprecated */
    status?: Maybe<Scalars["String"]>;
    /** Call to action to transition to next_status, can be null for now. so have a default! */
    statusProgressionCta?: Maybe<Scalars["String"]>;
    /** Structured metadata for this task */
    structuredMetadata?: Maybe<TaskStructuredMetadata>;
    /** Subject Type of Task */
    subjectType: Scalars["String"];
    /** list of users who have subscribed to this task */
    subscribers?: Maybe<Array<User>>;
    /** List of tags on this task */
    tags: Array<TomTag>;
    /** the task context */
    taskContext?: Maybe<TaskContext>;
    /** Tasks container */
    taskFeedItemConnections: TaskFeedItemConnections;
    /** When the current user last viewed task_feed_items. */
    taskFeedItemsLastViewedAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Related tasks */
    taskRelatedTasks?: Maybe<Array<Task>>;
    /** recurrence settings if applicable */
    tomTaskRecurrenceSetting?: Maybe<TaskRecurrenceSetting>;
    /** Task Type */
    type: Scalars["String"];
    /** The unit involved if applicable. */
    unit?: Maybe<Unit>;
    /** Is there a guest in this unit */
    unitOccupiedUntil?: Maybe<Scalars["RFC3339DateTime"]>;
    /** When the task was updated. */
    updatedAt: Scalars["RFC3339DateTime"];
    /** Creator of the task */
    user?: Maybe<User>;
  };

export type TaskTaskFeedItemConnectionsArgs = {
  filter?: InputMaybe<Array<Filter>>;
};

export type TaskActivity = Node &
  TaskFeedItem &
  UserNotificationResource & {
    /** When the comment was created. */
    activityTime: Scalars["RFC3339DateTime"];
    /** Activity type. */
    activityType: Scalars["String"];
    /** author of this item */
    author?: Maybe<User>;
    /** Comment text content. */
    body: Scalars["String"];
    /** When the comment was created. */
    createdAt: Scalars["RFC3339DateTime"];
    /** ID of the resource */
    id: Scalars["ID"];
    /** Indicates whether or not activity belongs to sub task */
    isSubtaskActivity?: Maybe<Scalars["Boolean"]>;
    /** useful metadata about each activity, based on activity_type */
    metadata?: Maybe<TaskActivityMetadata>;
    /**
     * Next value.
     * @deprecated use metadata union field
     */
    nextValue?: Maybe<Scalars["String"]>;
    /**
     * Previous value.
     * @deprecated use metadata union field
     */
    prevValue?: Maybe<Scalars["String"]>;
    /** Where this activity was initiated */
    source?: Maybe<ActivitySource>;
    /** Task that activity belongs to */
    task: Task;
    /** When the comment was last updated. */
    updatedAt: Scalars["RFC3339DateTime"];
    /** User that created this comment */
    user?: Maybe<User>;
  };

/** Feed item types that may be returned for a task */
export type TaskActivityMetadata =
  | AssigneeIdChangeMetadata
  | ChangedTagMetadata
  | DueAtChangeMetadata
  | EciLcoApprovedMetadata
  | EmptyTaskActivityMetadata
  | EtaChangeMetadata
  | NameChangeMetadata
  | NotesChangeMetadata
  | PermissionToEnterChangeMetadata
  | PriorityChangeMetadata
  | RecurrenceChangeMetadata
  | ScheduleChangeMetadata
  | StatusChangeMetadata;

/** Attributes for attachment on the task creation */
export type TaskAttachmentInput = {
  format: Format;
  host: Host;
  publicId?: InputMaybe<Scalars["String"]>;
  resourceType?: InputMaybe<Resource>;
};

export type TaskCategory = Node & {
  id: Scalars["ID"];
  /** name of the category. */
  name: Scalars["String"];
};

/** Task Category filters params */
export type TaskCategoryFilterInput = {
  /** location ids for searching categories in linked contexts */
  locationIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** subject_types will filter out all contexts which don't have at least one of those as valid_subject_type */
  subjectTypes?: InputMaybe<Array<TaskContextSubjectTypeEnum>>;
  /** the task type we should return the linked categories for */
  taskTypes?: InputMaybe<Array<TypeEnum>>;
};

export type TaskChecklistItem = Node & {
  /** When the checklist item was created. */
  createdAt: Scalars["RFC3339DateTime"];
  id: Scalars["ID"];
  /** Name of the checklist item. */
  name: Scalars["String"];
  /** Is this checklist required to be done to complete the task */
  required?: Maybe<Scalars["Boolean"]>;
  /** Status of this checklist item */
  status: ChecklistItemStatus;
};

/** The connection type for Task. */
export type TaskConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Task>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TaskConnections = {
  /** Index-based position of the search. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records. */
  hasMore: Scalars["Boolean"];
  /** The list of tasks. */
  tasks: Array<Task>;
  /** How many items total. */
  total: Scalars["Int"];
};

export type TaskContext = Node & {
  /** details of the context. */
  contextDetails?: Maybe<Array<TaskContextDetail>>;
  /** features of the context. */
  features?: Maybe<Array<TaskContextFeature>>;
  id: Scalars["ID"];
  /** name of the context. */
  name?: Maybe<Scalars["String"]>;
  /** category of the context. */
  taskCategory: TaskCategory;
  /** location of the context. */
  taskLocation: TaskLocation;
  /** task type of the context. */
  taskType: Scalars["String"];
};

/** Task context connection */
export type TaskContextConnections = {
  /** Index-based position of the search. */
  cursor: Scalars["String"];
  /** Are there more records. */
  hasMore: Scalars["Boolean"];
  /** The list of task contexts */
  serializedTreeStructuredTaskContexts: Scalars["String"];
  /** The list of task contexts */
  taskContexts: Array<TaskContext>;
  /** How many items total. */
  total: Scalars["Int"];
};

export type TaskContextDetail = Node & {
  /** context item. */
  contextItem?: Maybe<TaskContextItem>;
  id: Scalars["ID"];
  /** order of the context item in the details. */
  order?: Maybe<Scalars["Int"]>;
};

export type TaskContextFeature = {
  /** default value of the feature. */
  defaultValue?: Maybe<Scalars["String"]>;
  /** indicates if the feature can be written by consumer or not. */
  mutable: Scalars["Boolean"];
  /** name of the feature. */
  name: Scalars["String"];
  /** indicates if the feature is required or not. */
  required: Scalars["Boolean"];
};

/** task context input filters */
export type TaskContextFilterInput = {
  /** indicates if the task with this context can be created manually by the user or not */
  canTaskBeCreatedManually?: InputMaybe<Scalars["Boolean"]>;
  /** category ids of the contexts */
  categoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** location ids of the contexts */
  locationIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** subject_types will filter out all contexts which don't have at least one of those as valid_subject_type */
  subjectTypes?: InputMaybe<Array<TaskContextSubjectTypeEnum>>;
  /** task types of the contexts */
  taskTypes?: InputMaybe<Array<TypeEnum>>;
};

export type TaskContextItem = Node & {
  /** dispaly name of context item. */
  displayName: Scalars["String"];
  id: Scalars["ID"];
  /** name of context item. */
  name?: Maybe<Scalars["String"]>;
  /** localized name of context item. */
  nameLocalized?: Maybe<Scalars["String"]>;
};

/** Tom Task Context search filters params */
export type TaskContextSearchFilterInput = {
  /** indicates if the task with this context can be created manually by the user or not */
  canTaskBeCreatedManually?: InputMaybe<Scalars["Boolean"]>;
  /** subject type of the task context */
  subjectTypes?: InputMaybe<Array<TaskContextSubjectTypeEnum>>;
  /** task location place of the task context */
  taskLocationPlaces?: InputMaybe<Array<TaskLocationPlaceEnum>>;
  /** task type of the task context */
  taskTypes?: InputMaybe<Array<TypeEnum>>;
};

export enum TaskContextSubjectTypeEnum {
  Building = "Building",
  CufSpace = "Cuf_Space",
  Inquiry = "Inquiry",
  LeaseInquiry = "LeaseInquiry",
  TomBooking = "Tom_Booking",
  Unit = "Unit",
}

export type TaskDependencyInput = {
  dependencyTaskId: Scalars["ID"];
  dependencyType: TaskDependencyTypeEnum;
};

export enum TaskDependencyTypeEnum {
  FollowUpTask = "follow_up_task",
}

/** An edge in a connection. */
export type TaskEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node?: Maybe<Task>;
};

/** Feed item interface that may be returned for a task */
export type TaskFeedItem = {
  /** author of this item */
  author?: Maybe<User>;
  /** default text */
  body: Scalars["String"];
  /** When the comment was created. */
  createdAt: Scalars["RFC3339DateTime"];
  id: Scalars["ID"];
};

export type TaskFeedItemConnections = {
  /** When the current user last viewed task_feed_items. */
  lastViewedAt?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Feed items for this task */
  taskFeedItems: Array<TaskFeedItem>;
  /** How many items total. */
  unreadCount: Scalars["Int"];
};

/** filters */
export type TaskFilterInput = {
  /** can pass in '-1' for tasks without assignees set */
  assignee?: InputMaybe<Array<Scalars["String"]>>;
  buildingIds?: InputMaybe<Array<Scalars["String"]>>;
  city?: InputMaybe<Scalars["ID"]>;
  /** cleaning company ids */
  cleaningCompanyIds?: InputMaybe<Array<Scalars["String"]>>;
  /** if tasks are associated to a cleaning request then filter them by category */
  cleaningRequestCategory?: InputMaybe<Array<CleaningRequestCategory>>;
  /** tasks relevant to certain client roles */
  clientType?: InputMaybe<FilterClient>;
  /** Filter status must be set to complete */
  completedAtEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** Filter status must be set to complete */
  completedAtStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  createdAtEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  createdAtStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** ignored if filter_triaged == new */
  dueAtEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** ignored if filter_triaged == new */
  dueAtStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  dueOrLatestEndAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /**
   * tasks created during an booking,
   *                  not implemented yet
   */
  duringStay?: InputMaybe<FilterDuringStay>;
  /** loyalty tiers of the guests associated with the booking tasks */
  guestLoyaltyTiers?: InputMaybe<Array<LoyaltyTier>>;
  /** occupied or vacant */
  occupancy?: InputMaybe<Array<FilterOccupancy>>;
  /** can pass in -1 for tasks without priorities set */
  priority?: InputMaybe<Array<Scalars["Int"]>>;
  scheduledOrEarliestStartAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** by cuf space ID */
  spaceIds?: InputMaybe<Array<Scalars["ID"]>>;
  status?: InputMaybe<Array<FilterStatus>>;
  /** by subject ID */
  subjectIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** by task type */
  taskType?: InputMaybe<Array<TypeEnum>>;
  /** by tag ID */
  tomTags?: InputMaybe<Array<Scalars["ID"]>>;
  /** new or triaged */
  triaged?: InputMaybe<FilterTriaged>;
  unitIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type TaskLocation = Node & {
  id: Scalars["ID"];
  /** name of the location. */
  name: Scalars["String"];
  /** place of the location. unit/building for example. */
  place: Scalars["String"];
};

export type TaskLocationFilterInput = {
  /** task subject type */
  subjectType: TaskContextSubjectTypeEnum;
  /** filters the task locations which there is at least one task context with the provided task types. */
  taskContextTaskTypes?: InputMaybe<Array<TypeEnum>>;
};

export enum TaskLocationPlaceEnum {
  Building = "Building",
  Space = "Space",
  Unit = "Unit",
}

/** Metrics for city tasks, buildings tasks and users performing tasks in a city */
export type TaskMetrics = {
  /** Metrics related to buildings of a city */
  buildingMetrics: MetricsTable;
  /** Metrics related to a city */
  cityMetrics: Array<Metric>;
  /** Metrics related to users performing tasks in a city */
  userMetrics: MetricsTable;
};

/** Metrics for city tasks, buildings tasks and users performing tasks in a city */
export type TaskMetricsBuildingMetricsArgs = {
  filters: TaskMetricsFilterInput;
};

/** Metrics for city tasks, buildings tasks and users performing tasks in a city */
export type TaskMetricsCityMetricsArgs = {
  filters: TaskMetricsFilterInput;
};

/** Metrics for city tasks, buildings tasks and users performing tasks in a city */
export type TaskMetricsUserMetricsArgs = {
  filters: TaskMetricsFilterInput;
};

/** City report filters */
export type TaskMetricsFilterInput = {
  cityIds: Array<Scalars["ID"]>;
  dateEnd: Scalars["RFC3339DateTime"];
  dateStart: Scalars["RFC3339DateTime"];
  priorities?: InputMaybe<Array<Scalars["Int"]>>;
  taskTypes?: InputMaybe<Array<TypeEnum>>;
};

export type TaskRecurrenceSetting = Node & {
  /** what day this recurs on */
  daysOfWeek?: Maybe<Array<DaysOfWeek>>;
  id: Scalars["ID"];
  /** The scalar for interval. */
  intervalAmt: Scalars["Int"];
  /** The unit for interval. */
  intervalUnit: RecurrenceIntervalUnit;
  /** The task in question. */
  task: Task;
  /** the recurrence thread id. */
  threadId: Scalars["Int"];
};

/** way to specify recurrence settings */
export type TaskRecurrenceSettingsInput = {
  daysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  /** leaving this blank removes recurrence */
  intervalAmt?: InputMaybe<Scalars["Int"]>;
  /** leaving this blank removes recurrence */
  intervalUnit?: InputMaybe<RecurrenceIntervalUnit>;
};

export enum TaskScheduleStatusEnum {
  /** task is either scheduled or not scheduled */
  All = "all",
  /** task is scheduled */
  Scheduled = "scheduled",
  /** rask is not scheduled. */
  Unscheduled = "unscheduled",
}

/** Task scheduler connection */
export type TaskSchedulerConnections = {
  /** Index-based position of the search. */
  cursor: Scalars["String"];
  /** Are there more records. */
  hasMore: Scalars["Boolean"];
  /** The list of places (unit/cuf_space) */
  places: Array<TaskSchedulerPlace>;
  /** How many items total. */
  total: Scalars["Int"];
};

/** task scheduler input filters */
export type TaskSchedulerFilterInput = {
  /** assignee ids */
  assignee?: InputMaybe<Array<Scalars["String"]>>;
  /** building ids */
  buildingIds?: InputMaybe<Array<Scalars["String"]>>;
  /** [DEPRECATED] city id */
  city?: InputMaybe<Scalars["ID"]>;
  /** city ids */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** cleaning company ids */
  cleaningCompanyIds?: InputMaybe<Array<Scalars["String"]>>;
  /** cleaning request category */
  cleaningRequestCategory?: InputMaybe<Array<CleaningRequestCategory>>;
  /** end date in the date range */
  dueOrLatestEndAt: Scalars["RFC3339DateTime"];
  /** for same day cleans. Task types: Tom::Tasks::Clean */
  sameDayCleansOnly?: InputMaybe<Scalars["Boolean"]>;
  /** schedule status of the task (scheduled/unscheduled/all) */
  scheduleStatus?: InputMaybe<TaskScheduleStatusEnum>;
  /** start date in the date range */
  scheduledOrEarliestStartAt: Scalars["RFC3339DateTime"];
  /** task status */
  status?: InputMaybe<Array<FilterStatus>>;
  /** task types */
  taskType?: InputMaybe<Array<TypeEnum>>;
};

/** Scheduler metrics */
export type TaskSchedulerPlace = {
  /** apartment number (applies only to units) */
  aptNumber?: Maybe<Scalars["String"]>;
  /** if apt_number exist then apt_number otherwise internal_ref (applies only to units) */
  aptNumberOrInternalRef?: Maybe<Scalars["String"]>;
  /** number of bedrooms in the unit */
  brCount?: Maybe<Scalars["Int"]>;
  /** place's building */
  building: Building;
  /** City of the unit/cuf_space */
  city: City;
  /** type of cuf space */
  cufSpaceType?: Maybe<Scalars["String"]>;
  /** unique identifier of object */
  id: Scalars["String"];
  /** internal ref of unit/cuf_space */
  internalRef?: Maybe<Scalars["String"]>;
  /** number of bathrooms in the unit */
  nbrBathrooms?: Maybe<Scalars["Float"]>;
  /** related bookings for unit */
  relatedBookings: Array<Booking>;
  /** related schedules for unit */
  relatedSchedules?: Maybe<Array<Schedule>>;
  /** List of tasks */
  relatedTasks?: Maybe<Array<Task>>;
  /** short internal ref of unit/cuf_space */
  shortInternalRef?: Maybe<Scalars["String"]>;
};

/** Scheduler metrics */
export type TaskSchedulerPlaceRelatedBookingsArgs = {
  endAt: Scalars["RFC3339DateTime"];
  startAt: Scalars["RFC3339DateTime"];
};

/** Scheduler metrics */
export type TaskSchedulerPlaceRelatedSchedulesArgs = {
  endAt: Scalars["RFC3339DateTime"];
  startAt: Scalars["RFC3339DateTime"];
};

export enum TaskSortColumn {
  AssigneeId = "assignee_id",
  AssigneeName = "assignee_name",
  DueAt = "due_at",
  GuestLoyaltyTier = "guest_loyalty_tier",
  InternalRef = "internal_ref",
  Name = "name",
  Occupancy = "occupancy",
  Priority = "priority",
  Status = "status",
  TaskCompletedAt = "task_completed_at",
}

/** Sort by column */
export type TaskSortInput = {
  column: TaskSortColumn;
  order: SortAscDesc;
};

export enum TaskStatus {
  Arriving = "arriving",
  Canceled = "canceled",
  Complete = "complete",
  Deleted = "deleted",
  Enroute = "enroute",
  Inprogress = "inprogress",
  Ready = "ready",
  Waiting = "waiting",
}

export type TaskStructuredMetadata = {
  /** The Cleaning Company associated */
  cleaningCompany?: Maybe<CleaningCompany>;
  /** Date at which the task needs to be completed. Task types: GuestRequest */
  dateToComplete?: Maybe<Scalars["String"]>;
  /** Delivery Task that is associated with this task */
  deliveryTask?: Maybe<Task>;
  /** Desired check-in time (HH:MMformat). */
  desiredCheckInTime?: Maybe<Scalars["String"]>;
  /** Desired check-out time (HH:MMformat). */
  desiredCheckOutTime?: Maybe<Scalars["String"]>;
  /** Additional details to why is this relocation requested. Task types: GetRelocation/Request */
  detailsOfReasonForRelocation?: Maybe<Scalars["String"]>;
  /** Storage/drop-off location. */
  dropOffLocation?: Maybe<Scalars["String"]>;
  /** Item drop off time (HH:MM format). */
  dropOffTime?: Maybe<Scalars["String"]>;
  /** Earliest start time for the task. Task types: GuestRequest */
  earliestStartTime?: Maybe<Scalars["String"]>;
  /** When does the guest need to leave by? Task types: TrustAndSafetyEjection */
  ejectionAt?: Maybe<Scalars["String"]>;
  /** If ETA is enabled for the task or not */
  etaEnabled?: Maybe<FilterEtaEnabled>;
  /** When does the guest need to leave by? Task types: TrustAndSafetyEjection */
  evictionAt?: Maybe<Scalars["String"]>;
  /** Fallback relocation target if preferred unit is unavailable. Task types: GetRelocation/Request */
  fallbackRelocationUnit?: Maybe<Unit>;
  /** Whether the task is followed by guest services. Used to trigger asana task creation for Booking tasks */
  followedByGuestServices?: Maybe<Scalars["Boolean"]>;
  /**
   * Google Form URL associated with the task. Used in some city workflow. Task
   * types: InspectionTask MaintenanceInspectionTask OnboardingInspectionTask
   */
  googleFormUrl?: Maybe<Scalars["String"]>;
  /** Is the guest already aware they are being ejected? Task types: TrustAndSafetyEjection */
  guestAlreadyAware?: Maybe<Scalars["Boolean"]>;
  /** Has the guest received any previous warnings? Task types: TrustAndSafetyEjection */
  guestReceivedPreviousWarning?: Maybe<Scalars["Boolean"]>;
  /** How urgent is the task for the guest */
  guestUrgency?: Maybe<GuestUrgency>;
  /** Time of move. Task types: GetRelocation */
  intraStayTime?: Maybe<Scalars["String"]>;
  /** Online Travel Agency for the inquiry. Task types: GetRelocation */
  ota?: Maybe<Scalars["String"]>;
  /** Payment status */
  paymentStatus?: Maybe<PaymentStatus>;
  /** If the guest gave permission to enter their unit */
  permissionToEnter?: Maybe<FilterPte>;
  /** Item pick up quantity. Task types: PickupTask QuantityGuestRequest */
  pickUpQuantity?: Maybe<Scalars["String"]>;
  /** Pick-up Task that is associated with this task */
  pickUpTask?: Maybe<Task>;
  /** Item pick up time (HH:MM format). */
  pickUpTime?: Maybe<Scalars["String"]>;
  /** Link to the most preferred unit in the CUF. Task types: GetRelocation/Request */
  preferredRelocationUnit?: Maybe<Unit>;
  /** Preferred time window (HH:MM - HH:MM format). */
  preferredTimeWindow?: Maybe<Scalars["String"]>;
  /** quantity of the item requested. */
  quantity?: Maybe<Scalars["Int"]>;
  /** Reason why a guest was banned. Task types: TrustAndSafetyRequestToBanGuest */
  reasonForBan?: Maybe<Scalars["String"]>;
  /** Reason for clean. */
  reasonForClean?: Maybe<ReasonForClean>;
  /** Reason why a guest was evicted. Task types: TrustAndSafetyEjection, TrustAndSafety */
  reasonForEjection?: Maybe<Scalars["String"]>;
  /** Reason why a guest was evicted. Task types: TrustAndSafetyEjection */
  reasonForEviction?: Maybe<Scalars["String"]>;
  /** Reason for completed the task manually. Used for cleans completed outside the normal flow */
  reasonForManualCompletion?: Maybe<ReasonForManualCompletion>;
  /** Why is this relocation requested. Task types: GetRelocation/Request */
  reasonForRelocation?: Maybe<Scalars["String"]>;
  /** Time of move. Task types: Request */
  relocationIntendedTime?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Amenities requested. Task types: GuestRequestAmenities */
  requestedAmenities?: Maybe<GuestRequestAmenity>;
  /** Requested clean date */
  requestedCleaningDate?: Maybe<Scalars["String"]>;
  /** Requested cleaning time slot. Can be any of: ["morning", "early_afternoon", "late_afternoon"] */
  requestedCleaningTimeSlot?: Maybe<RequestedCleaningTimeSlot>;
  /** Hold security deposit amount. Task types: HoldSecurityDeposit. */
  securityDepositAmount?: Maybe<Scalars["String"]>;
  /** Hold security deposit reason. Task types: HoldSecurityDeposit. */
  securityDepositReason?: Maybe<Scalars["String"]>;
  /** Is security or city team on-site to coordinate? Task types: TrustAndSafetyEjection */
  securityOnsite?: Maybe<Scalars["Boolean"]>;
  /** Standard operation policy exception notes */
  sopExceptionNotes?: Maybe<Scalars["String"]>;
  /** Fallback relocation target if preferred unit is unavailable. Task types: Request */
  sourceOfRelocationRequest?: Maybe<RelocationSource>;
  /** Time reported for GuestInUnitAfterCheckout tasks. Task types: GuestInUnitAfterCheckout */
  timeGuestReportedInUnit?: Maybe<Scalars["RFC3339DateTime"]>;
};

export type TaskTypeConfiguration = Node & {
  /** Display name */
  displayName: Scalars["String"];
  /** Display name synonyms */
  displayNameSynonyms: Array<Scalars["String"]>;
  id: Scalars["ID"];
  /** Task type name */
  taskTypeName: Scalars["String"];
};

/** Tom Tasks search filters params */
export type TasksSearchFilterInput = {
  /** filter tom tasks for these city ids */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** window end for filtering tasks from this created at date */
  createdAtEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window start for filtering tasks from this created at date */
  createdAtStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** filter tom tasks for these statuses */
  statuses?: InputMaybe<Array<TaskStatus>>;
};

export type TomBooking = Booking &
  Node & {
    /** Owner of the booking */
    account?: Maybe<Account>;
    /** ID of the owner of the booking */
    accountId?: Maybe<Scalars["Int"]>;
    /** Actual arrival date time. */
    actualArrivalDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Actual departure date time. */
    actualDepartureDateTime?: Maybe<Scalars["RFC3339DateTime"]>;
    /** URL to the booking */
    bookingUrl?: Maybe<Scalars["String"]>;
    /** Check in time. */
    checkInTime: Scalars["RFC3339DateTime"];
    /** Check out time. */
    checkOutTime: Scalars["RFC3339DateTime"];
    /** the start date time of the cleaning window for check-out clean */
    cleaningWindowStartDateTime: Scalars["RFC3339DateTime"];
    /** confirmation code of the booking  */
    confirmationCode?: Maybe<Scalars["String"]>;
    /** The profile of the guest who owns the booking. */
    guestProfile?: Maybe<GuestProfile>;
    /** Unique inquiry identifier */
    id: Scalars["ID"];
    /** Tasks related to this booking */
    tomTasks: Array<Task>;
    /** unique key of the booking  */
    uniqueKey: Scalars["String"];
    /** unit assgined to the booking */
    unit: Unit;
  };

export type TomBookingTomTasksArgs = {
  includeIntrastayCleanTasks?: InputMaybe<Scalars["Boolean"]>;
};

/** Tom Booking search filters params */
export type TomBookingSearchFilterInput = {
  /** window end for filtering bookings by checkin date */
  checkInEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window start for filtering bookings by checkin date */
  checkInStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window end for filtering bookings by checkout date */
  checkOutEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** window start for filtering bookings by checkout date */
  checkOutStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** filter bookings for these city ids */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type TomTag = Node & {
  id: Scalars["ID"];
  /** Name or value of this tag. */
  name: Scalars["String"];
  /** Tag type or key. */
  tagType: Scalars["String"];
};

export type TomTeamMember = Node & {
  /** City info.  Use cityId if you don't need full details. */
  city: City;
  /** City id. */
  cityId: Scalars["Int"];
  id: Scalars["ID"];
  /** last latitude location recorded. */
  lastLocationLat?: Maybe<Scalars["Float"]>;
  /** last longitude location recorded. */
  lastLocationLng?: Maybe<Scalars["Float"]>;
};

/** Autogenerated return type of TrackEvent. */
export type TrackEventPayload = {
  response: TrackEventResponse;
};

export type TrackEventResponse = {
  error?: Maybe<Scalars["String"]>;
  eventName: Scalars["String"];
  eventPayload: Scalars["String"];
  success: Scalars["Boolean"];
  trackingInfo?: Maybe<Scalars["JSON"]>;
};

/** Autogenerated return type of TrackUserEvent. */
export type TrackUserEventPayload = {
  response: TrackEventResponse;
};

export type TravelSurveyQuestion = {
  /** Where to redirect to after completing the survey */
  redirectUrl?: Maybe<Scalars["String"]>;
  /** Question subtitle */
  subtitle?: Maybe<Scalars["String"]>;
  /** Question title */
  title: Scalars["String"];
  /** Question identifier or completion indicator */
  type: TravelSurveyQuestionTypeEnum;
};

export enum TravelSurveyQuestionTypeEnum {
  /** Customer satisfaction score */
  CsatScore = "csat_score",
  /** The survey is finished, no further questions */
  Finished = "finished",
}

export type TripadvisorAward = {
  /** The url of the award badge image. */
  assetSrc: Scalars["String"];
  /** The award category/type. */
  awardType: TripadvisorAwardTypeEnum;
  /** The year the award was received. */
  year: Scalars["Int"];
};

export enum TripadvisorAwardTypeEnum {
  BestOfTheBest = "best_of_the_best",
  TravelersChoice = "travelers_choice",
}

export type TrustAndSafety = {
  ejectionAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  guestAlreadyAware?: InputMaybe<GuestAlreadyAware>;
  guestReceivedPreviousWarning?: InputMaybe<GuestReceivedPreviousWarning>;
  reasonForBan?: InputMaybe<ReasonForBan>;
  reasonForEjection?: InputMaybe<ReasonForEjection>;
  securityOnsite?: InputMaybe<SecurityOnsite>;
};

export enum TypeEnum {
  GetFollowup = "GetFollowup",
  TomTasksBooking = "Tom_Tasks_Booking",
  TomTasksClean = "Tom_Tasks_Clean",
  TomTasksConnectedSpacesMaintenance = "Tom_Tasks_ConnectedSpacesMaintenance",
  TomTasksCreateLeaseCharge = "Tom_Tasks_CreateLeaseCharge",
  TomTasksCreateMasterLeaseRecord = "Tom_Tasks_CreateMasterLeaseRecord",
  TomTasksDirtyCheckInWarning = "Tom_Tasks_DirtyCheckInWarning",
  TomTasksEarlyCheckIn = "Tom_Tasks_EarlyCheckIn",
  TomTasksEciLcoFollowup = "Tom_Tasks_EciLcoFollowup",
  TomTasksGetFollowup = "Tom_Tasks_GetFollowup",
  TomTasksGetRelocation = "Tom_Tasks_GetRelocation",
  TomTasksGuestInUnitAfterCheckout = "Tom_Tasks_GuestInUnitAfterCheckout",
  TomTasksGuestIssue = "Tom_Tasks_GuestIssue",
  TomTasksGuestRequest = "Tom_Tasks_GuestRequest",
  TomTasksGuestRequestAmenities = "Tom_Tasks_GuestRequestAmenities",
  TomTasksHoldSecurityDeposit = "Tom_Tasks_HoldSecurityDeposit",
  TomTasksInPersonCheckIn = "Tom_Tasks_InPersonCheckIn",
  TomTasksInspection = "Tom_Tasks_Inspection",
  TomTasksInspectionTask = "Tom_Tasks_InspectionTask",
  TomTasksInternalHoldChecklist = "Tom_Tasks_InternalHoldChecklist",
  TomTasksInternalInquiryTask = "Tom_Tasks_InternalInquiryTask",
  TomTasksInternalSubtask = "Tom_Tasks_InternalSubtask",
  TomTasksInternalUnitTask = "Tom_Tasks_InternalUnitTask",
  TomTasksIntrastayCheck = "Tom_Tasks_IntrastayCheck",
  TomTasksIssue = "Tom_Tasks_Issue",
  TomTasksKeycafeKeyMissingNotification = "Tom_Tasks_KeycafeKeyMissingNotification",
  TomTasksLateCheckOut = "Tom_Tasks_LateCheckOut",
  TomTasksLeaseBillingSchedule = "Tom_Tasks_LeaseBillingSchedule",
  TomTasksLongTermCheckIn = "Tom_Tasks_LongTermCheckIn",
  TomTasksLongTermCheckOut = "Tom_Tasks_LongTermCheckOut",
  TomTasksLongTermNycCheckInSubTask = "Tom_Tasks_LongTermNycCheckInSubTask",
  TomTasksLongTermNycCheckOutSubTask = "Tom_Tasks_LongTermNycCheckOutSubTask",
  TomTasksLongTermPreCheckIn = "Tom_Tasks_LongTermPreCheckIn",
  TomTasksLongTermPreCheckOut = "Tom_Tasks_LongTermPreCheckOut",
  TomTasksLongTermScheduleCleaning = "Tom_Tasks_LongTermScheduleCleaning",
  TomTasksLongTermStay = "Tom_Tasks_LongTermStay",
  TomTasksLongTermSubTask = "Tom_Tasks_LongTermSubTask",
  TomTasksLuggageDropOff = "Tom_Tasks_LuggageDropOff",
  TomTasksMaintenanceInspectionTask = "Tom_Tasks_MaintenanceInspectionTask",
  TomTasksMoveInCompletionQualityAudit = "Tom_Tasks_MoveInCompletionQualityAudit",
  TomTasksOnboardingInspectionTask = "Tom_Tasks_OnboardingInspectionTask",
  TomTasksOrderGroceriesTask = "Tom_Tasks_OrderGroceriesTask",
  TomTasksOther = "Tom_Tasks_Other",
  TomTasksPickupTask = "Tom_Tasks_PickupTask",
  TomTasksQualityAudit = "Tom_Tasks_QualityAudit",
  TomTasksQuantityGuestRequest = "Tom_Tasks_QuantityGuestRequest",
  TomTasksRefundSecurityDeposit = "Tom_Tasks_RefundSecurityDeposit",
  TomTasksRequest = "Tom_Tasks_Request",
  TomTasksSpaceClean = "Tom_Tasks_SpaceClean",
  TomTasksTrustAndSafety = "Tom_Tasks_TrustAndSafety",
  TomTasksTrustAndSafetyEjection = "Tom_Tasks_TrustAndSafetyEjection",
  TomTasksTrustAndSafetyFollowup = "Tom_Tasks_TrustAndSafetyFollowup",
  TomTasksTrustAndSafetyRequestToBanGuest = "Tom_Tasks_TrustAndSafetyRequestToBanGuest",
  TomTasksVipBookingNotification = "Tom_Tasks_VipBookingNotification",
}

export type TypeStructuredMetadata = {
  booking?: InputMaybe<StructuredMetadataBooking>;
  clean?: InputMaybe<Clean>;
  connectedSpacesMaintenance?: InputMaybe<ConnectedSpacesMaintenance>;
  earlyCheckIn?: InputMaybe<EarlyCheckIn>;
  guestIssue?: InputMaybe<GuestIssue>;
  guestRequest?: InputMaybe<GuestRequest>;
  holdSecurityDeposit?: InputMaybe<HoldSecurityDeposit>;
  inspection?: InputMaybe<Inspection>;
  internalUnitTask?: InputMaybe<InternalUnitTask>;
  issue?: InputMaybe<Issue>;
  lateCheckOut?: InputMaybe<LateCheckOut>;
  request?: InputMaybe<Request>;
  trustAndSafety?: InputMaybe<TrustAndSafety>;
};

export type Unit = CommentTarget &
  Node & {
    /**
     * Access information for the unit, including building, lockbox, door access codes
     * @deprecated Use access information on the inquiry, not the unit.
     */
    access?: Maybe<UnitAccess>;
    /** ADA accessibility of unit */
    adaAccessible: Scalars["Boolean"];
    /**
     * Address of the unit.
     * @deprecated Address is not always formatted correctly, street, street number, etc instead
     */
    address: Scalars["String"];
    /** Building address with postal code */
    addressWithPostalCode: Scalars["String"];
    /** Amenity information for the unit */
    amenities: UnitAmenities;
    /** Apartment number, if applicable */
    aptNumber?: Maybe<Scalars["String"]>;
    /** if apt_number exist then apt_number otherwise internal_ref */
    aptNumberOrInternalRef: Scalars["String"];
    /** Availability End date of the unit */
    availabilityEndDt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Availability Start date of the unit */
    availabilityStartDt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** Bedrooms in the unit */
    bedrooms: Array<Bedroom>;
    /** The beds in the unit */
    beds?: Maybe<Array<UnitBed>>;
    /** Bookable At date of the unit */
    bookableAt?: Maybe<Scalars["RFC3339DateTime"]>;
    /** relevant booking info for this unit */
    bookingInfo?: Maybe<BookingInfo>;
    /** The number of bedrooms into the unit */
    brCount: Scalars["Int"];
    /** Unit's building */
    building: Building;
    /** The access type for the building */
    buildingAccessType?: Maybe<Scalars["String"]>;
    /** The building listing a unit belongs to */
    buildingListing?: Maybe<BuildingListing>;
    /** Info about if there are checkins and/or checkouts for this units today */
    checkInCheckOutInfo: CheckInCheckOutInfo;
    /** City of the unit. */
    city: City;
    /** Cleaning company associated with the unit. */
    cleaningCompany?: Maybe<CleaningCompany>;
    /** Unit's estimated cleaning fee */
    cleaningFee: Scalars["Float"];
    /** Name of the closest public transit station to the unit */
    closestMetroStation?: Maybe<Scalars["String"]>;
    /** Local currency */
    currency: Currency;
    /**
     * inquiry or leaseinquiry already in this unit if any
     * @deprecated please use bookingInfo instead
     */
    currentBooking?: Maybe<Inquiry>;
    /** Cleaning associated with the unit for the current day if there is one. */
    currentDayCleaning?: Maybe<Cleaning>;
    /** Whether the unit has a dishwasher */
    dishwasher?: Maybe<Scalars["Boolean"]>;
    /** Driving distance to downtown, in minutes */
    downtownDrivingMinutes?: Maybe<Scalars["Int"]>;
    /** Public transit distance to downtown, in minutes */
    downtownPublicTransportMinutes?: Maybe<Scalars["Int"]>;
    /** The access type for the elevator */
    elevatorAccessType?: Maybe<Scalars["String"]>;
    /** If the unit has an elevator. */
    elevatorAvailable: Scalars["Boolean"];
    /** Feature flags enabled for this unit */
    enabledFeatures?: Maybe<Array<Scalars["String"]>>;
    /** Unit's estimated cleaning duration */
    estimatedCleaningDuration?: Maybe<Scalars["Int"]>;
    /** First inquiry check in date of the unit */
    firstInquiryCheckInDate?: Maybe<Scalars["RFC3339DateTime"]>;
    /** The floor of the building with the unit. */
    floorOfTheBuilding?: Maybe<Scalars["String"]>;
    /** Link via Google Maps to the Google Place and lat / lng */
    googleMapsLink: Scalars["String"];
    /** The guest check-in instructions template */
    guestCheckInInstructions?: Maybe<Scalars["String"]>;
    /** The guest check-out instructions template */
    guestCheckOutInstructions?: Maybe<Scalars["String"]>;
    /** All guest-facing guide content items associated with this unit or its building */
    guideContent: Array<GuideContent>;
    /** Things to know about the unit */
    homeTruths: Array<HomeTruth>;
    /** Standard house rules for this unit */
    houseRules: Scalars["String"];
    /** Standard house rules disclaimer for this unit */
    houseRulesDisclaimer: Scalars["String"];
    /** Information regarding housekeeping */
    housekeepingNote: Scalars["String"];
    /** ID of the resource */
    id: Scalars["ID"];
    /** Images of the unit. */
    images: Array<UnitImage>;
    /** Whether the unit has in person check-in */
    inPersonCheckIn?: Maybe<Scalars["Boolean"]>;
    /** Internal ref of unit */
    internalRef: Scalars["String"];
    /** Unit's estimated intrastay cleaning fee */
    intrastayCleaningFee?: Maybe<CleaningPrice>;
    /** Latitude of the unit location. */
    latitude: Scalars["Float"];
    /** Life status of the unit */
    lifeStatus: LifeStatus;
    /** lifecycle validation warnings */
    lifecycleValidations?: Maybe<LifecycleValidationWarning>;
    /** The collection a unit belongs to */
    listing?: Maybe<Listing>;
    /** Unit can get rented for long term or not */
    longTermRental?: Maybe<Scalars["Boolean"]>;
    /** Longitude of the unit location. */
    longitude: Scalars["Float"];
    /** The minimum duration the unit can be rented */
    minimumStayLength?: Maybe<Scalars["Int"]>;
    /** Guest friendly name of the unit. */
    name: Scalars["String"];
    /** The number of bathrooms into the unit */
    nbrBathrooms: Scalars["Float"];
    /** Points of interest proximal to this unit */
    nearbyPointsOfInterest: Array<Poi>;
    /** Neighborhood of the unit. */
    neighborhood: Neighborhood;
    /**
     * upcoming inquiry or leaseinquiry for this unit if any
     * @deprecated please use bookingInfo instead
     */
    nextBooking?: Maybe<Inquiry>;
    /** The number of kitchens in the unit */
    numTotalKitchens: Scalars["Int"];
    /** Parking details available */
    parkingDetails: Scalars["String"];
    /** Parking options available */
    parkingTypes: ParkingTypes;
    /**
     * past inquiry or leaseinquiry for this unit if any
     * @deprecated please use bookingInfo instead
     */
    pastBooking?: Maybe<Inquiry>;
    /** Phase Lifecycle information for the unit */
    phaseLifecycle?: Maybe<PhaseLifecycle>;
    /** Postal code */
    postalCode: Scalars["String"];
    /** Type of the property (hotel, apartment, etc..) */
    propertyType?: Maybe<Scalars["String"]>;
    /** Quick marketing pitch of the unit. */
    quickPitch?: Maybe<Scalars["String"]>;
    /** related schedules for units */
    relatedSchedules: Array<Schedule>;
    /** List of tom tasks having this unit as `:subject` */
    relatedTasks: TaskConnections;
    /** the room reference. eventually this is going to replace internal-ref */
    roomRef?: Maybe<Scalars["String"]>;
    /** Internal ref of unit minus the city prefix */
    shortInternalRef: Scalars["String"];
    /** The number of persons the unit can accept to sleep */
    sleeps: Scalars["Int"];
    /** unit square footage */
    squareFootage?: Maybe<Scalars["Int"]>;
    /** State in which this address exists, if applicable */
    state?: Maybe<Scalars["String"]>;
    /** 2-character State abbreviation */
    stateCode?: Maybe<Scalars["String"]>;
    /** Static Google Map image for the unit's location */
    staticMapImage: Scalars["String"];
    /** Unit's default storage location */
    storageLocation?: Maybe<CufStorageLocation>;
    /** Name of the street */
    street: Scalars["String"];
    /** Street Number */
    streetNumber: Scalars["String"];
    /** Timezone this unit occupies */
    timezone: Scalars["String"];
    /** Name of local suburb, town, or city for address. */
    town?: Maybe<Scalars["String"]>;
    /** The access type for the unit */
    unitAccessType?: Maybe<Scalars["String"]>;
    /** Consumables for the unit */
    unitConsumables?: Maybe<Array<UnitConsumable>>;
    /** Unit group attributes for the unit */
    unitGroupAttribute?: Maybe<UnitGroupAttribute>;
    /** Lifecycle information for the unit */
    unitLifecycle?: Maybe<UnitLifecycle>;
    /** Whether the unit has a washing machine */
    washer?: Maybe<Scalars["Boolean"]>;
    /** If the unit wheelchair fully accessible. */
    wheelchairAccessible: Scalars["Boolean"];
    /** If the unit wheelchair partially accessible. */
    wheelchairPartiallyAccessible: Scalars["Boolean"];
    /** WiFi password for the unit. */
    wifiPassword?: Maybe<Scalars["String"]>;
    /** WiFi SSID for the unit. */
    wifiSsid?: Maybe<Scalars["String"]>;
  };

export type UnitImagesArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type UnitNearbyPointsOfInterestArgs = {
  filter: PoiFilterInput;
};

export type UnitRelatedSchedulesArgs = {
  filter?: InputMaybe<RelatedScheduleFilterInput>;
};

export type UnitRelatedTasksArgs = {
  filter?: InputMaybe<UnitRelatedTaskFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export type UnitStaticMapImageArgs = {
  height: Scalars["Int"];
  scale: Scalars["Int"];
  width: Scalars["Int"];
  zoom: Scalars["Int"];
};

export type UnitAccess = {
  /** This gets the building code associated with the unit, not the inquiry */
  buildingAccessCode?: Maybe<Scalars["String"]>;
  /** Building access type for the unit. */
  buildingAccessType?: Maybe<Scalars["String"]>;
  /** Elevator code for the unit. */
  elevatorAccessCode?: Maybe<Scalars["String"]>;
  /** Elevator access type for the unit. */
  elevatorAccessType?: Maybe<Scalars["String"]>;
  /** Indicates whether or not secured building access is required for the unit. */
  isBuildingAccessRequired: Scalars["Boolean"];
  /** Indicates whether or not secured elevator access is required for the unit. */
  isElevatorAccessRequired: Scalars["Boolean"];
  /** Indicates whether or not the unit will require an in person checkin. */
  isInPersonCheckin: Scalars["Boolean"];
  /** Indicates whether or not keys for the unit are in a lockbox */
  isLockboxRequired: Scalars["Boolean"];
  /** Lockbox code for the unit. */
  lockboxCode?: Maybe<Scalars["String"]>;
  /** Where is the lockbox */
  lockboxLocation?: Maybe<Scalars["String"]>;
  /**
   * Unit's auto door code or the currently programmed connected home auto door code.
   * @deprecated This gets a code associated with the unit, not the inquiry
   */
  unitAccessCode?: Maybe<Scalars["String"]>;
  /** Access information for the unit. Can return empty string */
  unitAccessType: Scalars["String"];
};

export type UnitAmenities = {
  /** Indicates whether or not the unit has air conditioning. */
  airConditioning: Scalars["Boolean"];
  /** Indicates whether or not the unit has a balcony. */
  balcony: Scalars["Boolean"];
  /** Indicates whether or not the unit has a coffee maker. */
  coffeeMaker: Scalars["Boolean"];
  /** Indicates whether or not the unit has a dishwasher. */
  dishwasher: Scalars["Boolean"];
  /** Indicates whether or not the unit has access to a fitness room. */
  fitnessRoomOrEquipment: Scalars["Boolean"];
  /** Indicates whether or not the unit has a fridge. */
  fridge: Scalars["Boolean"];
  /** Indicates whether or not the unit is in a building with a front desk. */
  frontDesk: Scalars["Boolean"];
  /** Indicates whether or not the unit has an hdmi cable. */
  hdmiCable: Scalars["Boolean"];
  /** Indicates whether or not the unit has access to a hot tub. */
  hotTub: Scalars["Boolean"];
  /** Indicates whether or not the unit has a kitchen. */
  kitchen: Scalars["Boolean"];
  /** Indicates whether or not the unit has kitchen utensils. */
  kitchenUtensils: Scalars["Boolean"];
  /** Indicates whether or not the unit has access to laundry in building. */
  laundryInBuilding: Scalars["Boolean"];
  /** Indicates whether or not the unit has laundry in unit. */
  laundryInUnit: Scalars["Boolean"];
  /** Indicates whether or not the unit has a microwave. */
  microwave: Scalars["Boolean"];
  /** Indicates whether or not the unit has a oven. */
  oven: Scalars["Boolean"];
  /** Indicates whether or not the unit has a patio. */
  patio: Scalars["Boolean"];
  /** Indicates whether or not the unit is pet friendly. */
  pets: Scalars["Boolean"];
  /** Indicates whether or not the unit has access to a ping poing table. */
  pingPongTable: Scalars["Boolean"];
  /** Indicates whether or not the unit has a pool. */
  pool: Scalars["Boolean"];
  /** Indicates whether or not the unit has access to a pool table. */
  poolTable: Scalars["Boolean"];
  /** Indicates whether or not the unit has rooftop access. */
  rooftop: Scalars["Boolean"];
  /** Indicates whether or not the unit has satellite or cable tv. */
  satelliteOrTvCable: Scalars["Boolean"];
  /** Indicates whether or not the unit has access to a sauna. */
  sauna: Scalars["Boolean"];
  /** Indicates whether or not the unit has access to a steam room. */
  steamRoom: Scalars["Boolean"];
  /** Indicates whether or not the unit has a stove. */
  stove: Scalars["Boolean"];
  /** Indicates whether or not the unit has a television. */
  television: Scalars["Boolean"];
  /** Indicates whether or not the unit has a terrace. */
  terrace: Scalars["Boolean"];
  /** Indicates whether or not the unit has wifi. */
  wifi: Scalars["Boolean"];
};

export type UnitAvailability = {
  /** Start and end date of the unit availability based on the provided dates */
  availabilityDates: Array<Scalars["String"]>;
  /** The distance in miles from the original inquiry's unit */
  distanceMiles: Scalars["Float"];
  /** Any notifications related to the unit availability. */
  notifications: Array<Notification>;
  /** The collection level the unit is sharing with the original inquiry's unit */
  sharedCollections: Array<Scalars["String"]>;
  /** The unit details */
  unit: Unit;
};

export type UnitAvailabilityTime = {
  /** When the unit will be available today (clean). Now or at 4 PM */
  availableAt: Scalars["String"];
  /** The unit id. */
  unitId: Scalars["ID"];
};

export type UnitBatchJob = Node & {
  /** Action that this batch job is performing (ex. 'UpdateTasks'). */
  action?: Maybe<BatchActions>;
  /** When the batch job was created. */
  createdAt: Scalars["RFC3339DateTime"];
  /** User that created the batch job. */
  createdBy?: Maybe<User>;
  /** ID of the user that created the batch job. */
  createdById?: Maybe<Scalars["ID"]>;
  /** Failed jobs in the batch. */
  errors: Array<UnitBatchJobError>;
  id: Scalars["ID"];
  /** Number of remaining jobs in the batch. */
  remaining: Scalars["Int"];
  /** Status of the batch job. Can be 'pending' and 'completed'. */
  status: BatchJobStatus;
  /** Number of individual jobs associated with this batch. */
  total: Scalars["Int"];
  /** When the batch job was updated. */
  updatedAt: Scalars["RFC3339DateTime"];
};

export type UnitBatchJobError = {
  /** Batch job error message */
  message: Scalars["String"];
  /** Batch job unit ID */
  unitId: Scalars["ID"];
};

export type UnitBed = {
  /** size of the bed */
  bedSize: BedSize;
  /** type of bed */
  bedType: Bed;
  /** unique identifier of the bed */
  id: Scalars["ID"];
};

/** A single unit's changes */
export type UnitChangeInput = {
  UnitFinops__record_status?: InputMaybe<Scalars["String"]>;
  UnitGroupAttribute__phase_lifecycle_id?: InputMaybe<Scalars["Int"]>;
  UnitGroupAttribute__unit_type?: InputMaybe<Scalars["String"]>;
  UnitLifecycle__bookable_earliest_date?: InputMaybe<
    Scalars["RFC3339DateTime"]
  >;
  UnitLifecycle__bookable_latest_date?: InputMaybe<Scalars["RFC3339DateTime"]>;
  UnitLifecycle__bookable_latest_date_final?: InputMaybe<Scalars["Boolean"]>;
  /** reason for changing bookable latest date */
  UnitLifecycle__bookable_latest_reason?: InputMaybe<Scalars["String"]>;
  UnitLifecycle__ffe_need_by_date?: InputMaybe<Scalars["RFC3339DateTime"]>;
  UnitLifecycle__handover_date?: InputMaybe<Scalars["RFC3339DateTime"]>;
  UnitLifecycle__handover_date_final?: InputMaybe<Scalars["Boolean"]>;
  UnitLifecycle__id_brief_submission_date?: InputMaybe<
    Scalars["RFC3339DateTime"]
  >;
  UnitLifecycle__id_brief_submission_date_final?: InputMaybe<
    Scalars["Boolean"]
  >;
  UnitLifecycle__lease_commencement_date?: InputMaybe<
    Scalars["RFC3339DateTime"]
  >;
  UnitLifecycle__lease_commencement_date_final?: InputMaybe<Scalars["Boolean"]>;
  UnitLifecycle__listing_date?: InputMaybe<Scalars["RFC3339DateTime"]>;
  UnitLifecycle__punch_date?: InputMaybe<Scalars["RFC3339DateTime"]>;
  UnitLifecycle__punch_date_final?: InputMaybe<Scalars["Boolean"]>;
  UnitLifecycle__welcome_letter_sent_date?: InputMaybe<
    Scalars["RFC3339DateTime"]
  >;
  Unit__apt_number?: InputMaybe<Scalars["String"]>;
  Unit__availability_start_dt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  Unit__bookable_at?: InputMaybe<Scalars["String"]>;
  Unit__br_count?: InputMaybe<Scalars["Int"]>;
  Unit__final_guest_ready_dt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  Unit__floor_of_the_building?: InputMaybe<Scalars["Int"]>;
  Unit__furniture_type?: InputMaybe<Scalars["String"]>;
  /** Unit id for these changes */
  Unit__id: Scalars["Int"];
  Unit__initial_partner_name?: InputMaybe<Scalars["String"]>;
  Unit__life_status?: InputMaybe<Scalars["String"]>;
  Unit__nbr_bathrooms?: InputMaybe<Scalars["String"]>;
  Unit__nbr_kitchens?: InputMaybe<Scalars["String"]>;
  Unit__photo_status?: InputMaybe<Scalars["String"]>;
  Unit__property_type?: InputMaybe<Scalars["String"]>;
};

export enum UnitCleaningPricingCurrency {
  Cad = "cad",
  Dhs = "dhs",
  Eur = "eur",
  Gbp = "gbp",
  Usd = "usd",
}

export type UnitConnections = {
  /** cursor. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records. */
  hasMore?: Maybe<Scalars["Boolean"]>;
  /** How many total. */
  total?: Maybe<Scalars["Int"]>;
  /** The list of units */
  units: Array<Unit>;
};

/** Consumable for a unit */
export type UnitConsumable = {
  /** Default value for the consumable */
  defaultValue?: Maybe<Scalars["Int"]>;
  /** Group of the consumable */
  group?: Maybe<Scalars["String"]>;
  /** Localized group of the consumable */
  groupLocalized?: Maybe<Scalars["String"]>;
  /** The key for the consumable metadata */
  metadataKey: Scalars["String"];
  /** Name of the consumable */
  name: Scalars["String"];
  /** Localized name of the consumable */
  nameLocalized: Scalars["String"];
  /** Note of the consumable */
  note?: Maybe<Scalars["String"]>;
  /** Localized note of the consumable */
  noteLocalized?: Maybe<Scalars["String"]>;
  /** Suggested maximum quantity for the consumable */
  suggestedMaxQuantity?: Maybe<Scalars["Int"]>;
};

/** Unit filters params */
export type UnitFilterInput = {
  /** Building IDs */
  buildingIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Unit's city IDs */
  cityId: Scalars["ID"];
  /** Unit IDs */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Unit internalRefs */
  internalRefs?: InputMaybe<Array<Scalars["String"]>>;
  /** Lease Deal ID */
  leaseDealId?: InputMaybe<Scalars["ID"]>;
  /** Array of life status */
  lifeStatuses?: InputMaybe<Array<LifeStatus>>;
  /** Unit Group Phase */
  phase?: InputMaybe<Scalars["String"]>;
  /** Unit Group Unit type */
  unitType?: InputMaybe<Scalars["String"]>;
};

/** Unit group properties for a unit. */
export type UnitGroupAttribute = Node & {
  id: Scalars["ID"];
  /** Phase. */
  phaseLifecycle?: Maybe<PhaseLifecycle>;
  /** Unit type. */
  unitType?: Maybe<Scalars["String"]>;
};

export type UnitImage = Node & {
  id: Scalars["ID"];
  /** URL of the image */
  url: Scalars["String"];
};

export type UnitImageUrlArgs = {
  aspectRatio?: InputMaybe<Scalars["String"]>;
  dpr?: InputMaybe<Scalars["Int"]>;
  width?: InputMaybe<Scalars["Int"]>;
};

/** Lifecycle dates and properties for a unit */
export type UnitLifecycle = Node & {
  /** Bookable earliest date */
  bookableEarliestDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Bookable latest date */
  bookableLatestDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Is the bookable latest date final? */
  bookableLatestDateFinal?: Maybe<Scalars["Boolean"]>;
  /** FF&E need by date */
  ffeNeedByDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Handover date */
  handoverDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Is the handover date final? */
  handoverDateFinal?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
  /** ID brief submission date */
  idBriefSubmissionDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Is the ID brief submission date final? */
  idBriefSubmissionDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Lease commencement date */
  leaseCommencementDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Is the lease commencement date final? */
  leaseCommencementDateFinal?: Maybe<Scalars["Boolean"]>;
  /** LCD Original */
  leaseCommencementDateOriginal?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Listing date */
  listingDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Punch date */
  punchDate?: Maybe<Scalars["RFC3339DateTime"]>;
  /** Is the punch date final? */
  punchDateFinal?: Maybe<Scalars["Boolean"]>;
  /** Welcome letter sent date */
  welcomeLetterSentDate?: Maybe<Scalars["RFC3339DateTime"]>;
};

export type UnitLosPolicy = {
  maximumLengthOfStay?: Maybe<Scalars["Int"]>;
  minimumLengthOfStay?: Maybe<Scalars["Int"]>;
  unitId: Scalars["Int"];
};

/** filters */
export type UnitRelatedTaskFilterInput = {
  /** can pass in '-1' for tasks without assignees set */
  assignee?: InputMaybe<Array<Scalars["String"]>>;
  /** if tasks are associated to a cleaning request then filter them by category */
  cleaningRequestCategory?: InputMaybe<Array<CleaningRequestCategory>>;
  /** ignored if filter_triaged == new */
  dueAtEnd?: InputMaybe<Scalars["RFC3339DateTime"]>;
  /** ignored if filter_triaged == new */
  dueAtStart?: InputMaybe<Scalars["RFC3339DateTime"]>;
  dueOrLatestEndAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  scheduledOrEarliestStartAt?: InputMaybe<Scalars["RFC3339DateTime"]>;
  status?: InputMaybe<Array<FilterStatus>>;
  /** by task type */
  taskType?: InputMaybe<Array<TypeEnum>>;
};

/** Unit search filters params */
export type UnitSearchFilterInput = {
  /** Building IDs */
  buildingIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Unit city IDs */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Unit live status */
  live?: InputMaybe<Scalars["Boolean"]>;
};

export enum UnitSortColumn {
  InternalRef = "internal_ref",
}

/** Sort by column */
export type UnitSortInput = {
  order: SortAscDesc;
};

export type UnitTypeCounts = {
  /** Number of units with five bedroom in the aggregate (Building/City, etc */
  fiveBr?: Maybe<Scalars["Int"]>;
  /** Number of units with four bedroom in the aggregate (Building/City, etc */
  fourBr?: Maybe<Scalars["Int"]>;
  /** Number of units in hotel type properties in the aggregate (Building/City, etc */
  hotel?: Maybe<Scalars["Int"]>;
  /** Number of units with one bedroom in the aggregate (Building/City, etc */
  oneBr?: Maybe<Scalars["Int"]>;
  /** Number of units with six or more bedrooms in the aggregate (Building/City, etc */
  sixBr?: Maybe<Scalars["Int"]>;
  /** Number of studios in the aggregate (Building/City, etc */
  studio?: Maybe<Scalars["Int"]>;
  /** Number of units with three bedroom in the aggregate (Building/City, etc */
  threeBr?: Maybe<Scalars["Int"]>;
  /** Number of units with two bedroom in the aggregate (Building/City, etc */
  twoBr?: Maybe<Scalars["Int"]>;
};

/** Autogenerated return type of UpdateAccountEmail. */
export type UpdateAccountEmailPayload = {
  success: Scalars["String"];
};

/** Attributes for updating an account */
export type UpdateAccountInput = {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  phoneNumber: PhoneNumberInput;
};

/** Autogenerated return type of UpdateAccountPassword. */
export type UpdateAccountPasswordPayload = {
  success: Scalars["Boolean"];
};

/** Autogenerated return type of UpdateAccount. */
export type UpdateAccountPayload = {
  account: Account;
};

/** Autogenerated return type of UpdateAccountPhone. */
export type UpdateAccountPhonePayload = {
  success: Scalars["String"];
};

/** Autogenerated return type of UpdateAccountSettings. */
export type UpdateAccountSettingsPayload = {
  account: Account;
};

/** Autogenerated return type of UpdateBuildingSupervisors. */
export type UpdateBuildingSupervisorsPayload = {
  building: Building;
};

/** Autogenerated return type of UpdateCheckInOutTimes. */
export type UpdateCheckInOutTimesPayload = {
  inquiry?: Maybe<Inquiry>;
};

/** Autogenerated return type of UpdateCleaningRequestCostAdjustment. */
export type UpdateCleaningRequestCostAdjustmentPayload = {
  cleaningRequestCostAdjustment: HkCleaningRequestCostAdjustment;
};

/** Autogenerated return type of UpdateComment. */
export type UpdateCommentPayload = {
  comment: Comment;
};

/** Autogenerated return type of UpdateCompany. */
export type UpdateCompanyPayload = {
  company: CleaningCompany;
};

/** Autogenerated return type of UpdateEciLcoRequest. */
export type UpdateEciLcoRequestPayload = {
  inquiry: Inquiry;
};

/** Update GeneralUnitCleaningPricing input */
export type UpdateGeneralUnitCleaningPricingInput = {
  bathCount: Scalars["Int"];
  bedCount: Scalars["Int"];
  cleanType: CleaningRequestCategory;
  currency: UnitCleaningPricingCurrency;
  id: Scalars["ID"];
  price: Scalars["Float"];
};

/** Autogenerated return type of UpdateGroupPayerPaymentDetails. */
export type UpdateGroupPayerPaymentDetailsPayload = {
  /** It will always return true, if not, it will raise an error. */
  success: Scalars["Boolean"];
};

/** Update IndividualUnitCleaningPricing input */
export type UpdateIndividualUnitCleaningPricingInput = {
  cleanType: CleaningRequestCategory;
  currency: UnitCleaningPricingCurrency;
  id: Scalars["ID"];
  price: Scalars["Float"];
};

/** Autogenerated return type of UpdateItem. */
export type UpdateItemPayload = {
  checklistItem: TaskChecklistItem;
};

/** Autogenerated return type of UpdateLeaseDeal. */
export type UpdateLeaseDealPayload = {
  leaseDeal?: Maybe<LeaseDeal>;
};

/** Autogenerated return type of UpdateLicensePlate. */
export type UpdateLicensePlatePayload = {
  success: Scalars["Boolean"];
};

/** Autogenerated return type of UpdateMiscService. */
export type UpdateMiscServicePayload = {
  hkMiscService: MiscService;
};

/** Autogenerated return type of UpdateNotification. */
export type UpdateNotificationPayload = {
  notification: UserNotification;
};

/** Autogenerated return type of UpdateNotificationsAsRead. */
export type UpdateNotificationsAsReadPayload = {
  success?: Maybe<Scalars["Boolean"]>;
};

/** Autogenerated return type of UpdateNotifications. */
export type UpdateNotificationsPayload = {
  success: Scalars["Boolean"];
};

/** Autogenerated return type of UpdateOtaGuestDetails. */
export type UpdateOtaGuestDetailsPayload = {
  errors: Array<BaseError>;
  response: BaseResponse;
  success: Scalars["Boolean"];
};

/** Autogenerated return type of UpdatePaymentMethod. */
export type UpdatePaymentMethodPayload = {
  paymentMethod: PaymentMethod;
};

/** Autogenerated return type of UpdatePet. */
export type UpdatePetPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of UpdatePhoneNumber. */
export type UpdatePhoneNumberPayload = {
  response: BaseResponse;
};

/** Autogenerated return type of UpdateQaEmailConfiguration. */
export type UpdateQaEmailConfigurationPayload = {
  qaEmailConfigurations: Array<QaEmailConfiguration>;
};

/** Autogenerated return type of UpdateScheduledPaymentAmount. */
export type UpdateScheduledPaymentAmountPayload = {
  response: ScheduledPaymentUpdateStatus;
};

/** Autogenerated return type of UpdateTask. */
export type UpdateTaskPayload = {
  task: Task;
};

/** Autogenerated return type of UpdateTasks. */
export type UpdateTasksPayload = {
  batchJob: BatchJob;
};

/** Autogenerated return type of UpdateTravelSurvey. */
export type UpdateTravelSurveyPayload = {
  travelSurveyQuestion: TravelSurveyQuestion;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  user: User;
};

export enum Upgrade {
  Breakfast = "breakfast",
  Parking = "parking",
  Pet = "pet",
}

export type UpgradeCurrent = {
  amountPaid: Scalars["String"];
  bathroomCount: Scalars["Int"];
  bedroomCount: Scalars["Int"];
  buildingName: Scalars["String"];
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  collectionId: Scalars["ID"];
  collectionName: Scalars["String"];
  features: Array<Amenity>;
  listingId?: Maybe<Scalars["ID"]>;
  neighborhood: Scalars["String"];
  photos: Array<Photo>;
  sleepCount: Scalars["Int"];
  squareFootage: Scalars["Int"];
  stayLength: Scalars["Int"];
};

export type UpgradeDetails = {
  /** The copy string describing this upgrade. */
  description?: Maybe<Scalars["String"]>;
  /** The copy string for the timeslot this upgrade is available. */
  timeAvailable?: Maybe<Scalars["String"]>;
};

export type UpgradeOption = {
  bathroomCount: Scalars["Int"];
  bedroomCount: Scalars["Int"];
  buildingName: Scalars["String"];
  collectionId: Scalars["ID"];
  collectionName: Scalars["String"];
  discount: Scalars["String"];
  features: Array<Amenity>;
  neighborhood: Scalars["String"];
  photos: Array<Photo>;
  pricePerNight: Scalars["String"];
  priceTotal: Scalars["String"];
  rawPricePerNight: Scalars["Float"];
  sleepCount: Scalars["Int"];
  squareFootage: Scalars["Int"];
  upgradeDescription: Scalars["String"];
  upgradePath: Scalars["String"];
};

export type UpgradeRestriction = {
  /** The maximum amount of items allowed for an inquiry. */
  maxBookable?: Maybe<Scalars["Int"]>;
  /** The lower bound of items allowed for an inquiry. */
  minBookable?: Maybe<Scalars["Int"]>;
};

export type UpgradeService = {
  /** Has this upgrade been booked */
  booked?: Maybe<Scalars["Boolean"]>;
  /** The localized, formatted price for displaying to the user. */
  displayPrice: Scalars["String"];
  /** The raw price of the upgrade, in USD. Useful for analytics. */
  price: Scalars["Int"];
  /** Upgrade schedule, e.g., /night or guest/night. */
  scheduleType: Scalars["String"];
  /** The sub_type of an upgrade type, e.g. hot / continental bkfst */
  subType?: Maybe<Scalars["String"]>;
  /** The type of upgrade. */
  type: Upgrade;
  /** The various details for this upgrade that are non-essential for booking. */
  upgradeDetails: UpgradeDetails;
  /** The restrictions for this upgrade. */
  upgradeRestrictions?: Maybe<UpgradeRestriction>;
};

export type Upgrades = {
  availableUpgrades: Array<UpgradeOption>;
  currentBooking: UpgradeCurrent;
  inquiryId: Scalars["ID"];
  /** One of (available | invalid_account | expired | in_progress | upgraded) */
  state: Scalars["String"];
};

/** Autogenerated return type of UploadFiles. */
export type UploadFilesPayload = {
  errors?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
  uploadedFiles?: Maybe<Array<Image>>;
};

export type UpsertCustomAccessCodePayload = {
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

/** Autogenerated return type of UpsertGroupDeposits. */
export type UpsertGroupDepositsPayload = {
  /** The new, backend-consolidated deposits */
  preBookingPaymentSchedule: Array<PreBookingPaymentSchedule>;
};

/** Autogenerated return type of UpsertGroup. */
export type UpsertGroupPayload = {
  /** The group trip */
  groupTrip: GroupTrip;
};

/** Autogenerated return type of UpsertSalesAccount. */
export type UpsertSalesAccountPayload = {
  /** The sales account */
  salesAccount: SalesAccount;
};

export type User = Node & {
  /**
   * User's avatar
   * @deprecated deprecated in favour of profile_picture
   */
  avatar?: Maybe<Image>;
  /** Batch jobs this user created. */
  batchJobs: Array<BatchJob>;
  /** The Cleaning Companies this user belongs to */
  cleaningCompanies?: Maybe<Array<CleaningCompany>>;
  /**
   * [DEPRECATED] The Cleaning Company that the user Manages
   * @deprecated Deprecated in favor of cleaning_companies
   */
  cleaningCompany?: Maybe<CleaningCompany>;
  /** Dispatch Dashboard Roles */
  dispatchRoles?: Maybe<Array<DispatchRole>>;
  /** Email of the user. */
  email: Scalars["String"];
  /** List of enabled Flatbook flipper flags for the user */
  featureFlags: Array<Scalars["String"]>;
  /** First name of the user. */
  firstName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Indicates whether or not the user is a GET user */
  isGetUser?: Maybe<Scalars["Boolean"]>;
  /** Last name of the user. */
  lastName?: Maybe<Scalars["String"]>;
  /** Name of the user. */
  name?: Maybe<Scalars["String"]>;
  /** Phone number of the user. */
  phone?: Maybe<Scalars["String"]>;
  /** User's profile picture */
  profilePicture?: Maybe<Attachment>;
  /** User roles */
  roles?: Maybe<Array<Scalars["String"]>>;
  /** List of tags on this task */
  tags: Array<TomTag>;
  /** TOM Team Member */
  tomTeamMember?: Maybe<TomTeamMember>;
};

export type UserConnections = {
  /** cursor. */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records. */
  hasMore?: Maybe<Scalars["Boolean"]>;
  /** How many total. */
  total?: Maybe<Scalars["Int"]>;
  /** The list of users */
  users: Array<User>;
};

/** User filters params */
export type UserFilterInput = {
  /** [DEPRECATED] User's Tom City affiliation */
  cityId?: InputMaybe<Scalars["ID"]>;
  /** User's Tom City affiliation */
  cityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Company IDs */
  companyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** User IDs */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** User roles */
  roles?: InputMaybe<Array<DispatchRoleName>>;
  /** Users tagged with Squad tags */
  squads?: InputMaybe<Array<SquadTag>>;
};

export type UserNotification = Node & {
  /** When the change was made */
  activityTime: Scalars["RFC3339DateTime"];
  /** Whether the notification is archived or not */
  archived: Scalars["Boolean"];
  /** User notification ID */
  id: Scalars["ID"];
  /** Reasons why this notification was generated */
  reasons?: Maybe<Array<NotificationReason>>;
  /** Resource that the notification is referring to */
  resource?: Maybe<UserNotificationResource>;
};

export type UserNotificationConnections = {
  /** cursor */
  cursor?: Maybe<Scalars["String"]>;
  /** Are there more records. */
  hasMore?: Maybe<Scalars["Boolean"]>;
  /** The list of notifications */
  notifications?: Maybe<Array<UserNotification>>;
  /** How many items total. */
  total: Scalars["Int"];
};

/** User notification item interface */
export type UserNotificationResource = {
  /** ID of the resource */
  id: Scalars["ID"];
  /** User that triggered this notification */
  user?: Maybe<User>;
};

export type UserNotificationTotal = {
  /** total number of notifications */
  total: Scalars["Int"];
};

export enum UserRole {
  CleaningAdmin = "cleaning_admin",
  HkContractor = "hk_contractor",
  Housekeeper = "housekeeper",
  TomManager = "tom_manager",
  TomTeamLead = "tom_team_lead",
}

export enum UserRoleName {
  AccountScrubber = "account_scrubber",
  Admin = "admin",
  ApolloMigrationDatesManagement = "apollo_migration_dates_management",
  BonvoyManager = "bonvoy_manager",
  BuildingOpeningsProjectManager = "building_openings_project_manager",
  CleaningAdmin = "cleaning_admin",
  ContentManager = "content_manager",
  Corrigo = "corrigo",
  CufManager = "cuf_manager",
  DataScience = "data_science",
  DevelopmentManager = "development_manager",
  Disable = "disable",
  Disabled = "disabled",
  Distribution = "distribution",
  EciLcoManager = "eci_lco_manager",
  Finance = "finance",
  FlexLeaseLocationManager = "flex_lease_location_manager",
  FlexLeaseManager = "flex_lease_manager",
  FlexLeaseTenantManager = "flex_lease_tenant_manager",
  GeneralManager = "general_manager",
  GetOvernightShiftLead = "get_overnight_shift_lead",
  GuestExperienceLead = "guest_experience_lead",
  GuestExperienceSpecialist = "guest_experience_specialist",
  HkContractor = "hk_contractor",
  HkCostReviewer = "hk_cost_reviewer",
  HospitalityAgent = "hospitality_agent",
  Housekeeper = "housekeeper",
  HrAdmin = "hr_admin",
  InPersonAccountManager = "in_person_account_manager",
  InquiryAlterer = "inquiry_alterer",
  InquiryCanceler = "inquiry_canceler",
  InquiryCanceller = "inquiry_canceller",
  InquiryEditor = "inquiry_editor",
  InquiryRelocator = "inquiry_relocator",
  InteriorDesignManager = "interior_design_manager",
  InternalHoldManager = "internal_hold_manager",
  LcoEciManager = "lco_eci_manager",
  LeaseAccountingIntegrationManager = "lease_accounting_integration_manager",
  LetManager = "let_manager",
  LotManager = "lot_manager",
  MassCommunication = "mass_communication",
  MassCommunications = "mass_communications",
  MoneyBillingManager = "money_billing_manager",
  MoneyCreditManager = "money_credit_manager",
  MoneyPaymentGatewayManager = "money_payment_gateway_manager",
  MoneyPaymentManager = "money_payment_manager",
  MoneyTerminalPaymentManager = "money_terminal_payment_manager",
  PhotoReviewer = "photo_reviewer",
  PricingCufFieldsEditor = "pricing_cuf_fields_editor",
  PromoCodeApprover = "promo_code_approver",
  RefundApprover = "refund_approver",
  RegionalManager = "regional_manager",
  RevenueManager = "revenue_manager",
  RmpBcCityManager = "rmp_bc_city_manager",
  RmpConsultant = "rmp_consultant",
  RmpRo = "rmp_ro",
  Sales = "sales",
  Staff = "staff",
  SystemAdmin = "system_admin",
  TaxManager = "tax_manager",
  TomConfigurationAdmin = "tom_configuration_admin",
  TomManager = "tom_manager",
  TomTeamLead = "tom_team_lead",
  TrustAndSafetyAccountReviewer = "trust_and_safety_account_reviewer",
  TrustAndSafetySpecialist = "trust_and_safety_specialist",
  TrustAndSafetySpeciliast = "trust_and_safety_speciliast",
  VipDesignator = "vip_designator",
  YieldManager = "yield_manager",
}

/** User filters params */
export type UserRolesFilterInput = {
  /** All User roles */
  roles?: InputMaybe<Array<UserRoleName>>;
};

/** User filters params */
export type UserSearchFilterInput = {
  /** Filter users that contains any of these roles */
  rolesAny?: InputMaybe<Array<UserRole>>;
};

export enum UserSortColumn {
  Email = "email",
  FirstName = "first_name",
  LastName = "last_name",
}

/** Sort by column */
export type UserSortInput = {
  column: UserSortColumn;
  order: SortAscDesc;
};

/** Autogenerated return type of VerifyConfirmationCodeForInquiryToken. */
export type VerifyConfirmationCodeForInquiryTokenPayload = {
  inquiryToken: Scalars["String"];
};

/** Autogenerated return type of VerifyPhoneV2. */
export type VerifyPhoneV2Payload = {
  result: PhoneVerificationResult;
};

export type WelcomeFeedItem = Node & {
  id: Scalars["ID"];
  /** Subtitle to display on the feed item */
  subtitle: Scalars["String"];
  /** Title to display on the feed item */
  title: Scalars["String"];
};

export type WifiInfoFeedItem = Node & {
  /** Call to action to display on the feed item */
  callToAction: Scalars["String"];
  id: Scalars["ID"];
  /** Inquiry associated with this feed item */
  inquiry: Inquiry;
  /** Title to display on the feed item */
  title: Scalars["String"];
  /** WiFi password for the unit. */
  wifiPassword?: Maybe<Scalars["String"]>;
  /** WiFi SSID for the unit. */
  wifiSsid?: Maybe<Scalars["String"]>;
};

export type SendResetPasswordInstructionsEmailMutationVariables = Exact<{
  email: Scalars["String"];
}>;

export type SendResetPasswordInstructionsEmailMutation = {
  sendResetPasswordInstructionsEmail?: { success?: boolean | null } | null;
};

export type RequestPhoneVerificationCodeMutationVariables = Exact<{
  countryCode: Scalars["String"];
  phoneNumber: Scalars["String"];
}>;

export type RequestPhoneVerificationCodeMutation = {
  requestPhoneVerificationCode?: {
    response: {
      success: boolean;
      error?: string | null;
      trackingInfo?: { [key: string]: any } | null;
    };
  } | null;
};

export type ConfirmPhoneVerificationCodeMutationVariables = Exact<{
  countryCode: Scalars["String"];
  phoneNumber: Scalars["String"];
  verificationCode: Scalars["String"];
}>;

export type ConfirmPhoneVerificationCodeMutation = {
  confirmPhoneVerificationCode?: {
    response: {
      success: boolean;
      error?: string | null;
      trackingInfo?: { [key: string]: any } | null;
    };
  } | null;
};

export type UpdateAccountMutationVariables = Exact<{
  accountSettingsInput: AccountSettingsInput;
}>;

export type UpdateAccountMutation = {
  updateAccountSettings?: {
    account: { id: string; marketingOptIn?: boolean | null };
  } | null;
};

export type EmailHasBeenTakenQueryVariables = Exact<{
  email: Scalars["String"];
}>;

export type EmailHasBeenTakenQuery = { emailHasBeenTaken: { used: boolean } };

export type AccountBookingsQueryVariables = Exact<{ [key: string]: never }>;

export type AccountBookingsQuery = {
  account: {
    id: string;
    bookings: Array<{
      id: string;
      uniqKey: string;
      name?: string | null;
      checkInTime: string;
      checkOutTime: string;
      accessHoursAvailableBeforeCheckIn?: number | null;
      inquiryState: InquiryState;
      accessInstructions?: string | null;
      rentalSiteName: string;
      invoice?: { invoicePdfUrl: string } | null;
      access?: {
        isInPersonCheckin: boolean;
        isLockboxRequired: boolean;
        lockboxCode?: string | null;
        isBuildingAccessRequired: boolean;
        buildingAccessType?: string | null;
        buildingAccessCode?: string | null;
        isElevatorAccessRequired: boolean;
        elevatorAccessType?: string | null;
        elevatorAccessCode?: string | null;
        unitAccessType: string;
        unitAccessCode?: string | null;
        keycafeCode?: string | null;
      } | null;
      unit: {
        aptNumber?: string | null;
        latitude: number;
        longitude: number;
        sleeps: number;
        closestMetroStation?: string | null;
        parkingDetails: string;
        wifiSsid?: string | null;
        wifiPassword?: string | null;
        city: {
          name: string;
          servicePartners: Array<{
            categoryKey: string;
            descriptionLong: string;
            displayName: string;
            url: string;
          }>;
        };
        building: { fullAddress: string };
        parkingTypes: {
          freeParkingLotDetails?: string | null;
          freeStreetParkingDetails?: string | null;
          paidParkingLotDetails?: string | null;
          paidStreetParkingDetails?: string | null;
          privateParkingDetails?: string | null;
        };
        storageLocation?: { guestFacingTextArray: Array<string> } | null;
      };
    }>;
  };
};

export type CountryCodesQueryVariables = Exact<{
  requiredStatesFor?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type CountryCodesQuery = {
  countryCodes: Array<{
    alpha2: string;
    alpha3: string;
    name: string;
    code: string;
    states?: Array<{ name: string; alpha2: string }> | null;
  }>;
};

export type CreateFlexLeaseInquiryMutationVariables = Exact<{
  listingId?: InputMaybe<Scalars["ID"]>;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  phone: Scalars["String"];
  dealBreakers: Scalars["String"];
  email: Scalars["String"];
  moveInOn?: InputMaybe<Scalars["String"]>;
  moveOutOn?: InputMaybe<Scalars["String"]>;
  occupation: Scalars["String"];
  sleeps?: InputMaybe<Scalars["Int"]>;
  city?: InputMaybe<Scalars["String"]>;
  bedrooms?: InputMaybe<Scalars["Int"]>;
  utmSource?: InputMaybe<Scalars["String"]>;
  utmMedium?: InputMaybe<Scalars["String"]>;
  utmCampaign?: InputMaybe<Scalars["String"]>;
  utmContent?: InputMaybe<Scalars["String"]>;
  utmTerm?: InputMaybe<Scalars["String"]>;
  initialReferrer?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
}>;

export type CreateFlexLeaseInquiryMutation = {
  createFlexLeaseInquiry?: {
    response: {
      success: boolean;
      error?: string | null;
      trackingInfo?: { [key: string]: any } | null;
    };
  } | null;
};

export type OtaBookingQueryQueryVariables = Exact<{
  bookingUniqKey: Scalars["String"];
}>;

export type OtaBookingQueryQuery = {
  otaBooking: {
    guestInfo: {
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      countryAlpha2?: string | null;
      countryCode?: string | null;
      phoneNumber?: string | null;
      dateOfBirth?: string | null;
      isBgcNeeded?: boolean | null;
    };
    productInfo: {
      image?: string | null;
      title: string;
      subtitle: string;
      checkInDateLabel?: string | null;
      checkOutDateLabel?: string | null;
      numberOfNights?: number | null;
      stayLengthLabel?: string | null;
    };
    inquiry: { id: number; account?: { id?: number | null } | null };
  };
};

export type GetMinimumNightsQueryVariables = Exact<{
  checkInDate: Scalars["String"];
  city: Scalars["String"];
}>;

export type GetMinimumNightsQuery = { minimumNights: { value: number } };

export type TrackEventMutationVariables = Exact<{
  anonymousId: Scalars["String"];
  eventName: Scalars["String"];
  eventPayload: Scalars["String"];
  context: Scalars["String"];
  environment: Scalars["String"];
}>;

export type TrackEventMutation = {
  trackEvent?: {
    response: {
      success: boolean;
      error?: string | null;
      eventName: string;
      eventPayload: string;
    };
  } | null;
};

export type UpdateAccountPasswordMutationVariables = Exact<{
  resetPasswordToken: Scalars["String"];
  password: Scalars["String"];
  passwordConfirmation: Scalars["String"];
}>;

export type UpdateAccountPasswordMutation = {
  updateAccountPassword?: { success: boolean } | null;
};

export type PrepareEciLcoInvoiceMutationVariables = Exact<{
  subjectId: Scalars["ID"];
  earlyCheckIn?: InputMaybe<Scalars["RFC3339DateTime"]>;
  lateCheckOut?: InputMaybe<Scalars["RFC3339DateTime"]>;
  missingDesiredCheckInTime?: InputMaybe<Scalars["Boolean"]>;
  missingDesiredCheckOutTime?: InputMaybe<Scalars["Boolean"]>;
  source?: InputMaybe<Scalars["String"]>;
}>;

export type PrepareEciLcoInvoiceMutation = {
  prepareEciLcoInvoice?: {
    invoice?: {
      id: string;
      totalAmount: number;
      currency: Currency;
      lineItems: Array<{
        type: string;
        description?: string | null;
        displayName: string;
        totalAmount: number;
        refundableOnCancellation?: boolean | null;
      }>;
    } | null;
  } | null;
};

export type AvailableEciLcoTimesQueryQueryVariables = Exact<{
  inquiryId: Scalars["ID"];
}>;

export type AvailableEciLcoTimesQueryQuery = {
  availableEciLcoTimes: {
    checkOutTime: string;
    checkInTime: string;
    eciTimes: Array<{
      available: boolean;
      price: number;
      time: string;
      displayTime?: string | null;
      isTheSameAsExistingTime?: boolean | null;
    }>;
    lcoTimes: Array<{
      available: boolean;
      price: number;
      time: string;
      displayTime?: string | null;
      isTheSameAsExistingTime?: boolean | null;
    }>;
  };
};

export type BookingQueryQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingQueryQuery = {
  booking: {
    id: string;
    unit: { timezone: string };
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
  };
};

export type MakeAsyncBookingPaymentMutationMutationVariables = Exact<{
  collectionId?: InputMaybe<Scalars["ID"]>;
  inquiryPaymentKey: Scalars["String"];
  receivableInvoiceId?: InputMaybe<Scalars["ID"]>;
  accountId?: InputMaybe<Scalars["ID"]>;
  promoCodes: Array<Scalars["String"]> | Scalars["String"];
  ancillaryServices?: InputMaybe<
    Array<AncillaryServiceInput> | AncillaryServiceInput
  >;
  ratePlanId?: InputMaybe<Scalars["ID"]>;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  addressStreet?: InputMaybe<Scalars["String"]>;
  addressApt?: InputMaybe<Scalars["String"]>;
  addressCity?: InputMaybe<Scalars["String"]>;
  addressState?: InputMaybe<Scalars["String"]>;
  addressCountry?: InputMaybe<Scalars["String"]>;
  addressZipcode?: InputMaybe<Scalars["String"]>;
  countryAlpha2: Scalars["String"];
  countryCode: Scalars["String"];
  phoneNumber: Scalars["String"];
  dateOfBirth: Scalars["String"];
  marketingOptIn: Scalars["Boolean"];
  paymentMethodId?: InputMaybe<Scalars["String"]>;
  paymentIntentId?: InputMaybe<Scalars["String"]>;
  paymentMethodDetails?: InputMaybe<Scalars["String"]>;
  billingZipcode?: InputMaybe<Scalars["String"]>;
  billingFirstName?: InputMaybe<Scalars["String"]>;
  billingLastName?: InputMaybe<Scalars["String"]>;
  savePaymentMethod?: InputMaybe<Scalars["Boolean"]>;
  redirectUri?: InputMaybe<Scalars["String"]>;
  bookingAgreementId?: InputMaybe<Scalars["ID"]>;
  loyaltyInfo?: InputMaybe<LoyaltyInfoInput>;
}>;

export type MakeAsyncBookingPaymentMutationMutation = {
  makeAsyncBookingPayment?: {
    response: {
      success: boolean;
      error?: string | null;
      checkoutProcessId: string;
    };
  } | null;
};

export type UpdatePetMutationVariables = Exact<{
  inquiryKey: Scalars["String"];
  petId?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  kind: PetKind;
  breed: Scalars["String"];
  weight: Scalars["Int"];
}>;

export type UpdatePetMutation = {
  updatePet?: { response: { success: boolean; error?: string | null } } | null;
};

export type RemovePetMutationVariables = Exact<{
  inquiryKey: Scalars["String"];
  petId: Scalars["Int"];
}>;

export type RemovePetMutation = {
  removePet?: { response: { success: boolean; error?: string | null } } | null;
};

export type InvoiceInfoFieldsFragment = {
  receivableInvoiceId?: string | null;
  hasMemberDiscount: boolean;
  ltsBooking: boolean;
  preAuthorizable: boolean;
  stripeCountryCode: string;
  chargeType?: string | null;
  lineItems: Array<{
    label: string;
    type: string;
    value: string;
    rawValue: number;
  }>;
  total: {
    label: string;
    value: string;
    rawValue: number;
    currency?: string | null;
  };
  discountCallout?: {
    label: string;
    type: string;
    value: string;
    rawValue: number;
  } | null;
  totalInBaseCurrency?: {
    label: string;
    value: string;
    rawValue: number;
    currency?: string | null;
  } | null;
};

export type CheckoutQueryQueryVariables = Exact<{
  collectionId?: InputMaybe<Scalars["String"]>;
  inquiryId?: InputMaybe<Scalars["String"]>;
  inquiryPaymentKey: Scalars["String"];
  promoCodes: Array<Scalars["String"]> | Scalars["String"];
  receivableInvoiceId?: InputMaybe<Scalars["String"]>;
  inEu: Scalars["Boolean"];
  type?: InputMaybe<Scalars["String"]>;
}>;

export type CheckoutQueryQuery = {
  checkout: {
    inquiryId: number;
    isUnavailable: boolean;
    listingUrl: string;
    guestInfo: {
      dateOfBirth?: string | null;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber?: string | null;
      countryAlpha2?: string | null;
      countryCode?: string | null;
      discountPricingMember?: boolean | null;
      marketingOptIn?: boolean | null;
      isFilled?: boolean | null;
      isBgcNeeded?: boolean | null;
      previousBookingsCount: number;
    };
    loyaltyInfos?: Array<{
      maskedGuestLoyaltyId?: string | null;
      loyaltyProgramId?: string | null;
    }> | null;
    paymentInfo: {
      currency?: string | null;
      paymentGateway?: PaymentGateway | null;
      paymentMethodId?: string | null;
      savedPaymentMethods?: Array<{
        id: string;
        brand: string;
        last4: string;
      }> | null;
      paymentCreationDetails?: Array<{
        gatewayName?: PaymentGateway | null;
        details?: string | null;
      }> | null;
    };
    productInfo: {
      title: string;
      building: string;
      subtitle: string;
      productId: string;
      listingId?: string | null;
      unitId: string;
      city: string;
      state: string;
      country: string;
      image?: string | null;
      checkInDate?: string | null;
      checkOutDate?: string | null;
      checkInDateLabel?: string | null;
      checkOutDateLabel?: string | null;
      checkInDow?: string | null;
      checkOutDow?: string | null;
      ratingAverage?: number | null;
      ratingState?: string | null;
      ratingTotal?: number | null;
      stayLength?: number | null;
      stayLengthLabel?: string | null;
      stayType: string;
      numberOfGuests?: number | null;
      numberOfNights?: number | null;
      gdsBooking?: boolean | null;
    };
    ltsInfo: {
      ltsEnabled: boolean;
      bookingAgreementId?: number | null;
      bookingAgreementText?: string | null;
    };
  };
};

export type CheckoutInvoiceQueryQueryVariables = Exact<{
  collectionId?: InputMaybe<Scalars["String"]>;
  inquiryId?: InputMaybe<Scalars["String"]>;
  inquiryPaymentKey: Scalars["String"];
  promoCodes: Array<Scalars["String"]> | Scalars["String"];
  ancillaryServices?: InputMaybe<
    Array<AncillaryServiceInput> | AncillaryServiceInput
  >;
  receivableInvoiceId?: InputMaybe<Scalars["String"]>;
  inEu: Scalars["Boolean"];
  targetCurrency?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
}>;

export type CheckoutInvoiceQueryQuery = {
  checkoutInvoice: {
    appliedPromoCodes: Array<string>;
    promoError?: string | null;
    remainingUnitsCount?: number | null;
    invoiceInfo: {
      receivableInvoiceId?: string | null;
      hasMemberDiscount: boolean;
      ltsBooking: boolean;
      preAuthorizable: boolean;
      stripeCountryCode: string;
      chargeType?: string | null;
      lineItems: Array<{
        label: string;
        type: string;
        value: string;
        rawValue: number;
      }>;
      total: {
        label: string;
        value: string;
        rawValue: number;
        currency?: string | null;
      };
      discountCallout?: {
        label: string;
        type: string;
        value: string;
        rawValue: number;
      } | null;
      totalInBaseCurrency?: {
        label: string;
        value: string;
        rawValue: number;
        currency?: string | null;
      } | null;
    };
    rateInfo: {
      memberRate?: string | null;
      ratePlans?: Array<{
        id?: string | null;
        name?: string | null;
        shortDescription?: string | null;
        description?: string | null;
        markedUpNightlyRateLabel?: string | null;
        effectiveNightlyRateLabel?: string | null;
        capabilityMessages: Array<string>;
        invoiceInfo: {
          receivableInvoiceId?: string | null;
          hasMemberDiscount: boolean;
          ltsBooking: boolean;
          preAuthorizable: boolean;
          stripeCountryCode: string;
          chargeType?: string | null;
          lineItems: Array<{
            label: string;
            type: string;
            value: string;
            rawValue: number;
          }>;
          total: {
            label: string;
            value: string;
            rawValue: number;
            currency?: string | null;
          };
          discountCallout?: {
            label: string;
            type: string;
            value: string;
            rawValue: number;
          } | null;
          totalInBaseCurrency?: {
            label: string;
            value: string;
            rawValue: number;
            currency?: string | null;
          } | null;
        };
      }> | null;
    };
  };
};

export type CheckoutProcessQueryQueryVariables = Exact<{
  checkoutProcessId: Scalars["String"];
}>;

export type CheckoutProcessQueryQuery = {
  checkoutProcess: {
    status: CheckoutProcessStatus;
    paymentGateway?: PaymentGateway | null;
    actionDetails?: string | null;
    paymentIntentClientSecret?: string | null;
    redirectUri?: string | null;
    authResultAvailable: boolean;
    authSuccess?: boolean | null;
    authError?: string | null;
    trackingInfo?: { [key: string]: any } | null;
    jwt?: string | null;
  };
};

export type AncillaryServicesQueryVariables = Exact<{
  inquiryId?: InputMaybe<Scalars["String"]>;
  bookingUniqKey?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
}>;

export type AncillaryServicesQuery = {
  ancillaryServices: Array<{
    displayPrice: string;
    feeType: AncillaryServiceFee;
    name: AncillaryServiceName;
    price: number;
    booked?: boolean | null;
  }>;
};

export type UpgradeServiceQueryVariables = Exact<{
  inquiryId?: InputMaybe<Scalars["String"]>;
  bookingUniqKey?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
  collectionId?: InputMaybe<Scalars["Int"]>;
}>;

export type UpgradeServiceQuery = {
  upgradeService: Array<{
    displayPrice: string;
    price: number;
    scheduleType: string;
    type: Upgrade;
    subType?: string | null;
    booked?: boolean | null;
    upgradeRestrictions?: {
      maxBookable?: number | null;
      minBookable?: number | null;
    } | null;
    upgradeDetails: { timeAvailable?: string | null };
  }>;
};

export type PetsQueryVariables = Exact<{
  inquiryKey: Scalars["String"];
}>;

export type PetsQuery = {
  pets?: Array<{
    id: number;
    name: string;
    kind: PetKind;
    breed: string;
    weight: number;
  }> | null;
};

export type AvailableEciTimesQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type AvailableEciTimesQuery = {
  availableEciTimes: {
    checkInTime: string;
    eciReason: string;
    currency: string;
    eciTimes: Array<{
      available: boolean;
      price: number;
      time: string;
      isTheSameAsExistingTime?: boolean | null;
      displayPrice?: string | null;
      displayTime?: string | null;
      standardPrice: number;
    }>;
  };
};

export type SendAppDownloadLinkMutationVariables = Exact<{
  confirmationCode: Scalars["String"];
}>;

export type SendAppDownloadLinkMutation = {
  sendAppDownloadLink?: {
    response: { success: boolean; error?: string | null };
  } | null;
};

export type UpdatePhoneNumberMutationVariables = Exact<{
  countryCode: Scalars["String"];
  phoneNumber: Scalars["String"];
}>;

export type UpdatePhoneNumberMutation = {
  updatePhoneNumber?: {
    response: { success: boolean; error?: string | null };
  } | null;
};

export type ResendPhoneVerificationCodeMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ResendPhoneVerificationCodeMutation = {
  resendPhoneVerificationCode?: {
    response: { success: boolean; error?: string | null };
  } | null;
};

export type VerifyPhoneMutationVariables = Exact<{
  phoneNumber: Scalars["String"];
  code: Scalars["String"];
}>;

export type VerifyPhoneMutation = { verifyPhone?: unknown | null };

export type ResendConfirmationEmailMutationVariables = Exact<{
  confirmationCode: Scalars["String"];
}>;

export type ResendConfirmationEmailMutation = {
  resendConfirmationEmail?: {
    response: { success: boolean; error?: string | null };
  } | null;
};

export type ConfirmationQueryQueryVariables = Exact<{
  inquiryPaymentKey: Scalars["String"];
  actionableTypes?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
  inEu: Scalars["Boolean"];
  targetCurrency?: InputMaybe<Scalars["String"]>;
  receivableInvoiceId?: InputMaybe<Scalars["String"]>;
}>;

export type ConfirmationQueryQuery = {
  confirmation: {
    chekinRegistrationLink?: string | null;
    showWelcomeReward?: boolean | null;
    showWelcomeRewardCta?: boolean | null;
    otaGuestInfoRequired?: boolean | null;
    orderInfo: { city: string; code: string };
    guestInfo: {
      email?: string | null;
      countryAlpha2?: string | null;
      countryCode?: string | null;
      phoneNumber?: string | null;
      discountPricingMember?: boolean | null;
      requiresIdVerification?: boolean | null;
      requiresPhoneVerification?: boolean | null;
      trustAndSafetyState: string;
      dateOfBirth?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      address: {
        streetAddress: string;
        streetAddress2?: string | null;
        stateOrProvince: string;
        cityName: string;
        postalCode: string;
        countryCode: string;
      };
    };
    actionables: Array<{
      type: string;
      completed?: boolean | null;
      status?: string | null;
      step?: string | null;
      metadata?: { [key: string]: any } | null;
    }>;
    invoiceInfo?: {
      hasMemberDiscount: boolean;
      ltsBooking: boolean;
      chargeType?: string | null;
      lineItems: Array<{ label: string; type: string; value: string }>;
      total: { label: string; value: string; currency?: string | null };
    } | null;
    invoiceInfoInTargetCurrency?: {
      hasMemberDiscount: boolean;
      ltsBooking: boolean;
      chargeType?: string | null;
      lineItems: Array<{ label: string; type: string; value: string }>;
      total: { label: string; value: string; currency?: string | null };
      totalInBaseCurrency?: {
        label: string;
        value: string;
        rawValue: number;
        currency?: string | null;
      } | null;
    } | null;
    paymentInfo?: {
      type?: string | null;
      brand?: string | null;
      last4?: string | null;
      paidDate?: string | null;
      cardholderName?: string | null;
    } | null;
    productInfo: {
      image?: string | null;
      title: string;
      subtitle: string;
      checkInDate?: string | null;
      checkOutDate?: string | null;
      checkInDateLabel?: string | null;
      checkOutDateLabel?: string | null;
      numberOfGuests?: number | null;
      numberOfNights?: number | null;
      stayLengthLabel?: string | null;
      ratingAverage?: number | null;
      ratingState?: string | null;
      ratingTotal?: number | null;
      gdsBooking?: boolean | null;
      airbnbBooking?: boolean | null;
    };
    cancellationInfo?: {
      name: string;
      description?: string | null;
      cancellationPolicy: string;
      priceFormula?: { adjustmentBasisPoints: number } | null;
    } | null;
    inquiry: {
      name?: string | null;
      accessHoursAvailableBeforeCheckIn?: number | null;
      inquiryState: InquiryState;
      isBooked?: boolean | null;
      isCancelled?: boolean | null;
      isInquiry?: boolean | null;
      isOnHold?: boolean | null;
      status: string;
      id: number;
      account?: { id?: number | null } | null;
      unit: { listing?: { url: string } | null };
    };
    eciLcoInfo?: {
      checkInChanged: boolean;
      checkOutChanged: boolean;
      checkInDate: string;
      checkOutDate: string;
      newCheckInTime: string;
      newCheckOutTime: string;
    } | null;
  };
};

export type CancellationPreviewQueryVariables = Exact<{
  inquiryId: Scalars["ID"];
}>;

export type CancellationPreviewQuery = {
  cancellationPreview?: {
    refundPercentage: number;
    refunds: Array<{
      refundMethod: RefundMethod;
      total: number;
      currency: string;
    }>;
  } | null;
};

export type RequestCancellationMutationMutationVariables = Exact<{
  inquiryId: Scalars["ID"];
}>;

export type RequestCancellationMutationMutation = {
  requestCancellation?: {
    followupRequired?: boolean | null;
    refundOwed?: boolean | null;
  } | null;
};

export type BuildingCollectionsAvailabilityQueryQueryVariables = Exact<{
  listingId: Scalars["ID"];
  checkInDate?: InputMaybe<Scalars["String"]>;
  checkOutDate?: InputMaybe<Scalars["String"]>;
  prices?: InputMaybe<Array<Scalars["Int"]> | Scalars["Int"]>;
  sleeps?: InputMaybe<Scalars["Int"]>;
  source?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
}>;

export type BuildingCollectionsAvailabilityQueryQuery = {
  buildingCollectionsAvailability: {
    collections: Array<{
      available?: boolean | null;
      bathroomCount: number;
      bedroomCount: number;
      collectionName?: string | null;
      collectionType: string;
      collectionId: string;
      displayPrice: string;
      displayPriceRaw: number;
      displayPriceLabel: string;
      longTermRental: boolean;
      minimumStayLength?: number | null;
      sleepCount: number;
      squareFootage: number;
      viewCount: number;
      adaAccessibilityInfo?: {
        isHearingAccessible?: boolean | null;
        isMobilityAccessible?: boolean | null;
        mobilityFeatures?: Array<string> | null;
        hearingFeatures?: Array<string> | null;
      } | null;
      amenities: Array<{
        name: string;
        active?: boolean | null;
        label?: string | null;
      }>;
      photos: Array<{
        tag?: string | null;
        caption?: string | null;
        mediumSrc: string;
        smallSrc: string;
        xlargeSrc: string;
        largeSrc: string;
      }>;
      quote?: {
        rateLabel?: string | null;
        totalLabel?: string | null;
        originalRateLabel?: string | null;
        remainingUnitsCount?: number | null;
        invoice: {
          adr?: string | null;
          contactToBookLts?: boolean | null;
          isBookingDisabled?: boolean | null;
          lineItems: Array<{
            key: string;
            label: string;
            value: string;
            primary: boolean;
          }>;
        };
      } | null;
    }>;
    filters: {
      availabilityFilter: {
        selected: { checkInDate?: string | null; checkOutDate?: string | null };
      };
      guestCountFilter: {
        selected: number;
        options: { min?: number | null; max?: number | null };
      };
      pricingFilter: {
        options: { min?: number | null; max?: number | null };
        selected: { min?: number | null; max?: number | null };
      };
    };
  };
};

export type BuildingCollectionsCalendarAvailabilitiesQueryQueryVariables =
  Exact<{
    id: Scalars["ID"];
    checkInDate?: InputMaybe<Scalars["String"]>;
    startCursor?: InputMaybe<Scalars["String"]>;
    endCursor?: InputMaybe<Scalars["String"]>;
    guestCount?: InputMaybe<Scalars["Int"]>;
  }>;

export type BuildingCollectionsCalendarAvailabilitiesQueryQuery = {
  buildingCollectionsCalendarAvailabilities: Array<{
    date: string;
    minimumStayLength: number;
    checkinAvailable: boolean;
  }>;
};

export type BuildingListingQueryQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type BuildingListingQueryQuery = {
  buildingListing:
    | {
        accessibilityInfo: Array<string>;
        buildingAddress: string;
        brandSegment?: string | null;
        buildingName: string;
        cityName: string;
        contactEmailLtr: string;
        contactEmailStr: string;
        countryName: string;
        countryCode: string;
        currency: string;
        downtownDrivingInfo?: string | null;
        homeTruths?: string | null;
        houseRules: Array<string>;
        id?: string | null;
        location: string;
        neighborhoodContent?: string | null;
        neighborhoodDescription?: string | null;
        neighborhoodName?: string | null;
        parkingInfo: Array<string>;
        publicTransportationInfo?: string | null;
        ratingAverage?: number | null;
        ratingState?: string | null;
        ratingTotal?: number | null;
        shortDescription?: string | null;
        stateName: string;
        stateCode?: string | null;
        title?: string | null;
        url: string;
        isHotel?: boolean | null;
        amenities: Array<{
          name: string;
          active?: boolean | null;
          label?: string | null;
        }>;
        buildingPhotos: Array<{
          tag?: string | null;
          caption?: string | null;
          mediumSrc: string;
          xlargeSrc: string;
          largeSrc: string;
        }>;
        geocode: { lat: number; lng: number };
        photos: Array<{
          tag?: string | null;
          caption?: string | null;
          mediumSrc: string;
          xlargeSrc: string;
          largeSrc: string;
        }>;
        topAmenities: Array<{
          name: string;
          active?: boolean | null;
          label?: string | null;
        }>;
        tripadvisorAward?: {
          awardType: TripadvisorAwardTypeEnum;
          year: number;
          assetSrc: string;
        } | null;
      }
    | { l1Url: string };
};

export type ListingUpgradeServiceQueryQueryVariables = Exact<{
  collectionId?: InputMaybe<Scalars["Int"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
}>;

export type ListingUpgradeServiceQueryQuery = {
  upgradeService: Array<{
    displayPrice: string;
    scheduleType: string;
    type: Upgrade;
    subType?: string | null;
  }>;
};

export type CreateInquiryMutationVariables = Exact<{
  listingId: Scalars["ID"];
  collectionId?: InputMaybe<Scalars["ID"]>;
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  promoCodes: Array<Scalars["String"]> | Scalars["String"];
  guestNb?: InputMaybe<Scalars["Int"]>;
  referralPartnerId?: InputMaybe<Scalars["String"]>;
}>;

export type CreateInquiryMutation = {
  createInquiry?: {
    payPath: string;
    id: string;
    uniqKey: string;
    trackingInfo?: { [key: string]: any } | null;
  } | null;
};

export type RoomUpgradesQueryVariables = Exact<{
  bookingUniqKey: Scalars["String"];
}>;

export type RoomUpgradesQuery = {
  roomUpgrades: {
    inquiryId: string;
    state: string;
    currentBooking: {
      amountPaid: string;
      checkInDate: string;
      checkOutDate: string;
      stayLength: number;
      listingId?: string | null;
    };
    availableUpgrades: Array<{
      pricePerNight: string;
      priceTotal: string;
      rawPricePerNight: number;
      discount: string;
      upgradeDescription: string;
      upgradePath: string;
    }>;
  };
};

export type NeighborhoodFilterFragment = {
  neighborhoodFilter: {
    options: Array<{ label: string; value: string }>;
    selected: Array<{ label: string; value: string }>;
  };
};

export type SearchBarFragment = {
  neighborhoodFilter: {
    options: Array<{ label: string; value: string }>;
    selected: Array<{ label: string; value: string }>;
  };
};

export type BuildingSearchQueryQueryVariables = Exact<{
  queryString: Scalars["String"];
  context?: InputMaybe<Scalars["String"]>;
  environment?: InputMaybe<Scalars["String"]>;
  targetCurrency?: InputMaybe<Scalars["String"]>;
}>;

export type BuildingSearchQueryQuery = {
  buildingSearch: {
    inventorySearchFilters: {
      cityFilter: {
        options: Array<{ label: string; value: string }>;
        selected: { label: string; value: string };
      };
      availabilityFilter: {
        selected: { checkInDate?: string | null; checkOutDate?: string | null };
      };
      guestCountFilter: {
        selected: number;
        options: { min?: number | null; max?: number | null };
      };
      pricingFilter: {
        options: { min?: number | null; max?: number | null };
        selected: { min?: number | null; max?: number | null };
      };
      bedroomCountFilter: {
        selected?: number | null;
        options: { min?: number | null; max?: number | null };
      };
      bedCountFilter: {
        selected?: number | null;
        options: { min?: number | null; max?: number | null };
      };
      bathroomCountFilter: {
        selected?: number | null;
        options: { min?: number | null; max?: number | null };
      };
      amenityFilter: {
        options: Array<{ label: string; value: string }>;
        selected: Array<{ label: string; value: string }>;
      };
      neighborhoodFilter: {
        options: Array<{ label: string; value: string }>;
        selected: Array<{ label: string; value: string }>;
      };
    };
    inventorySearchResult: {
      listingsOrder: Array<string>;
      markersOrder: Array<string>;
      listings: { [key: string]: any };
      markers: { [key: string]: any };
      listingToMarker: { [key: string]: any };
      markerToListings: { [key: string]: any };
      similarListings: Array<{ [key: string]: any }>;
    };
    inventorySearchSorting: {
      options: Array<{ label: string; value: string }>;
      selected: { label: string; value: string };
    };
    inventorySearchMetadata: {
      currencySymbol: string;
      count: number;
      totalCount: number;
      weeklyDiscount: string;
      biweeklyDiscount: string;
      monthlyDiscount: string;
      fortyFivePlusDiscount: string;
      defaultDiscount: string;
      appliedOffersTotal: {
        filterKey: string;
        discountLabel: string;
        discountValue: number;
      };
    };
  };
};

export type AssociateInquiryMutationVariables = Exact<{
  bookingUniqKey: Scalars["String"];
}>;

export type AssociateInquiryMutation = {
  associateInquiry?: { success: string } | null;
};

export type ConfirmPaymentMethodMutationVariables = Exact<{
  bookingUniqKey: Scalars["String"];
  paymentMethodId: Scalars["String"];
}>;

export type ConfirmPaymentMethodMutation = {
  confirmPaymentMethod?: {
    response: { success: boolean; error?: string | null };
  } | null;
};

export type CreateBookingAndPaymentLinkMutationVariables = Exact<{
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  collectionId: Scalars["String"];
  ratePlanId: Scalars["String"];
  guestId: Scalars["String"];
  paymentGateway: Scalars["String"];
}>;

export type CreateBookingAndPaymentLinkMutation = {
  createBookingAndPaymentLink: { bookingUniqKey: string; url: string };
};

export type RequestAlterationMutationVariables = Exact<{
  inquiryId: Scalars["ID"];
  newCheckInDate?: InputMaybe<Scalars["String"]>;
  newCheckOutDate?: InputMaybe<Scalars["String"]>;
}>;

export type RequestAlterationMutation = {
  requestAlteration?: {
    followupRequired?: boolean | null;
    invoiceId?: string | null;
    paymentLink?: string | null;
    refundOwed?: boolean | null;
  } | null;
};

export type SubmitCsatFeedbackMutationVariables = Exact<{
  bookingUniqKey: Scalars["String"];
  csatScore?: InputMaybe<Scalars["Int"]>;
  scoreReason?: InputMaybe<Scalars["String"]>;
  cleanliness?: InputMaybe<Scalars["Int"]>;
  condition?: InputMaybe<Scalars["Int"]>;
  staff?: InputMaybe<Scalars["Int"]>;
  safety?: InputMaybe<Scalars["Int"]>;
}>;

export type SubmitCsatFeedbackMutation = {
  submitCsatFeedback?: {
    response: {
      feedbackQuestionnaireCompleted: boolean;
      rateCompleted: boolean;
    };
  } | null;
};

export type UpdateGroupPayerPaymentDetailsMutationVariables = Exact<{
  slug: Scalars["String"];
  paymentMethodId: Scalars["String"];
}>;

export type UpdateGroupPayerPaymentDetailsMutation = {
  updateGroupPayerPaymentDetails?: { success: boolean } | null;
};

export type UpdateOtaGuestDetailsMutationVariables = Exact<{
  inquiryId: Scalars["ID"];
  otaGuestDetailsInput: OtaGuestDetailsInput;
}>;

export type UpdateOtaGuestDetailsMutation = {
  updateOtaGuestDetails?: {
    success: boolean;
    response: { success: boolean; error?: string | null };
    errors: Array<{ message: string; code: string }>;
  } | null;
};

export type UpdateSurveyQuestionMutationVariables = Exact<{
  uniqKey: Scalars["String"];
  csatScore: Scalars["Int"];
}>;

export type UpdateSurveyQuestionMutation = {
  updateTravelSurvey?: {
    travelSurveyQuestion: {
      title: string;
      subtitle?: string | null;
      redirectUrl?: string | null;
      type: TravelSurveyQuestionTypeEnum;
    };
  } | null;
};

export type BookingDetailsAndUpgradeServicesQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingDetailsAndUpgradeServicesQuery = {
  booking: {
    id: string;
    checkInTime: string;
    checkOutTime: string;
    confirmationCode?: string | null;
    accessHoursAvailableBeforeCheckIn?: number | null;
    guestIntendedArrivalTime?: string | null;
    guestIntendedDepartureTime?: string | null;
    hasPaymentPlan: boolean;
    isCancelled?: boolean | null;
    normalizedId: number;
    status: string;
    uniqKey: string;
    rentalSiteName: string;
    access?: { isInPersonCheckin: boolean } | null;
    account?: {
      id: string;
      canReceiveAccessInfo?: boolean | null;
      email: string;
      normalizedId?: number | null;
    } | null;
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
    earlyCheckInRequest?: {
      id: string;
      desiredTime: string;
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    lateCheckOutRequest?: {
      id: string;
      desiredTime: string;
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    pendingDateAdjustmentRequest?: {
      id: string;
      newLocalCheckInTime: string;
      newLocalCheckOutTime: string;
    } | null;
    unit: {
      id: string;
      brCount: number;
      googleMapsLink: string;
      name: string;
      nbrBathrooms: number;
      quickPitch?: string | null;
      sleeps: number;
      timezone: string;
      building: {
        id: string;
        fullAddress: string;
        displayName?: string | null;
        name: string;
      };
      images: Array<{ id: string; url: string }>;
      listing?: { id: string; url: string } | null;
      neighborhood: { id: string; description: string };
    };
  };
  upgradeService: Array<{
    booked?: boolean | null;
    subType?: string | null;
    type: Upgrade;
  }>;
};

export type IdVerificationQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type IdVerificationQuery = {
  booking: { checkInState: { idVerification?: { completed: boolean } | null } };
};

export type AccountAllowedActionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccountAllowedActionsQuery = {
  account: {
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
  };
};

export type AccountDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type AccountDetailsQuery = {
  account: {
    id: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    canQa?: boolean | null;
    fidelity?: { number?: string | null; source?: string | null } | null;
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
  };
};

export type AlterationAvailabilityQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type AlterationAvailabilityQuery = {
  alterationAvailability?: {
    maximumNightStay: number;
    minimumNightStay: number;
    availabilityData: Array<{
      data: {
        id: string;
        checkinAvailable: boolean;
        checkoutAvailable: boolean;
        minNights: number;
      };
    }>;
  } | null;
};

export type ModificationPreviewPricingQueryVariables = Exact<{
  id: Scalars["ID"];
  newCheckInDate?: InputMaybe<Scalars["String"]>;
  newCheckOutDate?: InputMaybe<Scalars["String"]>;
}>;

export type ModificationPreviewPricingQuery = {
  alterationPreviewPricing: {
    currency?: string | null;
    total?: number | null;
    message?: string | null;
    refundMethod?: RefundMethod | null;
    paymentDifference?: number | null;
  };
};

export type AccessAccountBookingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccessAccountBookingsQuery = {
  account: { bookings: Array<{ id: string; uniqKey: string }> };
};

export type BookingAccessAndUpgradeServicesQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingAccessAndUpgradeServicesQuery = {
  booking: {
    id: string;
    accessHoursAvailableBeforeCheckIn?: number | null;
    accessInstructions?: string | null;
    canReceiveAccessInstructions: boolean;
    checkInTime: string;
    guestIntendedArrivalTime?: string | null;
    checkOutTime: string;
    guestIntendedDepartureTime?: string | null;
    inquiryState: InquiryState;
    confirmationCode?: string | null;
    uniqKey: string;
    rentalSiteName: string;
    accessUnavailableReason?: AccessUnavailableReason | null;
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
    access?: {
      buildingAccessCode?: string | null;
      buildingAccessType?: string | null;
      elevatorAccessCode?: string | null;
      elevatorAccessType?: string | null;
      isBuildingAccessRequired: boolean;
      isElevatorAccessRequired: boolean;
      isInPersonCheckin: boolean;
      isLockboxRequired: boolean;
      keycafeCode?: string | null;
      lockboxCode?: string | null;
      unitAccessCode?: string | null;
      unitAccessType: string;
    } | null;
    unit: {
      id: string;
      aptNumber?: string | null;
      name: string;
      closestMetroStation?: string | null;
      googleMapsLink: string;
      propertyType?: string | null;
      staticMapImage: string;
      timezone: string;
      town?: string | null;
      wifiSsid?: string | null;
      wifiPassword?: string | null;
      listing?: { title?: string | null } | null;
      building: {
        id: string;
        breakfastDescription?: string | null;
        breakfastTiming?: string | null;
        freeBreakfast: boolean;
        garbageInformation?: string | null;
        mailInstructions?: string | null;
        recyclingInformation?: string | null;
        stateCode: string;
        streetAddress: string;
        displayName?: string | null;
        guestSpaces: Array<{
          id: string;
          description?: string | null;
          location: string;
          type: string;
          openHours: { hoursAsString: string };
        }>;
      };
      city: {
        id: string;
        country: string;
        name: string;
        servicePartners: Array<{
          id: string;
          categoryKey: string;
          categoryName: string;
          descriptionLong: string;
          displayName: string;
          url: string;
        }>;
      };
      parkingTypes: {
        freeParkingLotsNearby: boolean;
        freeParkingLotDetails?: string | null;
        freeStreetParking: boolean;
        freeStreetParkingDetails?: string | null;
        paidParkingLotsNearby: boolean;
        paidParkingLotDetails?: string | null;
        paidStreetParking: boolean;
        paidStreetParkingDetails?: string | null;
        privateParkingWithUnitFree: boolean;
        privateParkingWithUnitPaid: boolean;
        privateParkingDetails?: string | null;
      };
      storageLocation?: {
        id: string;
        guestFacingTextArray: Array<string>;
        name: string;
      } | null;
    };
  };
  upgradeService: Array<{
    booked?: boolean | null;
    subType?: string | null;
    type: Upgrade;
  }>;
};

export type BookingAccessQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingAccessQuery = {
  booking: {
    id: string;
    accessHoursAvailableBeforeCheckIn?: number | null;
    accessInstructions?: string | null;
    canReceiveAccessInstructions: boolean;
    checkInTime: string;
    guestIntendedArrivalTime?: string | null;
    checkOutTime: string;
    guestIntendedDepartureTime?: string | null;
    inquiryState: InquiryState;
    confirmationCode?: string | null;
    uniqKey: string;
    rentalSiteName: string;
    accessUnavailableReason?: AccessUnavailableReason | null;
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
    access?: {
      buildingAccessCode?: string | null;
      buildingAccessType?: string | null;
      elevatorAccessCode?: string | null;
      elevatorAccessType?: string | null;
      isBuildingAccessRequired: boolean;
      isElevatorAccessRequired: boolean;
      isInPersonCheckin: boolean;
      isLockboxRequired: boolean;
      keycafeCode?: string | null;
      lockboxCode?: string | null;
      unitAccessCode?: string | null;
      unitAccessType: string;
    } | null;
    unit: {
      id: string;
      aptNumber?: string | null;
      name: string;
      closestMetroStation?: string | null;
      googleMapsLink: string;
      propertyType?: string | null;
      staticMapImage: string;
      timezone: string;
      town?: string | null;
      wifiSsid?: string | null;
      wifiPassword?: string | null;
      listing?: { title?: string | null } | null;
      building: {
        id: string;
        breakfastDescription?: string | null;
        breakfastTiming?: string | null;
        freeBreakfast: boolean;
        garbageInformation?: string | null;
        mailInstructions?: string | null;
        recyclingInformation?: string | null;
        stateCode: string;
        streetAddress: string;
        displayName?: string | null;
        guestSpaces: Array<{
          id: string;
          description?: string | null;
          location: string;
          type: string;
          openHours: { hoursAsString: string };
        }>;
      };
      city: {
        id: string;
        country: string;
        name: string;
        servicePartners: Array<{
          id: string;
          categoryKey: string;
          categoryName: string;
          descriptionLong: string;
          displayName: string;
          url: string;
        }>;
      };
      parkingTypes: {
        freeParkingLotsNearby: boolean;
        freeParkingLotDetails?: string | null;
        freeStreetParking: boolean;
        freeStreetParkingDetails?: string | null;
        paidParkingLotsNearby: boolean;
        paidParkingLotDetails?: string | null;
        paidStreetParking: boolean;
        paidStreetParkingDetails?: string | null;
        privateParkingWithUnitFree: boolean;
        privateParkingWithUnitPaid: boolean;
        privateParkingDetails?: string | null;
      };
      storageLocation?: {
        id: string;
        guestFacingTextArray: Array<string>;
        name: string;
      } | null;
    };
  };
};

export type BookingAccessUpgradeServicesQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingAccessUpgradeServicesQuery = {
  upgradeService: Array<{
    booked?: boolean | null;
    subType?: string | null;
    type: Upgrade;
  }>;
};

export type BookingAllowedActionsQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingAllowedActionsQuery = {
  booking: {
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
  };
};

export type BookingAndCheckInStateQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingAndCheckInStateQuery = {
  booking: {
    creditCardRequirementsCompleted: boolean;
    collectionId?: string | null;
    isCancelled?: boolean | null;
    requiresCompletion: boolean;
    inquiryState: InquiryState;
    uniqKey: string;
    status: string;
    rentalSiteName: string;
    actions?: Array<{ type: ActionType } | null> | null;
    checkInState: {
      personalInfoVerification?: { completed: boolean } | null;
      phoneVerification?: { completed: boolean } | null;
      paymentVerification?: { completed: boolean } | null;
      idVerification?: { completed: boolean } | null;
    };
    revenueReceivableInvoices?: Array<{ id: string }> | null;
  };
};

export type BookingCcConfirmationQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingCcConfirmationQuery = {
  booking: {
    id: string;
    uniqKey: string;
    requiresCompletion: boolean;
    requiresVerification: boolean;
    checkInTime: string;
    checkOutTime: string;
    confirmationCode?: string | null;
    guestIntendedArrivalTime?: string | null;
    guestIntendedDepartureTime?: string | null;
    hasPaymentPlan: boolean;
    inquiryState: InquiryState;
    isCancelled?: boolean | null;
    rentalSiteName: string;
    account?: {
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      normalizedId?: number | null;
    } | null;
    pendingDateAdjustmentRequest?: {
      id: string;
      newLocalCheckInTime: string;
      newLocalCheckOutTime: string;
    } | null;
    earlyCheckInRequest?: {
      id: string;
      desiredTime: string;
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    lateCheckOutRequest?: {
      id: string;
      desiredTime: string;
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    unit: {
      id: string;
      brCount: number;
      googleMapsLink: string;
      name: string;
      nbrBathrooms: number;
      sleeps: number;
      timezone: string;
      building: { id: string; fullAddress: string };
      images: Array<{ id: string; url: string }>;
      listing?: { id: string; url: string } | null;
    };
  };
};

export type BookingDateAdjustmentQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingDateAdjustmentQuery = {
  booking: {
    id: string;
    uniqKey: string;
    checkInTime: string;
    checkOutTime: string;
    collectionId?: string | null;
    inquiryState: InquiryState;
    unit: { id: string; timezone: string };
    pendingDateAdjustmentRequest?: {
      id: string;
      newLocalCheckInTime: string;
      newLocalCheckOutTime: string;
      revenueReceivableInvoice?: { id: string } | null;
    } | null;
  };
};

export type BookingDetailsQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingDetailsQuery = {
  booking: {
    id: string;
    checkInTime: string;
    checkOutTime: string;
    confirmationCode?: string | null;
    accessHoursAvailableBeforeCheckIn?: number | null;
    guestIntendedArrivalTime?: string | null;
    guestIntendedDepartureTime?: string | null;
    hasPaymentPlan: boolean;
    isCancelled?: boolean | null;
    normalizedId: number;
    status: string;
    uniqKey: string;
    rentalSiteName: string;
    access?: { isInPersonCheckin: boolean } | null;
    account?: {
      id: string;
      canReceiveAccessInfo?: boolean | null;
      email: string;
      normalizedId?: number | null;
    } | null;
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
    earlyCheckInRequest?: {
      id: string;
      desiredTime: string;
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    lateCheckOutRequest?: {
      id: string;
      desiredTime: string;
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    pendingDateAdjustmentRequest?: {
      id: string;
      newLocalCheckInTime: string;
      newLocalCheckOutTime: string;
    } | null;
    unit: {
      id: string;
      brCount: number;
      googleMapsLink: string;
      name: string;
      nbrBathrooms: number;
      quickPitch?: string | null;
      sleeps: number;
      timezone: string;
      building: {
        id: string;
        fullAddress: string;
        displayName?: string | null;
        name: string;
      };
      images: Array<{ id: string; url: string }>;
      listing?: { id: string; url: string } | null;
      neighborhood: { id: string; description: string };
    };
  };
};

export type BookingDetailsUpgradeServicesQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingDetailsUpgradeServicesQuery = {
  upgradeService: Array<{
    booked?: boolean | null;
    subType?: string | null;
    type: Upgrade;
  }>;
};

export type BookingLatestReceiptQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingLatestReceiptQuery = {
  booking: { id: string; latestReceipt?: string | null };
};

export type BookingSurveyQuestionQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingSurveyQuestionQuery = {
  travelSurveyQuestion: {
    title: string;
    subtitle?: string | null;
    redirectUrl?: string | null;
    type: TravelSurveyQuestionTypeEnum;
  };
};

export type BookingVerificationRedirectionQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type BookingVerificationRedirectionQuery = {
  bookingVerificationRedirection: {
    redirectionPath: string;
    redirectionUrl: string;
  };
};

export type CsatFeedbackQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type CsatFeedbackQuery = {
  csatFeedback?: {
    feedbackQuestionnaireCompleted: boolean;
    rateCompleted: boolean;
  } | null;
};

export type CustomizePagePrepareAddonInvoiceMutationVariables = Exact<{
  inquiryKey: Scalars["String"];
  ancillaryServices: Array<AncillaryServiceInput> | AncillaryServiceInput;
}>;

export type CustomizePagePrepareAddonInvoiceMutation = {
  prepareAddonInvoice?: {
    invoice?: { checkoutUrl?: string | null } | null;
  } | null;
};

export type FetchCheckoutDetailsQueryVariables = Exact<{
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  collectionId: Scalars["String"];
}>;

export type FetchCheckoutDetailsQuery = {
  fetchCheckoutDetails: {
    productDetails?: {
      name: string;
      description: string;
      image?: string | null;
    } | null;
    pricingPlans?: Array<{
      id: string;
      name: string;
      description: string;
      invoiceDetails: {
        totalAmount: number;
        currency: string;
        lineItemDetails: Array<{
          type: string;
          subtype: string;
          description: string;
          quantity: number;
          averageUnitPrice: number;
          total: number;
          dailyRates?: Array<{ date: string; amount: number }> | null;
        }>;
      };
    }> | null;
  };
};

export type GeneratePaymentMethodIFrameMutationVariables = Exact<{
  locale?: InputMaybe<Scalars["String"]>;
  uniqueCode: Scalars["String"];
  styles?: InputMaybe<Scalars["String"]>;
  buttonType?: InputMaybe<Scalars["String"]>;
}>;

export type GeneratePaymentMethodIFrameMutation = {
  generatePaymentMethodIFrame?: {
    iframe?: string | null;
    sessionKey?: string | null;
  } | null;
};

export type GroupPayerPaymentDetailsQueryVariables = Exact<{
  slug: Scalars["String"];
}>;

export type GroupPayerPaymentDetailsQuery = {
  groupPayerPaymentDetails: { city: string; bookingDatesLabel: string };
};

export type ManageReservationDropdownQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type ManageReservationDropdownQuery = {
  booking: {
    id: string;
    alterationsAllowed: boolean;
    cancellationsAllowed?: boolean | null;
    guestModificationAllowed: boolean;
    hasPaymentPlan: boolean;
    instantEciLcoEnabled?: boolean | null;
    inquiryState: InquiryState;
    isEciRequestAvailable: boolean;
    isLcoRequestAvailable: boolean;
    normalizedId: number;
    rentalSiteName: string;
    uniqKey: string;
    account?: { id: string } | null;
    cancellationEligibility?: {
      isEligible: boolean;
      ineligibleReason?: IneligibleForCancellationReason | null;
      otaLink?: string | null;
    } | null;
    earlyCheckInRequest?: {
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    lateCheckOutRequest?: {
      eciLcoRequestId: number;
      status: EciLcoStatus;
    } | null;
    actions?: Array<{
      type: ActionType;
      externalUrl?: string | null;
    } | null> | null;
  };
};

export type OtaBookingQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type OtaBookingQuery = {
  booking: {
    uniqKey: string;
    name?: string | null;
    confirmationCode?: string | null;
    rentalSiteName: string;
    checkInTime: string;
    checkOutTime: string;
    inquiryState: InquiryState;
    isCancelled?: boolean | null;
    status: string;
    id: number;
    account?: { id?: number | null } | null;
    unit: {
      timezone: string;
      images: Array<{ url: string }>;
      listing?: {
        title?: string | null;
        cityName: string;
        buildingName: string;
        neighborhoodName?: string | null;
      } | null;
      building: { requiresBackgroundCheck?: boolean | null };
    };
    checkInState: {
      personalInfoVerification?: {
        completed: boolean;
        guestInfo: {
          email?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          countryAlpha2?: string | null;
          countryCode?: string | null;
          phoneNumber?: string | null;
          dateOfBirth?: string | null;
          isBgcNeeded?: boolean | null;
          address: {
            streetAddress: string;
            streetAddress2?: string | null;
            stateOrProvince: string;
            cityName: string;
            postalCode: string;
            countryCode: string;
          };
        };
      } | null;
      phoneVerification?: { completed: boolean } | null;
      paymentVerification?: {
        completed: boolean;
        isSonderMor: boolean;
        unpaidCharges: boolean;
        cardholderName?: string | null;
        paymentInfo?: {
          currency?: string | null;
          paymentMethodId?: string | null;
          savedPaymentMethods?: Array<{
            id: string;
            brand: string;
            default: boolean;
            expMonth: number;
            expYear: number;
            last4: string;
            type: string;
          }> | null;
        } | null;
      } | null;
      idVerification?: {
        completed: boolean;
        persona?: {
          templateId?: string | null;
          dynamicFlowTemplateId?: string | null;
          riskLevel?: string | null;
        } | null;
        chekin?: {
          registrationLink?: string | null;
          idvEnabled?: boolean | null;
          verificationType?: string | null;
          requiredForAllGuests?: boolean | null;
        } | null;
      } | null;
    };
  };
};

export type ProfileAccountBookingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ProfileAccountBookingsQuery = {
  account: {
    id: string;
    normalizedId?: number | null;
    bookingsAndCancellations: Array<{
      collectionId?: string | null;
      checkInTime: string;
      checkOutTime: string;
      hasPaymentPlan: boolean;
      hasPendingDateAdjustmentRequest: boolean;
      id: string;
      isBooked?: boolean | null;
      isCancelled?: boolean | null;
      name?: string | null;
      normalizedId: number;
      rentalSiteName: string;
      requiresCompletion: boolean;
      requiresSurvey: boolean;
      status: string;
      uniqKey: string;
      account?: { id: string; normalizedId?: number | null } | null;
      revenueReceivableInvoices?: Array<{ id: string }> | null;
      unit: {
        name: string;
        timezone: string;
        building: { fullAddress: string };
        city: { name: string };
        images: Array<{ url: string }>;
      };
    }>;
  };
};

export type TokenizeCreditCardMutationVariables = Exact<{
  uniqueCode: Scalars["String"];
  paymentKey: Scalars["String"];
  sessionKey: Scalars["String"];
  cardIssuer: Scalars["String"];
  maskedCardNumber: Scalars["String"];
  expirationDate: Scalars["String"];
}>;

export type TokenizeCreditCardMutation = { tokenizeCreditCard: boolean };

export type CustomizeBookingBookingQueryQueryVariables = Exact<{
  uniqKey: Scalars["String"];
}>;

export type CustomizeBookingBookingQueryQuery = { booking: { id: number } };

export type DevToolsAccountQueryVariables = Exact<{ [key: string]: never }>;

export type DevToolsAccountQuery = { account: { canQa?: boolean | null } };

export type ReferrerQueryQueryVariables = Exact<{
  referralCode: Scalars["String"];
}>;

export type ReferrerQueryQuery = {
  referrer?: { referralCode: string; referrerName: string } | null;
};

export const InvoiceInfoFieldsFragmentDoc = gql`
  fragment InvoiceInfoFields on InvoiceInfo {
    receivableInvoiceId
    hasMemberDiscount
    ltsBooking
    preAuthorizable
    lineItems {
      label
      type
      value
      rawValue
    }
    total {
      label
      value
      rawValue
      currency
    }
    discountCallout {
      label
      type
      value
      rawValue
    }
    stripeCountryCode
    chargeType
    totalInBaseCurrency {
      label
      value
      rawValue
      currency
    }
  }
`;
export const NeighborhoodFilterFragmentDoc = gql`
  fragment NeighborhoodFilter on InventorySearchFilters {
    neighborhoodFilter {
      options {
        label
        value
      }
      selected {
        label
        value
      }
    }
  }
`;
export const SearchBarFragmentDoc = gql`
  fragment SearchBar on InventorySearchFilters {
    ...NeighborhoodFilter
  }
  ${NeighborhoodFilterFragmentDoc}
`;
export const SendResetPasswordInstructionsEmailDocument = gql`
  mutation SendResetPasswordInstructionsEmail($email: String!) {
    sendResetPasswordInstructionsEmail(email: $email) {
      success
    }
  }
`;
export type SendResetPasswordInstructionsEmailMutationFn =
  Apollo.MutationFunction<
    SendResetPasswordInstructionsEmailMutation,
    SendResetPasswordInstructionsEmailMutationVariables
  >;

/**
 * __useSendResetPasswordInstructionsEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordInstructionsEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordInstructionsEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordInstructionsEmailMutation, { data, loading, error }] = useSendResetPasswordInstructionsEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordInstructionsEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendResetPasswordInstructionsEmailMutation,
    SendResetPasswordInstructionsEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendResetPasswordInstructionsEmailMutation,
    SendResetPasswordInstructionsEmailMutationVariables
  >(SendResetPasswordInstructionsEmailDocument, options);
}
export type SendResetPasswordInstructionsEmailMutationHookResult = ReturnType<
  typeof useSendResetPasswordInstructionsEmailMutation
>;
export type SendResetPasswordInstructionsEmailMutationResult =
  Apollo.MutationResult<SendResetPasswordInstructionsEmailMutation>;
export type SendResetPasswordInstructionsEmailMutationOptions =
  Apollo.BaseMutationOptions<
    SendResetPasswordInstructionsEmailMutation,
    SendResetPasswordInstructionsEmailMutationVariables
  >;
export const RequestPhoneVerificationCodeDocument = gql`
  mutation requestPhoneVerificationCode(
    $countryCode: String!
    $phoneNumber: String!
  ) {
    requestPhoneVerificationCode(
      countryCode: $countryCode
      phoneNumber: $phoneNumber
    ) {
      response {
        success
        error
        trackingInfo
      }
    }
  }
`;
export type RequestPhoneVerificationCodeMutationFn = Apollo.MutationFunction<
  RequestPhoneVerificationCodeMutation,
  RequestPhoneVerificationCodeMutationVariables
>;

/**
 * __useRequestPhoneVerificationCodeMutation__
 *
 * To run a mutation, you first call `useRequestPhoneVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPhoneVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPhoneVerificationCodeMutation, { data, loading, error }] = useRequestPhoneVerificationCodeMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useRequestPhoneVerificationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPhoneVerificationCodeMutation,
    RequestPhoneVerificationCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestPhoneVerificationCodeMutation,
    RequestPhoneVerificationCodeMutationVariables
  >(RequestPhoneVerificationCodeDocument, options);
}
export type RequestPhoneVerificationCodeMutationHookResult = ReturnType<
  typeof useRequestPhoneVerificationCodeMutation
>;
export type RequestPhoneVerificationCodeMutationResult =
  Apollo.MutationResult<RequestPhoneVerificationCodeMutation>;
export type RequestPhoneVerificationCodeMutationOptions =
  Apollo.BaseMutationOptions<
    RequestPhoneVerificationCodeMutation,
    RequestPhoneVerificationCodeMutationVariables
  >;
export const ConfirmPhoneVerificationCodeDocument = gql`
  mutation confirmPhoneVerificationCode(
    $countryCode: String!
    $phoneNumber: String!
    $verificationCode: String!
  ) {
    confirmPhoneVerificationCode(
      countryCode: $countryCode
      phoneNumber: $phoneNumber
      verificationCode: $verificationCode
    ) {
      response {
        success
        error
        trackingInfo
      }
    }
  }
`;
export type ConfirmPhoneVerificationCodeMutationFn = Apollo.MutationFunction<
  ConfirmPhoneVerificationCodeMutation,
  ConfirmPhoneVerificationCodeMutationVariables
>;

/**
 * __useConfirmPhoneVerificationCodeMutation__
 *
 * To run a mutation, you first call `useConfirmPhoneVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPhoneVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPhoneVerificationCodeMutation, { data, loading, error }] = useConfirmPhoneVerificationCodeMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useConfirmPhoneVerificationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmPhoneVerificationCodeMutation,
    ConfirmPhoneVerificationCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfirmPhoneVerificationCodeMutation,
    ConfirmPhoneVerificationCodeMutationVariables
  >(ConfirmPhoneVerificationCodeDocument, options);
}
export type ConfirmPhoneVerificationCodeMutationHookResult = ReturnType<
  typeof useConfirmPhoneVerificationCodeMutation
>;
export type ConfirmPhoneVerificationCodeMutationResult =
  Apollo.MutationResult<ConfirmPhoneVerificationCodeMutation>;
export type ConfirmPhoneVerificationCodeMutationOptions =
  Apollo.BaseMutationOptions<
    ConfirmPhoneVerificationCodeMutation,
    ConfirmPhoneVerificationCodeMutationVariables
  >;
export const UpdateAccountDocument = gql`
  mutation UpdateAccount($accountSettingsInput: AccountSettingsInput!) {
    updateAccountSettings(accountSettingsInput: $accountSettingsInput) {
      account {
        id
        marketingOptIn
      }
    }
  }
`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<
  UpdateAccountMutation,
  UpdateAccountMutationVariables
>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      accountSettingsInput: // value for 'accountSettingsInput'
 *   },
 * });
 */
export function useUpdateAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccountMutation,
    UpdateAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAccountMutation,
    UpdateAccountMutationVariables
  >(UpdateAccountDocument, options);
}
export type UpdateAccountMutationHookResult = ReturnType<
  typeof useUpdateAccountMutation
>;
export type UpdateAccountMutationResult =
  Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountMutation,
  UpdateAccountMutationVariables
>;
export const EmailHasBeenTakenDocument = gql`
  query EmailHasBeenTaken($email: String!) {
    emailHasBeenTaken(email: $email) {
      used
    }
  }
`;

/**
 * __useEmailHasBeenTakenQuery__
 *
 * To run a query within a React component, call `useEmailHasBeenTakenQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailHasBeenTakenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailHasBeenTakenQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailHasBeenTakenQuery(
  baseOptions: Apollo.QueryHookOptions<
    EmailHasBeenTakenQuery,
    EmailHasBeenTakenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EmailHasBeenTakenQuery,
    EmailHasBeenTakenQueryVariables
  >(EmailHasBeenTakenDocument, options);
}
export function useEmailHasBeenTakenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmailHasBeenTakenQuery,
    EmailHasBeenTakenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EmailHasBeenTakenQuery,
    EmailHasBeenTakenQueryVariables
  >(EmailHasBeenTakenDocument, options);
}
export type EmailHasBeenTakenQueryHookResult = ReturnType<
  typeof useEmailHasBeenTakenQuery
>;
export type EmailHasBeenTakenLazyQueryHookResult = ReturnType<
  typeof useEmailHasBeenTakenLazyQuery
>;
export type EmailHasBeenTakenQueryResult = Apollo.QueryResult<
  EmailHasBeenTakenQuery,
  EmailHasBeenTakenQueryVariables
>;
export const AccountBookingsDocument = gql`
  query AccountBookings {
    account {
      id
      bookings {
        id
        uniqKey
        name
        checkInTime
        checkOutTime
        accessHoursAvailableBeforeCheckIn
        invoice {
          invoicePdfUrl
        }
        inquiryState
        accessInstructions
        access {
          isInPersonCheckin
          isLockboxRequired
          lockboxCode
          isBuildingAccessRequired
          buildingAccessType
          buildingAccessCode
          isElevatorAccessRequired
          elevatorAccessType
          elevatorAccessCode
          unitAccessType
          unitAccessCode
          keycafeCode
        }
        rentalSiteName
        unit {
          city {
            name
            servicePartners {
              categoryKey
              descriptionLong
              displayName
              url
            }
          }
          building {
            fullAddress
          }
          aptNumber
          latitude
          longitude
          sleeps
          closestMetroStation
          parkingDetails
          parkingTypes {
            freeParkingLotDetails
            freeStreetParkingDetails
            paidParkingLotDetails
            paidStreetParkingDetails
            privateParkingDetails
          }
          storageLocation {
            guestFacingTextArray
          }
          wifiSsid
          wifiPassword
        }
      }
    }
  }
`;

/**
 * __useAccountBookingsQuery__
 *
 * To run a query within a React component, call `useAccountBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBookingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountBookingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountBookingsQuery,
    AccountBookingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountBookingsQuery, AccountBookingsQueryVariables>(
    AccountBookingsDocument,
    options,
  );
}
export function useAccountBookingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountBookingsQuery,
    AccountBookingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountBookingsQuery,
    AccountBookingsQueryVariables
  >(AccountBookingsDocument, options);
}
export type AccountBookingsQueryHookResult = ReturnType<
  typeof useAccountBookingsQuery
>;
export type AccountBookingsLazyQueryHookResult = ReturnType<
  typeof useAccountBookingsLazyQuery
>;
export type AccountBookingsQueryResult = Apollo.QueryResult<
  AccountBookingsQuery,
  AccountBookingsQueryVariables
>;
export const CountryCodesDocument = gql`
  query CountryCodes($requiredStatesFor: [String!]) {
    countryCodes(requiredStatesFor: $requiredStatesFor) {
      alpha2
      alpha3
      name
      code
      states {
        name
        alpha2
      }
    }
  }
`;

/**
 * __useCountryCodesQuery__
 *
 * To run a query within a React component, call `useCountryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryCodesQuery({
 *   variables: {
 *      requiredStatesFor: // value for 'requiredStatesFor'
 *   },
 * });
 */
export function useCountryCodesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CountryCodesQuery,
    CountryCodesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountryCodesQuery, CountryCodesQueryVariables>(
    CountryCodesDocument,
    options,
  );
}
export function useCountryCodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountryCodesQuery,
    CountryCodesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountryCodesQuery, CountryCodesQueryVariables>(
    CountryCodesDocument,
    options,
  );
}
export type CountryCodesQueryHookResult = ReturnType<
  typeof useCountryCodesQuery
>;
export type CountryCodesLazyQueryHookResult = ReturnType<
  typeof useCountryCodesLazyQuery
>;
export type CountryCodesQueryResult = Apollo.QueryResult<
  CountryCodesQuery,
  CountryCodesQueryVariables
>;
export const CreateFlexLeaseInquiryDocument = gql`
  mutation createFlexLeaseInquiry(
    $listingId: ID
    $firstName: String!
    $lastName: String!
    $phone: String!
    $dealBreakers: String!
    $email: String!
    $moveInOn: String
    $moveOutOn: String
    $occupation: String!
    $sleeps: Int
    $city: String
    $bedrooms: Int
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmContent: String
    $utmTerm: String
    $initialReferrer: String
    $source: String
  ) {
    createFlexLeaseInquiry(
      listingId: $listingId
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      dealBreakers: $dealBreakers
      email: $email
      moveInOn: $moveInOn
      moveOutOn: $moveOutOn
      occupation: $occupation
      sleeps: $sleeps
      city: $city
      bedrooms: $bedrooms
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmContent: $utmContent
      utmTerm: $utmTerm
      initialReferrer: $initialReferrer
      source: $source
    ) {
      response {
        success
        error
        trackingInfo
      }
    }
  }
`;
export type CreateFlexLeaseInquiryMutationFn = Apollo.MutationFunction<
  CreateFlexLeaseInquiryMutation,
  CreateFlexLeaseInquiryMutationVariables
>;

/**
 * __useCreateFlexLeaseInquiryMutation__
 *
 * To run a mutation, you first call `useCreateFlexLeaseInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlexLeaseInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlexLeaseInquiryMutation, { data, loading, error }] = useCreateFlexLeaseInquiryMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      dealBreakers: // value for 'dealBreakers'
 *      email: // value for 'email'
 *      moveInOn: // value for 'moveInOn'
 *      moveOutOn: // value for 'moveOutOn'
 *      occupation: // value for 'occupation'
 *      sleeps: // value for 'sleeps'
 *      city: // value for 'city'
 *      bedrooms: // value for 'bedrooms'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      utmContent: // value for 'utmContent'
 *      utmTerm: // value for 'utmTerm'
 *      initialReferrer: // value for 'initialReferrer'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCreateFlexLeaseInquiryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFlexLeaseInquiryMutation,
    CreateFlexLeaseInquiryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFlexLeaseInquiryMutation,
    CreateFlexLeaseInquiryMutationVariables
  >(CreateFlexLeaseInquiryDocument, options);
}
export type CreateFlexLeaseInquiryMutationHookResult = ReturnType<
  typeof useCreateFlexLeaseInquiryMutation
>;
export type CreateFlexLeaseInquiryMutationResult =
  Apollo.MutationResult<CreateFlexLeaseInquiryMutation>;
export type CreateFlexLeaseInquiryMutationOptions = Apollo.BaseMutationOptions<
  CreateFlexLeaseInquiryMutation,
  CreateFlexLeaseInquiryMutationVariables
>;
export const OtaBookingQueryDocument = gql`
  query OTABookingQuery($bookingUniqKey: String!) {
    otaBooking(bookingUniqKey: $bookingUniqKey) {
      guestInfo {
        email
        firstName
        lastName
        countryAlpha2
        countryCode
        phoneNumber
        dateOfBirth
        isBgcNeeded
      }
      productInfo {
        image
        title
        subtitle
        checkInDateLabel
        checkOutDateLabel
        numberOfNights
        stayLengthLabel
      }
      inquiry {
        account {
          id: normalizedId
        }
        id: normalizedId
      }
    }
  }
`;

/**
 * __useOtaBookingQueryQuery__
 *
 * To run a query within a React component, call `useOtaBookingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtaBookingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtaBookingQueryQuery({
 *   variables: {
 *      bookingUniqKey: // value for 'bookingUniqKey'
 *   },
 * });
 */
export function useOtaBookingQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    OtaBookingQueryQuery,
    OtaBookingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OtaBookingQueryQuery, OtaBookingQueryQueryVariables>(
    OtaBookingQueryDocument,
    options,
  );
}
export function useOtaBookingQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OtaBookingQueryQuery,
    OtaBookingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OtaBookingQueryQuery,
    OtaBookingQueryQueryVariables
  >(OtaBookingQueryDocument, options);
}
export type OtaBookingQueryQueryHookResult = ReturnType<
  typeof useOtaBookingQueryQuery
>;
export type OtaBookingQueryLazyQueryHookResult = ReturnType<
  typeof useOtaBookingQueryLazyQuery
>;
export type OtaBookingQueryQueryResult = Apollo.QueryResult<
  OtaBookingQueryQuery,
  OtaBookingQueryQueryVariables
>;
export const GetMinimumNightsDocument = gql`
  query GetMinimumNights($checkInDate: String!, $city: String!) {
    minimumNights(checkInDate: $checkInDate, city: $city) {
      value
    }
  }
`;

/**
 * __useGetMinimumNightsQuery__
 *
 * To run a query within a React component, call `useGetMinimumNightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinimumNightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinimumNightsQuery({
 *   variables: {
 *      checkInDate: // value for 'checkInDate'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useGetMinimumNightsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMinimumNightsQuery,
    GetMinimumNightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMinimumNightsQuery, GetMinimumNightsQueryVariables>(
    GetMinimumNightsDocument,
    options,
  );
}
export function useGetMinimumNightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMinimumNightsQuery,
    GetMinimumNightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMinimumNightsQuery,
    GetMinimumNightsQueryVariables
  >(GetMinimumNightsDocument, options);
}
export type GetMinimumNightsQueryHookResult = ReturnType<
  typeof useGetMinimumNightsQuery
>;
export type GetMinimumNightsLazyQueryHookResult = ReturnType<
  typeof useGetMinimumNightsLazyQuery
>;
export type GetMinimumNightsQueryResult = Apollo.QueryResult<
  GetMinimumNightsQuery,
  GetMinimumNightsQueryVariables
>;
export const TrackEventDocument = gql`
  mutation TrackEvent(
    $anonymousId: String!
    $eventName: String!
    $eventPayload: String!
    $context: String!
    $environment: String!
  ) {
    trackEvent(
      anonymousId: $anonymousId
      eventName: $eventName
      eventPayload: $eventPayload
      context: $context
      environment: $environment
    ) {
      response {
        success
        error
        eventName
        eventPayload
      }
    }
  }
`;
export type TrackEventMutationFn = Apollo.MutationFunction<
  TrackEventMutation,
  TrackEventMutationVariables
>;

/**
 * __useTrackEventMutation__
 *
 * To run a mutation, you first call `useTrackEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackEventMutation, { data, loading, error }] = useTrackEventMutation({
 *   variables: {
 *      anonymousId: // value for 'anonymousId'
 *      eventName: // value for 'eventName'
 *      eventPayload: // value for 'eventPayload'
 *      context: // value for 'context'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useTrackEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackEventMutation,
    TrackEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TrackEventMutation, TrackEventMutationVariables>(
    TrackEventDocument,
    options,
  );
}
export type TrackEventMutationHookResult = ReturnType<
  typeof useTrackEventMutation
>;
export type TrackEventMutationResult =
  Apollo.MutationResult<TrackEventMutation>;
export type TrackEventMutationOptions = Apollo.BaseMutationOptions<
  TrackEventMutation,
  TrackEventMutationVariables
>;
export const UpdateAccountPasswordDocument = gql`
  mutation UpdateAccountPassword(
    $resetPasswordToken: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    updateAccountPassword(
      resetPasswordToken: $resetPasswordToken
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      success
    }
  }
`;
export type UpdateAccountPasswordMutationFn = Apollo.MutationFunction<
  UpdateAccountPasswordMutation,
  UpdateAccountPasswordMutationVariables
>;

/**
 * __useUpdateAccountPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPasswordMutation, { data, loading, error }] = useUpdateAccountPasswordMutation({
 *   variables: {
 *      resetPasswordToken: // value for 'resetPasswordToken'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useUpdateAccountPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccountPasswordMutation,
    UpdateAccountPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAccountPasswordMutation,
    UpdateAccountPasswordMutationVariables
  >(UpdateAccountPasswordDocument, options);
}
export type UpdateAccountPasswordMutationHookResult = ReturnType<
  typeof useUpdateAccountPasswordMutation
>;
export type UpdateAccountPasswordMutationResult =
  Apollo.MutationResult<UpdateAccountPasswordMutation>;
export type UpdateAccountPasswordMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountPasswordMutation,
  UpdateAccountPasswordMutationVariables
>;
export const PrepareEciLcoInvoiceDocument = gql`
  mutation PrepareEciLcoInvoice(
    $subjectId: ID!
    $earlyCheckIn: RFC3339DateTime
    $lateCheckOut: RFC3339DateTime
    $missingDesiredCheckInTime: Boolean
    $missingDesiredCheckOutTime: Boolean
    $source: String
  ) {
    prepareEciLcoInvoice(
      subjectId: $subjectId
      earlyCheckIn: $earlyCheckIn
      lateCheckOut: $lateCheckOut
      missingDesiredCheckInTime: $missingDesiredCheckInTime
      missingDesiredCheckOutTime: $missingDesiredCheckOutTime
      source: $source
    ) {
      invoice {
        id
        totalAmount
        currency
        lineItems {
          type
          description
          displayName
          totalAmount
          refundableOnCancellation
        }
      }
    }
  }
`;
export type PrepareEciLcoInvoiceMutationFn = Apollo.MutationFunction<
  PrepareEciLcoInvoiceMutation,
  PrepareEciLcoInvoiceMutationVariables
>;

/**
 * __usePrepareEciLcoInvoiceMutation__
 *
 * To run a mutation, you first call `usePrepareEciLcoInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareEciLcoInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareEciLcoInvoiceMutation, { data, loading, error }] = usePrepareEciLcoInvoiceMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      earlyCheckIn: // value for 'earlyCheckIn'
 *      lateCheckOut: // value for 'lateCheckOut'
 *      missingDesiredCheckInTime: // value for 'missingDesiredCheckInTime'
 *      missingDesiredCheckOutTime: // value for 'missingDesiredCheckOutTime'
 *      source: // value for 'source'
 *   },
 * });
 */
export function usePrepareEciLcoInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PrepareEciLcoInvoiceMutation,
    PrepareEciLcoInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PrepareEciLcoInvoiceMutation,
    PrepareEciLcoInvoiceMutationVariables
  >(PrepareEciLcoInvoiceDocument, options);
}
export type PrepareEciLcoInvoiceMutationHookResult = ReturnType<
  typeof usePrepareEciLcoInvoiceMutation
>;
export type PrepareEciLcoInvoiceMutationResult =
  Apollo.MutationResult<PrepareEciLcoInvoiceMutation>;
export type PrepareEciLcoInvoiceMutationOptions = Apollo.BaseMutationOptions<
  PrepareEciLcoInvoiceMutation,
  PrepareEciLcoInvoiceMutationVariables
>;
export const AvailableEciLcoTimesQueryDocument = gql`
  query AvailableEciLcoTimesQuery($inquiryId: ID!) {
    availableEciLcoTimes(inquiryId: $inquiryId) {
      eciTimes {
        available
        price
        time
        displayTime
        isTheSameAsExistingTime
      }
      lcoTimes {
        available
        price
        time
        displayTime
        isTheSameAsExistingTime
      }
      checkOutTime
      checkInTime
    }
  }
`;

/**
 * __useAvailableEciLcoTimesQueryQuery__
 *
 * To run a query within a React component, call `useAvailableEciLcoTimesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableEciLcoTimesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableEciLcoTimesQueryQuery({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *   },
 * });
 */
export function useAvailableEciLcoTimesQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    AvailableEciLcoTimesQueryQuery,
    AvailableEciLcoTimesQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AvailableEciLcoTimesQueryQuery,
    AvailableEciLcoTimesQueryQueryVariables
  >(AvailableEciLcoTimesQueryDocument, options);
}
export function useAvailableEciLcoTimesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableEciLcoTimesQueryQuery,
    AvailableEciLcoTimesQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableEciLcoTimesQueryQuery,
    AvailableEciLcoTimesQueryQueryVariables
  >(AvailableEciLcoTimesQueryDocument, options);
}
export type AvailableEciLcoTimesQueryQueryHookResult = ReturnType<
  typeof useAvailableEciLcoTimesQueryQuery
>;
export type AvailableEciLcoTimesQueryLazyQueryHookResult = ReturnType<
  typeof useAvailableEciLcoTimesQueryLazyQuery
>;
export type AvailableEciLcoTimesQueryQueryResult = Apollo.QueryResult<
  AvailableEciLcoTimesQueryQuery,
  AvailableEciLcoTimesQueryQueryVariables
>;
export const BookingQueryDocument = gql`
  query BookingQuery($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      unit {
        timezone
      }
      actions {
        type
        externalUrl
      }
    }
  }
`;

/**
 * __useBookingQueryQuery__
 *
 * To run a query within a React component, call `useBookingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQueryQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingQueryQuery,
    BookingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingQueryQuery, BookingQueryQueryVariables>(
    BookingQueryDocument,
    options,
  );
}
export function useBookingQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingQueryQuery,
    BookingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingQueryQuery, BookingQueryQueryVariables>(
    BookingQueryDocument,
    options,
  );
}
export type BookingQueryQueryHookResult = ReturnType<
  typeof useBookingQueryQuery
>;
export type BookingQueryLazyQueryHookResult = ReturnType<
  typeof useBookingQueryLazyQuery
>;
export type BookingQueryQueryResult = Apollo.QueryResult<
  BookingQueryQuery,
  BookingQueryQueryVariables
>;
export const MakeAsyncBookingPaymentMutationDocument = gql`
  mutation MakeAsyncBookingPaymentMutation(
    $collectionId: ID
    $inquiryPaymentKey: String!
    $receivableInvoiceId: ID
    $accountId: ID
    $promoCodes: [String!]!
    $ancillaryServices: [AncillaryServiceInput!]
    $ratePlanId: ID
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String
    $addressStreet: String
    $addressApt: String
    $addressCity: String
    $addressState: String
    $addressCountry: String
    $addressZipcode: String
    $countryAlpha2: String!
    $countryCode: String!
    $phoneNumber: String!
    $dateOfBirth: String!
    $marketingOptIn: Boolean!
    $paymentMethodId: String
    $paymentIntentId: String
    $paymentMethodDetails: String
    $billingZipcode: String
    $billingFirstName: String
    $billingLastName: String
    $savePaymentMethod: Boolean
    $redirectUri: String
    $bookingAgreementId: ID
    $loyaltyInfo: LoyaltyInfoInput
  ) {
    makeAsyncBookingPayment(
      collectionId: $collectionId
      inquiryPaymentKey: $inquiryPaymentKey
      receivableInvoiceId: $receivableInvoiceId
      accountId: $accountId
      promoCodes: $promoCodes
      ancillaryServices: $ancillaryServices
      ratePlanId: $ratePlanId
      redirectUri: $redirectUri
      guestInfo: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
        countryAlpha2: $countryAlpha2
        countryCode: $countryCode
        phoneNumber: $phoneNumber
        dateOfBirth: $dateOfBirth
        marketingOptIn: $marketingOptIn
        addressStreet: $addressStreet
        addressApt: $addressApt
        addressCity: $addressCity
        addressState: $addressState
        addressCountry: $addressCountry
        addressZipcode: $addressZipcode
      }
      paymentInfo: {
        paymentMethodId: $paymentMethodId
        paymentIntentId: $paymentIntentId
        paymentMethodDetails: $paymentMethodDetails
        billingFirstName: $billingFirstName
        billingLastName: $billingLastName
        billingZipcode: $billingZipcode
        savePaymentMethod: $savePaymentMethod
      }
      loyaltyInfo: $loyaltyInfo
      bookingAgreementId: $bookingAgreementId
    ) {
      response {
        success
        error
        checkoutProcessId
      }
    }
  }
`;
export type MakeAsyncBookingPaymentMutationMutationFn = Apollo.MutationFunction<
  MakeAsyncBookingPaymentMutationMutation,
  MakeAsyncBookingPaymentMutationMutationVariables
>;

/**
 * __useMakeAsyncBookingPaymentMutationMutation__
 *
 * To run a mutation, you first call `useMakeAsyncBookingPaymentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeAsyncBookingPaymentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeAsyncBookingPaymentMutationMutation, { data, loading, error }] = useMakeAsyncBookingPaymentMutationMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      inquiryPaymentKey: // value for 'inquiryPaymentKey'
 *      receivableInvoiceId: // value for 'receivableInvoiceId'
 *      accountId: // value for 'accountId'
 *      promoCodes: // value for 'promoCodes'
 *      ancillaryServices: // value for 'ancillaryServices'
 *      ratePlanId: // value for 'ratePlanId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      addressStreet: // value for 'addressStreet'
 *      addressApt: // value for 'addressApt'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressCountry: // value for 'addressCountry'
 *      addressZipcode: // value for 'addressZipcode'
 *      countryAlpha2: // value for 'countryAlpha2'
 *      countryCode: // value for 'countryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      marketingOptIn: // value for 'marketingOptIn'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      paymentIntentId: // value for 'paymentIntentId'
 *      paymentMethodDetails: // value for 'paymentMethodDetails'
 *      billingZipcode: // value for 'billingZipcode'
 *      billingFirstName: // value for 'billingFirstName'
 *      billingLastName: // value for 'billingLastName'
 *      savePaymentMethod: // value for 'savePaymentMethod'
 *      redirectUri: // value for 'redirectUri'
 *      bookingAgreementId: // value for 'bookingAgreementId'
 *      loyaltyInfo: // value for 'loyaltyInfo'
 *   },
 * });
 */
export function useMakeAsyncBookingPaymentMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeAsyncBookingPaymentMutationMutation,
    MakeAsyncBookingPaymentMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeAsyncBookingPaymentMutationMutation,
    MakeAsyncBookingPaymentMutationMutationVariables
  >(MakeAsyncBookingPaymentMutationDocument, options);
}
export type MakeAsyncBookingPaymentMutationMutationHookResult = ReturnType<
  typeof useMakeAsyncBookingPaymentMutationMutation
>;
export type MakeAsyncBookingPaymentMutationMutationResult =
  Apollo.MutationResult<MakeAsyncBookingPaymentMutationMutation>;
export type MakeAsyncBookingPaymentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    MakeAsyncBookingPaymentMutationMutation,
    MakeAsyncBookingPaymentMutationMutationVariables
  >;
export const UpdatePetDocument = gql`
  mutation UpdatePet(
    $inquiryKey: String!
    $petId: Int
    $name: String!
    $kind: PetKind!
    $breed: String!
    $weight: Int!
  ) {
    updatePet(
      inquiryKey: $inquiryKey
      petId: $petId
      kind: $kind
      name: $name
      breed: $breed
      weight: $weight
    ) {
      response {
        success
        error
      }
    }
  }
`;
export type UpdatePetMutationFn = Apollo.MutationFunction<
  UpdatePetMutation,
  UpdatePetMutationVariables
>;

/**
 * __useUpdatePetMutation__
 *
 * To run a mutation, you first call `useUpdatePetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetMutation, { data, loading, error }] = useUpdatePetMutation({
 *   variables: {
 *      inquiryKey: // value for 'inquiryKey'
 *      petId: // value for 'petId'
 *      name: // value for 'name'
 *      kind: // value for 'kind'
 *      breed: // value for 'breed'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdatePetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePetMutation,
    UpdatePetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePetMutation, UpdatePetMutationVariables>(
    UpdatePetDocument,
    options,
  );
}
export type UpdatePetMutationHookResult = ReturnType<
  typeof useUpdatePetMutation
>;
export type UpdatePetMutationResult = Apollo.MutationResult<UpdatePetMutation>;
export type UpdatePetMutationOptions = Apollo.BaseMutationOptions<
  UpdatePetMutation,
  UpdatePetMutationVariables
>;
export const RemovePetDocument = gql`
  mutation RemovePet($inquiryKey: String!, $petId: Int!) {
    removePet(inquiryKey: $inquiryKey, petId: $petId) {
      response {
        success
        error
      }
    }
  }
`;
export type RemovePetMutationFn = Apollo.MutationFunction<
  RemovePetMutation,
  RemovePetMutationVariables
>;

/**
 * __useRemovePetMutation__
 *
 * To run a mutation, you first call `useRemovePetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePetMutation, { data, loading, error }] = useRemovePetMutation({
 *   variables: {
 *      inquiryKey: // value for 'inquiryKey'
 *      petId: // value for 'petId'
 *   },
 * });
 */
export function useRemovePetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePetMutation,
    RemovePetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemovePetMutation, RemovePetMutationVariables>(
    RemovePetDocument,
    options,
  );
}
export type RemovePetMutationHookResult = ReturnType<
  typeof useRemovePetMutation
>;
export type RemovePetMutationResult = Apollo.MutationResult<RemovePetMutation>;
export type RemovePetMutationOptions = Apollo.BaseMutationOptions<
  RemovePetMutation,
  RemovePetMutationVariables
>;
export const CheckoutQueryDocument = gql`
  query CheckoutQuery(
    $collectionId: String
    $inquiryId: String
    $inquiryPaymentKey: String!
    $promoCodes: [String!]!
    $receivableInvoiceId: String
    $inEu: Boolean!
    $type: String
  ) {
    checkout(
      collectionId: $collectionId
      inquiryId: $inquiryId
      inquiryPaymentKey: $inquiryPaymentKey
      promoCodes: $promoCodes
      receivableInvoiceId: $receivableInvoiceId
      clientInfo: { inEu: $inEu }
      type: $type
    ) {
      guestInfo {
        dateOfBirth
        email
        firstName
        lastName
        phoneNumber
        countryAlpha2
        countryCode
        discountPricingMember
        marketingOptIn
        isFilled
        isBgcNeeded
        previousBookingsCount
      }
      loyaltyInfos {
        maskedGuestLoyaltyId
        loyaltyProgramId
      }
      paymentInfo {
        currency
        savedPaymentMethods {
          id
          brand
          last4
        }
        paymentGateway
        paymentMethodId
        paymentCreationDetails {
          gatewayName
          details
        }
      }
      productInfo {
        title
        building
        subtitle
        productId
        listingId
        unitId
        city
        state
        country
        image
        checkInDate
        checkOutDate
        checkInDateLabel
        checkOutDateLabel
        checkInDow
        checkOutDow
        ratingAverage
        ratingState
        ratingTotal
        stayLength
        stayLengthLabel
        stayType
        numberOfGuests
        numberOfNights
        gdsBooking
      }
      ltsInfo {
        ltsEnabled
        bookingAgreementId
        bookingAgreementText
      }
      inquiryId
      isUnavailable
      listingUrl
    }
  }
`;

/**
 * __useCheckoutQueryQuery__
 *
 * To run a query within a React component, call `useCheckoutQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQueryQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      inquiryId: // value for 'inquiryId'
 *      inquiryPaymentKey: // value for 'inquiryPaymentKey'
 *      promoCodes: // value for 'promoCodes'
 *      receivableInvoiceId: // value for 'receivableInvoiceId'
 *      inEu: // value for 'inEu'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCheckoutQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckoutQueryQuery,
    CheckoutQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckoutQueryQuery, CheckoutQueryQueryVariables>(
    CheckoutQueryDocument,
    options,
  );
}
export function useCheckoutQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckoutQueryQuery,
    CheckoutQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckoutQueryQuery, CheckoutQueryQueryVariables>(
    CheckoutQueryDocument,
    options,
  );
}
export type CheckoutQueryQueryHookResult = ReturnType<
  typeof useCheckoutQueryQuery
>;
export type CheckoutQueryLazyQueryHookResult = ReturnType<
  typeof useCheckoutQueryLazyQuery
>;
export type CheckoutQueryQueryResult = Apollo.QueryResult<
  CheckoutQueryQuery,
  CheckoutQueryQueryVariables
>;
export const CheckoutInvoiceQueryDocument = gql`
  query CheckoutInvoiceQuery(
    $collectionId: String
    $inquiryId: String
    $inquiryPaymentKey: String!
    $promoCodes: [String!]!
    $ancillaryServices: [AncillaryServiceInput!]
    $receivableInvoiceId: String
    $inEu: Boolean!
    $targetCurrency: String
    $type: String
  ) {
    checkoutInvoice(
      collectionId: $collectionId
      inquiryId: $inquiryId
      inquiryPaymentKey: $inquiryPaymentKey
      promoCodes: $promoCodes
      ancillaryServices: $ancillaryServices
      receivableInvoiceId: $receivableInvoiceId
      clientInfo: { inEu: $inEu }
      targetCurrency: $targetCurrency
      type: $type
    ) {
      appliedPromoCodes
      invoiceInfo {
        ...InvoiceInfoFields
      }
      promoError
      rateInfo {
        memberRate
        ratePlans {
          id
          name
          shortDescription
          description
          markedUpNightlyRateLabel
          effectiveNightlyRateLabel
          invoiceInfo {
            ...InvoiceInfoFields
          }
          capabilityMessages
        }
      }
      remainingUnitsCount
    }
  }
  ${InvoiceInfoFieldsFragmentDoc}
`;

/**
 * __useCheckoutInvoiceQueryQuery__
 *
 * To run a query within a React component, call `useCheckoutInvoiceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutInvoiceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutInvoiceQueryQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      inquiryId: // value for 'inquiryId'
 *      inquiryPaymentKey: // value for 'inquiryPaymentKey'
 *      promoCodes: // value for 'promoCodes'
 *      ancillaryServices: // value for 'ancillaryServices'
 *      receivableInvoiceId: // value for 'receivableInvoiceId'
 *      inEu: // value for 'inEu'
 *      targetCurrency: // value for 'targetCurrency'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCheckoutInvoiceQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckoutInvoiceQueryQuery,
    CheckoutInvoiceQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckoutInvoiceQueryQuery,
    CheckoutInvoiceQueryQueryVariables
  >(CheckoutInvoiceQueryDocument, options);
}
export function useCheckoutInvoiceQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckoutInvoiceQueryQuery,
    CheckoutInvoiceQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckoutInvoiceQueryQuery,
    CheckoutInvoiceQueryQueryVariables
  >(CheckoutInvoiceQueryDocument, options);
}
export type CheckoutInvoiceQueryQueryHookResult = ReturnType<
  typeof useCheckoutInvoiceQueryQuery
>;
export type CheckoutInvoiceQueryLazyQueryHookResult = ReturnType<
  typeof useCheckoutInvoiceQueryLazyQuery
>;
export type CheckoutInvoiceQueryQueryResult = Apollo.QueryResult<
  CheckoutInvoiceQueryQuery,
  CheckoutInvoiceQueryQueryVariables
>;
export const CheckoutProcessQueryDocument = gql`
  query CheckoutProcessQuery($checkoutProcessId: String!) {
    checkoutProcess(checkoutProcessId: $checkoutProcessId) {
      status
      paymentGateway
      actionDetails
      paymentIntentClientSecret
      redirectUri
      authResultAvailable
      authSuccess
      authError
      trackingInfo
      jwt
    }
  }
`;

/**
 * __useCheckoutProcessQueryQuery__
 *
 * To run a query within a React component, call `useCheckoutProcessQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutProcessQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutProcessQueryQuery({
 *   variables: {
 *      checkoutProcessId: // value for 'checkoutProcessId'
 *   },
 * });
 */
export function useCheckoutProcessQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckoutProcessQueryQuery,
    CheckoutProcessQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckoutProcessQueryQuery,
    CheckoutProcessQueryQueryVariables
  >(CheckoutProcessQueryDocument, options);
}
export function useCheckoutProcessQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckoutProcessQueryQuery,
    CheckoutProcessQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckoutProcessQueryQuery,
    CheckoutProcessQueryQueryVariables
  >(CheckoutProcessQueryDocument, options);
}
export type CheckoutProcessQueryQueryHookResult = ReturnType<
  typeof useCheckoutProcessQueryQuery
>;
export type CheckoutProcessQueryLazyQueryHookResult = ReturnType<
  typeof useCheckoutProcessQueryLazyQuery
>;
export type CheckoutProcessQueryQueryResult = Apollo.QueryResult<
  CheckoutProcessQueryQuery,
  CheckoutProcessQueryQueryVariables
>;
export const AncillaryServicesDocument = gql`
  query AncillaryServices(
    $inquiryId: String
    $bookingUniqKey: String
    $targetCurrency: String
  ) {
    ancillaryServices(
      inquiryId: $inquiryId
      bookingUniqKey: $bookingUniqKey
      targetCurrency: $targetCurrency
    ) {
      displayPrice
      feeType
      name
      price
      booked
    }
  }
`;

/**
 * __useAncillaryServicesQuery__
 *
 * To run a query within a React component, call `useAncillaryServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAncillaryServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAncillaryServicesQuery({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *      bookingUniqKey: // value for 'bookingUniqKey'
 *      targetCurrency: // value for 'targetCurrency'
 *   },
 * });
 */
export function useAncillaryServicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AncillaryServicesQuery,
    AncillaryServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AncillaryServicesQuery,
    AncillaryServicesQueryVariables
  >(AncillaryServicesDocument, options);
}
export function useAncillaryServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AncillaryServicesQuery,
    AncillaryServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AncillaryServicesQuery,
    AncillaryServicesQueryVariables
  >(AncillaryServicesDocument, options);
}
export type AncillaryServicesQueryHookResult = ReturnType<
  typeof useAncillaryServicesQuery
>;
export type AncillaryServicesLazyQueryHookResult = ReturnType<
  typeof useAncillaryServicesLazyQuery
>;
export type AncillaryServicesQueryResult = Apollo.QueryResult<
  AncillaryServicesQuery,
  AncillaryServicesQueryVariables
>;
export const UpgradeServiceDocument = gql`
  query UpgradeService(
    $inquiryId: String
    $bookingUniqKey: String
    $targetCurrency: String
    $collectionId: Int
  ) {
    upgradeService(
      inquiryId: $inquiryId
      bookingUniqKey: $bookingUniqKey
      targetCurrency: $targetCurrency
      collectionId: $collectionId
    ) {
      displayPrice
      price
      scheduleType
      type
      subType
      booked
      upgradeRestrictions {
        maxBookable
        minBookable
      }
      upgradeDetails {
        timeAvailable
      }
    }
  }
`;

/**
 * __useUpgradeServiceQuery__
 *
 * To run a query within a React component, call `useUpgradeServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpgradeServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpgradeServiceQuery({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *      bookingUniqKey: // value for 'bookingUniqKey'
 *      targetCurrency: // value for 'targetCurrency'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useUpgradeServiceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UpgradeServiceQuery,
    UpgradeServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UpgradeServiceQuery, UpgradeServiceQueryVariables>(
    UpgradeServiceDocument,
    options,
  );
}
export function useUpgradeServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpgradeServiceQuery,
    UpgradeServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UpgradeServiceQuery, UpgradeServiceQueryVariables>(
    UpgradeServiceDocument,
    options,
  );
}
export type UpgradeServiceQueryHookResult = ReturnType<
  typeof useUpgradeServiceQuery
>;
export type UpgradeServiceLazyQueryHookResult = ReturnType<
  typeof useUpgradeServiceLazyQuery
>;
export type UpgradeServiceQueryResult = Apollo.QueryResult<
  UpgradeServiceQuery,
  UpgradeServiceQueryVariables
>;
export const PetsDocument = gql`
  query Pets($inquiryKey: String!) {
    pets(inquiryKey: $inquiryKey) {
      id
      name
      kind
      breed
      weight
    }
  }
`;

/**
 * __usePetsQuery__
 *
 * To run a query within a React component, call `usePetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetsQuery({
 *   variables: {
 *      inquiryKey: // value for 'inquiryKey'
 *   },
 * });
 */
export function usePetsQuery(
  baseOptions: Apollo.QueryHookOptions<PetsQuery, PetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PetsQuery, PetsQueryVariables>(PetsDocument, options);
}
export function usePetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PetsQuery, PetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PetsQuery, PetsQueryVariables>(
    PetsDocument,
    options,
  );
}
export type PetsQueryHookResult = ReturnType<typeof usePetsQuery>;
export type PetsLazyQueryHookResult = ReturnType<typeof usePetsLazyQuery>;
export type PetsQueryResult = Apollo.QueryResult<PetsQuery, PetsQueryVariables>;
export const AvailableEciTimesDocument = gql`
  query AvailableEciTimes($uniqKey: String!) {
    availableEciTimes(uniqKey: $uniqKey) {
      checkInTime
      eciTimes {
        available
        price
        time
        isTheSameAsExistingTime
        displayPrice
        displayTime
        standardPrice
      }
      eciReason
      currency
    }
  }
`;

/**
 * __useAvailableEciTimesQuery__
 *
 * To run a query within a React component, call `useAvailableEciTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableEciTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableEciTimesQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useAvailableEciTimesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AvailableEciTimesQuery,
    AvailableEciTimesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AvailableEciTimesQuery,
    AvailableEciTimesQueryVariables
  >(AvailableEciTimesDocument, options);
}
export function useAvailableEciTimesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableEciTimesQuery,
    AvailableEciTimesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableEciTimesQuery,
    AvailableEciTimesQueryVariables
  >(AvailableEciTimesDocument, options);
}
export type AvailableEciTimesQueryHookResult = ReturnType<
  typeof useAvailableEciTimesQuery
>;
export type AvailableEciTimesLazyQueryHookResult = ReturnType<
  typeof useAvailableEciTimesLazyQuery
>;
export type AvailableEciTimesQueryResult = Apollo.QueryResult<
  AvailableEciTimesQuery,
  AvailableEciTimesQueryVariables
>;
export const SendAppDownloadLinkDocument = gql`
  mutation SendAppDownloadLink($confirmationCode: String!) {
    sendAppDownloadLink(confirmationCode: $confirmationCode) {
      response {
        success
        error
      }
    }
  }
`;
export type SendAppDownloadLinkMutationFn = Apollo.MutationFunction<
  SendAppDownloadLinkMutation,
  SendAppDownloadLinkMutationVariables
>;

/**
 * __useSendAppDownloadLinkMutation__
 *
 * To run a mutation, you first call `useSendAppDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAppDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAppDownloadLinkMutation, { data, loading, error }] = useSendAppDownloadLinkMutation({
 *   variables: {
 *      confirmationCode: // value for 'confirmationCode'
 *   },
 * });
 */
export function useSendAppDownloadLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendAppDownloadLinkMutation,
    SendAppDownloadLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendAppDownloadLinkMutation,
    SendAppDownloadLinkMutationVariables
  >(SendAppDownloadLinkDocument, options);
}
export type SendAppDownloadLinkMutationHookResult = ReturnType<
  typeof useSendAppDownloadLinkMutation
>;
export type SendAppDownloadLinkMutationResult =
  Apollo.MutationResult<SendAppDownloadLinkMutation>;
export type SendAppDownloadLinkMutationOptions = Apollo.BaseMutationOptions<
  SendAppDownloadLinkMutation,
  SendAppDownloadLinkMutationVariables
>;
export const UpdatePhoneNumberDocument = gql`
  mutation UpdatePhoneNumber($countryCode: String!, $phoneNumber: String!) {
    updatePhoneNumber(countryCode: $countryCode, phoneNumber: $phoneNumber) {
      response {
        success
        error
      }
    }
  }
`;
export type UpdatePhoneNumberMutationFn = Apollo.MutationFunction<
  UpdatePhoneNumberMutation,
  UpdatePhoneNumberMutationVariables
>;

/**
 * __useUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberMutation, { data, loading, error }] = useUpdatePhoneNumberMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdatePhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePhoneNumberMutation,
    UpdatePhoneNumberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePhoneNumberMutation,
    UpdatePhoneNumberMutationVariables
  >(UpdatePhoneNumberDocument, options);
}
export type UpdatePhoneNumberMutationHookResult = ReturnType<
  typeof useUpdatePhoneNumberMutation
>;
export type UpdatePhoneNumberMutationResult =
  Apollo.MutationResult<UpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  UpdatePhoneNumberMutation,
  UpdatePhoneNumberMutationVariables
>;
export const ResendPhoneVerificationCodeDocument = gql`
  mutation ResendPhoneVerificationCode {
    resendPhoneVerificationCode {
      response {
        success
        error
      }
    }
  }
`;
export type ResendPhoneVerificationCodeMutationFn = Apollo.MutationFunction<
  ResendPhoneVerificationCodeMutation,
  ResendPhoneVerificationCodeMutationVariables
>;

/**
 * __useResendPhoneVerificationCodeMutation__
 *
 * To run a mutation, you first call `useResendPhoneVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPhoneVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPhoneVerificationCodeMutation, { data, loading, error }] = useResendPhoneVerificationCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendPhoneVerificationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendPhoneVerificationCodeMutation,
    ResendPhoneVerificationCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendPhoneVerificationCodeMutation,
    ResendPhoneVerificationCodeMutationVariables
  >(ResendPhoneVerificationCodeDocument, options);
}
export type ResendPhoneVerificationCodeMutationHookResult = ReturnType<
  typeof useResendPhoneVerificationCodeMutation
>;
export type ResendPhoneVerificationCodeMutationResult =
  Apollo.MutationResult<ResendPhoneVerificationCodeMutation>;
export type ResendPhoneVerificationCodeMutationOptions =
  Apollo.BaseMutationOptions<
    ResendPhoneVerificationCodeMutation,
    ResendPhoneVerificationCodeMutationVariables
  >;
export const VerifyPhoneDocument = gql`
  mutation VerifyPhone($phoneNumber: String!, $code: String!) {
    verifyPhone(phoneNumber: $phoneNumber, code: $code)
  }
`;
export type VerifyPhoneMutationFn = Apollo.MutationFunction<
  VerifyPhoneMutation,
  VerifyPhoneMutationVariables
>;

/**
 * __useVerifyPhoneMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneMutation, { data, loading, error }] = useVerifyPhoneMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyPhoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyPhoneMutation,
    VerifyPhoneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyPhoneMutation, VerifyPhoneMutationVariables>(
    VerifyPhoneDocument,
    options,
  );
}
export type VerifyPhoneMutationHookResult = ReturnType<
  typeof useVerifyPhoneMutation
>;
export type VerifyPhoneMutationResult =
  Apollo.MutationResult<VerifyPhoneMutation>;
export type VerifyPhoneMutationOptions = Apollo.BaseMutationOptions<
  VerifyPhoneMutation,
  VerifyPhoneMutationVariables
>;
export const ResendConfirmationEmailDocument = gql`
  mutation ResendConfirmationEmail($confirmationCode: String!) {
    resendConfirmationEmail(confirmationCode: $confirmationCode) {
      response {
        success
        error
      }
    }
  }
`;
export type ResendConfirmationEmailMutationFn = Apollo.MutationFunction<
  ResendConfirmationEmailMutation,
  ResendConfirmationEmailMutationVariables
>;

/**
 * __useResendConfirmationEmailMutation__
 *
 * To run a mutation, you first call `useResendConfirmationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConfirmationEmailMutation, { data, loading, error }] = useResendConfirmationEmailMutation({
 *   variables: {
 *      confirmationCode: // value for 'confirmationCode'
 *   },
 * });
 */
export function useResendConfirmationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendConfirmationEmailMutation,
    ResendConfirmationEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendConfirmationEmailMutation,
    ResendConfirmationEmailMutationVariables
  >(ResendConfirmationEmailDocument, options);
}
export type ResendConfirmationEmailMutationHookResult = ReturnType<
  typeof useResendConfirmationEmailMutation
>;
export type ResendConfirmationEmailMutationResult =
  Apollo.MutationResult<ResendConfirmationEmailMutation>;
export type ResendConfirmationEmailMutationOptions = Apollo.BaseMutationOptions<
  ResendConfirmationEmailMutation,
  ResendConfirmationEmailMutationVariables
>;
export const ConfirmationQueryDocument = gql`
  query ConfirmationQuery(
    $inquiryPaymentKey: String!
    $actionableTypes: [String!]
    $inEu: Boolean!
    $targetCurrency: String
    $receivableInvoiceId: String
  ) {
    confirmation(
      inquiryPaymentKey: $inquiryPaymentKey
      actionableTypes: $actionableTypes
      clientInfo: { inEu: $inEu }
      targetCurrency: $targetCurrency
      receivableInvoiceId: $receivableInvoiceId
    ) {
      orderInfo {
        city
        code
      }
      guestInfo {
        email
        countryAlpha2
        countryCode
        phoneNumber
        discountPricingMember
        requiresIdVerification
        requiresPhoneVerification
        trustAndSafetyState
        dateOfBirth
        firstName
        lastName
        address {
          streetAddress
          streetAddress2
          stateOrProvince
          cityName
          postalCode
          countryCode
        }
      }
      actionables {
        type
        completed
        status
        step
        metadata
      }
      invoiceInfo {
        hasMemberDiscount
        ltsBooking
        lineItems {
          label
          type
          value
        }
        total {
          label
          value
          currency
        }
        chargeType
      }
      invoiceInfoInTargetCurrency {
        hasMemberDiscount
        ltsBooking
        lineItems {
          label
          type
          value
        }
        total {
          label
          value
          currency
        }
        chargeType
        totalInBaseCurrency {
          label
          value
          rawValue
          currency
        }
      }
      paymentInfo {
        type
        brand
        last4
        paidDate
        cardholderName
      }
      productInfo {
        image
        title
        subtitle
        checkInDate
        checkOutDate
        checkInDateLabel
        checkOutDateLabel
        numberOfGuests
        numberOfNights
        stayLengthLabel
        ratingAverage
        ratingState
        ratingTotal
        gdsBooking
        airbnbBooking
      }
      cancellationInfo {
        name
        description
        cancellationPolicy
        priceFormula {
          adjustmentBasisPoints
        }
      }
      inquiry {
        account {
          id: normalizedId
        }
        id: normalizedId
        name
        accessHoursAvailableBeforeCheckIn
        inquiryState
        isBooked
        isCancelled
        isInquiry
        isOnHold
        status
        unit {
          listing {
            url
          }
        }
      }
      eciLcoInfo {
        checkInChanged
        checkOutChanged
        checkInDate
        checkOutDate
        newCheckInTime
        newCheckOutTime
      }
      chekinRegistrationLink
      showWelcomeReward
      showWelcomeRewardCta
      otaGuestInfoRequired
    }
  }
`;

/**
 * __useConfirmationQueryQuery__
 *
 * To run a query within a React component, call `useConfirmationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmationQueryQuery({
 *   variables: {
 *      inquiryPaymentKey: // value for 'inquiryPaymentKey'
 *      actionableTypes: // value for 'actionableTypes'
 *      inEu: // value for 'inEu'
 *      targetCurrency: // value for 'targetCurrency'
 *      receivableInvoiceId: // value for 'receivableInvoiceId'
 *   },
 * });
 */
export function useConfirmationQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConfirmationQueryQuery,
    ConfirmationQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConfirmationQueryQuery,
    ConfirmationQueryQueryVariables
  >(ConfirmationQueryDocument, options);
}
export function useConfirmationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConfirmationQueryQuery,
    ConfirmationQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConfirmationQueryQuery,
    ConfirmationQueryQueryVariables
  >(ConfirmationQueryDocument, options);
}
export type ConfirmationQueryQueryHookResult = ReturnType<
  typeof useConfirmationQueryQuery
>;
export type ConfirmationQueryLazyQueryHookResult = ReturnType<
  typeof useConfirmationQueryLazyQuery
>;
export type ConfirmationQueryQueryResult = Apollo.QueryResult<
  ConfirmationQueryQuery,
  ConfirmationQueryQueryVariables
>;
export const CancellationPreviewDocument = gql`
  query CancellationPreview($inquiryId: ID!) {
    cancellationPreview(inquiryId: $inquiryId) {
      refundPercentage
      refunds {
        refundMethod
        total
        currency
      }
    }
  }
`;

/**
 * __useCancellationPreviewQuery__
 *
 * To run a query within a React component, call `useCancellationPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationPreviewQuery({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *   },
 * });
 */
export function useCancellationPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    CancellationPreviewQuery,
    CancellationPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CancellationPreviewQuery,
    CancellationPreviewQueryVariables
  >(CancellationPreviewDocument, options);
}
export function useCancellationPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CancellationPreviewQuery,
    CancellationPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CancellationPreviewQuery,
    CancellationPreviewQueryVariables
  >(CancellationPreviewDocument, options);
}
export type CancellationPreviewQueryHookResult = ReturnType<
  typeof useCancellationPreviewQuery
>;
export type CancellationPreviewLazyQueryHookResult = ReturnType<
  typeof useCancellationPreviewLazyQuery
>;
export type CancellationPreviewQueryResult = Apollo.QueryResult<
  CancellationPreviewQuery,
  CancellationPreviewQueryVariables
>;
export const RequestCancellationMutationDocument = gql`
  mutation RequestCancellationMutation($inquiryId: ID!) {
    requestCancellation(inquiryId: $inquiryId) {
      followupRequired
      refundOwed
    }
  }
`;
export type RequestCancellationMutationMutationFn = Apollo.MutationFunction<
  RequestCancellationMutationMutation,
  RequestCancellationMutationMutationVariables
>;

/**
 * __useRequestCancellationMutationMutation__
 *
 * To run a mutation, you first call `useRequestCancellationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCancellationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCancellationMutationMutation, { data, loading, error }] = useRequestCancellationMutationMutation({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *   },
 * });
 */
export function useRequestCancellationMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestCancellationMutationMutation,
    RequestCancellationMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestCancellationMutationMutation,
    RequestCancellationMutationMutationVariables
  >(RequestCancellationMutationDocument, options);
}
export type RequestCancellationMutationMutationHookResult = ReturnType<
  typeof useRequestCancellationMutationMutation
>;
export type RequestCancellationMutationMutationResult =
  Apollo.MutationResult<RequestCancellationMutationMutation>;
export type RequestCancellationMutationMutationOptions =
  Apollo.BaseMutationOptions<
    RequestCancellationMutationMutation,
    RequestCancellationMutationMutationVariables
  >;
export const BuildingCollectionsAvailabilityQueryDocument = gql`
  query BuildingCollectionsAvailabilityQuery(
    $listingId: ID!
    $checkInDate: String
    $checkOutDate: String
    $prices: [Int!]
    $sleeps: Int
    $source: String
    $targetCurrency: String
  ) {
    buildingCollectionsAvailability(
      listingId: $listingId
      checkInDate: $checkInDate
      checkOutDate: $checkOutDate
      prices: $prices
      sleeps: $sleeps
      source: $source
      targetCurrency: $targetCurrency
    ) {
      collections {
        adaAccessibilityInfo {
          isHearingAccessible
          isMobilityAccessible
          mobilityFeatures
          hearingFeatures
        }
        amenities {
          name
          active
          label
        }
        available
        bathroomCount
        bedroomCount
        collectionName
        collectionType
        collectionId
        displayPrice
        displayPriceRaw
        displayPriceLabel
        longTermRental
        minimumStayLength
        photos {
          tag
          caption
          mediumSrc
          smallSrc
          xlargeSrc
          largeSrc
        }
        quote {
          invoice {
            adr
            contactToBookLts
            isBookingDisabled
            lineItems {
              key
              label
              value
              primary
            }
          }
          rateLabel
          totalLabel
          originalRateLabel
          remainingUnitsCount
        }
        sleepCount
        squareFootage
        viewCount
      }
      filters {
        availabilityFilter {
          selected {
            checkInDate
            checkOutDate
          }
        }
        guestCountFilter {
          options {
            min
            max
          }
          selected
        }
        pricingFilter {
          options {
            min
            max
          }
          selected {
            min
            max
          }
        }
      }
    }
  }
`;

/**
 * __useBuildingCollectionsAvailabilityQueryQuery__
 *
 * To run a query within a React component, call `useBuildingCollectionsAvailabilityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingCollectionsAvailabilityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingCollectionsAvailabilityQueryQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      prices: // value for 'prices'
 *      sleeps: // value for 'sleeps'
 *      source: // value for 'source'
 *      targetCurrency: // value for 'targetCurrency'
 *   },
 * });
 */
export function useBuildingCollectionsAvailabilityQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    BuildingCollectionsAvailabilityQueryQuery,
    BuildingCollectionsAvailabilityQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BuildingCollectionsAvailabilityQueryQuery,
    BuildingCollectionsAvailabilityQueryQueryVariables
  >(BuildingCollectionsAvailabilityQueryDocument, options);
}
export function useBuildingCollectionsAvailabilityQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BuildingCollectionsAvailabilityQueryQuery,
    BuildingCollectionsAvailabilityQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BuildingCollectionsAvailabilityQueryQuery,
    BuildingCollectionsAvailabilityQueryQueryVariables
  >(BuildingCollectionsAvailabilityQueryDocument, options);
}
export type BuildingCollectionsAvailabilityQueryQueryHookResult = ReturnType<
  typeof useBuildingCollectionsAvailabilityQueryQuery
>;
export type BuildingCollectionsAvailabilityQueryLazyQueryHookResult =
  ReturnType<typeof useBuildingCollectionsAvailabilityQueryLazyQuery>;
export type BuildingCollectionsAvailabilityQueryQueryResult =
  Apollo.QueryResult<
    BuildingCollectionsAvailabilityQueryQuery,
    BuildingCollectionsAvailabilityQueryQueryVariables
  >;
export const BuildingCollectionsCalendarAvailabilitiesQueryDocument = gql`
  query BuildingCollectionsCalendarAvailabilitiesQuery(
    $id: ID!
    $checkInDate: String
    $startCursor: String
    $endCursor: String
    $guestCount: Int
  ) {
    buildingCollectionsCalendarAvailabilities(
      id: $id
      checkInDate: $checkInDate
      startCursor: $startCursor
      endCursor: $endCursor
      guestCount: $guestCount
    ) {
      date
      minimumStayLength
      checkinAvailable
    }
  }
`;

/**
 * __useBuildingCollectionsCalendarAvailabilitiesQueryQuery__
 *
 * To run a query within a React component, call `useBuildingCollectionsCalendarAvailabilitiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingCollectionsCalendarAvailabilitiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingCollectionsCalendarAvailabilitiesQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      checkInDate: // value for 'checkInDate'
 *      startCursor: // value for 'startCursor'
 *      endCursor: // value for 'endCursor'
 *      guestCount: // value for 'guestCount'
 *   },
 * });
 */
export function useBuildingCollectionsCalendarAvailabilitiesQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    BuildingCollectionsCalendarAvailabilitiesQueryQuery,
    BuildingCollectionsCalendarAvailabilitiesQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BuildingCollectionsCalendarAvailabilitiesQueryQuery,
    BuildingCollectionsCalendarAvailabilitiesQueryQueryVariables
  >(BuildingCollectionsCalendarAvailabilitiesQueryDocument, options);
}
export function useBuildingCollectionsCalendarAvailabilitiesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BuildingCollectionsCalendarAvailabilitiesQueryQuery,
    BuildingCollectionsCalendarAvailabilitiesQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BuildingCollectionsCalendarAvailabilitiesQueryQuery,
    BuildingCollectionsCalendarAvailabilitiesQueryQueryVariables
  >(BuildingCollectionsCalendarAvailabilitiesQueryDocument, options);
}
export type BuildingCollectionsCalendarAvailabilitiesQueryQueryHookResult =
  ReturnType<typeof useBuildingCollectionsCalendarAvailabilitiesQueryQuery>;
export type BuildingCollectionsCalendarAvailabilitiesQueryLazyQueryHookResult =
  ReturnType<typeof useBuildingCollectionsCalendarAvailabilitiesQueryLazyQuery>;
export type BuildingCollectionsCalendarAvailabilitiesQueryQueryResult =
  Apollo.QueryResult<
    BuildingCollectionsCalendarAvailabilitiesQueryQuery,
    BuildingCollectionsCalendarAvailabilitiesQueryQueryVariables
  >;
export const BuildingListingQueryDocument = gql`
  query BuildingListingQuery($id: ID!) {
    buildingListing(id: $id) {
      ... on BuildingListing {
        accessibilityInfo
        amenities {
          name
          active
          label
        }
        buildingAddress
        brandSegment
        buildingName
        buildingPhotos {
          tag
          caption
          mediumSrc
          xlargeSrc
          largeSrc
        }
        cityName
        contactEmailLtr
        contactEmailStr
        countryName
        countryCode
        currency
        downtownDrivingInfo
        geocode {
          lat
          lng
        }
        homeTruths
        houseRules
        id
        location
        neighborhoodContent
        neighborhoodDescription
        neighborhoodName
        parkingInfo
        photos {
          tag
          caption
          mediumSrc
          xlargeSrc
          largeSrc
        }
        publicTransportationInfo
        ratingAverage
        ratingState
        ratingTotal
        shortDescription
        stateName
        stateCode
        title
        topAmenities {
          name
          active
          label
        }
        tripadvisorAward {
          awardType
          year
          assetSrc
        }
        url
        isHotel
      }
      ... on Listing {
        l1Url
      }
    }
  }
`;

/**
 * __useBuildingListingQueryQuery__
 *
 * To run a query within a React component, call `useBuildingListingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingListingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingListingQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingListingQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    BuildingListingQueryQuery,
    BuildingListingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BuildingListingQueryQuery,
    BuildingListingQueryQueryVariables
  >(BuildingListingQueryDocument, options);
}
export function useBuildingListingQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BuildingListingQueryQuery,
    BuildingListingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BuildingListingQueryQuery,
    BuildingListingQueryQueryVariables
  >(BuildingListingQueryDocument, options);
}
export type BuildingListingQueryQueryHookResult = ReturnType<
  typeof useBuildingListingQueryQuery
>;
export type BuildingListingQueryLazyQueryHookResult = ReturnType<
  typeof useBuildingListingQueryLazyQuery
>;
export type BuildingListingQueryQueryResult = Apollo.QueryResult<
  BuildingListingQueryQuery,
  BuildingListingQueryQueryVariables
>;
export const ListingUpgradeServiceQueryDocument = gql`
  query ListingUpgradeServiceQuery(
    $collectionId: Int
    $targetCurrency: String
  ) {
    upgradeService(
      collectionId: $collectionId
      targetCurrency: $targetCurrency
    ) {
      displayPrice
      scheduleType
      type
      subType
    }
  }
`;

/**
 * __useListingUpgradeServiceQueryQuery__
 *
 * To run a query within a React component, call `useListingUpgradeServiceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingUpgradeServiceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingUpgradeServiceQueryQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      targetCurrency: // value for 'targetCurrency'
 *   },
 * });
 */
export function useListingUpgradeServiceQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListingUpgradeServiceQueryQuery,
    ListingUpgradeServiceQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListingUpgradeServiceQueryQuery,
    ListingUpgradeServiceQueryQueryVariables
  >(ListingUpgradeServiceQueryDocument, options);
}
export function useListingUpgradeServiceQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListingUpgradeServiceQueryQuery,
    ListingUpgradeServiceQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListingUpgradeServiceQueryQuery,
    ListingUpgradeServiceQueryQueryVariables
  >(ListingUpgradeServiceQueryDocument, options);
}
export type ListingUpgradeServiceQueryQueryHookResult = ReturnType<
  typeof useListingUpgradeServiceQueryQuery
>;
export type ListingUpgradeServiceQueryLazyQueryHookResult = ReturnType<
  typeof useListingUpgradeServiceQueryLazyQuery
>;
export type ListingUpgradeServiceQueryQueryResult = Apollo.QueryResult<
  ListingUpgradeServiceQueryQuery,
  ListingUpgradeServiceQueryQueryVariables
>;
export const CreateInquiryDocument = gql`
  mutation createInquiry(
    $listingId: ID!
    $collectionId: ID
    $checkInDate: String!
    $checkOutDate: String!
    $promoCodes: [String!]!
    $guestNb: Int
    $referralPartnerId: String
  ) {
    createInquiry(
      listingId: $listingId
      collectionId: $collectionId
      checkInDate: $checkInDate
      checkOutDate: $checkOutDate
      promoCodes: $promoCodes
      guestNb: $guestNb
      referralPartnerId: $referralPartnerId
    ) {
      payPath
      id
      uniqKey
      trackingInfo
    }
  }
`;
export type CreateInquiryMutationFn = Apollo.MutationFunction<
  CreateInquiryMutation,
  CreateInquiryMutationVariables
>;

/**
 * __useCreateInquiryMutation__
 *
 * To run a mutation, you first call `useCreateInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInquiryMutation, { data, loading, error }] = useCreateInquiryMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      collectionId: // value for 'collectionId'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      promoCodes: // value for 'promoCodes'
 *      guestNb: // value for 'guestNb'
 *      referralPartnerId: // value for 'referralPartnerId'
 *   },
 * });
 */
export function useCreateInquiryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInquiryMutation,
    CreateInquiryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInquiryMutation,
    CreateInquiryMutationVariables
  >(CreateInquiryDocument, options);
}
export type CreateInquiryMutationHookResult = ReturnType<
  typeof useCreateInquiryMutation
>;
export type CreateInquiryMutationResult =
  Apollo.MutationResult<CreateInquiryMutation>;
export type CreateInquiryMutationOptions = Apollo.BaseMutationOptions<
  CreateInquiryMutation,
  CreateInquiryMutationVariables
>;
export const RoomUpgradesDocument = gql`
  query RoomUpgrades($bookingUniqKey: String!) {
    roomUpgrades(bookingUniqKey: $bookingUniqKey) {
      inquiryId
      state
      currentBooking {
        amountPaid
        checkInDate
        checkOutDate
        stayLength
        listingId
      }
      availableUpgrades {
        pricePerNight
        priceTotal
        rawPricePerNight
        discount
        upgradeDescription
        upgradePath
      }
    }
  }
`;

/**
 * __useRoomUpgradesQuery__
 *
 * To run a query within a React component, call `useRoomUpgradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomUpgradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomUpgradesQuery({
 *   variables: {
 *      bookingUniqKey: // value for 'bookingUniqKey'
 *   },
 * });
 */
export function useRoomUpgradesQuery(
  baseOptions: Apollo.QueryHookOptions<
    RoomUpgradesQuery,
    RoomUpgradesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RoomUpgradesQuery, RoomUpgradesQueryVariables>(
    RoomUpgradesDocument,
    options,
  );
}
export function useRoomUpgradesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoomUpgradesQuery,
    RoomUpgradesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RoomUpgradesQuery, RoomUpgradesQueryVariables>(
    RoomUpgradesDocument,
    options,
  );
}
export type RoomUpgradesQueryHookResult = ReturnType<
  typeof useRoomUpgradesQuery
>;
export type RoomUpgradesLazyQueryHookResult = ReturnType<
  typeof useRoomUpgradesLazyQuery
>;
export type RoomUpgradesQueryResult = Apollo.QueryResult<
  RoomUpgradesQuery,
  RoomUpgradesQueryVariables
>;
export const BuildingSearchQueryDocument = gql`
  query buildingSearchQuery(
    $queryString: String!
    $context: String
    $environment: String
    $targetCurrency: String
  ) {
    buildingSearch(
      queryString: $queryString
      context: $context
      environment: $environment
      targetCurrency: $targetCurrency
    ) {
      inventorySearchFilters {
        ...SearchBar
        cityFilter {
          options {
            label
            value
          }
          selected {
            label
            value
          }
        }
        availabilityFilter {
          selected {
            checkInDate
            checkOutDate
          }
        }
        guestCountFilter {
          options {
            min
            max
          }
          selected
        }
        pricingFilter {
          options {
            min
            max
          }
          selected {
            min
            max
          }
        }
        bedroomCountFilter {
          options {
            min
            max
          }
          selected
        }
        bedCountFilter {
          options {
            min
            max
          }
          selected
        }
        bathroomCountFilter {
          options {
            min
            max
          }
          selected
        }
        amenityFilter {
          options {
            label
            value
          }
          selected {
            label
            value
          }
        }
      }
      inventorySearchResult {
        listingsOrder
        markersOrder
        listings
        markers
        listingToMarker
        markerToListings
        similarListings
      }
      inventorySearchSorting {
        options {
          label
          value
        }
        selected {
          label
          value
        }
      }
      inventorySearchMetadata {
        currencySymbol
        count
        totalCount
        weeklyDiscount
        biweeklyDiscount
        monthlyDiscount
        fortyFivePlusDiscount
        defaultDiscount
        appliedOffersTotal {
          filterKey
          discountLabel
          discountValue
        }
      }
    }
  }
  ${SearchBarFragmentDoc}
`;

/**
 * __useBuildingSearchQueryQuery__
 *
 * To run a query within a React component, call `useBuildingSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingSearchQueryQuery({
 *   variables: {
 *      queryString: // value for 'queryString'
 *      context: // value for 'context'
 *      environment: // value for 'environment'
 *      targetCurrency: // value for 'targetCurrency'
 *   },
 * });
 */
export function useBuildingSearchQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    BuildingSearchQueryQuery,
    BuildingSearchQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BuildingSearchQueryQuery,
    BuildingSearchQueryQueryVariables
  >(BuildingSearchQueryDocument, options);
}
export function useBuildingSearchQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BuildingSearchQueryQuery,
    BuildingSearchQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BuildingSearchQueryQuery,
    BuildingSearchQueryQueryVariables
  >(BuildingSearchQueryDocument, options);
}
export type BuildingSearchQueryQueryHookResult = ReturnType<
  typeof useBuildingSearchQueryQuery
>;
export type BuildingSearchQueryLazyQueryHookResult = ReturnType<
  typeof useBuildingSearchQueryLazyQuery
>;
export type BuildingSearchQueryQueryResult = Apollo.QueryResult<
  BuildingSearchQueryQuery,
  BuildingSearchQueryQueryVariables
>;
export const AssociateInquiryDocument = gql`
  mutation AssociateInquiry($bookingUniqKey: String!) {
    associateInquiry(bookingUniqKey: $bookingUniqKey) {
      success
    }
  }
`;
export type AssociateInquiryMutationFn = Apollo.MutationFunction<
  AssociateInquiryMutation,
  AssociateInquiryMutationVariables
>;

/**
 * __useAssociateInquiryMutation__
 *
 * To run a mutation, you first call `useAssociateInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateInquiryMutation, { data, loading, error }] = useAssociateInquiryMutation({
 *   variables: {
 *      bookingUniqKey: // value for 'bookingUniqKey'
 *   },
 * });
 */
export function useAssociateInquiryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssociateInquiryMutation,
    AssociateInquiryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssociateInquiryMutation,
    AssociateInquiryMutationVariables
  >(AssociateInquiryDocument, options);
}
export type AssociateInquiryMutationHookResult = ReturnType<
  typeof useAssociateInquiryMutation
>;
export type AssociateInquiryMutationResult =
  Apollo.MutationResult<AssociateInquiryMutation>;
export type AssociateInquiryMutationOptions = Apollo.BaseMutationOptions<
  AssociateInquiryMutation,
  AssociateInquiryMutationVariables
>;
export const ConfirmPaymentMethodDocument = gql`
  mutation ConfirmPaymentMethod(
    $bookingUniqKey: String!
    $paymentMethodId: String!
  ) {
    confirmPaymentMethod(
      bookingUniqKey: $bookingUniqKey
      paymentMethodId: $paymentMethodId
    ) {
      response {
        success
        error
      }
    }
  }
`;
export type ConfirmPaymentMethodMutationFn = Apollo.MutationFunction<
  ConfirmPaymentMethodMutation,
  ConfirmPaymentMethodMutationVariables
>;

/**
 * __useConfirmPaymentMethodMutation__
 *
 * To run a mutation, you first call `useConfirmPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPaymentMethodMutation, { data, loading, error }] = useConfirmPaymentMethodMutation({
 *   variables: {
 *      bookingUniqKey: // value for 'bookingUniqKey'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useConfirmPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmPaymentMethodMutation,
    ConfirmPaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfirmPaymentMethodMutation,
    ConfirmPaymentMethodMutationVariables
  >(ConfirmPaymentMethodDocument, options);
}
export type ConfirmPaymentMethodMutationHookResult = ReturnType<
  typeof useConfirmPaymentMethodMutation
>;
export type ConfirmPaymentMethodMutationResult =
  Apollo.MutationResult<ConfirmPaymentMethodMutation>;
export type ConfirmPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  ConfirmPaymentMethodMutation,
  ConfirmPaymentMethodMutationVariables
>;
export const CreateBookingAndPaymentLinkDocument = gql`
  mutation createBookingAndPaymentLink(
    $checkInDate: String!
    $checkOutDate: String!
    $collectionId: String!
    $ratePlanId: String!
    $guestId: String!
    $paymentGateway: String!
  ) {
    createBookingAndPaymentLink(
      input: {
        checkInDate: $checkInDate
        checkOutDate: $checkOutDate
        collectionId: $collectionId
        ratePlanId: $ratePlanId
        guestId: $guestId
        paymentGateway: $paymentGateway
      }
    ) {
      bookingUniqKey
      url
    }
  }
`;
export type CreateBookingAndPaymentLinkMutationFn = Apollo.MutationFunction<
  CreateBookingAndPaymentLinkMutation,
  CreateBookingAndPaymentLinkMutationVariables
>;

/**
 * __useCreateBookingAndPaymentLinkMutation__
 *
 * To run a mutation, you first call `useCreateBookingAndPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingAndPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingAndPaymentLinkMutation, { data, loading, error }] = useCreateBookingAndPaymentLinkMutation({
 *   variables: {
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      collectionId: // value for 'collectionId'
 *      ratePlanId: // value for 'ratePlanId'
 *      guestId: // value for 'guestId'
 *      paymentGateway: // value for 'paymentGateway'
 *   },
 * });
 */
export function useCreateBookingAndPaymentLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBookingAndPaymentLinkMutation,
    CreateBookingAndPaymentLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBookingAndPaymentLinkMutation,
    CreateBookingAndPaymentLinkMutationVariables
  >(CreateBookingAndPaymentLinkDocument, options);
}
export type CreateBookingAndPaymentLinkMutationHookResult = ReturnType<
  typeof useCreateBookingAndPaymentLinkMutation
>;
export type CreateBookingAndPaymentLinkMutationResult =
  Apollo.MutationResult<CreateBookingAndPaymentLinkMutation>;
export type CreateBookingAndPaymentLinkMutationOptions =
  Apollo.BaseMutationOptions<
    CreateBookingAndPaymentLinkMutation,
    CreateBookingAndPaymentLinkMutationVariables
  >;
export const RequestAlterationDocument = gql`
  mutation RequestAlteration(
    $inquiryId: ID!
    $newCheckInDate: String
    $newCheckOutDate: String
  ) {
    requestAlteration(
      inquiryId: $inquiryId
      newCheckInDate: $newCheckInDate
      newCheckOutDate: $newCheckOutDate
    ) {
      followupRequired
      invoiceId
      paymentLink
      refundOwed
    }
  }
`;
export type RequestAlterationMutationFn = Apollo.MutationFunction<
  RequestAlterationMutation,
  RequestAlterationMutationVariables
>;

/**
 * __useRequestAlterationMutation__
 *
 * To run a mutation, you first call `useRequestAlterationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAlterationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAlterationMutation, { data, loading, error }] = useRequestAlterationMutation({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *      newCheckInDate: // value for 'newCheckInDate'
 *      newCheckOutDate: // value for 'newCheckOutDate'
 *   },
 * });
 */
export function useRequestAlterationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestAlterationMutation,
    RequestAlterationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestAlterationMutation,
    RequestAlterationMutationVariables
  >(RequestAlterationDocument, options);
}
export type RequestAlterationMutationHookResult = ReturnType<
  typeof useRequestAlterationMutation
>;
export type RequestAlterationMutationResult =
  Apollo.MutationResult<RequestAlterationMutation>;
export type RequestAlterationMutationOptions = Apollo.BaseMutationOptions<
  RequestAlterationMutation,
  RequestAlterationMutationVariables
>;
export const SubmitCsatFeedbackDocument = gql`
  mutation SubmitCsatFeedback(
    $bookingUniqKey: String!
    $csatScore: Int
    $scoreReason: String
    $cleanliness: Int
    $condition: Int
    $staff: Int
    $safety: Int
  ) {
    submitCsatFeedback(
      input: {
        bookingUniqKey: $bookingUniqKey
        csatScore: $csatScore
        scoreReason: $scoreReason
        cleanliness: $cleanliness
        condition: $condition
        staff: $staff
        safety: $safety
      }
    ) {
      response {
        feedbackQuestionnaireCompleted
        rateCompleted
      }
    }
  }
`;
export type SubmitCsatFeedbackMutationFn = Apollo.MutationFunction<
  SubmitCsatFeedbackMutation,
  SubmitCsatFeedbackMutationVariables
>;

/**
 * __useSubmitCsatFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitCsatFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCsatFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCsatFeedbackMutation, { data, loading, error }] = useSubmitCsatFeedbackMutation({
 *   variables: {
 *      bookingUniqKey: // value for 'bookingUniqKey'
 *      csatScore: // value for 'csatScore'
 *      scoreReason: // value for 'scoreReason'
 *      cleanliness: // value for 'cleanliness'
 *      condition: // value for 'condition'
 *      staff: // value for 'staff'
 *      safety: // value for 'safety'
 *   },
 * });
 */
export function useSubmitCsatFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitCsatFeedbackMutation,
    SubmitCsatFeedbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitCsatFeedbackMutation,
    SubmitCsatFeedbackMutationVariables
  >(SubmitCsatFeedbackDocument, options);
}
export type SubmitCsatFeedbackMutationHookResult = ReturnType<
  typeof useSubmitCsatFeedbackMutation
>;
export type SubmitCsatFeedbackMutationResult =
  Apollo.MutationResult<SubmitCsatFeedbackMutation>;
export type SubmitCsatFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SubmitCsatFeedbackMutation,
  SubmitCsatFeedbackMutationVariables
>;
export const UpdateGroupPayerPaymentDetailsDocument = gql`
  mutation UpdateGroupPayerPaymentDetails(
    $slug: String!
    $paymentMethodId: String!
  ) {
    updateGroupPayerPaymentDetails(
      slug: $slug
      paymentMethodId: $paymentMethodId
    ) {
      success
    }
  }
`;
export type UpdateGroupPayerPaymentDetailsMutationFn = Apollo.MutationFunction<
  UpdateGroupPayerPaymentDetailsMutation,
  UpdateGroupPayerPaymentDetailsMutationVariables
>;

/**
 * __useUpdateGroupPayerPaymentDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateGroupPayerPaymentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupPayerPaymentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupPayerPaymentDetailsMutation, { data, loading, error }] = useUpdateGroupPayerPaymentDetailsMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useUpdateGroupPayerPaymentDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupPayerPaymentDetailsMutation,
    UpdateGroupPayerPaymentDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateGroupPayerPaymentDetailsMutation,
    UpdateGroupPayerPaymentDetailsMutationVariables
  >(UpdateGroupPayerPaymentDetailsDocument, options);
}
export type UpdateGroupPayerPaymentDetailsMutationHookResult = ReturnType<
  typeof useUpdateGroupPayerPaymentDetailsMutation
>;
export type UpdateGroupPayerPaymentDetailsMutationResult =
  Apollo.MutationResult<UpdateGroupPayerPaymentDetailsMutation>;
export type UpdateGroupPayerPaymentDetailsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateGroupPayerPaymentDetailsMutation,
    UpdateGroupPayerPaymentDetailsMutationVariables
  >;
export const UpdateOtaGuestDetailsDocument = gql`
  mutation UpdateOtaGuestDetails(
    $inquiryId: ID!
    $otaGuestDetailsInput: OtaGuestDetailsInput!
  ) {
    updateOtaGuestDetails(
      inquiryId: $inquiryId
      otaGuestDetailsInput: $otaGuestDetailsInput
    ) {
      response {
        success
        error
      }
      success
      errors {
        message
        code
      }
    }
  }
`;
export type UpdateOtaGuestDetailsMutationFn = Apollo.MutationFunction<
  UpdateOtaGuestDetailsMutation,
  UpdateOtaGuestDetailsMutationVariables
>;

/**
 * __useUpdateOtaGuestDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOtaGuestDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOtaGuestDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOtaGuestDetailsMutation, { data, loading, error }] = useUpdateOtaGuestDetailsMutation({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *      otaGuestDetailsInput: // value for 'otaGuestDetailsInput'
 *   },
 * });
 */
export function useUpdateOtaGuestDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOtaGuestDetailsMutation,
    UpdateOtaGuestDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOtaGuestDetailsMutation,
    UpdateOtaGuestDetailsMutationVariables
  >(UpdateOtaGuestDetailsDocument, options);
}
export type UpdateOtaGuestDetailsMutationHookResult = ReturnType<
  typeof useUpdateOtaGuestDetailsMutation
>;
export type UpdateOtaGuestDetailsMutationResult =
  Apollo.MutationResult<UpdateOtaGuestDetailsMutation>;
export type UpdateOtaGuestDetailsMutationOptions = Apollo.BaseMutationOptions<
  UpdateOtaGuestDetailsMutation,
  UpdateOtaGuestDetailsMutationVariables
>;
export const UpdateSurveyQuestionDocument = gql`
  mutation UpdateSurveyQuestion($uniqKey: String!, $csatScore: Int!) {
    updateTravelSurvey(uniqKey: $uniqKey, csatScore: $csatScore) {
      travelSurveyQuestion {
        title
        subtitle
        redirectUrl
        type
      }
    }
  }
`;
export type UpdateSurveyQuestionMutationFn = Apollo.MutationFunction<
  UpdateSurveyQuestionMutation,
  UpdateSurveyQuestionMutationVariables
>;

/**
 * __useUpdateSurveyQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyQuestionMutation, { data, loading, error }] = useUpdateSurveyQuestionMutation({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *      csatScore: // value for 'csatScore'
 *   },
 * });
 */
export function useUpdateSurveyQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSurveyQuestionMutation,
    UpdateSurveyQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSurveyQuestionMutation,
    UpdateSurveyQuestionMutationVariables
  >(UpdateSurveyQuestionDocument, options);
}
export type UpdateSurveyQuestionMutationHookResult = ReturnType<
  typeof useUpdateSurveyQuestionMutation
>;
export type UpdateSurveyQuestionMutationResult =
  Apollo.MutationResult<UpdateSurveyQuestionMutation>;
export type UpdateSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSurveyQuestionMutation,
  UpdateSurveyQuestionMutationVariables
>;
export const BookingDetailsAndUpgradeServicesDocument = gql`
  query BookingDetailsAndUpgradeServices($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      access {
        isInPersonCheckin
      }
      account {
        id
        canReceiveAccessInfo
        email
        normalizedId
      }
      actions {
        type
        externalUrl
      }
      checkInTime
      checkOutTime
      confirmationCode
      earlyCheckInRequest {
        id
        desiredTime
        eciLcoRequestId
        status
      }
      accessHoursAvailableBeforeCheckIn
      guestIntendedArrivalTime
      guestIntendedDepartureTime
      hasPaymentPlan
      isCancelled
      lateCheckOutRequest {
        id
        desiredTime
        eciLcoRequestId
        status
      }
      normalizedId
      pendingDateAdjustmentRequest {
        id
        newLocalCheckInTime
        newLocalCheckOutTime
      }
      unit {
        id
        brCount
        building {
          id
          fullAddress
          displayName
          name
        }
        googleMapsLink
        images(limit: 0) {
          id
          url
        }
        listing {
          id
          url
        }
        name
        nbrBathrooms
        neighborhood {
          id
          description
        }
        quickPitch
        sleeps
        timezone
      }
      status
      uniqKey
      rentalSiteName
    }
    upgradeService(bookingUniqKey: $uniqKey) {
      booked
      subType
      type
    }
  }
`;

/**
 * __useBookingDetailsAndUpgradeServicesQuery__
 *
 * To run a query within a React component, call `useBookingDetailsAndUpgradeServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDetailsAndUpgradeServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDetailsAndUpgradeServicesQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingDetailsAndUpgradeServicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingDetailsAndUpgradeServicesQuery,
    BookingDetailsAndUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingDetailsAndUpgradeServicesQuery,
    BookingDetailsAndUpgradeServicesQueryVariables
  >(BookingDetailsAndUpgradeServicesDocument, options);
}
export function useBookingDetailsAndUpgradeServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingDetailsAndUpgradeServicesQuery,
    BookingDetailsAndUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingDetailsAndUpgradeServicesQuery,
    BookingDetailsAndUpgradeServicesQueryVariables
  >(BookingDetailsAndUpgradeServicesDocument, options);
}
export type BookingDetailsAndUpgradeServicesQueryHookResult = ReturnType<
  typeof useBookingDetailsAndUpgradeServicesQuery
>;
export type BookingDetailsAndUpgradeServicesLazyQueryHookResult = ReturnType<
  typeof useBookingDetailsAndUpgradeServicesLazyQuery
>;
export type BookingDetailsAndUpgradeServicesQueryResult = Apollo.QueryResult<
  BookingDetailsAndUpgradeServicesQuery,
  BookingDetailsAndUpgradeServicesQueryVariables
>;
export const IdVerificationDocument = gql`
  query IdVerification($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      checkInState {
        idVerification {
          completed
        }
      }
    }
  }
`;

/**
 * __useIdVerificationQuery__
 *
 * To run a query within a React component, call `useIdVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdVerificationQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useIdVerificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    IdVerificationQuery,
    IdVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IdVerificationQuery, IdVerificationQueryVariables>(
    IdVerificationDocument,
    options,
  );
}
export function useIdVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IdVerificationQuery,
    IdVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IdVerificationQuery, IdVerificationQueryVariables>(
    IdVerificationDocument,
    options,
  );
}
export type IdVerificationQueryHookResult = ReturnType<
  typeof useIdVerificationQuery
>;
export type IdVerificationLazyQueryHookResult = ReturnType<
  typeof useIdVerificationLazyQuery
>;
export type IdVerificationQueryResult = Apollo.QueryResult<
  IdVerificationQuery,
  IdVerificationQueryVariables
>;
export const AccountAllowedActionsDocument = gql`
  query AccountAllowedActions {
    account {
      actions {
        type
        externalUrl
      }
    }
  }
`;

/**
 * __useAccountAllowedActionsQuery__
 *
 * To run a query within a React component, call `useAccountAllowedActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountAllowedActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountAllowedActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountAllowedActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountAllowedActionsQuery,
    AccountAllowedActionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccountAllowedActionsQuery,
    AccountAllowedActionsQueryVariables
  >(AccountAllowedActionsDocument, options);
}
export function useAccountAllowedActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountAllowedActionsQuery,
    AccountAllowedActionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountAllowedActionsQuery,
    AccountAllowedActionsQueryVariables
  >(AccountAllowedActionsDocument, options);
}
export type AccountAllowedActionsQueryHookResult = ReturnType<
  typeof useAccountAllowedActionsQuery
>;
export type AccountAllowedActionsLazyQueryHookResult = ReturnType<
  typeof useAccountAllowedActionsLazyQuery
>;
export type AccountAllowedActionsQueryResult = Apollo.QueryResult<
  AccountAllowedActionsQuery,
  AccountAllowedActionsQueryVariables
>;
export const AccountDetailsDocument = gql`
  query AccountDetails {
    account {
      id
      email
      firstName
      lastName
      canQa
      fidelity {
        number
        source
      }
      actions {
        type
        externalUrl
      }
    }
  }
`;

/**
 * __useAccountDetailsQuery__
 *
 * To run a query within a React component, call `useAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountDetailsQuery,
    AccountDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountDetailsQuery, AccountDetailsQueryVariables>(
    AccountDetailsDocument,
    options,
  );
}
export function useAccountDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountDetailsQuery,
    AccountDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountDetailsQuery, AccountDetailsQueryVariables>(
    AccountDetailsDocument,
    options,
  );
}
export type AccountDetailsQueryHookResult = ReturnType<
  typeof useAccountDetailsQuery
>;
export type AccountDetailsLazyQueryHookResult = ReturnType<
  typeof useAccountDetailsLazyQuery
>;
export type AccountDetailsQueryResult = Apollo.QueryResult<
  AccountDetailsQuery,
  AccountDetailsQueryVariables
>;
export const AlterationAvailabilityDocument = gql`
  query AlterationAvailability($id: ID!) {
    alterationAvailability(inquiryId: $id) {
      maximumNightStay
      minimumNightStay
      availabilityData {
        data {
          id
          checkinAvailable
          checkoutAvailable
          minNights
        }
      }
    }
  }
`;

/**
 * __useAlterationAvailabilityQuery__
 *
 * To run a query within a React component, call `useAlterationAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlterationAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlterationAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlterationAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlterationAvailabilityQuery,
    AlterationAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlterationAvailabilityQuery,
    AlterationAvailabilityQueryVariables
  >(AlterationAvailabilityDocument, options);
}
export function useAlterationAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlterationAvailabilityQuery,
    AlterationAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlterationAvailabilityQuery,
    AlterationAvailabilityQueryVariables
  >(AlterationAvailabilityDocument, options);
}
export type AlterationAvailabilityQueryHookResult = ReturnType<
  typeof useAlterationAvailabilityQuery
>;
export type AlterationAvailabilityLazyQueryHookResult = ReturnType<
  typeof useAlterationAvailabilityLazyQuery
>;
export type AlterationAvailabilityQueryResult = Apollo.QueryResult<
  AlterationAvailabilityQuery,
  AlterationAvailabilityQueryVariables
>;
export const ModificationPreviewPricingDocument = gql`
  query ModificationPreviewPricing(
    $id: ID!
    $newCheckInDate: String
    $newCheckOutDate: String
  ) {
    alterationPreviewPricing(
      inquiryId: $id
      newCheckInDate: $newCheckInDate
      newCheckOutDate: $newCheckOutDate
    ) {
      currency
      total
      message
      refundMethod
      paymentDifference
    }
  }
`;

/**
 * __useModificationPreviewPricingQuery__
 *
 * To run a query within a React component, call `useModificationPreviewPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useModificationPreviewPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModificationPreviewPricingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      newCheckInDate: // value for 'newCheckInDate'
 *      newCheckOutDate: // value for 'newCheckOutDate'
 *   },
 * });
 */
export function useModificationPreviewPricingQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModificationPreviewPricingQuery,
    ModificationPreviewPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ModificationPreviewPricingQuery,
    ModificationPreviewPricingQueryVariables
  >(ModificationPreviewPricingDocument, options);
}
export function useModificationPreviewPricingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModificationPreviewPricingQuery,
    ModificationPreviewPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ModificationPreviewPricingQuery,
    ModificationPreviewPricingQueryVariables
  >(ModificationPreviewPricingDocument, options);
}
export type ModificationPreviewPricingQueryHookResult = ReturnType<
  typeof useModificationPreviewPricingQuery
>;
export type ModificationPreviewPricingLazyQueryHookResult = ReturnType<
  typeof useModificationPreviewPricingLazyQuery
>;
export type ModificationPreviewPricingQueryResult = Apollo.QueryResult<
  ModificationPreviewPricingQuery,
  ModificationPreviewPricingQueryVariables
>;
export const AccessAccountBookingsDocument = gql`
  query AccessAccountBookings {
    account {
      bookings {
        id
        uniqKey
      }
    }
  }
`;

/**
 * __useAccessAccountBookingsQuery__
 *
 * To run a query within a React component, call `useAccessAccountBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessAccountBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessAccountBookingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessAccountBookingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccessAccountBookingsQuery,
    AccessAccountBookingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccessAccountBookingsQuery,
    AccessAccountBookingsQueryVariables
  >(AccessAccountBookingsDocument, options);
}
export function useAccessAccountBookingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccessAccountBookingsQuery,
    AccessAccountBookingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccessAccountBookingsQuery,
    AccessAccountBookingsQueryVariables
  >(AccessAccountBookingsDocument, options);
}
export type AccessAccountBookingsQueryHookResult = ReturnType<
  typeof useAccessAccountBookingsQuery
>;
export type AccessAccountBookingsLazyQueryHookResult = ReturnType<
  typeof useAccessAccountBookingsLazyQuery
>;
export type AccessAccountBookingsQueryResult = Apollo.QueryResult<
  AccessAccountBookingsQuery,
  AccessAccountBookingsQueryVariables
>;
export const BookingAccessAndUpgradeServicesDocument = gql`
  query bookingAccessAndUpgradeServices($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      actions {
        type
        externalUrl
      }
      access {
        buildingAccessCode
        buildingAccessType
        elevatorAccessCode
        elevatorAccessType
        isBuildingAccessRequired
        isElevatorAccessRequired
        isInPersonCheckin
        isLockboxRequired
        keycafeCode
        lockboxCode
        unitAccessCode
        unitAccessType
      }
      accessHoursAvailableBeforeCheckIn
      accessInstructions
      canReceiveAccessInstructions
      checkInTime
      guestIntendedArrivalTime
      checkOutTime
      guestIntendedDepartureTime
      inquiryState
      confirmationCode
      unit {
        id
        aptNumber
        name
        listing {
          title
        }
        building {
          id
          breakfastDescription
          breakfastTiming
          freeBreakfast
          garbageInformation
          guestSpaces {
            id
            description
            location
            openHours {
              hoursAsString
            }
            type
          }
          mailInstructions
          recyclingInformation
          stateCode
          streetAddress
          displayName
        }
        city {
          id
          country
          name
          servicePartners {
            id
            categoryKey
            categoryName
            descriptionLong
            displayName
            url
          }
        }
        closestMetroStation
        googleMapsLink
        parkingTypes {
          freeParkingLotsNearby
          freeParkingLotDetails
          freeStreetParking
          freeStreetParkingDetails
          paidParkingLotsNearby
          paidParkingLotDetails
          paidStreetParking
          paidStreetParkingDetails
          privateParkingWithUnitFree
          privateParkingWithUnitPaid
          privateParkingDetails
        }
        propertyType
        staticMapImage(height: 300, width: 640, zoom: 16, scale: 2)
        storageLocation {
          id
          guestFacingTextArray
          name
        }
        timezone
        town
        wifiSsid
        wifiPassword
      }
      uniqKey
      rentalSiteName
      accessUnavailableReason
    }
    upgradeService(bookingUniqKey: $uniqKey) {
      booked
      subType
      type
    }
  }
`;

/**
 * __useBookingAccessAndUpgradeServicesQuery__
 *
 * To run a query within a React component, call `useBookingAccessAndUpgradeServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAccessAndUpgradeServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAccessAndUpgradeServicesQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingAccessAndUpgradeServicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingAccessAndUpgradeServicesQuery,
    BookingAccessAndUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingAccessAndUpgradeServicesQuery,
    BookingAccessAndUpgradeServicesQueryVariables
  >(BookingAccessAndUpgradeServicesDocument, options);
}
export function useBookingAccessAndUpgradeServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingAccessAndUpgradeServicesQuery,
    BookingAccessAndUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingAccessAndUpgradeServicesQuery,
    BookingAccessAndUpgradeServicesQueryVariables
  >(BookingAccessAndUpgradeServicesDocument, options);
}
export type BookingAccessAndUpgradeServicesQueryHookResult = ReturnType<
  typeof useBookingAccessAndUpgradeServicesQuery
>;
export type BookingAccessAndUpgradeServicesLazyQueryHookResult = ReturnType<
  typeof useBookingAccessAndUpgradeServicesLazyQuery
>;
export type BookingAccessAndUpgradeServicesQueryResult = Apollo.QueryResult<
  BookingAccessAndUpgradeServicesQuery,
  BookingAccessAndUpgradeServicesQueryVariables
>;
export const BookingAccessDocument = gql`
  query BookingAccess($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      actions {
        type
        externalUrl
      }
      access {
        buildingAccessCode
        buildingAccessType
        elevatorAccessCode
        elevatorAccessType
        isBuildingAccessRequired
        isElevatorAccessRequired
        isInPersonCheckin
        isLockboxRequired
        keycafeCode
        lockboxCode
        unitAccessCode
        unitAccessType
      }
      accessHoursAvailableBeforeCheckIn
      accessInstructions
      canReceiveAccessInstructions
      checkInTime
      guestIntendedArrivalTime
      checkOutTime
      guestIntendedDepartureTime
      inquiryState
      confirmationCode
      unit {
        id
        aptNumber
        name
        listing {
          title
        }
        building {
          id
          breakfastDescription
          breakfastTiming
          freeBreakfast
          garbageInformation
          guestSpaces {
            id
            description
            location
            openHours {
              hoursAsString
            }
            type
          }
          mailInstructions
          recyclingInformation
          stateCode
          streetAddress
          displayName
        }
        city {
          id
          country
          name
          servicePartners {
            id
            categoryKey
            categoryName
            descriptionLong
            displayName
            url
          }
        }
        closestMetroStation
        googleMapsLink
        parkingTypes {
          freeParkingLotsNearby
          freeParkingLotDetails
          freeStreetParking
          freeStreetParkingDetails
          paidParkingLotsNearby
          paidParkingLotDetails
          paidStreetParking
          paidStreetParkingDetails
          privateParkingWithUnitFree
          privateParkingWithUnitPaid
          privateParkingDetails
        }
        propertyType
        staticMapImage(height: 300, width: 640, zoom: 16, scale: 2)
        storageLocation {
          id
          guestFacingTextArray
          name
        }
        timezone
        town
        wifiSsid
        wifiPassword
      }
      uniqKey
      rentalSiteName
      accessUnavailableReason
    }
  }
`;

/**
 * __useBookingAccessQuery__
 *
 * To run a query within a React component, call `useBookingAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAccessQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingAccessQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingAccessQuery,
    BookingAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingAccessQuery, BookingAccessQueryVariables>(
    BookingAccessDocument,
    options,
  );
}
export function useBookingAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingAccessQuery,
    BookingAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingAccessQuery, BookingAccessQueryVariables>(
    BookingAccessDocument,
    options,
  );
}
export type BookingAccessQueryHookResult = ReturnType<
  typeof useBookingAccessQuery
>;
export type BookingAccessLazyQueryHookResult = ReturnType<
  typeof useBookingAccessLazyQuery
>;
export type BookingAccessQueryResult = Apollo.QueryResult<
  BookingAccessQuery,
  BookingAccessQueryVariables
>;
export const BookingAccessUpgradeServicesDocument = gql`
  query BookingAccessUpgradeServices($uniqKey: String!) {
    upgradeService(bookingUniqKey: $uniqKey) {
      booked
      subType
      type
    }
  }
`;

/**
 * __useBookingAccessUpgradeServicesQuery__
 *
 * To run a query within a React component, call `useBookingAccessUpgradeServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAccessUpgradeServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAccessUpgradeServicesQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingAccessUpgradeServicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingAccessUpgradeServicesQuery,
    BookingAccessUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingAccessUpgradeServicesQuery,
    BookingAccessUpgradeServicesQueryVariables
  >(BookingAccessUpgradeServicesDocument, options);
}
export function useBookingAccessUpgradeServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingAccessUpgradeServicesQuery,
    BookingAccessUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingAccessUpgradeServicesQuery,
    BookingAccessUpgradeServicesQueryVariables
  >(BookingAccessUpgradeServicesDocument, options);
}
export type BookingAccessUpgradeServicesQueryHookResult = ReturnType<
  typeof useBookingAccessUpgradeServicesQuery
>;
export type BookingAccessUpgradeServicesLazyQueryHookResult = ReturnType<
  typeof useBookingAccessUpgradeServicesLazyQuery
>;
export type BookingAccessUpgradeServicesQueryResult = Apollo.QueryResult<
  BookingAccessUpgradeServicesQuery,
  BookingAccessUpgradeServicesQueryVariables
>;
export const BookingAllowedActionsDocument = gql`
  query BookingAllowedActions($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      actions {
        type
        externalUrl
      }
    }
  }
`;

/**
 * __useBookingAllowedActionsQuery__
 *
 * To run a query within a React component, call `useBookingAllowedActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAllowedActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAllowedActionsQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingAllowedActionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingAllowedActionsQuery,
    BookingAllowedActionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingAllowedActionsQuery,
    BookingAllowedActionsQueryVariables
  >(BookingAllowedActionsDocument, options);
}
export function useBookingAllowedActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingAllowedActionsQuery,
    BookingAllowedActionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingAllowedActionsQuery,
    BookingAllowedActionsQueryVariables
  >(BookingAllowedActionsDocument, options);
}
export type BookingAllowedActionsQueryHookResult = ReturnType<
  typeof useBookingAllowedActionsQuery
>;
export type BookingAllowedActionsLazyQueryHookResult = ReturnType<
  typeof useBookingAllowedActionsLazyQuery
>;
export type BookingAllowedActionsQueryResult = Apollo.QueryResult<
  BookingAllowedActionsQuery,
  BookingAllowedActionsQueryVariables
>;
export const BookingAndCheckInStateDocument = gql`
  query BookingAndCheckInState($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      creditCardRequirementsCompleted
      collectionId
      isCancelled
      actions {
        type
      }
      checkInState {
        personalInfoVerification {
          completed
        }
        phoneVerification {
          completed
        }
        paymentVerification {
          completed
        }
        idVerification {
          completed
        }
      }
      requiresCompletion
      inquiryState
      uniqKey
      status
      rentalSiteName
      revenueReceivableInvoices(
        states: pending
        excludeWithServiceInvoices: true
      ) {
        id
      }
    }
  }
`;

/**
 * __useBookingAndCheckInStateQuery__
 *
 * To run a query within a React component, call `useBookingAndCheckInStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAndCheckInStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAndCheckInStateQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingAndCheckInStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingAndCheckInStateQuery,
    BookingAndCheckInStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingAndCheckInStateQuery,
    BookingAndCheckInStateQueryVariables
  >(BookingAndCheckInStateDocument, options);
}
export function useBookingAndCheckInStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingAndCheckInStateQuery,
    BookingAndCheckInStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingAndCheckInStateQuery,
    BookingAndCheckInStateQueryVariables
  >(BookingAndCheckInStateDocument, options);
}
export type BookingAndCheckInStateQueryHookResult = ReturnType<
  typeof useBookingAndCheckInStateQuery
>;
export type BookingAndCheckInStateLazyQueryHookResult = ReturnType<
  typeof useBookingAndCheckInStateLazyQuery
>;
export type BookingAndCheckInStateQueryResult = Apollo.QueryResult<
  BookingAndCheckInStateQuery,
  BookingAndCheckInStateQueryVariables
>;
export const BookingCcConfirmationDocument = gql`
  query BookingCCConfirmation($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      uniqKey
      requiresCompletion
      requiresVerification
      account {
        id
        firstName
        lastName
        normalizedId
      }
      checkInTime
      checkOutTime
      confirmationCode
      pendingDateAdjustmentRequest {
        id
        newLocalCheckInTime
        newLocalCheckOutTime
      }
      earlyCheckInRequest {
        id
        desiredTime
        eciLcoRequestId
        status
      }
      lateCheckOutRequest {
        id
        desiredTime
        eciLcoRequestId
        status
      }
      guestIntendedArrivalTime
      guestIntendedDepartureTime
      hasPaymentPlan
      inquiryState
      isCancelled
      unit {
        id
        building {
          id
          fullAddress
        }
        brCount
        googleMapsLink
        images(limit: 0) {
          id
          url
        }
        listing {
          id
          url
        }
        name
        nbrBathrooms
        sleeps
        timezone
      }
      rentalSiteName
    }
  }
`;

/**
 * __useBookingCcConfirmationQuery__
 *
 * To run a query within a React component, call `useBookingCcConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCcConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCcConfirmationQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingCcConfirmationQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingCcConfirmationQuery,
    BookingCcConfirmationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingCcConfirmationQuery,
    BookingCcConfirmationQueryVariables
  >(BookingCcConfirmationDocument, options);
}
export function useBookingCcConfirmationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingCcConfirmationQuery,
    BookingCcConfirmationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingCcConfirmationQuery,
    BookingCcConfirmationQueryVariables
  >(BookingCcConfirmationDocument, options);
}
export type BookingCcConfirmationQueryHookResult = ReturnType<
  typeof useBookingCcConfirmationQuery
>;
export type BookingCcConfirmationLazyQueryHookResult = ReturnType<
  typeof useBookingCcConfirmationLazyQuery
>;
export type BookingCcConfirmationQueryResult = Apollo.QueryResult<
  BookingCcConfirmationQuery,
  BookingCcConfirmationQueryVariables
>;
export const BookingDateAdjustmentDocument = gql`
  query BookingDateAdjustment($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      uniqKey
      checkInTime
      checkOutTime
      collectionId
      unit {
        id
        timezone
      }
      inquiryState
      pendingDateAdjustmentRequest {
        id
        newLocalCheckInTime
        newLocalCheckOutTime
        revenueReceivableInvoice {
          id
        }
      }
    }
  }
`;

/**
 * __useBookingDateAdjustmentQuery__
 *
 * To run a query within a React component, call `useBookingDateAdjustmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDateAdjustmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDateAdjustmentQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingDateAdjustmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingDateAdjustmentQuery,
    BookingDateAdjustmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingDateAdjustmentQuery,
    BookingDateAdjustmentQueryVariables
  >(BookingDateAdjustmentDocument, options);
}
export function useBookingDateAdjustmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingDateAdjustmentQuery,
    BookingDateAdjustmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingDateAdjustmentQuery,
    BookingDateAdjustmentQueryVariables
  >(BookingDateAdjustmentDocument, options);
}
export type BookingDateAdjustmentQueryHookResult = ReturnType<
  typeof useBookingDateAdjustmentQuery
>;
export type BookingDateAdjustmentLazyQueryHookResult = ReturnType<
  typeof useBookingDateAdjustmentLazyQuery
>;
export type BookingDateAdjustmentQueryResult = Apollo.QueryResult<
  BookingDateAdjustmentQuery,
  BookingDateAdjustmentQueryVariables
>;
export const BookingDetailsDocument = gql`
  query BookingDetails($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      access {
        isInPersonCheckin
      }
      account {
        id
        canReceiveAccessInfo
        email
        normalizedId
      }
      actions {
        type
        externalUrl
      }
      checkInTime
      checkOutTime
      confirmationCode
      earlyCheckInRequest {
        id
        desiredTime
        eciLcoRequestId
        status
      }
      accessHoursAvailableBeforeCheckIn
      guestIntendedArrivalTime
      guestIntendedDepartureTime
      hasPaymentPlan
      isCancelled
      lateCheckOutRequest {
        id
        desiredTime
        eciLcoRequestId
        status
      }
      normalizedId
      pendingDateAdjustmentRequest {
        id
        newLocalCheckInTime
        newLocalCheckOutTime
      }
      unit {
        id
        brCount
        building {
          id
          fullAddress
          displayName
          name
        }
        googleMapsLink
        images(limit: 0) {
          id
          url
        }
        listing {
          id
          url
        }
        name
        nbrBathrooms
        neighborhood {
          id
          description
        }
        quickPitch
        sleeps
        timezone
      }
      status
      uniqKey
      rentalSiteName
    }
  }
`;

/**
 * __useBookingDetailsQuery__
 *
 * To run a query within a React component, call `useBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDetailsQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingDetailsQuery,
    BookingDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BookingDetailsQuery, BookingDetailsQueryVariables>(
    BookingDetailsDocument,
    options,
  );
}
export function useBookingDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingDetailsQuery,
    BookingDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BookingDetailsQuery, BookingDetailsQueryVariables>(
    BookingDetailsDocument,
    options,
  );
}
export type BookingDetailsQueryHookResult = ReturnType<
  typeof useBookingDetailsQuery
>;
export type BookingDetailsLazyQueryHookResult = ReturnType<
  typeof useBookingDetailsLazyQuery
>;
export type BookingDetailsQueryResult = Apollo.QueryResult<
  BookingDetailsQuery,
  BookingDetailsQueryVariables
>;
export const BookingDetailsUpgradeServicesDocument = gql`
  query BookingDetailsUpgradeServices($uniqKey: String!) {
    upgradeService(bookingUniqKey: $uniqKey) {
      booked
      subType
      type
    }
  }
`;

/**
 * __useBookingDetailsUpgradeServicesQuery__
 *
 * To run a query within a React component, call `useBookingDetailsUpgradeServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDetailsUpgradeServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDetailsUpgradeServicesQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingDetailsUpgradeServicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingDetailsUpgradeServicesQuery,
    BookingDetailsUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingDetailsUpgradeServicesQuery,
    BookingDetailsUpgradeServicesQueryVariables
  >(BookingDetailsUpgradeServicesDocument, options);
}
export function useBookingDetailsUpgradeServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingDetailsUpgradeServicesQuery,
    BookingDetailsUpgradeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingDetailsUpgradeServicesQuery,
    BookingDetailsUpgradeServicesQueryVariables
  >(BookingDetailsUpgradeServicesDocument, options);
}
export type BookingDetailsUpgradeServicesQueryHookResult = ReturnType<
  typeof useBookingDetailsUpgradeServicesQuery
>;
export type BookingDetailsUpgradeServicesLazyQueryHookResult = ReturnType<
  typeof useBookingDetailsUpgradeServicesLazyQuery
>;
export type BookingDetailsUpgradeServicesQueryResult = Apollo.QueryResult<
  BookingDetailsUpgradeServicesQuery,
  BookingDetailsUpgradeServicesQueryVariables
>;
export const BookingLatestReceiptDocument = gql`
  query BookingLatestReceipt($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      latestReceipt
    }
  }
`;

/**
 * __useBookingLatestReceiptQuery__
 *
 * To run a query within a React component, call `useBookingLatestReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingLatestReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingLatestReceiptQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingLatestReceiptQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingLatestReceiptQuery,
    BookingLatestReceiptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingLatestReceiptQuery,
    BookingLatestReceiptQueryVariables
  >(BookingLatestReceiptDocument, options);
}
export function useBookingLatestReceiptLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingLatestReceiptQuery,
    BookingLatestReceiptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingLatestReceiptQuery,
    BookingLatestReceiptQueryVariables
  >(BookingLatestReceiptDocument, options);
}
export type BookingLatestReceiptQueryHookResult = ReturnType<
  typeof useBookingLatestReceiptQuery
>;
export type BookingLatestReceiptLazyQueryHookResult = ReturnType<
  typeof useBookingLatestReceiptLazyQuery
>;
export type BookingLatestReceiptQueryResult = Apollo.QueryResult<
  BookingLatestReceiptQuery,
  BookingLatestReceiptQueryVariables
>;
export const BookingSurveyQuestionDocument = gql`
  query BookingSurveyQuestion($uniqKey: String!) {
    travelSurveyQuestion(uniqKey: $uniqKey) {
      title
      subtitle
      redirectUrl
      type
    }
  }
`;

/**
 * __useBookingSurveyQuestionQuery__
 *
 * To run a query within a React component, call `useBookingSurveyQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingSurveyQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingSurveyQuestionQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingSurveyQuestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingSurveyQuestionQuery,
    BookingSurveyQuestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingSurveyQuestionQuery,
    BookingSurveyQuestionQueryVariables
  >(BookingSurveyQuestionDocument, options);
}
export function useBookingSurveyQuestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingSurveyQuestionQuery,
    BookingSurveyQuestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingSurveyQuestionQuery,
    BookingSurveyQuestionQueryVariables
  >(BookingSurveyQuestionDocument, options);
}
export type BookingSurveyQuestionQueryHookResult = ReturnType<
  typeof useBookingSurveyQuestionQuery
>;
export type BookingSurveyQuestionLazyQueryHookResult = ReturnType<
  typeof useBookingSurveyQuestionLazyQuery
>;
export type BookingSurveyQuestionQueryResult = Apollo.QueryResult<
  BookingSurveyQuestionQuery,
  BookingSurveyQuestionQueryVariables
>;
export const BookingVerificationRedirectionDocument = gql`
  query BookingVerificationRedirection($uniqKey: String!) {
    bookingVerificationRedirection(uniqKey: $uniqKey) {
      redirectionPath
      redirectionUrl
    }
  }
`;

/**
 * __useBookingVerificationRedirectionQuery__
 *
 * To run a query within a React component, call `useBookingVerificationRedirectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingVerificationRedirectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingVerificationRedirectionQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useBookingVerificationRedirectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingVerificationRedirectionQuery,
    BookingVerificationRedirectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookingVerificationRedirectionQuery,
    BookingVerificationRedirectionQueryVariables
  >(BookingVerificationRedirectionDocument, options);
}
export function useBookingVerificationRedirectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingVerificationRedirectionQuery,
    BookingVerificationRedirectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookingVerificationRedirectionQuery,
    BookingVerificationRedirectionQueryVariables
  >(BookingVerificationRedirectionDocument, options);
}
export type BookingVerificationRedirectionQueryHookResult = ReturnType<
  typeof useBookingVerificationRedirectionQuery
>;
export type BookingVerificationRedirectionLazyQueryHookResult = ReturnType<
  typeof useBookingVerificationRedirectionLazyQuery
>;
export type BookingVerificationRedirectionQueryResult = Apollo.QueryResult<
  BookingVerificationRedirectionQuery,
  BookingVerificationRedirectionQueryVariables
>;
export const CsatFeedbackDocument = gql`
  query CsatFeedback($uniqKey: String!) {
    csatFeedback(uniqKey: $uniqKey) {
      feedbackQuestionnaireCompleted
      rateCompleted
    }
  }
`;

/**
 * __useCsatFeedbackQuery__
 *
 * To run a query within a React component, call `useCsatFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsatFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsatFeedbackQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useCsatFeedbackQuery(
  baseOptions: Apollo.QueryHookOptions<
    CsatFeedbackQuery,
    CsatFeedbackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CsatFeedbackQuery, CsatFeedbackQueryVariables>(
    CsatFeedbackDocument,
    options,
  );
}
export function useCsatFeedbackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CsatFeedbackQuery,
    CsatFeedbackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CsatFeedbackQuery, CsatFeedbackQueryVariables>(
    CsatFeedbackDocument,
    options,
  );
}
export type CsatFeedbackQueryHookResult = ReturnType<
  typeof useCsatFeedbackQuery
>;
export type CsatFeedbackLazyQueryHookResult = ReturnType<
  typeof useCsatFeedbackLazyQuery
>;
export type CsatFeedbackQueryResult = Apollo.QueryResult<
  CsatFeedbackQuery,
  CsatFeedbackQueryVariables
>;
export const CustomizePagePrepareAddonInvoiceDocument = gql`
  mutation CustomizePagePrepareAddonInvoice(
    $inquiryKey: String!
    $ancillaryServices: [AncillaryServiceInput!]!
  ) {
    prepareAddonInvoice(
      inquiryKey: $inquiryKey
      ancillaryServices: $ancillaryServices
    ) {
      invoice {
        checkoutUrl
      }
    }
  }
`;
export type CustomizePagePrepareAddonInvoiceMutationFn =
  Apollo.MutationFunction<
    CustomizePagePrepareAddonInvoiceMutation,
    CustomizePagePrepareAddonInvoiceMutationVariables
  >;

/**
 * __useCustomizePagePrepareAddonInvoiceMutation__
 *
 * To run a mutation, you first call `useCustomizePagePrepareAddonInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomizePagePrepareAddonInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customizePagePrepareAddonInvoiceMutation, { data, loading, error }] = useCustomizePagePrepareAddonInvoiceMutation({
 *   variables: {
 *      inquiryKey: // value for 'inquiryKey'
 *      ancillaryServices: // value for 'ancillaryServices'
 *   },
 * });
 */
export function useCustomizePagePrepareAddonInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomizePagePrepareAddonInvoiceMutation,
    CustomizePagePrepareAddonInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomizePagePrepareAddonInvoiceMutation,
    CustomizePagePrepareAddonInvoiceMutationVariables
  >(CustomizePagePrepareAddonInvoiceDocument, options);
}
export type CustomizePagePrepareAddonInvoiceMutationHookResult = ReturnType<
  typeof useCustomizePagePrepareAddonInvoiceMutation
>;
export type CustomizePagePrepareAddonInvoiceMutationResult =
  Apollo.MutationResult<CustomizePagePrepareAddonInvoiceMutation>;
export type CustomizePagePrepareAddonInvoiceMutationOptions =
  Apollo.BaseMutationOptions<
    CustomizePagePrepareAddonInvoiceMutation,
    CustomizePagePrepareAddonInvoiceMutationVariables
  >;
export const FetchCheckoutDetailsDocument = gql`
  query FetchCheckoutDetails(
    $checkInDate: String!
    $checkOutDate: String!
    $collectionId: String!
  ) {
    fetchCheckoutDetails(
      input: {
        checkInDate: $checkInDate
        checkOutDate: $checkOutDate
        collectionId: $collectionId
      }
    ) {
      productDetails {
        name
        description
        image
      }
      pricingPlans {
        id
        name
        description
        invoiceDetails {
          totalAmount
          currency
          lineItemDetails {
            type
            subtype
            description
            quantity
            averageUnitPrice
            total
            dailyRates {
              date
              amount
            }
          }
        }
      }
    }
  }
`;

/**
 * __useFetchCheckoutDetailsQuery__
 *
 * To run a query within a React component, call `useFetchCheckoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCheckoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCheckoutDetailsQuery({
 *   variables: {
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useFetchCheckoutDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCheckoutDetailsQuery,
    FetchCheckoutDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchCheckoutDetailsQuery,
    FetchCheckoutDetailsQueryVariables
  >(FetchCheckoutDetailsDocument, options);
}
export function useFetchCheckoutDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCheckoutDetailsQuery,
    FetchCheckoutDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchCheckoutDetailsQuery,
    FetchCheckoutDetailsQueryVariables
  >(FetchCheckoutDetailsDocument, options);
}
export type FetchCheckoutDetailsQueryHookResult = ReturnType<
  typeof useFetchCheckoutDetailsQuery
>;
export type FetchCheckoutDetailsLazyQueryHookResult = ReturnType<
  typeof useFetchCheckoutDetailsLazyQuery
>;
export type FetchCheckoutDetailsQueryResult = Apollo.QueryResult<
  FetchCheckoutDetailsQuery,
  FetchCheckoutDetailsQueryVariables
>;
export const GeneratePaymentMethodIFrameDocument = gql`
  mutation GeneratePaymentMethodIFrame(
    $locale: String
    $uniqueCode: String!
    $styles: String
    $buttonType: String
  ) {
    generatePaymentMethodIFrame(
      locale: $locale
      uniqueCode: $uniqueCode
      styles: $styles
      buttonType: $buttonType
    ) {
      iframe
      sessionKey
    }
  }
`;
export type GeneratePaymentMethodIFrameMutationFn = Apollo.MutationFunction<
  GeneratePaymentMethodIFrameMutation,
  GeneratePaymentMethodIFrameMutationVariables
>;

/**
 * __useGeneratePaymentMethodIFrameMutation__
 *
 * To run a mutation, you first call `useGeneratePaymentMethodIFrameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaymentMethodIFrameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePaymentMethodIFrameMutation, { data, loading, error }] = useGeneratePaymentMethodIFrameMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *      uniqueCode: // value for 'uniqueCode'
 *      styles: // value for 'styles'
 *      buttonType: // value for 'buttonType'
 *   },
 * });
 */
export function useGeneratePaymentMethodIFrameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GeneratePaymentMethodIFrameMutation,
    GeneratePaymentMethodIFrameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GeneratePaymentMethodIFrameMutation,
    GeneratePaymentMethodIFrameMutationVariables
  >(GeneratePaymentMethodIFrameDocument, options);
}
export type GeneratePaymentMethodIFrameMutationHookResult = ReturnType<
  typeof useGeneratePaymentMethodIFrameMutation
>;
export type GeneratePaymentMethodIFrameMutationResult =
  Apollo.MutationResult<GeneratePaymentMethodIFrameMutation>;
export type GeneratePaymentMethodIFrameMutationOptions =
  Apollo.BaseMutationOptions<
    GeneratePaymentMethodIFrameMutation,
    GeneratePaymentMethodIFrameMutationVariables
  >;
export const GroupPayerPaymentDetailsDocument = gql`
  query GroupPayerPaymentDetails($slug: String!) {
    groupPayerPaymentDetails(slug: $slug) {
      city
      bookingDatesLabel
    }
  }
`;

/**
 * __useGroupPayerPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGroupPayerPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPayerPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPayerPaymentDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGroupPayerPaymentDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupPayerPaymentDetailsQuery,
    GroupPayerPaymentDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GroupPayerPaymentDetailsQuery,
    GroupPayerPaymentDetailsQueryVariables
  >(GroupPayerPaymentDetailsDocument, options);
}
export function useGroupPayerPaymentDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupPayerPaymentDetailsQuery,
    GroupPayerPaymentDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GroupPayerPaymentDetailsQuery,
    GroupPayerPaymentDetailsQueryVariables
  >(GroupPayerPaymentDetailsDocument, options);
}
export type GroupPayerPaymentDetailsQueryHookResult = ReturnType<
  typeof useGroupPayerPaymentDetailsQuery
>;
export type GroupPayerPaymentDetailsLazyQueryHookResult = ReturnType<
  typeof useGroupPayerPaymentDetailsLazyQuery
>;
export type GroupPayerPaymentDetailsQueryResult = Apollo.QueryResult<
  GroupPayerPaymentDetailsQuery,
  GroupPayerPaymentDetailsQueryVariables
>;
export const ManageReservationDropdownDocument = gql`
  query ManageReservationDropdown($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id
      account {
        id
      }
      alterationsAllowed
      cancellationsAllowed
      guestModificationAllowed
      cancellationEligibility {
        isEligible
        ineligibleReason
        otaLink
      }
      earlyCheckInRequest {
        eciLcoRequestId
        status
      }
      hasPaymentPlan
      instantEciLcoEnabled
      inquiryState
      isEciRequestAvailable
      isLcoRequestAvailable
      normalizedId
      lateCheckOutRequest {
        eciLcoRequestId
        status
      }
      actions {
        type
        externalUrl
      }
      rentalSiteName
      uniqKey
    }
  }
`;

/**
 * __useManageReservationDropdownQuery__
 *
 * To run a query within a React component, call `useManageReservationDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageReservationDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageReservationDropdownQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useManageReservationDropdownQuery(
  baseOptions: Apollo.QueryHookOptions<
    ManageReservationDropdownQuery,
    ManageReservationDropdownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManageReservationDropdownQuery,
    ManageReservationDropdownQueryVariables
  >(ManageReservationDropdownDocument, options);
}
export function useManageReservationDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManageReservationDropdownQuery,
    ManageReservationDropdownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManageReservationDropdownQuery,
    ManageReservationDropdownQueryVariables
  >(ManageReservationDropdownDocument, options);
}
export type ManageReservationDropdownQueryHookResult = ReturnType<
  typeof useManageReservationDropdownQuery
>;
export type ManageReservationDropdownLazyQueryHookResult = ReturnType<
  typeof useManageReservationDropdownLazyQuery
>;
export type ManageReservationDropdownQueryResult = Apollo.QueryResult<
  ManageReservationDropdownQuery,
  ManageReservationDropdownQueryVariables
>;
export const OtaBookingDocument = gql`
  query OtaBooking($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id: normalizedId
      uniqKey
      name
      confirmationCode
      rentalSiteName
      checkInTime
      checkOutTime
      inquiryState
      isCancelled
      status
      account {
        id: normalizedId
      }
      unit {
        timezone
        images(limit: 0) {
          url
        }
        listing {
          title
          cityName
          buildingName
          neighborhoodName
        }
        building {
          requiresBackgroundCheck
        }
      }
      checkInState {
        personalInfoVerification {
          completed
          guestInfo {
            email
            firstName
            lastName
            countryAlpha2
            countryCode
            phoneNumber
            dateOfBirth
            isBgcNeeded
            address {
              streetAddress
              streetAddress2
              stateOrProvince
              cityName
              postalCode
              countryCode
            }
          }
        }
        phoneVerification {
          completed
        }
        paymentVerification {
          completed
          isSonderMor
          unpaidCharges
          cardholderName
          paymentInfo {
            currency
            paymentMethodId
            savedPaymentMethods {
              id
              brand
              default
              expMonth
              expYear
              last4
              type
            }
          }
        }
        idVerification {
          completed
          persona {
            templateId
            dynamicFlowTemplateId
            riskLevel
          }
          chekin {
            registrationLink
            idvEnabled
            verificationType
            requiredForAllGuests
          }
        }
      }
    }
  }
`;

/**
 * __useOtaBookingQuery__
 *
 * To run a query within a React component, call `useOtaBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtaBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtaBookingQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useOtaBookingQuery(
  baseOptions: Apollo.QueryHookOptions<
    OtaBookingQuery,
    OtaBookingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OtaBookingQuery, OtaBookingQueryVariables>(
    OtaBookingDocument,
    options,
  );
}
export function useOtaBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OtaBookingQuery,
    OtaBookingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OtaBookingQuery, OtaBookingQueryVariables>(
    OtaBookingDocument,
    options,
  );
}
export type OtaBookingQueryHookResult = ReturnType<typeof useOtaBookingQuery>;
export type OtaBookingLazyQueryHookResult = ReturnType<
  typeof useOtaBookingLazyQuery
>;
export type OtaBookingQueryResult = Apollo.QueryResult<
  OtaBookingQuery,
  OtaBookingQueryVariables
>;
export const ProfileAccountBookingsDocument = gql`
  query ProfileAccountBookings {
    account {
      id
      normalizedId
      bookingsAndCancellations {
        account {
          id
          normalizedId
        }
        collectionId
        checkInTime
        checkOutTime
        hasPaymentPlan
        hasPendingDateAdjustmentRequest
        id
        isBooked
        isCancelled
        name
        normalizedId
        rentalSiteName
        requiresCompletion
        requiresSurvey
        revenueReceivableInvoices(states: pending) {
          id
        }
        unit {
          building {
            fullAddress
          }
          city {
            name
          }
          images(limit: 1) {
            url
          }
          name
          timezone
        }
        status
        uniqKey
      }
    }
  }
`;

/**
 * __useProfileAccountBookingsQuery__
 *
 * To run a query within a React component, call `useProfileAccountBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileAccountBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileAccountBookingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileAccountBookingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProfileAccountBookingsQuery,
    ProfileAccountBookingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProfileAccountBookingsQuery,
    ProfileAccountBookingsQueryVariables
  >(ProfileAccountBookingsDocument, options);
}
export function useProfileAccountBookingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfileAccountBookingsQuery,
    ProfileAccountBookingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProfileAccountBookingsQuery,
    ProfileAccountBookingsQueryVariables
  >(ProfileAccountBookingsDocument, options);
}
export type ProfileAccountBookingsQueryHookResult = ReturnType<
  typeof useProfileAccountBookingsQuery
>;
export type ProfileAccountBookingsLazyQueryHookResult = ReturnType<
  typeof useProfileAccountBookingsLazyQuery
>;
export type ProfileAccountBookingsQueryResult = Apollo.QueryResult<
  ProfileAccountBookingsQuery,
  ProfileAccountBookingsQueryVariables
>;
export const TokenizeCreditCardDocument = gql`
  mutation TokenizeCreditCard(
    $uniqueCode: String!
    $paymentKey: String!
    $sessionKey: String!
    $cardIssuer: String!
    $maskedCardNumber: String!
    $expirationDate: String!
  ) {
    tokenizeCreditCard(
      uniqueCode: $uniqueCode
      paymentKey: $paymentKey
      sessionKey: $sessionKey
      cardIssuer: $cardIssuer
      maskedCardNumber: $maskedCardNumber
      expirationDate: $expirationDate
    )
  }
`;
export type TokenizeCreditCardMutationFn = Apollo.MutationFunction<
  TokenizeCreditCardMutation,
  TokenizeCreditCardMutationVariables
>;

/**
 * __useTokenizeCreditCardMutation__
 *
 * To run a mutation, you first call `useTokenizeCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenizeCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenizeCreditCardMutation, { data, loading, error }] = useTokenizeCreditCardMutation({
 *   variables: {
 *      uniqueCode: // value for 'uniqueCode'
 *      paymentKey: // value for 'paymentKey'
 *      sessionKey: // value for 'sessionKey'
 *      cardIssuer: // value for 'cardIssuer'
 *      maskedCardNumber: // value for 'maskedCardNumber'
 *      expirationDate: // value for 'expirationDate'
 *   },
 * });
 */
export function useTokenizeCreditCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TokenizeCreditCardMutation,
    TokenizeCreditCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TokenizeCreditCardMutation,
    TokenizeCreditCardMutationVariables
  >(TokenizeCreditCardDocument, options);
}
export type TokenizeCreditCardMutationHookResult = ReturnType<
  typeof useTokenizeCreditCardMutation
>;
export type TokenizeCreditCardMutationResult =
  Apollo.MutationResult<TokenizeCreditCardMutation>;
export type TokenizeCreditCardMutationOptions = Apollo.BaseMutationOptions<
  TokenizeCreditCardMutation,
  TokenizeCreditCardMutationVariables
>;
export const CustomizeBookingBookingQueryDocument = gql`
  query CustomizeBookingBookingQuery($uniqKey: String!) {
    booking(uniqKey: $uniqKey) {
      id: normalizedId
    }
  }
`;

/**
 * __useCustomizeBookingBookingQueryQuery__
 *
 * To run a query within a React component, call `useCustomizeBookingBookingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomizeBookingBookingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomizeBookingBookingQueryQuery({
 *   variables: {
 *      uniqKey: // value for 'uniqKey'
 *   },
 * });
 */
export function useCustomizeBookingBookingQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomizeBookingBookingQueryQuery,
    CustomizeBookingBookingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomizeBookingBookingQueryQuery,
    CustomizeBookingBookingQueryQueryVariables
  >(CustomizeBookingBookingQueryDocument, options);
}
export function useCustomizeBookingBookingQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomizeBookingBookingQueryQuery,
    CustomizeBookingBookingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomizeBookingBookingQueryQuery,
    CustomizeBookingBookingQueryQueryVariables
  >(CustomizeBookingBookingQueryDocument, options);
}
export type CustomizeBookingBookingQueryQueryHookResult = ReturnType<
  typeof useCustomizeBookingBookingQueryQuery
>;
export type CustomizeBookingBookingQueryLazyQueryHookResult = ReturnType<
  typeof useCustomizeBookingBookingQueryLazyQuery
>;
export type CustomizeBookingBookingQueryQueryResult = Apollo.QueryResult<
  CustomizeBookingBookingQueryQuery,
  CustomizeBookingBookingQueryQueryVariables
>;
export const DevToolsAccountDocument = gql`
  query DevToolsAccount {
    account {
      canQa
    }
  }
`;

/**
 * __useDevToolsAccountQuery__
 *
 * To run a query within a React component, call `useDevToolsAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevToolsAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DevToolsAccountQuery,
    DevToolsAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DevToolsAccountQuery, DevToolsAccountQueryVariables>(
    DevToolsAccountDocument,
    options,
  );
}
export function useDevToolsAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DevToolsAccountQuery,
    DevToolsAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DevToolsAccountQuery,
    DevToolsAccountQueryVariables
  >(DevToolsAccountDocument, options);
}
export type DevToolsAccountQueryHookResult = ReturnType<
  typeof useDevToolsAccountQuery
>;
export type DevToolsAccountLazyQueryHookResult = ReturnType<
  typeof useDevToolsAccountLazyQuery
>;
export type DevToolsAccountQueryResult = Apollo.QueryResult<
  DevToolsAccountQuery,
  DevToolsAccountQueryVariables
>;
export const ReferrerQueryDocument = gql`
  query ReferrerQuery($referralCode: String!) {
    referrer(referralCode: $referralCode) {
      referralCode
      referrerName
    }
  }
`;

/**
 * __useReferrerQueryQuery__
 *
 * To run a query within a React component, call `useReferrerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferrerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferrerQueryQuery({
 *   variables: {
 *      referralCode: // value for 'referralCode'
 *   },
 * });
 */
export function useReferrerQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReferrerQueryQuery,
    ReferrerQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReferrerQueryQuery, ReferrerQueryQueryVariables>(
    ReferrerQueryDocument,
    options,
  );
}
export function useReferrerQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReferrerQueryQuery,
    ReferrerQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReferrerQueryQuery, ReferrerQueryQueryVariables>(
    ReferrerQueryDocument,
    options,
  );
}
export type ReferrerQueryQueryHookResult = ReturnType<
  typeof useReferrerQueryQuery
>;
export type ReferrerQueryLazyQueryHookResult = ReturnType<
  typeof useReferrerQueryLazyQuery
>;
export type ReferrerQueryQueryResult = Apollo.QueryResult<
  ReferrerQueryQuery,
  ReferrerQueryQueryVariables
>;
